import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

export type AccessUserPayload = {
  __typename?: 'AccessUserPayload';
  access_token?: Maybe<Scalars['String']>;
  maxLoginAttempts?: Maybe<Scalars['Int']>;
  mfaAvailableMethods?: Maybe<Array<MfaMethod>>;
  mfaMethod?: Maybe<MfaMethod>;
  mfaRequired?: Maybe<Scalars['Boolean']>;
  mfaToken?: Maybe<Scalars['String']>;
  remainingLoginAttempts?: Maybe<Scalars['Int']>;
  response?: Maybe<ResponsePayload>;
  roles?: Maybe<Array<Role>>;
};

export type Account = {
  __typename?: 'Account';
  accountNo?: Maybe<Scalars['String']>;
  accountPayable?: Maybe<Array<AccountsPayable>>;
  accountPayableRefunds?: Maybe<Array<PayableRefund>>;
  active: Scalars['Boolean'];
  bills?: Maybe<Array<Bill>>;
  caseBilling?: Maybe<Array<CaseBilling>>;
  category: AccountCategory;
  childAccounts?: Maybe<Array<Account>>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  currentBalance?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  glAccountPayableLineItems?: Maybe<Array<AccountsPayableLineItem>>;
  glAccountPayableRefunds?: Maybe<Array<PayableRefund>>;
  glAccountVendor?: Maybe<Array<Vendor>>;
  glStatements?: Maybe<Array<GlAccountStatement>>;
  id: Scalars['String'];
  institution?: Maybe<Scalars['String']>;
  isBankAccount: Scalars['Boolean'];
  journalEntryLineItems?: Maybe<Array<JournalEntryLineItem>>;
  name: Scalars['String'];
  openingBalance?: Maybe<Scalars['Float']>;
  parentAccount?: Maybe<Account>;
  parentAccountId?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Payment>>;
  reconciliations?: Maybe<Array<Reconciliation>>;
  routingNo?: Maybe<Scalars['String']>;
  sortCode: Scalars['String'];
  statements?: Maybe<Array<AccountStatement>>;
  type?: Maybe<AccountType>;
  updatedAt: Scalars['String'];
};

/** Accounting categories assets, liabilities, etc */
export enum AccountCategory {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Revenue = 'REVENUE'
}

export type AccountPayablePayload = {
  __typename?: 'AccountPayablePayload';
  accountPayableEntry: AccountsPayable;
  response?: Maybe<ResponsePayload>;
};

export type AccountPayload = {
  __typename?: 'AccountPayload';
  account?: Maybe<Account>;
  response?: Maybe<ResponsePayload>;
};

export type AccountReconciliationInput = {
  accountId: Scalars['String'];
  monthOfYear?: InputMaybe<Scalars['String']>;
};

export type AccountReconciliationResponse = {
  __typename?: 'AccountReconciliationResponse';
  lastReconciliation?: Maybe<Reconciliation>;
  openingBalance?: Maybe<Scalars['Float']>;
  reconciliation?: Maybe<Reconciliation>;
  response?: Maybe<ResponsePayload>;
};

export type AccountStatement = {
  __typename?: 'AccountStatement';
  account: Account;
  closingBalance: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Account type */
export enum AccountType {
  Operating = 'OPERATING',
  Trust = 'TRUST'
}

export type AccountingPeriod = {
  __typename?: 'AccountingPeriod';
  closedAt?: Maybe<Scalars['DateTime']>;
  closedBy?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  fiscalYear: Scalars['Float'];
  id: Scalars['String'];
  month: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
  status: PeriodStatus;
  unclosedAt?: Maybe<Scalars['DateTime']>;
  unclosedBy?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
};

export type AccountsInput = {
  accountNo?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<AccountCategory>;
  hasAccountNo?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  includeAllActiveAndInactiveAccounts?: InputMaybe<Scalars['Boolean']>;
  institution?: InputMaybe<Scalars['String']>;
  isBankAccount?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  parentAccountId?: InputMaybe<Scalars['String']>;
  searchValue?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AccountType>;
};

export type AccountsPayable = {
  __typename?: 'AccountsPayable';
  account?: Maybe<Account>;
  actionDetails?: Maybe<PayableActionMetadata>;
  amount: Scalars['Float'];
  /** Matters whose expense entry for this payable is billed */
  billedCaseIds?: Maybe<Array<Scalars['String']>>;
  /** Check No if payment method is check; Ach No if payment method is Ach; EFT if paymentMethod is EFT */
  checkOrAchNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  duplicates?: Maybe<Array<AccountsPayable>>;
  entries?: Maybe<Array<Entry>>;
  id: Scalars['String'];
  invoiceDate: Scalars['DateTime'];
  invoiceNo?: Maybe<Scalars['String']>;
  /** Whether a payment for this payable has been reconciled */
  isReconciled?: Maybe<Scalars['Boolean']>;
  journalEntries?: Maybe<Array<JournalEntry>>;
  lineItems?: Maybe<Array<AccountsPayableLineItem>>;
  parent?: Maybe<AccountsPayable>;
  payDate: Scalars['DateTime'];
  paymentMethod: PaymentMethod;
  payments?: Maybe<Array<Payment>>;
  /** Timestamp when the check was last printed (not preview) */
  printedAt?: Maybe<Scalars['DateTime']>;
  /** Statement date the payment was reconciled against */
  reconciledAt?: Maybe<Scalars['String']>;
  /** Timestamp the reconciliation was finalized */
  reconciledOn?: Maybe<Scalars['DateTime']>;
  refunds?: Maybe<Array<PayableRefund>>;
  reissuedFrom?: Maybe<AccountsPayable>;
  reissues?: Maybe<Array<AccountsPayable>>;
  status: PayableStatus;
  updatedAt: Scalars['String'];
  vendor?: Maybe<Vendor>;
  voucherNo: Scalars['String'];
};

export type AccountsPayableLineItem = {
  __typename?: 'AccountsPayableLineItem';
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  client?: Maybe<ExternalUser>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  glAccount: Account;
  id: Scalars['String'];
  litigation?: Maybe<Case>;
  office: Office;
  payable: AccountsPayable;
  sortOrder: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type AccountsPayablePayload = {
  __typename?: 'AccountsPayablePayload';
  apEntries: Array<AccountsPayable>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
  totalAmount: Scalars['Float'];
};

export type AccountsPayload = {
  __typename?: 'AccountsPayload';
  accounts?: Maybe<Array<Maybe<Account>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type AccountsReceivableEntry = {
  __typename?: 'AccountsReceivableEntry';
  balance: Scalars['Float'];
  bill?: Maybe<Bill>;
  case?: Maybe<Case>;
  caseExternalUserToExternalUserRoles?: Maybe<Array<CaseToExternalUserToExternalUserRole>>;
  clientsInterest: Array<ClientsInterest>;
  paid: Scalars['Float'];
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  total: Scalars['Float'];
};

export type AccountsReceivableSummary = {
  __typename?: 'AccountsReceivableSummary';
  totalARs: Scalars['Float'];
  totalInvoiced: Scalars['Float'];
};

export type AchOrEftNumberPayload = {
  __typename?: 'AchOrEftNumberPayload';
  achOrEftNo: Scalars['String'];
  response?: Maybe<ResponsePayload>;
};

export enum ActivityEntityType {
  Account = 'ACCOUNT',
  AccountPayable = 'ACCOUNT_PAYABLE',
  Bill = 'BILL',
  ConflictCheck = 'CONFLICT_CHECK',
  Entry = 'ENTRY',
  FundRequest = 'FUND_REQUEST',
  LawType = 'LAW_TYPE',
  Matter = 'MATTER',
  MatterEvents = 'MATTER_EVENTS',
  MatterType = 'MATTER_TYPE',
  Notes = 'NOTES',
  PayableRefund = 'PAYABLE_REFUND',
  Payments = 'PAYMENTS',
  PaymentRefund = 'PAYMENT_REFUND',
  Reconciliation = 'RECONCILIATION',
  References = 'REFERENCES',
  Reports = 'REPORTS',
  Task = 'TASK',
  User = 'USER',
  UserMatterTask = 'USER_MATTER_TASK'
}

export type ActivityPayload = {
  __typename?: 'ActivityPayload';
  activities?: Maybe<Array<Maybe<ActivityTracking>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type ActivityTracking = {
  __typename?: 'ActivityTracking';
  action: ActivityTrackingAction;
  actorName?: Maybe<Scalars['String']>;
  batchId?: Maybe<Scalars['String']>;
  billId?: Maybe<Scalars['Float']>;
  caseId?: Maybe<Scalars['String']>;
  changes?: Maybe<Scalars['JSON']>;
  context?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<ActivityEntityType>;
  id: Scalars['String'];
  /** @deprecated Never returned; read `context` and `changes` instead. */
  metadata?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ActivityTrackingAction {
  ActivatedOrDeactivatedReference = 'ACTIVATED_OR_DEACTIVATED_REFERENCE',
  AppliedClientFunds = 'APPLIED_CLIENT_FUNDS',
  AppliedCredits = 'APPLIED_CREDITS',
  AppliedInterest = 'APPLIED_INTEREST',
  ApprovedBill = 'APPROVED_BILL',
  ArchivedAccount = 'ARCHIVED_ACCOUNT',
  ArchivedBill = 'ARCHIVED_BILL',
  ArchivedMatter = 'ARCHIVED_MATTER',
  AssignedSomeoneToTask = 'ASSIGNED_SOMEONE_TO_TASK',
  AttorneyApprovedBills = 'ATTORNEY_APPROVED_BILLS',
  CancelledReport = 'CANCELLED_REPORT',
  CarriedForwardBill = 'CARRIED_FORWARD_BILL',
  ClientPaidOnline = 'CLIENT_PAID_ONLINE',
  ClosedMatter = 'CLOSED_MATTER',
  ConvertedConsultToMatter = 'CONVERTED_CONSULT_TO_MATTER',
  ConvertedFlatFeeToHourly = 'CONVERTED_FLAT_FEE_TO_HOURLY',
  CreatedAccount = 'CREATED_ACCOUNT',
  CreatedAccountPayable = 'CREATED_ACCOUNT_PAYABLE',
  CreatedBill = 'CREATED_BILL',
  CreatedCaseEvent = 'CREATED_CASE_EVENT',
  CreatedCaseTask = 'CREATED_CASE_TASK',
  CreatedEntry = 'CREATED_ENTRY',
  CreatedFundRequest = 'CREATED_FUND_REQUEST',
  CreatedLawType = 'CREATED_LAW_TYPE',
  CreatedMatter = 'CREATED_MATTER',
  CreatedMatterNotes = 'CREATED_MATTER_NOTES',
  CreatedMatterType = 'CREATED_MATTER_TYPE',
  CreatedPaymentRefund = 'CREATED_PAYMENT_REFUND',
  CreatedReference = 'CREATED_REFERENCE',
  CreatedRefundForPayable = 'CREATED_REFUND_FOR_PAYABLE',
  CreateFirmPayment = 'CREATE_FIRM_PAYMENT',
  DeletedCaseEvent = 'DELETED_CASE_EVENT',
  DeletedCaseTask = 'DELETED_CASE_TASK',
  DeletedEntry = 'DELETED_ENTRY',
  DeletedInterest = 'DELETED_INTEREST',
  DeletedLawType = 'DELETED_LAW_TYPE',
  DeletedMatter = 'DELETED_MATTER',
  DeletedMatterNotes = 'DELETED_MATTER_NOTES',
  DeletedMatterType = 'DELETED_MATTER_TYPE',
  DeletedReference = 'DELETED_REFERENCE',
  DepartmentHeadApprovedBills = 'DEPARTMENT_HEAD_APPROVED_BILLS',
  FailedToSendBillToClient = 'FAILED_TO_SEND_BILL_TO_CLIENT',
  FailedToSendReminderToClient = 'FAILED_TO_SEND_REMINDER_TO_CLIENT',
  FinalizedBill = 'FINALIZED_BILL',
  GeneratedPreBills = 'GENERATED_PRE_BILLS',
  GeneratedPreBillsForAllAttorneys = 'GENERATED_PRE_BILLS_FOR_ALL_ATTORNEYS',
  GeneratedQuickBill = 'GENERATED_QUICK_BILL',
  MarkedBillAsDelivered = 'MARKED_BILL_AS_DELIVERED',
  MarkedPayableAsPaid = 'MARKED_PAYABLE_AS_PAID',
  MarkedPaymentLegacyReconciled = 'MARKED_PAYMENT_LEGACY_RECONCILED',
  MarkedVoucherAsPaid = 'MARKED_VOUCHER_AS_PAID',
  PaymentStatusUpdatedByProcessor = 'PAYMENT_STATUS_UPDATED_BY_PROCESSOR',
  PerformedBulkAction = 'PERFORMED_BULK_ACTION',
  RanConflictCheck = 'RAN_CONFLICT_CHECK',
  ReconcilePayments = 'RECONCILE_PAYMENTS',
  RecordedClientCredit = 'RECORDED_CLIENT_CREDIT',
  RecordedManualPayment = 'RECORDED_MANUAL_PAYMENT',
  RemovedUserFromTask = 'REMOVED_USER_FROM_TASK',
  ReopenedMatter = 'REOPENED_MATTER',
  RequestedReport = 'REQUESTED_REPORT',
  ResendBillToClient = 'RESEND_BILL_TO_CLIENT',
  RetriedReport = 'RETRIED_REPORT',
  ReturnedCheck = 'RETURNED_CHECK',
  ReversedPayment = 'REVERSED_PAYMENT',
  SentBillsToAttorney = 'SENT_BILLS_TO_ATTORNEY',
  SentBillToClient = 'SENT_BILL_TO_CLIENT',
  SentReminderToClient = 'SENT_REMINDER_TO_CLIENT',
  SwitchedInterestRate = 'SWITCHED_INTEREST_RATE',
  TransferredFundsBetweenAccounts = 'TRANSFERRED_FUNDS_BETWEEN_ACCOUNTS',
  UndoReconciliation = 'UNDO_RECONCILIATION',
  UnlockedUser = 'UNLOCKED_USER',
  UpdatedAccount = 'UPDATED_ACCOUNT',
  UpdatedAccountPayable = 'UPDATED_ACCOUNT_PAYABLE',
  UpdatedAssigneesOfTask = 'UPDATED_ASSIGNEES_OF_TASK',
  UpdatedBill = 'UPDATED_BILL',
  UpdatedBillDueDate = 'UPDATED_BILL_DUE_DATE',
  UpdatedBillStatus = 'UPDATED_BILL_STATUS',
  UpdatedCaseEvent = 'UPDATED_CASE_EVENT',
  UpdatedCaseTask = 'UPDATED_CASE_TASK',
  UpdatedEntry = 'UPDATED_ENTRY',
  UpdatedFundRequest = 'UPDATED_FUND_REQUEST',
  UpdatedLawType = 'UPDATED_LAW_TYPE',
  UpdatedMatter = 'UPDATED_MATTER',
  UpdatedMatterNotes = 'UPDATED_MATTER_NOTES',
  UpdatedMatterType = 'UPDATED_MATTER_TYPE',
  UpdatedPayment = 'UPDATED_PAYMENT',
  UpdatedReference = 'UPDATED_REFERENCE',
  VoidedBill = 'VOIDED_BILL',
  VoidAndReissueCheck = 'VOID_AND_REISSUE_CHECK',
  VoidCheck = 'VOID_CHECK',
  VoidPayable = 'VOID_PAYABLE',
  WroteOffBill = 'WROTE_OFF_BILL'
}

export type AddUsersToCaseInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  court?: Maybe<Court>;
  createdAt: Scalars['String'];
  externalUser?: Maybe<ExternalUser>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  office?: Maybe<Office>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  vendor?: Maybe<Vendor>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressPayload = {
  __typename?: 'AddressPayload';
  address?: Maybe<Address>;
  response?: Maybe<ResponsePayload>;
};

export type ApplyCreditsInput = {
  amount: Scalars['Float'];
  billId: Scalars['Float'];
  clientId: Scalars['String'];
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
};

export type ApproveBillByAttorneyInput = {
  billId: Scalars['Float'];
};

export type ApproveBillByAttorneyPayload = {
  __typename?: 'ApproveBillByAttorneyPayload';
  bill: Bill;
  response?: Maybe<ResponsePayload>;
};

export type ApproveBillByDepartmentHeadInput = {
  billId: Scalars['Float'];
};

export type ApproveBillByDepartmentHeadPayload = {
  __typename?: 'ApproveBillByDepartmentHeadPayload';
  bill: Bill;
  response?: Maybe<ResponsePayload>;
};

export type ArchiveBillInput = {
  billId: Scalars['Float'];
};

export type ArchiveCase = {
  id: Scalars['String'];
};

export type AssignExternalUserToCase = {
  externalUserId: Scalars['String'];
  litigationId: Scalars['String'];
};

export type AssignExternalUserToCourt = {
  courtId: Scalars['String'];
  externalUserId: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isLocked: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: AttachmentType;
  typeId: Scalars['String'];
  updatedAt: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type AttachmentMediaPayload = {
  __typename?: 'AttachmentMediaPayload';
  preSignedUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

export type AttachmentPayload = {
  __typename?: 'AttachmentPayload';
  attachment?: Maybe<Attachment>;
  response?: Maybe<ResponsePayload>;
};

/** The type is assigned */
export enum AttachmentType {
  Case = 'CASE',
  CaseCsv = 'CASE_CSV'
}

export type AttachmentsPayload = {
  __typename?: 'AttachmentsPayload';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

/** Case Attribute */
export enum AttributeName {
  AccidentDate = 'ACCIDENT_DATE',
  AdvantageCode = 'ADVANTAGE_CODE',
  CaseNumber = 'CASE_NUMBER',
  Description = 'DESCRIPTION',
  Status = 'STATUS',
  Title = 'TITLE'
}

export type BankData = {
  __typename?: 'BankData';
  accountNumber: Scalars['String'];
  accountType?: Maybe<Scalars['String']>;
  nameOnAccount: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type BankDataInput = {
  accountNumber: Scalars['String'];
  accountType?: InputMaybe<Scalars['String']>;
  nameOnAccount: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type Bill = {
  __typename?: 'Bill';
  accessTokens?: Maybe<Array<BillAccessToken>>;
  account?: Maybe<Account>;
  advInvoiceNo?: Maybe<Scalars['String']>;
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  amountPaid?: Maybe<Scalars['Float']>;
  approvedByResponsibleAttorney?: Maybe<User>;
  attorneyApprovedAt?: Maybe<Scalars['DateTime']>;
  billCopies?: Maybe<Array<BillCopy>>;
  billItems?: Maybe<Array<BillItem>>;
  billTimelines?: Maybe<Array<BillTimeline>>;
  billingPeriodDate?: Maybe<Scalars['DateTime']>;
  case: Case;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  creditBalance?: Maybe<Scalars['Float']>;
  departmentApprovedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  finalApprover?: Maybe<User>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  interests?: Maybe<Array<Interest>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  journalEntries?: Maybe<Array<JournalEntry>>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
  outstandingBalance?: Maybe<Scalars['Float']>;
  payOffAmount?: Maybe<Scalars['Float']>;
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  payments?: Maybe<Array<Payment>>;
  pdfSnapshotS3Key?: Maybe<Scalars['String']>;
  sendToClient: Scalars['Boolean'];
  status: BillStatus;
  trustBalance?: Maybe<Scalars['Float']>;
  type: BillType;
  updatedAt: Scalars['String'];
  writtenOffInterest?: Maybe<Scalars['Float']>;
  writtenOffPrincipal?: Maybe<Scalars['Float']>;
  writtenOffReason?: Maybe<Scalars['String']>;
};

export type BillAccessToken = {
  __typename?: 'BillAccessToken';
  amount: Scalars['Float'];
  bill: Bill;
  client?: Maybe<ExternalUser>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  token: Scalars['String'];
  updatedAt: Scalars['String'];
  viewedAt?: Maybe<Scalars['DateTime']>;
  writtenOffInterest?: Maybe<Scalars['Float']>;
  writtenOffPrincipal?: Maybe<Scalars['Float']>;
};

/** Bulk Actions for Bills */
export enum BillBulkAction {
  ApproveBills = 'APPROVE_BILLS',
  SendBillsToAttorney = 'SEND_BILLS_TO_ATTORNEY',
  SendBillsToClient = 'SEND_BILLS_TO_CLIENT',
  SendReminderToClients = 'SEND_REMINDER_TO_CLIENTS',
  VoidBills = 'VOID_BILLS'
}

export type BillBulkInput = {
  allBills?: InputMaybe<Scalars['Boolean']>;
  billIds?: InputMaybe<Array<Scalars['Float']>>;
  bulkActionType: BillBulkAction;
};

export type BillCopy = {
  __typename?: 'BillCopy';
  /** ISO timestamp when this copy was generated */
  generatedAt?: Maybe<Scalars['String']>;
  /** Id of the user who generated this copy (null for system/finalization) */
  generatedBy?: Maybe<Scalars['String']>;
  /** Display name of the user who generated this copy */
  generatedByName?: Maybe<Scalars['String']>;
  /** One of 'finalization' | 'regenerated' */
  source?: Maybe<Scalars['String']>;
};

/** Available methods for delivering bills */
export enum BillDeliveryMethod {
  Email = 'EMAIL',
  Paper = 'PAPER',
  Text = 'TEXT'
}

export type BillEmailBatch = {
  __typename?: 'BillEmailBatch';
  billingCycle: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  items?: Maybe<Array<BillEmailBatchItem>>;
  periodMonth: Scalars['Int'];
  periodYear: Scalars['Int'];
  status: BillEmailBatchStatus;
  updatedAt: Scalars['String'];
};

export type BillEmailBatchItem = {
  __typename?: 'BillEmailBatchItem';
  batch: BillEmailBatch;
  bill: Bill;
  billViewedAt?: Maybe<Scalars['DateTime']>;
  caseToExternalUserRoleId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  recipientClientNumber?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  responsibleAttorney?: Maybe<Scalars['String']>;
  sendGridMessageId?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status: BillEmailBatchItemStatus;
  type: BillEmailBatchItemType;
  updatedAt: Scalars['String'];
};

export type BillEmailBatchItemStats = {
  __typename?: 'BillEmailBatchItemStats';
  /** Pending items whose bill was already emailed from the bill page; Send marks them sent, no email */
  alreadySent: Scalars['Int'];
  /** Pending items on pre-bills still awaiting attorney approval */
  awaitingApproval: Scalars['Int'];
  /** FAILED + BOUNCED */
  failed: Scalars['Int'];
  /** Pending items on bills in a status that is never emailed, e.g. written off */
  notSendable: Scalars['Int'];
  pending: Scalars['Int'];
  /** SENT + DELIVERED */
  sent: Scalars['Int'];
  total: Scalars['Int'];
  /** Pending items Send will email */
  willSend: Scalars['Int'];
};

export enum BillEmailBatchItemStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  Excluded = 'EXCLUDED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum BillEmailBatchItemType {
  Email = 'EMAIL',
  Paper = 'PAPER'
}

export enum BillEmailBatchStatus {
  Completed = 'COMPLETED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Sending = 'SENDING'
}

/** Case bill generation limit type */
export enum BillGenerationType {
  Amount = 'AMOUNT',
  Hours = 'HOURS'
}

export type BillInterestInput = {
  billId: Scalars['Float'];
  clientId: Scalars['String'];
  token: Scalars['String'];
};

export type BillInterestPayload = {
  __typename?: 'BillInterestPayload';
  interestAccrued: Scalars['Float'];
  interestDue: Scalars['Float'];
  rate: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type BillItem = {
  __typename?: 'BillItem';
  amount?: Maybe<Scalars['Float']>;
  bill: Bill;
  createdAt: Scalars['String'];
  entry: Entry;
  id: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BillItemTemplate = {
  __typename?: 'BillItemTemplate';
  amount: Scalars['Float'];
  attorneyName: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  entryType: Scalars['String'];
  qty: Scalars['Float'];
  rate: Scalars['Float'];
};

export type BillPaymentsInput = {
  billId?: InputMaybe<Scalars['Float']>;
  caseId?: InputMaybe<Scalars['String']>;
  onlyRefunds?: InputMaybe<Scalars['Boolean']>;
};

export type BillPaymentsPayload = {
  __typename?: 'BillPaymentsPayload';
  payments: Array<Payment>;
  response?: Maybe<ResponsePayload>;
};

export type BillSnapshotDownloadPayload = {
  __typename?: 'BillSnapshotDownloadPayload';
  /** Pre-signed URL to download the bill snapshot PDF */
  preSignedUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

/** Billing lifecycle */
export enum BillStatus {
  ApprovedByResponsibleAttorney = 'APPROVED_BY_RESPONSIBLE_ATTORNEY',
  Archived = 'ARCHIVED',
  Billed = 'BILLED',
  Draft = 'DRAFT',
  Forwarded = 'FORWARDED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PrePaid = 'PRE_PAID',
  SentForApproval = 'SENT_FOR_APPROVAL',
  SentToClient = 'SENT_TO_CLIENT',
  Void = 'VOID',
  WrittenOff = 'WRITTEN_OFF'
}

export type BillTimeline = {
  __typename?: 'BillTimeline';
  action: BillTimelineAction;
  bill: Bill;
  createdAt: Scalars['String'];
  deliveryMetadata?: Maybe<DeliveryMetadata>;
  description: Scalars['String'];
  id: Scalars['String'];
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Metadata>;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
};

/** Action performed on the bill */
export enum BillTimelineAction {
  AppliedInterest = 'APPLIED_INTEREST',
  BillAccountantEmailSent = 'BILL_ACCOUNTANT_EMAIL_SENT',
  BillApprovalEmailSentToDepartment = 'BILL_APPROVAL_EMAIL_SENT_TO_DEPARTMENT',
  BillApprovalEmailSentToResponsibleAttorney = 'BILL_APPROVAL_EMAIL_SENT_TO_RESPONSIBLE_ATTORNEY',
  BillApproved = 'BILL_APPROVED',
  BillApprovedByAttorney = 'BILL_APPROVED_BY_ATTORNEY',
  BillApprovedByDepartmentHead = 'BILL_APPROVED_BY_DEPARTMENT_HEAD',
  BillArchived = 'BILL_ARCHIVED',
  BillCarryForward = 'BILL_CARRY_FORWARD',
  BillClientFundsApplied = 'BILL_CLIENT_FUNDS_APPLIED',
  BillCreated = 'BILL_CREATED',
  BillCreditsApplied = 'BILL_CREDITS_APPLIED',
  BillDepartmentApprovalSkipped = 'BILL_DEPARTMENT_APPROVAL_SKIPPED',
  BillDiscountUpdated = 'BILL_DISCOUNT_UPDATED',
  BillDueDateUpdated = 'BILL_DUE_DATE_UPDATED',
  BillFinalized = 'BILL_FINALIZED',
  BillInvoiceEmailSentToClient = 'BILL_INVOICE_EMAIL_SENT_TO_CLIENT',
  BillInvoiceEmailSentToExecutives = 'BILL_INVOICE_EMAIL_SENT_TO_EXECUTIVES',
  BillInvoiceTextSentToClient = 'BILL_INVOICE_TEXT_SENT_TO_CLIENT',
  BillIsInDraft = 'BILL_IS_IN_DRAFT',
  BillMarkedAsDelivered = 'BILL_MARKED_AS_DELIVERED',
  BillPaid = 'BILL_PAID',
  BillPartiallyPaid = 'BILL_PARTIALLY_PAID',
  BillPaymentReceived = 'BILL_PAYMENT_RECEIVED',
  BillPaymentReversed = 'BILL_PAYMENT_REVERSED',
  BillPdfSnapshotGenerated = 'BILL_PDF_SNAPSHOT_GENERATED',
  BillRefundInitiated = 'BILL_REFUND_INITIATED',
  BillStatusUpdated = 'BILL_STATUS_UPDATED',
  BillViewedByClient = 'BILL_VIEWED_BY_CLIENT',
  BillVoided = 'BILL_VOIDED',
  BillWrittenOff = 'BILL_WRITTEN_OFF',
  ClientBillCopyGenerated = 'CLIENT_BILL_COPY_GENERATED',
  CreatedPrePaidBill = 'CREATED_PRE_PAID_BILL',
  FailedToSendBillInvoiceToClient = 'FAILED_TO_SEND_BILL_INVOICE_TO_CLIENT',
  FailedToSendReminderToClient = 'FAILED_TO_SEND_REMINDER_TO_CLIENT',
  FundRequestCreated = 'FUND_REQUEST_CREATED',
  InterestEntriesDeleted = 'INTEREST_ENTRIES_DELETED',
  MigratedBillFromAdvantage = 'MIGRATED_BILL_FROM_ADVANTAGE',
  MigratedInterestFromAdvantage = 'MIGRATED_INTEREST_FROM_ADVANTAGE',
  MigratedPaymentFromAdvantage = 'MIGRATED_PAYMENT_FROM_ADVANTAGE',
  MigratedWriteOffFromAdvantage = 'MIGRATED_WRITE_OFF_FROM_ADVANTAGE',
  PayableVoidCreditDeleted = 'PAYABLE_VOID_CREDIT_DELETED',
  PayableVoidExpenseRemoved = 'PAYABLE_VOID_EXPENSE_REMOVED',
  PayableVoidSettlementApplied = 'PAYABLE_VOID_SETTLEMENT_APPLIED',
  ReminderEmailSentToClient = 'REMINDER_EMAIL_SENT_TO_CLIENT',
  ReminderTextSentToClient = 'REMINDER_TEXT_SENT_TO_CLIENT',
  SendingBillInvoiceToClient = 'SENDING_BILL_INVOICE_TO_CLIENT',
  SendingReminderToClient = 'SENDING_REMINDER_TO_CLIENT',
  SwitchedInterestRateBecauseOfMissingPayment = 'SWITCHED_INTEREST_RATE_BECAUSE_OF_MISSING_PAYMENT'
}

/** Bill type */
export enum BillType {
  Bill = 'BILL',
  Fund = 'FUND'
}

export type BillableCaseDetail = {
  __typename?: 'BillableCaseDetail';
  billingType: BillingType;
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  consultMatterNumber?: Maybe<Scalars['String']>;
  discount: Scalars['Float'];
  discountPercentage?: Maybe<Scalars['Float']>;
  entries: Array<BillableEntry>;
  payoffAmount?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  totalAmount: Scalars['Float'];
  totalUnbilledHours: Scalars['Float'];
};

export type BillableCasesByType = {
  __typename?: 'BillableCasesByType';
  consult?: Maybe<Array<BillableCaseDetail>>;
  contingency?: Maybe<Array<BillableCaseDetail>>;
  contingencyHybrid?: Maybe<Array<BillableCaseDetail>>;
  flatFee?: Maybe<Array<BillableCaseDetail>>;
  hourly?: Maybe<Array<BillableCaseDetail>>;
  hybrid?: Maybe<Array<BillableCaseDetail>>;
  proBono?: Maybe<Array<BillableCaseDetail>>;
};

export type BillableCasesPayload = {
  __typename?: 'BillableCasesPayload';
  cases: BillableCasesByType;
  response?: Maybe<ResponsePayload>;
};

export type BillableEntry = {
  __typename?: 'BillableEntry';
  amount: Scalars['Float'];
  id: Scalars['String'];
  type: EntryType;
};

/** Case payment plan billing cycle */
export enum BillingCycle {
  CustomDate = 'CUSTOM_DATE',
  EndOfMonth = 'END_OF_MONTH',
  MidOfMonth = 'MID_OF_MONTH'
}

export type BillingSummary = {
  __typename?: 'BillingSummary';
  advArBalance?: Maybe<Scalars['Float']>;
  arBalance?: Maybe<Scalars['Float']>;
  lastBillDate?: Maybe<Scalars['DateTime']>;
  lastPaymentAmount?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  paidToDate?: Maybe<Scalars['Float']>;
  totalRefunds?: Maybe<Scalars['Float']>;
};

/** Case billing type */
export enum BillingType {
  Consult = 'CONSULT',
  Contingency = 'CONTINGENCY',
  ContingencyHybrid = 'CONTINGENCY_HYBRID',
  FlatFee = 'FLAT_FEE',
  Hourly = 'HOURLY',
  Hybrid = 'HYBRID',
  ProBono = 'PRO_BONO'
}

export type BulkActionPayload = {
  __typename?: 'BulkActionPayload';
  response: ResponsePayload;
  results: Array<BulkActionResult>;
};

export type BulkActionResult = {
  __typename?: 'BulkActionResult';
  billId: Scalars['Float'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CardData = {
  __typename?: 'CardData';
  cardNumber: Scalars['String'];
  customerFirstName?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  expDate?: Maybe<Scalars['String']>;
};

export type CardDataInput = {
  cardNumber: Scalars['String'];
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  expDate?: InputMaybe<Scalars['String']>;
};

export type CarriableVoidedBill = {
  __typename?: 'CarriableVoidedBill';
  accruedInterest: Scalars['Float'];
  billId: Scalars['Float'];
  fromDate?: Maybe<Scalars['DateTime']>;
  toDate?: Maybe<Scalars['DateTime']>;
  voidedAt?: Maybe<Scalars['DateTime']>;
};

export type CarriableVoidedBillsPayload = {
  __typename?: 'CarriableVoidedBillsPayload';
  bills: Array<CarriableVoidedBill>;
  response?: Maybe<ResponsePayload>;
};

export type Case = {
  __typename?: 'Case';
  accidentDate?: Maybe<Scalars['String']>;
  accountsPayableLineItems?: Maybe<Array<AccountsPayableLineItem>>;
  advCaseNumber?: Maybe<Scalars['String']>;
  advantageCode?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  billing?: Maybe<CaseBilling>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  caseEvents?: Maybe<Array<Maybe<CaseEvent>>>;
  caseHistories?: Maybe<Array<Maybe<CaseHistory>>>;
  caseLegalFeeReceiveds?: Maybe<Array<Maybe<CaseLegalFeeReceived>>>;
  caseNumber?: Maybe<Scalars['String']>;
  caseReferences?: Maybe<Array<Maybe<CaseReference>>>;
  caseToExternalUserToExternalUserRole?: Maybe<Array<CaseToExternalUserToExternalUserRole>>;
  caseToUsers?: Maybe<Array<Maybe<CaseToUser>>>;
  caseType?: Maybe<CaseType>;
  caseTypeId: Scalars['String'];
  ccEmailBillsTo?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  completedDate?: Maybe<Scalars['String']>;
  consultAttorney?: Maybe<User>;
  consultMatterNumber?: Maybe<Scalars['String']>;
  convertedToNormalMatter?: Maybe<Scalars['String']>;
  convertedToNormalMatterBy?: Maybe<User>;
  court?: Maybe<Court>;
  courtId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  docketNo?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isConsultMatter?: Maybe<Scalars['Boolean']>;
  /** Whether the matter carries unpaid debt older than the firm's grace period and still owes money on balance. Same rule as the Delinquent Bills print job and the Final Bills delinquent filter. */
  isDelinquent?: Maybe<Scalars['Boolean']>;
  isInternalMatter?: Maybe<Scalars['Boolean']>;
  journalEntries?: Maybe<Array<Maybe<JournalEntry>>>;
  location?: Maybe<Office>;
  notes?: Maybe<Array<Note>>;
  openDate?: Maybe<Scalars['String']>;
  openedBy?: Maybe<User>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  profitCenter?: Maybe<Office>;
  setting?: Maybe<CaseSetting>;
  status: CaseStatus;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  userCasesTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
};

export type CaseBilling = {
  __typename?: 'CaseBilling';
  advArBalance?: Maybe<Scalars['Float']>;
  advBillCosts?: Maybe<Scalars['Float']>;
  advBillFees?: Maybe<Scalars['Float']>;
  advBillHours?: Maybe<Scalars['Float']>;
  advContractBalance?: Maybe<Scalars['Float']>;
  advLastBillDate?: Maybe<Scalars['DateTime']>;
  advLastPayDate?: Maybe<Scalars['DateTime']>;
  advLastPaymentamount?: Maybe<Scalars['Float']>;
  advPaidToDate?: Maybe<Scalars['Float']>;
  advTotalContractFee?: Maybe<Scalars['Float']>;
  advUnbillCredits?: Maybe<Scalars['Float']>;
  billApprover?: Maybe<User>;
  billEntireFlatFeeUpfront?: Maybe<Scalars['Boolean']>;
  billGenerationAmount?: Maybe<Scalars['Float']>;
  billGenerationHours?: Maybe<Scalars['Float']>;
  billGenerationLimitEnabled?: Maybe<Scalars['Boolean']>;
  billGenerationType?: Maybe<BillGenerationType>;
  billingCycle?: Maybe<BillingCycle>;
  billingCycleCustomDate?: Maybe<Scalars['Float']>;
  billingType: BillingType;
  consultationFee?: Maybe<Scalars['Float']>;
  contingencySettlementAmount?: Maybe<Scalars['Float']>;
  contingencyShare?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  discountAmount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  discountType?: Maybe<DiscountType>;
  flatFee?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  increaseInterestRateOnFirstLatePayment?: Maybe<Scalars['Boolean']>;
  interestRates?: Maybe<Array<InterestRate>>;
  isFlatFeeHoursExhausted?: Maybe<Scalars['Boolean']>;
  minimumFundsThreshold?: Maybe<Scalars['Float']>;
  monthlyFlatFee?: Maybe<Scalars['Float']>;
  pauseBillingUntil?: Maybe<Scalars['DateTime']>;
  paymentPlanStartDate?: Maybe<Scalars['DateTime']>;
  retainerAccount?: Maybe<Account>;
  retainerAmount?: Maybe<Scalars['Float']>;
  skipDeptHeadApproval?: Maybe<Scalars['Boolean']>;
  specialPayments?: Maybe<Array<SpecialPayment>>;
  splitBillEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['String'];
  upfrontFlatFee?: Maybe<Scalars['Float']>;
  writeOffInterest?: Maybe<Scalars['Boolean']>;
};

export type CaseChartsFinancialSummary = {
  __typename?: 'CaseChartsFinancialSummary';
  expenses: Scalars['Float'];
  interestIncome: Scalars['Float'];
  investigatorTime: Scalars['Float'];
  moneyInTrust: Scalars['Float'];
  paidToDate: Scalars['Float'];
  writtenOff: Scalars['Float'];
};

export enum CaseChartsHoursRole {
  Attorney = 'ATTORNEY',
  Investigator = 'INVESTIGATOR',
  Other = 'OTHER',
  Paralegal = 'PARALEGAL'
}

export type CaseChartsHoursSummary = {
  __typename?: 'CaseChartsHoursSummary';
  accommodated: Scalars['Float'];
  billed: Scalars['Float'];
  byPerson: Array<CaseChartsPersonHours>;
  onPreBill: Scalars['Float'];
  total: Scalars['Float'];
  unbilled: Scalars['Float'];
  wip: Scalars['Float'];
};

export type CaseChartsPersonHours = {
  __typename?: 'CaseChartsPersonHours';
  accommodated: Scalars['Float'];
  billed: Scalars['Float'];
  legalTeamPosition?: Maybe<UserType>;
  name: Scalars['String'];
  onPreBill: Scalars['Float'];
  role: CaseChartsHoursRole;
  total: Scalars['Float'];
  unbilled: Scalars['Float'];
  userId?: Maybe<Scalars['String']>;
  wip: Scalars['Float'];
};

export type CaseChartsSummaryPayload = {
  __typename?: 'CaseChartsSummaryPayload';
  arBalance?: Maybe<Scalars['Float']>;
  financialSummary: CaseChartsFinancialSummary;
  flatFeeSummary?: Maybe<FlatFeeSummary>;
  hoursSummary?: Maybe<CaseChartsHoursSummary>;
  response?: Maybe<ResponsePayload>;
};

export type CaseEntriesByFeeTypesInput = {
  caseId: Scalars['String'];
  feeTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type CaseEntriesByFeeTypesPayload = {
  __typename?: 'CaseEntriesByFeeTypesPayload';
  entries?: Maybe<Array<Maybe<Entry>>>;
  response?: Maybe<ResponsePayload>;
};

export type CaseEvent = {
  __typename?: 'CaseEvent';
  createdAt: Scalars['String'];
  eventType: EventType;
  hearingAt?: Maybe<Scalars['String']>;
  hearingEndsAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  litigation?: Maybe<Case>;
  nextHearingAt?: Maybe<Scalars['String']>;
  nextHearingAtTime?: Maybe<Scalars['String']>;
  outlookEventId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type CaseEventInput = {
  id: Scalars['String'];
};

export type CaseEventPayload = {
  __typename?: 'CaseEventPayload';
  caseEvent?: Maybe<CaseEvent>;
  response?: Maybe<ResponsePayload>;
};

export type CaseEventsByCaseInput = {
  caseId: Scalars['String'];
};

export type CaseEventsPayload = {
  __typename?: 'CaseEventsPayload';
  caseEvents?: Maybe<Array<Maybe<CaseEvent>>>;
  response?: Maybe<ResponsePayload>;
};

export type CaseFinancialTimelinePayload = {
  __typename?: 'CaseFinancialTimelinePayload';
  events: Array<FinancialTimelineEvent>;
  response?: Maybe<ResponsePayload>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CaseFinancialsPayload = {
  __typename?: 'CaseFinancialsPayload';
  billingSummary?: Maybe<BillingSummary>;
  costEntriesSummary: EntriesSummary;
  costSummary?: Maybe<CostSummary>;
  expensesSummary: EntriesSummary;
  flatFeeSummary?: Maybe<FlatFeeSummary>;
  legalFeeSummary: EntriesSummary;
  response?: Maybe<ResponsePayload>;
  timeEntriesSummary: EntriesSummary;
};

export type CaseHistory = {
  __typename?: 'CaseHistory';
  attributeName: AttributeName;
  changeApprover: User;
  changeRequestor: User;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  litigation?: Maybe<Case>;
  newValue: Scalars['String'];
  oldValue: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CaseInput = {
  id: Scalars['String'];
};

export type CaseLegalFeeReceived = {
  __typename?: 'CaseLegalFeeReceived';
  bill?: Maybe<Bill>;
  billId?: Maybe<Scalars['Float']>;
  case: Case;
  caseId: Scalars['String'];
  createdAt: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['String'];
  legalFee: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type CaseLegalTeamInput = {
  hourlyRate?: InputMaybe<Scalars['Float']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type CaseNextBillingDatePayload = {
  __typename?: 'CaseNextBillingDatePayload';
  date: Scalars['DateTime'];
  response?: Maybe<ResponsePayload>;
};

export type CasePartyInput = {
  billDeliveryMethods?: InputMaybe<Array<BillDeliveryMethod>>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']>;
  externalUserCaseRole: ExternalUserCaseRole;
  splitBillShare?: InputMaybe<Scalars['Float']>;
  userId: Scalars['String'];
  userRoleId: Scalars['String'];
};

export type CasePayload = {
  __typename?: 'CasePayload';
  case?: Maybe<Case>;
  response?: Maybe<ResponsePayload>;
};

export type CaseReference = {
  __typename?: 'CaseReference';
  case: Case;
  caseId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  percentage?: Maybe<Scalars['Float']>;
  reference: Reference;
  referenceId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type CaseSetting = {
  __typename?: 'CaseSetting';
  createdAt?: Maybe<Scalars['String']>;
  flatFeeHoursNotificationThreshold?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  sendFlatFeeHoursExhaustedNotification?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Case lifecycle */
export enum CaseStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED'
}

export type CaseToExternalUserToExternalUserRole = {
  __typename?: 'CaseToExternalUserToExternalUserRole';
  billDeliveryMethods?: Maybe<Array<BillDeliveryMethod>>;
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingPhoneNumber?: Maybe<Scalars['String']>;
  caseRole?: Maybe<ExternalUserCaseRole>;
  createdAt: Scalars['String'];
  creditBalance?: Maybe<Scalars['Float']>;
  externalUserToExternalUserRole: ExternalUserToExternalUserRole;
  externalUserToExternalUserRoleId: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  isArchivedAt?: Maybe<Scalars['String']>;
  litigation?: Maybe<Case>;
  litigationId: Scalars['String'];
  settlementCheck?: Maybe<SettlementCheck>;
  splitBillShare?: Maybe<Scalars['Float']>;
  trustBalance?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
};

export type CaseToUser = {
  __typename?: 'CaseToUser';
  caseId: Scalars['String'];
  createdAt: Scalars['String'];
  hourlyRate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  litigation?: Maybe<Case>;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['String'];
  userType: UserType;
};

export type CaseType = {
  __typename?: 'CaseType';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  lawType?: Maybe<LawType>;
  lawTypeId: Scalars['String'];
  litigations?: Maybe<Array<Maybe<Case>>>;
  name: Scalars['String'];
  totalCaseCount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
};

export type CaseTypeInput = {
  id: Scalars['String'];
};

export type CaseTypePayload = {
  __typename?: 'CaseTypePayload';
  caseType?: Maybe<CaseType>;
  response?: Maybe<ResponsePayload>;
};

export type CaseTypesInput = {
  lawTypeId: Scalars['String'];
};

export type CaseTypesPayload = {
  __typename?: 'CaseTypesPayload';
  caseTypes?: Maybe<Array<Maybe<CaseType>>>;
  response?: Maybe<ResponsePayload>;
};

export type CaseWithLowTrustBalancePayload = {
  __typename?: 'CaseWithLowTrustBalancePayload';
  amountToBill: Scalars['Float'];
  caseNumber: Scalars['String'];
  id: Scalars['String'];
  minimumFundsThreshold: Scalars['Float'];
  retainerAmount: Scalars['Float'];
  title: Scalars['String'];
  totalTrustBalance: Scalars['Float'];
};

export type CasesInput = {
  billingType?: InputMaybe<BillingType>;
  caseTypeId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  courtId?: InputMaybe<Scalars['String']>;
  /** YYYY-MM-DD HH:MM */
  endDate?: InputMaybe<Scalars['String']>;
  /** YYYY-MM-DD HH:MM */
  from?: InputMaybe<Scalars['String']>;
  isConsultCase?: InputMaybe<Scalars['Boolean']>;
  isWorkCompleted?: InputMaybe<Scalars['Boolean']>;
  lawTypeId?: InputMaybe<Scalars['String']>;
  officeName?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderCaseBy>;
  orderByDirection?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  searchValue?: InputMaybe<Scalars['String']>;
  /** YYYY-MM-DD HH:MM */
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CaseStatus>;
  /** YYYY-MM-DD HH:MM */
  to?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CasesLightInput = {
  billingType?: InputMaybe<BillingType>;
  clientId?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  /** YYYY-MM-DD HH:MM */
  from?: InputMaybe<Scalars['String']>;
  isConsultCase?: InputMaybe<Scalars['Boolean']>;
  isWorkCompleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderCaseBy>;
  orderByDirection?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  searchValue?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CaseStatus>;
  /** YYYY-MM-DD HH:MM */
  to?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CasesPayload = {
  __typename?: 'CasesPayload';
  cases?: Maybe<Array<Maybe<Case>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type CasesWithLowTrustBalanceInput = {
  attorneyId?: InputMaybe<Scalars['String']>;
  caseId?: InputMaybe<Scalars['String']>;
};

export type CasesWithLowTrustBalancePayload = {
  __typename?: 'CasesWithLowTrustBalancePayload';
  cases: Array<CaseWithLowTrustBalancePayload>;
  response?: Maybe<ResponsePayload>;
};

export type CategoriesBalancesPayload = {
  __typename?: 'CategoriesBalancesPayload';
  asset: Scalars['Float'];
  equity: Scalars['Float'];
  expense: Scalars['Float'];
  liability: Scalars['Float'];
  revenue: Scalars['Float'];
};

export type CategoriesPayload = {
  __typename?: 'CategoriesPayload';
  categories?: Maybe<Array<Maybe<Category>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CategoryPayload = {
  __typename?: 'CategoryPayload';
  category?: Maybe<Category>;
  response?: Maybe<ResponsePayload>;
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type CheckAssignmentConflict = {
  __typename?: 'CheckAssignmentConflict';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  source: CheckConflictSource;
  state?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
  voucherNo?: Maybe<Scalars['String']>;
};

/** Why a payable in a check run cannot be printed on the leaf its position names */
export enum CheckAssignmentIssue {
  AlreadyAssigned = 'ALREADY_ASSIGNED',
  MissingNumber = 'MISSING_NUMBER',
  None = 'NONE',
  NotACheck = 'NOT_A_CHECK',
  NumberTaken = 'NUMBER_TAKEN',
  Voided = 'VOIDED',
  VoucherNotFound = 'VOUCHER_NOT_FOUND',
  WrongBank = 'WRONG_BANK'
}

export type CheckAssignmentPlanPayload = {
  __typename?: 'CheckAssignmentPlanPayload';
  canPrint: Scalars['Boolean'];
  firstCheckNo?: Maybe<Scalars['String']>;
  lastCheckNo?: Maybe<Scalars['String']>;
  nextAvailableCheckNo?: Maybe<Scalars['String']>;
  printableCount: Scalars['Int'];
  response?: Maybe<ResponsePayload>;
  rows: Array<CheckAssignmentRow>;
  suggestion?: Maybe<Scalars['String']>;
};

export type CheckAssignmentRow = {
  __typename?: 'CheckAssignmentRow';
  amount: Scalars['Float'];
  checkNo?: Maybe<Scalars['String']>;
  conflict?: Maybe<CheckAssignmentConflict>;
  existingCheckNo?: Maybe<Scalars['String']>;
  issue: CheckAssignmentIssue;
  issueMessage?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  printedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PayableStatus>;
  vendorName?: Maybe<Scalars['String']>;
  voucherNo: Scalars['String'];
};

/** What kind of record already holds a check number */
export enum CheckConflictSource {
  Payable = 'PAYABLE',
  Payment = 'PAYMENT'
}

export type CheckConflictsInput = {
  addresses?: InputMaybe<Array<CreateAddressForExtUserInput>>;
  alienId?: InputMaybe<Scalars['String']>;
  arrearsBalance?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  contractBalance?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalUserRoleId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  homePhone?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  isConsultClient?: InputMaybe<Scalars['Boolean']>;
  isInternational?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastPayAmount?: InputMaybe<Scalars['String']>;
  lastPayDate?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  pagination: PaginationInput;
  personalPhone?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberExtension?: InputMaybe<Scalars['String']>;
  residualBalance?: InputMaybe<Scalars['String']>;
  searchStyle: ConflictSearchStyle;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalUserStatus>;
  suffix?: InputMaybe<Scalars['String']>;
  trustBalance?: InputMaybe<Scalars['String']>;
};

export type ClearReconciliationSessionInput = {
  sessionId: Scalars['Int'];
  version: Scalars['Int'];
};

export type ClientAddressTemplate = {
  __typename?: 'ClientAddressTemplate';
  label1: Scalars['String'];
  label2: Scalars['String'];
};

export type ClientLedgerMatter = {
  __typename?: 'ClientLedgerMatter';
  clientName?: Maybe<Scalars['String']>;
  clientNumber?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  matterNumber?: Maybe<Scalars['String']>;
  matterTitle?: Maybe<Scalars['String']>;
  responsibleAttorney?: Maybe<Scalars['String']>;
};

export type ClientLedgerPayload = {
  __typename?: 'ClientLedgerPayload';
  headers: Array<Scalars['String']>;
  matter?: Maybe<ClientLedgerMatter>;
  response?: Maybe<ResponsePayload>;
  rows: Array<Scalars['JSON']>;
};

export type ClientsInterest = {
  __typename?: 'ClientsInterest';
  clientId: Scalars['String'];
  interestAccrued: Scalars['Float'];
  interestDue: Scalars['Float'];
};

export type CloseAccountingPeriodInput = {
  accountId?: InputMaybe<Scalars['String']>;
  fiscalYear: Scalars['Int'];
  month: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
};

export type ConfirmMfaAuthEnrollmentInput = {
  code: Scalars['String'];
};

export type ConflictResponse = {
  __typename?: 'ConflictResponse';
  conflicts: Array<ExternalUsersConflict>;
  pagination?: Maybe<PaginationPayload>;
};

/** The search style */
export enum ConflictSearchStyle {
  Contains = 'CONTAINS',
  Exact = 'EXACT',
  StartsWith = 'STARTS_WITH'
}

export type ConsultCaseBillInput = {
  amount: Scalars['Float'];
  caseId: Scalars['String'];
};

export type ConsultCaseBillPayload = {
  __typename?: 'ConsultCaseBillPayload';
  billId: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type ContingencyFinalBillInput = {
  caseId: Scalars['String'];
  contingencyShare: Scalars['Float'];
  legalFee: Scalars['Float'];
  settlementAmount: Scalars['Float'];
};

export type ContingencyFinalBillPayload = {
  __typename?: 'ContingencyFinalBillPayload';
  billId: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type ContingencyFundRequestInput = {
  amount: Scalars['Float'];
  caseId: Scalars['String'];
  description: Scalars['String'];
  trustAccountId: Scalars['String'];
};

export type ContingencyFundRequestPayload = {
  __typename?: 'ContingencyFundRequestPayload';
  fundRequestId: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type CostSummary = {
  __typename?: 'CostSummary';
  costBilled: Scalars['Float'];
  costPaidToDate: Scalars['Float'];
  costUnpaid: Scalars['Float'];
};

export type Court = {
  __typename?: 'Court';
  addresses?: Maybe<Array<Maybe<Address>>>;
  chiefAdmin?: Maybe<Scalars['String']>;
  closeTime?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  courtCode?: Maybe<Scalars['String']>;
  courtToExternalUserToExternalUserRole?: Maybe<Array<Maybe<CourtToExternalUserToExternalUserRole>>>;
  createdAt: Scalars['String'];
  endDay?: Maybe<WeekDays>;
  id: Scalars['String'];
  litigations?: Maybe<Array<Maybe<Case>>>;
  municipality?: Maybe<Scalars['String']>;
  mvcCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  openTime?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  startDay?: Maybe<WeekDays>;
  totalCaseCount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
};

export type CourtDate = {
  __typename?: 'CourtDate';
  caseId: Scalars['String'];
  caseNumber?: Maybe<Scalars['String']>;
  caseStatus: CaseStatus;
  caseTitle?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  consultMatterNumber?: Maybe<Scalars['String']>;
  courtName?: Maybe<Scalars['String']>;
  /** Wall-clock start, ISO string in UTC */
  hearingAt: Scalars['String'];
  /** Wall-clock end, ISO string in UTC */
  hearingEndsAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isConsultMatter?: Maybe<Scalars['Boolean']>;
  responsibleAttorneyId?: Maybe<Scalars['String']>;
  responsibleAttorneyName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CourtDatesInput = {
  /** Last day of the range, YYYY-MM-DD (inclusive) */
  endDate: Scalars['String'];
  /** Resp 1 attorney; ignored for attorney-scoped users */
  responsibleAttorneyId?: InputMaybe<Scalars['String']>;
  /** First day of the range, YYYY-MM-DD (inclusive) */
  startDate: Scalars['String'];
};

export type CourtDatesPayload = {
  __typename?: 'CourtDatesPayload';
  courtDates: Array<CourtDate>;
  response?: Maybe<ResponsePayload>;
};

export type CourtPayload = {
  __typename?: 'CourtPayload';
  court?: Maybe<Court>;
  response?: Maybe<ResponsePayload>;
};

export type CourtToExternalUserToExternalUserRole = {
  __typename?: 'CourtToExternalUserToExternalUserRole';
  court?: Maybe<Court>;
  courtId: Scalars['String'];
  createdAt: Scalars['String'];
  externalUser?: Maybe<ExternalUser>;
  externalUserId: Scalars['String'];
  externalUserToExternalUserRole?: Maybe<ExternalUserToExternalUserRole>;
  externalUserToExternalUserRoleId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  isArchivedAt?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type CourtsInput = {
  paginationOptions: PaginationInput;
  searchValue?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CourtsPayload = {
  __typename?: 'CourtsPayload';
  courts?: Maybe<Array<Maybe<Court>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type CreateAccountInput = {
  accountNo?: InputMaybe<Scalars['String']>;
  category: AccountCategory;
  description?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<Scalars['String']>;
  isBankAccount: Scalars['Boolean'];
  name: Scalars['String'];
  openingBalance?: InputMaybe<Scalars['Float']>;
  parentAccountId?: InputMaybe<Scalars['String']>;
  routingNo?: InputMaybe<Scalars['String']>;
  sortCode: Scalars['String'];
  type: AccountType;
};

export type CreateAddressForExtUserInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  /** Provide only when adding a new address to existing externalUser */
  externalUserId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateAddressForOfficeInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateAddressForVendorInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateAttachmentInput = {
  description?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** enum type for module type - Upload Media */
  type: AttachmentType;
  typeId: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type CreateBillItemInput = {
  amount: Scalars['Float'];
  entryId: Scalars['String'];
};

export type CreateCarriedForwardInterestInput = {
  billId: Scalars['Float'];
  clientId: Scalars['String'];
  sourceBillIds: Array<Scalars['Float']>;
};

export type CreateCarriedForwardInterestPayload = {
  __typename?: 'CreateCarriedForwardInterestPayload';
  createdCount: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
  totalCarried: Scalars['Float'];
};

export type CreateCaseBillingInput = {
  advTotalContractFee?: InputMaybe<Scalars['Float']>;
  billApproverId?: InputMaybe<Scalars['String']>;
  billEntireFlatFeeUpfront?: InputMaybe<Scalars['Boolean']>;
  billGenerationAmount?: InputMaybe<Scalars['Float']>;
  billGenerationHours?: InputMaybe<Scalars['Float']>;
  billGenerationLimitEnabled?: InputMaybe<Scalars['Boolean']>;
  billGenerationType?: InputMaybe<BillGenerationType>;
  billingCycle?: InputMaybe<BillingCycle>;
  billingCycleCustomDate?: InputMaybe<Scalars['Float']>;
  billingType: BillingType;
  consultationFee?: InputMaybe<Scalars['Float']>;
  contingencySettlementAmount?: InputMaybe<Scalars['Float']>;
  contingencyShare?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  flatFee?: InputMaybe<Scalars['Float']>;
  increaseInterestRateOnFirstLatePayment?: InputMaybe<Scalars['Boolean']>;
  interestRates?: InputMaybe<Array<InterestRateInput>>;
  isFlatFeeHoursExhausted?: InputMaybe<Scalars['Boolean']>;
  minimumFundsThreshold?: InputMaybe<Scalars['Float']>;
  monthlyFlatFee?: InputMaybe<Scalars['Float']>;
  pauseBillingUntil?: InputMaybe<Scalars['DateTime']>;
  paymentPlanStartDate?: InputMaybe<Scalars['DateTime']>;
  retainerAccountId?: InputMaybe<Scalars['String']>;
  retainerAmount?: InputMaybe<Scalars['Float']>;
  skipDeptHeadApproval?: InputMaybe<Scalars['Boolean']>;
  specialPayments?: InputMaybe<Array<SpecialPaymentInput>>;
  splitBillEnabled?: InputMaybe<Scalars['Boolean']>;
  upfrontFlatFee?: InputMaybe<Scalars['Float']>;
  writeOffInterest?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCaseEventInput = {
  caseId: Scalars['String'];
  eventType: EventType;
  hearingAt?: InputMaybe<Scalars['String']>;
  hearingEndsAt?: InputMaybe<Scalars['String']>;
  nextHearingAt?: InputMaybe<Scalars['String']>;
  nextHearingAtTime?: InputMaybe<Scalars['String']>;
  outlookEventId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateCaseInput = {
  accidentDate?: InputMaybe<Scalars['String']>;
  advantageCode?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  billing: CreateCaseBillingInput;
  caseNumber?: InputMaybe<Scalars['String']>;
  caseParties: Array<CasePartyInput>;
  caseTypeId: Scalars['String'];
  ccEmailBillsTo?: InputMaybe<Scalars['String']>;
  closeDate?: InputMaybe<Scalars['String']>;
  completedDate?: InputMaybe<Scalars['String']>;
  consultAttorneyId?: InputMaybe<Scalars['String']>;
  consultMatterNumber?: InputMaybe<Scalars['String']>;
  courtId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  docketNo?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  isConsultMatter?: InputMaybe<Scalars['Boolean']>;
  isInternalMatter?: InputMaybe<Scalars['Boolean']>;
  judge?: InputMaybe<CreateExternalUser>;
  judgeUserId?: InputMaybe<Scalars['String']>;
  judgeUserRoleId?: InputMaybe<Scalars['String']>;
  legalTeam: Array<CaseLegalTeamInput>;
  locationId: Scalars['Float'];
  openDate?: InputMaybe<Scalars['String']>;
  openedBy?: InputMaybe<Scalars['String']>;
  profitCenterId: Scalars['Float'];
  references: Array<ReferenceInput>;
  setting?: InputMaybe<CreateCaseSettingInput>;
  status: CaseStatus;
  title: Scalars['String'];
  userType?: InputMaybe<UserType>;
};

export type CreateCaseSettingInput = {
  flatFeeHoursNotificationThreshold?: InputMaybe<Scalars['Float']>;
  sendFlatFeeHoursExhaustedNotification?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCaseTypeInput = {
  lawTypeId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateCourtInput = {
  addresses?: InputMaybe<Array<CreateAddressForExtUserInput>>;
  chiefAdmin?: InputMaybe<Scalars['String']>;
  closeTime?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  courtCode?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  externalUserRoleId?: InputMaybe<Scalars['String']>;
  municipality?: InputMaybe<Scalars['String']>;
  mvcCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openTime?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateDepartmentInput = {
  departmentHeadId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  lawTypeIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type CreateDocPageInput = {
  icon?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<DocPageScope>;
  title: Scalars['String'];
};

export type CreateExternalUser = {
  addresses?: InputMaybe<Array<CreateAddressForExtUserInput>>;
  alienId?: InputMaybe<Scalars['String']>;
  arrearsBalance?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  contractBalance?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalUserRoleId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  homePhone?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  isConsultClient?: InputMaybe<Scalars['Boolean']>;
  isInternational?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastPayAmount?: InputMaybe<Scalars['String']>;
  lastPayDate?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  personalPhone?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberExtension?: InputMaybe<Scalars['String']>;
  residualBalance?: InputMaybe<Scalars['String']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  status: ExternalUserStatus;
  suffix?: InputMaybe<Scalars['String']>;
  trustBalance?: InputMaybe<Scalars['String']>;
};

export type CreateFirmPaymentInput = {
  amount: Scalars['Float'];
  bankAccountId: Scalars['String'];
  caseId?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  glAccountId: Scalars['String'];
  officeId: Scalars['Float'];
  paymentMethod: PaymentMethod;
  referenceNumber?: InputMaybe<Scalars['String']>;
  slipNumber?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Float']>;
};

export type CreateFundRequestInput = {
  amount: Scalars['Float'];
  caseId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  sendToClient?: InputMaybe<Scalars['Boolean']>;
};

export type CreateFundRequestPayload = {
  __typename?: 'CreateFundRequestPayload';
  fundRequests: Array<Bill>;
  response?: Maybe<ResponsePayload>;
};

export type CreateJournalEntryLineItemInput = {
  accountId: Scalars['String'];
  advRefno?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  fromAdv?: InputMaybe<Scalars['Boolean']>;
  officeId?: InputMaybe<Scalars['Float']>;
  type: JournalEntryType;
};

export type CreateLawTypeInput = {
  name: Scalars['String'];
  syncWithOutlook: Scalars['Boolean'];
};

export type CreateManualEntryInput = {
  amount?: InputMaybe<Scalars['Float']>;
  billable: Scalars['Boolean'];
  caseId: Scalars['String'];
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<EntryType>;
  feeTypeId?: InputMaybe<Scalars['String']>;
  isSystemGenerated?: InputMaybe<Scalars['Boolean']>;
  payableId?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Float']>;
  rate: Scalars['Float'];
  rateType?: InputMaybe<EntryRateType>;
  sendNotesToMatterNotes?: InputMaybe<Scalars['Boolean']>;
  showOnBill: Scalars['Boolean'];
  status?: InputMaybe<EntryStatus>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserRole>;
};

export type CreateManualJournalEntriesInput = {
  journalEntry: CreateManualJournalEntryInput;
};

export type CreateManualJournalEntriesPayload = {
  __typename?: 'CreateManualJournalEntriesPayload';
  journalEntry: JournalEntry;
  response?: Maybe<ResponsePayload>;
};

export type CreateManualJournalEntryInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  fromAdv?: InputMaybe<Scalars['Boolean']>;
  isClosedYearAdjustment?: InputMaybe<Scalars['Boolean']>;
  lineItems: Array<CreateJournalEntryLineItemInput>;
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateNoteInput = {
  caseId: Scalars['String'];
  description: Scalars['String'];
  externalUserId?: InputMaybe<Scalars['String']>;
  noteTypeId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateOfficeInput = {
  addresses?: InputMaybe<Array<CreateAddressForOfficeInput>>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isLocationOpen: Scalars['Boolean'];
  name: Scalars['String'];
  officeNumber?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OfficeType>;
};

export type CreatePayableInput = {
  amount: Scalars['Float'];
  bankAccountId: Scalars['String'];
  checkOrAchNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  invoiceDate: Scalars['DateTime'];
  lineItems: Array<CreatePayableLineItemInput>;
  payDate: Scalars['DateTime'];
  paymentMethod: Scalars['String'];
  status: PayableStatus;
  vendorId: Scalars['Float'];
  voucherNo: Scalars['String'];
};

export type CreatePayableLineItemInput = {
  advRefno?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fromAdv?: InputMaybe<Scalars['Boolean']>;
  glAccountId: Scalars['String'];
  litigationId?: InputMaybe<Scalars['String']>;
  officeId: Scalars['Float'];
};

export type CreatePayableRefundInput = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  glAccountId: Scalars['String'];
  officeId?: InputMaybe<Scalars['Float']>;
  payableId: Scalars['String'];
  paymentMethod?: PaymentMethod;
  referenceNo?: InputMaybe<Scalars['String']>;
};

export type CreatePrintJobInput = {
  /** Optional: filter by attorney user IDs */
  attorneyIds?: InputMaybe<Array<Scalars['String']>>;
  /** UserType role to match the attorney against (e.g. responsibleAttorney1). "any" means any legal team role. Defaults to responsibleAttorney1. */
  attorneyRole?: InputMaybe<Scalars['String']>;
  /** Batch ID for PRINT_BATCH print job type */
  batchId?: InputMaybe<Scalars['Int']>;
  /** For CUSTOM type: explicit bill IDs */
  billIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Required for POTENTIAL_BILLS: which billing cycle to preview. Sets the entry cutoff exactly as real generation does. */
  billingCycle?: InputMaybe<BillingCycle>;
  /** For DELINQUENT_BILLS: which matter billing types to include (e.g. flatFee, hourly). Omit for no billing-type restriction, which is how the job behaved before this filter existed. */
  billingTypes?: InputMaybe<Array<BillingType>>;
  /** Case/matter ID for BY_MATTER print job type */
  caseId?: InputMaybe<Scalars['String']>;
  /** Required for POTENTIAL_BILLS when billingCycle is CUSTOM_DATE: the cutoff date (YYYY-MM-DD). */
  customDate?: InputMaybe<Scalars['String']>;
  /** For DELINQUENT_BILLS: which bill delivery methods to include. Omit for the Paper-only default that every other job type uses. Passing all three methods removes the delivery-method restriction entirely, so matters with no delivery method set are printed too. */
  deliveryMethods?: InputMaybe<Array<BillDeliveryMethod>>;
  /** For DELINQUENT_BILLS: also print the matter billing (proforma) notes, as pre-bills do. */
  includeProformaNotes?: InputMaybe<Scalars['Boolean']>;
  /** For POTENTIAL_BILLS: also include matters with no new billable work but an unpaid or open bill. The scheduled monthly run raises a $0 carry-forward bill for these; the attorney bulk run skips them. */
  includeZeroDollarBills?: InputMaybe<Scalars['Boolean']>;
  /** For DELINQUENT_BILLS: FULLY_UNPAID keeps only matters that have paid nothing at all against their aged bills; PARTIALLY_UNPAID keeps the rest that still owe. Omit (or pass both) for no restriction, which is how the job behaved before this filter existed. */
  paymentStatuses?: InputMaybe<Array<DelinquentPaymentStatus>>;
  printJobType: PrintJobType;
  /** Sort printed bills by attorney name or case number */
  sortBy?: InputMaybe<PrintJobSortBy>;
  /** Sort direction (default ASC) */
  sortDir?: InputMaybe<PrintJobSortDir>;
  /** For PRINT_BATCH / PRINT_BATCH_ALL: keep only the batch bills whose matter currently holds trust money (WITH_TRUST), only those whose matter holds none (WITHOUT_TRUST), or every bill (ALL / omitted). Uses the same trust test as the "Bills with Trust Money" checkbox on the bills list. */
  trustScope?: InputMaybe<PrintJobTrustScope>;
};

export type CreateReferenceInput = {
  active: Scalars['Boolean'];
  eligibleFor1099Report: Scalars['Boolean'];
  reference: Scalars['String'];
  sourceTypeId: Scalars['String'];
};

export type CreateReportInput = {
  groupName: Scalars['String'];
  selectionFields?: InputMaybe<Scalars['JSON']>;
  selectionName: Scalars['String'];
  sortFields?: InputMaybe<Array<ReportSortInput>>;
};

export type CreateTaskInput = {
  caseId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: TaskType;
};

export type CreateVendorInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<CreateAddressForVendorInput>>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  officeId?: InputMaybe<Scalars['Float']>;
  parentVendor?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  required1099: Scalars['Boolean'];
  separateCheckPerInvoice: Scalars['Boolean'];
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CreditBalanceClientPayload = {
  __typename?: 'CreditBalanceClientPayload';
  clientId: Scalars['String'];
  creditBalance: Scalars['Float'];
  name: Scalars['String'];
};

export type CreditBalanceSummaryPayload = {
  __typename?: 'CreditBalanceSummaryPayload';
  clients: Array<CreditBalanceClientPayload>;
  response?: Maybe<ResponsePayload>;
  totalCreditBalance: Scalars['Float'];
  voidedPayableCredit?: Maybe<Scalars['Float']>;
};

export type DateAndOfficeIds = {
  date: Scalars['DateTime'];
  officeId?: InputMaybe<Scalars['Float']>;
  slipNumber?: InputMaybe<Scalars['String']>;
};

export type DeleteCase = {
  id: Scalars['String'];
};

export type DeleteCaseEvent = {
  id: Scalars['String'];
};

export type DeleteCaseType = {
  id: Scalars['String'];
};

export type DeleteExternalUser = {
  id: Scalars['String'];
};

export type DeleteInterestEntriesInput = {
  billId: Scalars['Float'];
  clientId: Scalars['String'];
  fromDate: Scalars['String'];
  writeOffInterest?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteInterestEntriesPayload = {
  __typename?: 'DeleteInterestEntriesPayload';
  deletedCount: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type DeleteLawType = {
  id: Scalars['String'];
};

export type DeleteNote = {
  id: Scalars['String'];
};

export type DeleteTask = {
  id: Scalars['String'];
};

export type DeleteUserCaseTask = {
  id: Scalars['String'];
};

/** Whether a matter's aged bills have received no payment at all, or a partial payment */
export enum DelinquentPaymentStatus {
  FullyUnpaid = 'FULLY_UNPAID',
  PartiallyUnpaid = 'PARTIALLY_UNPAID'
}

export type DeliveryMetadata = {
  __typename?: 'DeliveryMetadata';
  content?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Department = {
  __typename?: 'Department';
  departmentHead?: Maybe<User>;
  departmentHeadId?: Maybe<Scalars['String']>;
  departmentToLawTypes?: Maybe<Array<DepartmentToLawType>>;
  departmentToUsers?: Maybe<Array<DepartmentToUsers>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DepartmentFilters = {
  lawTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type DepartmentHeadPayload = {
  __typename?: 'DepartmentHeadPayload';
  isDepartmentHead: Scalars['Boolean'];
  response?: Maybe<ResponsePayload>;
};

export type DepartmentPayload = {
  __typename?: 'DepartmentPayload';
  department?: Maybe<Department>;
  response?: Maybe<ResponsePayload>;
};

export type DepartmentToLawType = {
  __typename?: 'DepartmentToLawType';
  createdAt: Scalars['DateTime'];
  department: Department;
  departmentId: Scalars['String'];
  id: Scalars['String'];
  lawType: LawType;
  lawTypeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DepartmentToUsers = {
  __typename?: 'DepartmentToUsers';
  createdAt: Scalars['DateTime'];
  department: Department;
  departmentId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type DepartmentUser = {
  __typename?: 'DepartmentUser';
  activities?: Maybe<Array<ActivityTracking>>;
  approvedBills?: Maybe<Array<Bill>>;
  approvedBillsAsAttorney?: Maybe<Array<Bill>>;
  approvedCaseBillings?: Maybe<Array<Maybe<CaseBilling>>>;
  assignedTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
  billTimelines?: Maybe<Array<BillTimeline>>;
  caseApproverHistories?: Maybe<Array<Maybe<CaseHistory>>>;
  caseRequestorHistories?: Maybe<Array<Maybe<CaseHistory>>>;
  caseToUsers?: Maybe<Array<Maybe<CaseToUser>>>;
  createdAccountPayables?: Maybe<Array<AccountsPayable>>;
  createdAccounts?: Maybe<Array<Account>>;
  createdAt: Scalars['String'];
  createdBills?: Maybe<Array<Maybe<Bill>>>;
  createdPayableRefunds?: Maybe<Array<PayableRefund>>;
  createdPayments?: Maybe<Array<Payment>>;
  createdReports?: Maybe<Array<Report>>;
  deletedAccountPayables?: Maybe<Array<AccountsPayable>>;
  deletedAccountPayablesLineItems?: Maybe<Array<AccountsPayableLineItem>>;
  deletedEntries?: Maybe<Array<Entry>>;
  deletedJournalEntries?: Maybe<Array<JournalEntry>>;
  deletedJournalEntryLineItems?: Maybe<Array<JournalEntryLineItem>>;
  deletedPaymentAllocations?: Maybe<Array<PaymentAllocation>>;
  deletedPayments?: Maybe<Array<Payment>>;
  departmentHead?: Maybe<Scalars['Boolean']>;
  deptToUsers?: Maybe<Array<Maybe<DepartmentToUsers>>>;
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  initials?: Maybe<Scalars['String']>;
  journalEntries?: Maybe<Array<JournalEntry>>;
  lastName?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  mfaAuthEnabled?: Maybe<Scalars['Boolean']>;
  mfaEmailEnabled?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Array<Note>>;
  office?: Maybe<Office>;
  openedMatters?: Maybe<Array<Case>>;
  paralegals?: Maybe<Array<Maybe<User>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  reconciledPayments?: Maybe<Array<Payment>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  status: UserStatus;
  supervisingUsers?: Maybe<Array<Maybe<User>>>;
  updatedAt: Scalars['String'];
  userCasesTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
};

export type DepartmentUsersPayload = {
  __typename?: 'DepartmentUsersPayload';
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
  users: Array<DepartmentUser>;
};

export type DepartmentsPayload = {
  __typename?: 'DepartmentsPayload';
  departments?: Maybe<Array<Maybe<Department>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

/** Case discount type */
export enum DiscountType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DocMediaAsset = {
  __typename?: 'DocMediaAsset';
  createdAt: Scalars['DateTime'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  key: Scalars['String'];
  mediaType: DocMediaType;
  mimeType: Scalars['String'];
  pageId?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  uploadedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']>;
};

export enum DocMediaType {
  File = 'FILE',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Video = 'VIDEO'
}

export type DocPage = {
  __typename?: 'DocPage';
  children?: Maybe<Array<DocPage>>;
  content?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  draftContent?: Maybe<Scalars['JSONObject']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  parent?: Maybe<DocPage>;
  parentId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<User>;
  scope: DocPageScope;
  slug: Scalars['String'];
  sortOrder: Scalars['Int'];
  status: DocPageStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export type DocPagePayload = {
  __typename?: 'DocPagePayload';
  docPage?: Maybe<DocPage>;
  response?: Maybe<ResponsePayload>;
};

export type DocPageRevision = {
  __typename?: 'DocPageRevision';
  changeSummary?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  editor?: Maybe<User>;
  id: Scalars['String'];
  pageId: Scalars['String'];
  status: DocPageStatus;
  title: Scalars['String'];
};

export type DocPageRevisionsPayload = {
  __typename?: 'DocPageRevisionsPayload';
  response?: Maybe<ResponsePayload>;
  revisions?: Maybe<Array<Maybe<DocPageRevision>>>;
};

export enum DocPageScope {
  Org = 'ORG',
  Personal = 'PERSONAL'
}

export type DocPageSearchPayload = {
  __typename?: 'DocPageSearchPayload';
  limit: Scalars['Int'];
  page: Scalars['Int'];
  response?: Maybe<ResponsePayload>;
  results?: Maybe<Array<Maybe<DocPageSearchResult>>>;
  total: Scalars['Int'];
};

export type DocPageSearchResult = {
  __typename?: 'DocPageSearchResult';
  page: DocPage;
  snippet?: Maybe<Scalars['String']>;
  titleMatch: Scalars['Boolean'];
};

export enum DocPageStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type DocPagesPayload = {
  __typename?: 'DocPagesPayload';
  docPages?: Maybe<Array<Maybe<DocPage>>>;
  response?: Maybe<ResponsePayload>;
};

export type EntriesPayload = {
  __typename?: 'EntriesPayload';
  entries?: Maybe<Array<Maybe<Entry>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type EntriesSummary = {
  __typename?: 'EntriesSummary';
  amount: Scalars['Float'];
  time: Scalars['Float'];
};

export type Entry = {
  __typename?: 'Entry';
  advInvoiceNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  billItems?: Maybe<Array<BillItem>>;
  billable: Scalars['Boolean'];
  case?: Maybe<Case>;
  caseId: Scalars['String'];
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  entryType?: Maybe<EntryType>;
  feeType?: Maybe<FeeType>;
  feeTypeId?: Maybe<Scalars['String']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isSystemGenerated?: Maybe<Scalars['Boolean']>;
  isTimerPaused?: Maybe<Scalars['Boolean']>;
  pauseTime?: Maybe<Scalars['DateTime']>;
  payable?: Maybe<AccountsPayable>;
  qty?: Maybe<Scalars['Float']>;
  rate: Scalars['Float'];
  rateType?: Maybe<EntryRateType>;
  sendNotesToMatterNotes?: Maybe<Scalars['Boolean']>;
  showOnBill: Scalars['Boolean'];
  startTime?: Maybe<Scalars['DateTime']>;
  status: EntryStatus;
  totalPausedTime?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<UserRole>;
};

/** Sort entries by createdAt (most recent) or date (activity date) */
export enum EntryOrderBy {
  CreatedAt = 'CREATED_AT',
  Date = 'DATE'
}

/** Sort direction ASC or DESC */
export enum EntryOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type EntryPayload = {
  __typename?: 'EntryPayload';
  entry?: Maybe<Entry>;
  response?: Maybe<ResponsePayload>;
};

/** Where the entry rate came from (PROFILE, MATTER) */
export enum EntryRateType {
  Matter = 'MATTER',
  Profile = 'PROFILE'
}

/** The status of the entry (DRAFT, BILLED, UNBILLED) */
export enum EntryStatus {
  Billed = 'BILLED',
  Draft = 'DRAFT',
  Unbilled = 'UNBILLED'
}

/** The type of the entry (LEGAL, COST, EXPENSE) */
export enum EntryType {
  Cost = 'COST',
  Expense = 'EXPENSE',
  Legal = 'LEGAL',
  NonClient = 'NON_CLIENT',
  Time = 'TIME'
}

export type EntryTypeSummary = {
  __typename?: 'EntryTypeSummary';
  /** Number of entries */
  entryCount: Scalars['Int'];
  /** Entry type */
  entryType: EntryType;
  /** Total amount billed */
  totalAmountBilled: Scalars['Float'];
  /** Total amount logged */
  totalAmountLogged: Scalars['Float'];
  /** Total duration billed in hours */
  totalDurationBilled?: Maybe<Scalars['Float']>;
  /** Total duration logged in hours (time/cost entries) */
  totalDurationLogged?: Maybe<Scalars['Float']>;
};

export type EscrowBalanceSummaryPayload = {
  __typename?: 'EscrowBalanceSummaryPayload';
  balance: Scalars['Float'];
  clients: Array<TrustBalanceClientPayload>;
  response?: Maybe<ResponsePayload>;
};

/** Case event type */
export enum EventType {
  CourtDate = 'COURT_DATE',
  Event = 'EVENT'
}

export type ExternalUser = {
  __typename?: 'ExternalUser';
  accountsPayableLineItems?: Maybe<Array<Maybe<AccountsPayableLineItem>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  advAddressbill?: Maybe<Scalars['String']>;
  advAddressmail?: Maybe<Scalars['String']>;
  advClientId?: Maybe<Scalars['String']>;
  advClientType?: Maybe<Scalars['String']>;
  advEmail?: Maybe<Scalars['String']>;
  advPhone?: Maybe<Scalars['String']>;
  advPhoneCell?: Maybe<Scalars['String']>;
  advPhoneHome?: Maybe<Scalars['String']>;
  alienId?: Maybe<Scalars['String']>;
  arrearsBalance?: Maybe<Scalars['String']>;
  billAccessTokens?: Maybe<Array<Maybe<BillAccessToken>>>;
  billInterests?: Maybe<Array<Maybe<Interest>>>;
  businessName?: Maybe<Scalars['String']>;
  clientNumber?: Maybe<Scalars['String']>;
  consultClientNumber?: Maybe<Scalars['String']>;
  contractBalance?: Maybe<Scalars['String']>;
  courtToExternalUserToExternalUserRole?: Maybe<Array<Maybe<CourtToExternalUserToExternalUserRole>>>;
  createdAt: Scalars['String'];
  dateOfArrival?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  driverLicenseNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalUserRoles?: Maybe<Array<Maybe<ExternalUserToExternalUserRole>>>;
  firstName: Scalars['String'];
  fromAdv?: Maybe<Scalars['Boolean']>;
  homePhone?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  initials?: Maybe<Scalars['String']>;
  insurance?: Maybe<Scalars['String']>;
  isConsultClient?: Maybe<Scalars['Boolean']>;
  isInternational?: Maybe<Scalars['Boolean']>;
  journalEntries?: Maybe<Array<Maybe<JournalEntry>>>;
  language?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  lastPayAmount?: Maybe<Scalars['String']>;
  lastPayDate?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  personalPhone?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberExtension?: Maybe<Scalars['String']>;
  residualBalance?: Maybe<Scalars['String']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  status?: Maybe<ExternalUserStatus>;
  suffix?: Maybe<Scalars['String']>;
  trustBalance?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

/** External user role in case */
export enum ExternalUserCaseRole {
  AssistantProsecutor = 'ASSISTANT_PROSECUTOR',
  Beneficiary = 'BENEFICIARY',
  CorporateOfficer = 'CORPORATE_OFFICER',
  CoDefendant = 'CO_DEFENDANT',
  CoSigner = 'CO_SIGNER',
  Expert = 'EXPERT',
  FamilyMember = 'FAMILY_MEMBER',
  Friend = 'FRIEND',
  Miscellaneous = 'MISCELLANEOUS',
  Petitioner = 'PETITIONER',
  Plaintiff = 'PLAINTIFF',
  PrimaryAdversary = 'PRIMARY_ADVERSARY',
  PrimaryClient = 'PRIMARY_CLIENT',
  Respondent = 'RESPONDENT',
  SecondaryClient = 'SECONDARY_CLIENT',
  Victim = 'VICTIM',
  Witness = 'WITNESS'
}

export type ExternalUserInput = {
  id: Scalars['String'];
};

export type ExternalUserPayload = {
  __typename?: 'ExternalUserPayload';
  externalUser?: Maybe<ExternalUser>;
  response?: Maybe<ResponsePayload>;
};

export type ExternalUserRole = {
  __typename?: 'ExternalUserRole';
  createdAt: Scalars['String'];
  externalUsers?: Maybe<Array<Maybe<ExternalUserToExternalUserRole>>>;
  id: Scalars['String'];
  role: ExternalUserRoleRole;
  updatedAt: Scalars['String'];
};

/** The external user role assigned */
export enum ExternalUserRoleRole {
  Adversary = 'ADVERSARY',
  Client = 'CLIENT',
  Contact = 'CONTACT',
  CourtAdministrator = 'COURT_ADMINISTRATOR',
  Judge = 'JUDGE'
}

export type ExternalUserRolesPayload = {
  __typename?: 'ExternalUserRolesPayload';
  externalUserRoles?: Maybe<Array<Maybe<ExternalUserRole>>>;
  response?: Maybe<ResponsePayload>;
};

/** The ExternalUser status */
export enum ExternalUserStatus {
  Active = 'ACTIVE',
  Deactive = 'DEACTIVE'
}

export type ExternalUserToExternalUserRole = {
  __typename?: 'ExternalUserToExternalUserRole';
  caseToExternalUserToExternalUserRole?: Maybe<Array<Maybe<CaseToExternalUserToExternalUserRole>>>;
  courtToExternalUserToExternalUserRole?: Maybe<Array<Maybe<CourtToExternalUserToExternalUserRole>>>;
  createdAt: Scalars['String'];
  externalUser?: Maybe<ExternalUser>;
  externalUserId: Scalars['String'];
  externalUserRole?: Maybe<ExternalUserRole>;
  externalUserRoleId: Scalars['String'];
  externalUserRoleIdOld?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ExternalUsersConflict = {
  __typename?: 'ExternalUsersConflict';
  case?: Maybe<Case>;
  caseRole?: Maybe<Scalars['String']>;
  contact: ExternalUser;
  role: Scalars['String'];
};

export type ExternalUsersInput = {
  courtId?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderExternalUsersBy>;
  orderByDirection?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  roles?: InputMaybe<Array<ExternalUserRoleRole>>;
  searchValue?: InputMaybe<Scalars['String']>;
};

export type ExternalUsersPayload = {
  __typename?: 'ExternalUsersPayload';
  externalUsers?: Maybe<Array<Maybe<ExternalUser>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type FeeType = {
  __typename?: 'FeeType';
  createdAt: Scalars['DateTime'];
  feeType: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FeeTypePayload = {
  __typename?: 'FeeTypePayload';
  feeType?: Maybe<FeeType>;
  response?: Maybe<ResponsePayload>;
};

export type FeeTypesPayload = {
  __typename?: 'FeeTypesPayload';
  feeTypes?: Maybe<Array<Maybe<FeeType>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type FetchAccountsPayableInput = {
  bankAccountId?: InputMaybe<Scalars['String']>;
  /** Match the Check / Ref No column ONLY, as a whole value (not a substring). Use this instead of `keyword` when looking up a specific check: `keyword` also matches voucherNo/description, so searching "3661" returns voucher 36610, check 13661, etc. */
  checkNumber?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  /** Search only the description/notes field (case-insensitive) */
  descriptionKeyword?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  invoiceDateFrom?: InputMaybe<Scalars['String']>;
  invoiceDateTo?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  matterId?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  paginationOptions: PaginationInput;
  printFilter?: InputMaybe<PrintFilter>;
  status?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['Float']>;
  voidFilter?: InputMaybe<VoidFilter>;
  voucherType?: InputMaybe<Scalars['String']>;
};

export type FetchAccountsReceivableInput = {
  endDate: Scalars['DateTime'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type FetchAccountsReceivablePayload = {
  __typename?: 'FetchAccountsReceivablePayload';
  arEntries: Array<AccountsReceivableEntry>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
  summary: AccountsReceivableSummary;
};

export type FetchAllOfficesInput = {
  keyword?: InputMaybe<Scalars['String']>;
};

export type FetchAllReferencesInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
  referenceId?: InputMaybe<Scalars['String']>;
  sourceTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type FetchAllReferralSourceInput = {
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
};

export type FetchAllVendorsInput = {
  keyword?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type FetchBillDetailsByMatterInput = {
  matterId: Scalars['String'];
};

export type FetchBillDetailsInput = {
  billId: Scalars['Float'];
};

export type FetchBillDetailsPayload = {
  __typename?: 'FetchBillDetailsPayload';
  bill: Bill;
  response?: Maybe<ResponsePayload>;
};

export type FetchBillableCasesInput = {
  attorneyId?: InputMaybe<Scalars['String']>;
  billingCycle: BillingCycle;
  caseId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  customDate?: InputMaybe<Scalars['String']>;
  paralegalId?: InputMaybe<Scalars['String']>;
};

export type FetchCarriableVoidedBillsInput = {
  billId: Scalars['Float'];
  clientId: Scalars['String'];
};

export type FetchCategoriesInput = {
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
};

export type FetchClientLedgerInput = {
  endDate?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<Scalars['String']>;
  matterId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type FetchClientNoPayload = {
  __typename?: 'FetchClientNoPayload';
  clientNo?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

export type FetchDataForRecordPaymentsInput = {
  /** Bill ID (highest priority) */
  billId?: InputMaybe<Scalars['Float']>;
  /** Client ID (lowest priority) */
  clientId?: InputMaybe<Scalars['String']>;
  /** Matter ID (second priority) */
  matterId?: InputMaybe<Scalars['String']>;
};

export type FetchDataForRecordPaymentsPayload = {
  __typename?: 'FetchDataForRecordPaymentsPayload';
  cases?: Maybe<Array<Maybe<Case>>>;
  client?: Maybe<ExternalUser>;
  response?: Maybe<ResponsePayload>;
};

export type FetchDepartmentHeadInput = {
  caseId: Scalars['String'];
  userId: Scalars['String'];
};

export type FetchDepartmentUsersByLawTypeInput = {
  lawTypeId: Scalars['String'];
  paginationOptions: PaginationInput;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type FetchDepartmentsInput = {
  departmentFilters?: InputMaybe<DepartmentFilters>;
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
};

export type FetchDocPageInput = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type FetchEntriesInput = {
  filters: TimeEntryFilters;
  order?: InputMaybe<EntryOrderDirection>;
  orderBy?: InputMaybe<EntryOrderBy>;
  paginationOptions: PaginationInput;
};

export type FetchFeeTypeInput = {
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
};

export type FetchFinalBillsInput = {
  attorneyId?: InputMaybe<Scalars['String']>;
  billDeliveryType?: InputMaybe<Scalars['String']>;
  caseType?: InputMaybe<BillingType>;
  clientNumber?: InputMaybe<Scalars['String']>;
  lawTypeId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  /** When true, returns only FLAT FEE bills belonging to a matter that carries an unpaid balance more than 30 days old — including balances carried forward onto later bills — and where none of those aged bills has received any payment at all. Collection matters (Resp1 Attorney Coll1/Coll2) are left out unless the attorney filter is itself Coll1/Coll2. Backs the "Delinquent Bills" filter, and matches the DELINQUENT_BILLS print job defaults so both surfaces report the same set. */
  onlyPastDue?: InputMaybe<Scalars['Boolean']>;
  /** Accounting/admin only. When true, returns only bills whose matter currently has client credit available (cached credit balance > 0). */
  onlyWithCredit?: InputMaybe<Scalars['Boolean']>;
  /** Accounting/admin only. When true, returns only bills whose matter currently has trust money (cached trust balance > 0). */
  onlyWithTrust?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Filter by delivery state: true = sent to client, false = not sent. Omit for all. */
  sentStatus?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<BillStatus>>;
};

export type FetchFundRequestPayload = {
  __typename?: 'FetchFundRequestPayload';
  fundRequest?: Maybe<Bill>;
  response?: Maybe<ResponsePayload>;
};

export type FetchFundRequestsInput = {
  limit: Scalars['Int'];
  matterId?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BillStatus>;
};

export type FetchFundRequestsPayload = {
  __typename?: 'FetchFundRequestsPayload';
  fundRequests: Array<Bill>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
};

export type FetchGeneralLedgerInput = {
  accountId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
  startDate: Scalars['DateTime'];
};

export type FetchHourlyCasesInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type FetchInterestEntriesInput = {
  billId?: InputMaybe<Scalars['Float']>;
  caseId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type FetchJournalEntriesInput = {
  accountId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  excludeManual?: InputMaybe<Scalars['Boolean']>;
  excludeSystemGenerated?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type FetchJournalEntriesPayload = {
  __typename?: 'FetchJournalEntriesPayload';
  journalEntries?: Maybe<Array<JournalEntry>>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
};

export type FetchLogsInput = {
  caseId?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<ActivityEntityType>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  paginationOptions: PaginationInput;
  searchValue?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FetchOutstandingBillsInput = {
  caseId: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  /** When present, returns all outstanding bills for the case except this one. When omitted, returns only FORWARDED bills. Use when viewing a pre-bill to see all outstanding balances. */
  excludeBillId?: InputMaybe<Scalars['Float']>;
  token?: InputMaybe<Scalars['String']>;
};

export type FetchPayableRefundsInput = {
  accountId?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  officeId?: InputMaybe<Scalars['Float']>;
  page: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  voucherNo?: InputMaybe<Scalars['String']>;
};

export type FetchPayableRefundsPayload = {
  __typename?: 'FetchPayableRefundsPayload';
  pagination: PaginationPayload;
  payableRefunds: Array<PayableRefund>;
  response?: Maybe<ResponsePayload>;
};

export type FetchPaymentsByProfitCenterInput = {
  accountId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  monthOfYear?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderPaymentBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentType?: InputMaybe<PaymentType>;
  reconciled: Scalars['Boolean'];
  reconciliationId?: InputMaybe<Scalars['Float']>;
};

export type FetchPaymentsFilters = {
  accountId?: InputMaybe<Scalars['String']>;
  caseId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  excludeGeneralLedgerPayments?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  monthOfYear?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<OrderPaymentBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentOf?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<PaymentType>;
  reconciled?: InputMaybe<Scalars['Boolean']>;
  reconciliationId?: InputMaybe<Scalars['Float']>;
  settled?: InputMaybe<Scalars['Boolean']>;
  slipNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type FetchPaymentsInput = {
  filters?: InputMaybe<FetchPaymentsFilters>;
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
};

export type FetchPreBillsInput = {
  attorneyId?: InputMaybe<Scalars['String']>;
  billDeliveryType?: InputMaybe<Scalars['String']>;
  caseType?: InputMaybe<BillingType>;
  lawTypeId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  /** Accounting/admin only. When true, returns only pre-bills whose matter currently has client credit available (cached credit balance > 0). */
  onlyWithCredit?: InputMaybe<Scalars['Boolean']>;
  /** Accounting/admin only. When true, returns only pre-bills whose matter currently has trust money (cached trust balance > 0). */
  onlyWithTrust?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BillStatus>;
};

export type FetchPrintJobsInput = {
  /** Filter by batch ID (for batch print job types) */
  batchId?: InputMaybe<Scalars['Int']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  /** Filter by print job type */
  printJobType?: InputMaybe<PrintJobType>;
  /** Filter by single status */
  status?: InputMaybe<Scalars['String']>;
  /** Filter by multiple statuses (e.g. REQUESTED, IN_PROGRESS, COMPLETED). When set, takes precedence over status. */
  statuses?: InputMaybe<Array<Scalars['String']>>;
};

export type FetchPublicBillDetailsInput = {
  token: Scalars['String'];
};

export type FetchPublicBillDetailsPayload = {
  __typename?: 'FetchPublicBillDetailsPayload';
  amountDue: Scalars['Float'];
  bill: Bill;
  client?: Maybe<ExternalUser>;
  response?: Maybe<ResponsePayload>;
};

export type FetchQueueJobsInput = {
  limit?: Scalars['Int'];
  queueName: Scalars['String'];
  start?: Scalars['Int'];
  state: QueueJobState;
};

export type FetchQuickBillDetailsInput = {
  caseId: Scalars['String'];
};

export type FetchQuickBillDetailsPayload = {
  __typename?: 'FetchQuickBillDetailsPayload';
  case: Case;
  entries: Array<Entry>;
  response?: Maybe<ResponsePayload>;
};

export type FetchReconciliationsInput = {
  accountId?: InputMaybe<Scalars['String']>;
  monthOfYear?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  reverted?: InputMaybe<Scalars['Boolean']>;
};

export type FetchRemainingFlatFeeInput = {
  caseId: Scalars['String'];
  excludeInterest?: InputMaybe<Scalars['Boolean']>;
};

export type FetchRemainingFlatFeePayload = {
  __typename?: 'FetchRemainingFlatFeePayload';
  remainingFlatFee: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type FinalBillsPayload = {
  __typename?: 'FinalBillsPayload';
  bills: Array<Bill>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
};

export enum FinancialTimelineCategory {
  Bill = 'BILL',
  Matter = 'MATTER',
  Payable = 'PAYABLE',
  Payment = 'PAYMENT',
  Refund = 'REFUND'
}

export type FinancialTimelineEvent = {
  __typename?: 'FinancialTimelineEvent';
  actorName?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  billId?: Maybe<Scalars['Float']>;
  category: FinancialTimelineCategory;
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type FirmDashboardAccountingPayload = {
  __typename?: 'FirmDashboardAccountingPayload';
  incomingByBankAccount: Array<FirmDashboardAmount>;
  incomingByOperatingAccount: Array<FirmDashboardAmount>;
  incomingMonthly: Array<FirmDashboardMonthlyAmounts>;
  incomingOperatingTotal: Scalars['Float'];
  incomingTrustTotal: Scalars['Float'];
  outgoingByGlAccount: Array<FirmDashboardAmount>;
  outgoingOperatingByMethod: Array<FirmDashboardAmount>;
  outgoingOperatingTotal: Scalars['Float'];
  outgoingTotal: Scalars['Float'];
  outgoingTrustByMethod: Array<FirmDashboardAmount>;
  outgoingTrustTotal: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type FirmDashboardAmount = {
  __typename?: 'FirmDashboardAmount';
  amount: Scalars['Float'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type FirmDashboardBillingPayload = {
  __typename?: 'FirmDashboardBillingPayload';
  amountByBillingType: Array<FirmDashboardAmount>;
  amountByCategory: Array<FirmDashboardAmount>;
  billsByBillingType: Array<FirmDashboardCount>;
  billsByLawType: Array<FirmDashboardCount>;
  billsByStatus: Array<FirmDashboardCount>;
  finalBillsCount: Scalars['Int'];
  preBillsCount: Scalars['Int'];
  response?: Maybe<ResponsePayload>;
  totalBillsAmount: Scalars['Float'];
  totalBillsCount: Scalars['Int'];
};

export type FirmDashboardConsultsCreated = {
  __typename?: 'FirmDashboardConsultsCreated';
  converted: Scalars['Int'];
  notConverted: Scalars['Int'];
  total: Scalars['Int'];
};

export type FirmDashboardCount = {
  __typename?: 'FirmDashboardCount';
  count: Scalars['Int'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type FirmDashboardDateRangeInput = {
  /** Last day of the range (inclusive), YYYY-MM-DD in ET */
  endDate: Scalars['String'];
  /** First day of the range (inclusive), YYYY-MM-DD in ET */
  startDate: Scalars['String'];
};

export type FirmDashboardMatterStatusCount = {
  __typename?: 'FirmDashboardMatterStatusCount';
  active: Scalars['Int'];
  completed: Scalars['Int'];
  count: Scalars['Int'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type FirmDashboardMattersCreated = {
  __typename?: 'FirmDashboardMattersCreated';
  direct: Scalars['Int'];
  fromConsults: Scalars['Int'];
  total: Scalars['Int'];
};

export type FirmDashboardMattersPayload = {
  __typename?: 'FirmDashboardMattersPayload';
  activeByBillingType: Array<FirmDashboardMatterStatusCount>;
  activeByLawType: Array<FirmDashboardMatterStatusCount>;
  activeByResponsibleAttorney: Array<FirmDashboardCount>;
  activeMatters: FirmDashboardStatusTotals;
  closedMatters: FirmDashboardStatusTotals;
  consultsCreated: FirmDashboardConsultsCreated;
  mattersCreated: FirmDashboardMattersCreated;
  newMattersByBillingType: Array<FirmDashboardCount>;
  response?: Maybe<ResponsePayload>;
  workCompletedMatters: FirmDashboardStatusTotals;
};

export type FirmDashboardMonthlyAmounts = {
  __typename?: 'FirmDashboardMonthlyAmounts';
  amounts: Array<FirmDashboardAmount>;
  month: Scalars['String'];
};

export type FirmDashboardStatusTotals = {
  __typename?: 'FirmDashboardStatusTotals';
  asOfToday: Scalars['Int'];
  inRange: Scalars['Int'];
};

export type FlatFeeSummary = {
  __typename?: 'FlatFeeSummary';
  contractFee: Scalars['Float'];
  discount: Scalars['Float'];
  hybridFlatFeeUsed: Scalars['Float'];
  paidAmount: Scalars['Float'];
  payoffAmount?: Maybe<Scalars['Float']>;
  residualBalance: Scalars['Float'];
  unpaidAmount: Scalars['Float'];
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  response?: Maybe<ResponsePayload>;
};

export type GlAccountStatement = {
  __typename?: 'GLAccountStatement';
  account: Account;
  closingBalance: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  date: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GeneralLedgerEntry = {
  __typename?: 'GeneralLedgerEntry';
  account: Account;
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  fromAdv: Scalars['Boolean'];
  id: Scalars['String'];
  journalEntry: JournalEntry;
  office?: Maybe<Office>;
  runningBalance: Scalars['Float'];
  type: JournalEntryType;
  updatedAt: Scalars['String'];
};

export type GenerateAllPreBillsInput = {
  billingCycle: BillingCycle;
  customDate?: InputMaybe<Scalars['String']>;
};

export type GenerateBillsForAttorneysInput = {
  attorneyIds: Array<Scalars['String']>;
  billingCycle: BillingCycle;
  customDate?: InputMaybe<Scalars['String']>;
};

export type GeneratePreBillInput = {
  amount: Scalars['Float'];
  billingPeriodDate?: InputMaybe<Scalars['String']>;
  caseId: Scalars['String'];
  discount: Scalars['Float'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  isFinalBill?: InputMaybe<Scalars['Boolean']>;
  items: Array<CreateBillItemInput>;
  payOffAmount?: InputMaybe<Scalars['Float']>;
  sendToClient?: InputMaybe<Scalars['Boolean']>;
  type: BillType;
};

export type GeneratePreBillsPayload = {
  __typename?: 'GeneratePreBillsPayload';
  billIds: Array<Scalars['Float']>;
  response?: Maybe<ResponsePayload>;
};

export type GenerateQuickBillEntriesInput = {
  new: Array<CreateManualEntryInput>;
  updated: Array<UpdateEntryInput>;
};

export type GenerateQuickBillInput = {
  billingNotes: Array<Scalars['String']>;
  caseId: Scalars['String'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  entries: GenerateQuickBillEntriesInput;
  isFinalBill?: InputMaybe<Scalars['Boolean']>;
};

export type GenerateQuickBillPayload = {
  __typename?: 'GenerateQuickBillPayload';
  billId: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type GetAttachment = {
  typeId: Scalars['String'];
};

export type GetBatchInput = {
  /** Only items whose matter has one of these users on its legal team (see attorneyRole). */
  attorneyIds?: InputMaybe<Array<Scalars['String']>>;
  /** UserType role to match attorneyIds against (e.g. responsibleAttorney1). "any" means any legal team role. Defaults to responsibleAttorney1. */
  attorneyRole?: InputMaybe<Scalars['String']>;
  batchId: Scalars['Int'];
  billStatus?: InputMaybe<BillStatus>;
  billingType?: InputMaybe<BillingType>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<BillEmailBatchItemStatus>;
  /** Only items whose matter currently holds trust money (WITH_TRUST), only those whose matter holds none (WITHOUT_TRUST), or all of them (ALL / omitted). Mirrors the print job option of the same name so the print-jobs preview shows exactly what the job will print. Also narrows `stats`, because the batch-emails Send honours it. */
  trustScope?: InputMaybe<PrintJobTrustScope>;
  type?: InputMaybe<BillEmailBatchItemType>;
};

export type GetBatchPayload = {
  __typename?: 'GetBatchPayload';
  /** Distinct bill statuses present in the whole batch (for filter dropdowns) */
  availableBillStatuses?: Maybe<Array<Maybe<BillStatus>>>;
  batch: BillEmailBatch;
  pagination?: Maybe<PaginationPayload>;
  /** Aggregate counts across the whole batch, narrowed only by the filters Send honours (attorney, billing type, trust scope) */
  stats?: Maybe<BillEmailBatchItemStats>;
};

export type GetBatchesPayload = {
  __typename?: 'GetBatchesPayload';
  batches: Array<BillEmailBatch>;
};

export type GetCaseClientsInput = {
  caseId: Scalars['String'];
};

export type GetCaseClientsPayload = {
  __typename?: 'GetCaseClientsPayload';
  clients: Array<CaseToExternalUserToExternalUserRole>;
  response?: Maybe<ResponsePayload>;
};

export type GetClientBalanceInAccountInput = {
  accountId: Scalars['String'];
  caseId: Scalars['String'];
  clientId: Scalars['String'];
};

export type GetClientBalanceInAccountPayload = {
  __typename?: 'GetClientBalanceInAccountPayload';
  balance: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type GetClientCreditBalanceInput = {
  caseId: Scalars['String'];
  clientId: Scalars['String'];
};

export type GetClientCreditBalancePayload = {
  __typename?: 'GetClientCreditBalancePayload';
  creditBalance: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type GetClientTrustBalanceInput = {
  caseId: Scalars['String'];
  clientId: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};

export type GetClientTrustBalancePayload = {
  __typename?: 'GetClientTrustBalancePayload';
  response?: Maybe<ResponsePayload>;
  trustBalance?: Maybe<Scalars['Float']>;
};

export type GetCourt = {
  id: Scalars['String'];
};

export type GetCreditBalanceSummaryInput = {
  caseId: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type GetDepartmentHeadForCasePayload = {
  __typename?: 'GetDepartmentHeadForCasePayload';
  departmentHead?: Maybe<User>;
  response?: Maybe<ResponsePayload>;
};

export type GetMedia = {
  id?: InputMaybe<Scalars['String']>;
};

export type GetTrustBalanceSummaryInput = {
  caseId: Scalars['String'];
};

export type HourlyAmountLoggedForCasePayload = {
  __typename?: 'HourlyAmountLoggedForCasePayload';
  hourlyAmountLogged: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type HourlyCasesPayload = {
  __typename?: 'HourlyCasesPayload';
  cases?: Maybe<Array<Maybe<Case>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type IoltaBalanceSummaryPayload = {
  __typename?: 'IOLTABalanceSummaryPayload';
  balance: Scalars['Float'];
  clients: Array<TrustBalanceClientPayload>;
  response?: Maybe<ResponsePayload>;
  retainerAccount?: Maybe<Account>;
};

export type InitialPaymentLockPayload = {
  __typename?: 'InitialPaymentLockPayload';
  billId?: Maybe<Scalars['Int']>;
  billStatus?: Maybe<BillStatus>;
  canEdit: Scalars['Boolean'];
  canGenerateBill: Scalars['Boolean'];
  entryIds: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
  state: InitialPaymentLockState;
};

export enum InitialPaymentLockState {
  Locked = 'LOCKED',
  NoBill = 'NO_BILL',
  Voidable = 'VOIDABLE'
}

export type Interest = {
  __typename?: 'Interest';
  accruedInterest: Scalars['Float'];
  advRefno?: Maybe<Scalars['String']>;
  bill: Bill;
  carriedForwardFromBillId?: Maybe<Scalars['Int']>;
  client: ExternalUser;
  createdAt: Scalars['String'];
  cumulativeInterest: Scalars['Float'];
  date: Scalars['DateTime'];
  /** No of days overdue from due date */
  days: Scalars['Int'];
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** Balance on which interest is calculated */
  principal: Scalars['Float'];
  /** Interest rate used for the interest calculation */
  rate: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type InterestEntriesPayload = {
  __typename?: 'InterestEntriesPayload';
  interestEntries: Array<Interest>;
  pagination: PaginationPayload;
  response?: Maybe<ResponsePayload>;
};

export type InterestRate = {
  __typename?: 'InterestRate';
  activeRate?: Maybe<Scalars['Boolean']>;
  applicableDays?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

export type InterestRateInput = {
  applicableDays?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
};

export type JournalEntry = {
  __typename?: 'JournalEntry';
  advJournalRef?: Maybe<Scalars['String']>;
  affectedFiscalYear?: Maybe<Scalars['Float']>;
  bill?: Maybe<Bill>;
  case?: Maybe<Case>;
  client?: Maybe<ExternalUser>;
  closedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isClosedYearAdjustment: Scalars['Boolean'];
  isSystemGenerated: Scalars['Boolean'];
  isYearEndCloseEntry: Scalars['Boolean'];
  journalEntryNumber: Scalars['Float'];
  lineItems?: Maybe<Array<JournalEntryLineItem>>;
  notes?: Maybe<Scalars['String']>;
  payable?: Maybe<AccountsPayable>;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  postedInFiscalYear?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
  vendor?: Maybe<Vendor>;
};

export type JournalEntryLineItem = {
  __typename?: 'JournalEntryLineItem';
  account: Account;
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  fromAdv: Scalars['Boolean'];
  id: Scalars['String'];
  journalEntry: JournalEntry;
  office?: Maybe<Office>;
  type: JournalEntryType;
  updatedAt: Scalars['String'];
};

/** Type of journal entry (debit or credit) */
export enum JournalEntryType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type LawType = {
  __typename?: 'LawType';
  caseTypes?: Maybe<Array<CaseType>>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  syncWithOutlook: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

export type LawTypeInput = {
  id: Scalars['String'];
};

export type LawTypePayload = {
  __typename?: 'LawTypePayload';
  lawType?: Maybe<LawType>;
  response?: Maybe<ResponsePayload>;
};

export type LawTypesPayload = {
  __typename?: 'LawTypesPayload';
  lawTypes?: Maybe<Array<Maybe<LawType>>>;
  response?: Maybe<ResponsePayload>;
};

export type LedgerReport = {
  __typename?: 'LedgerReport';
  accountCode: Scalars['String'];
  accountId: Scalars['String'];
  accountName: Scalars['String'];
  amount: Scalars['Float'];
  bill?: Maybe<Bill>;
  client?: Maybe<ExternalUser>;
  createdAgainstType?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  matter?: Maybe<Case>;
  payable?: Maybe<AccountsPayable>;
  type: Scalars['String'];
};

export type LedgerReportPayload = {
  __typename?: 'LedgerReportPayload';
  pagination: PaginationPayload;
  reports: Array<LedgerReport>;
  response?: Maybe<ResponsePayload>;
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MarkBillsAsDeliveredPayload = {
  __typename?: 'MarkBillsAsDeliveredPayload';
  /** Bills that were marked as delivered */
  markedBillIds: Array<Scalars['Float']>;
  response?: Maybe<ResponsePayload>;
  /** Selected bills left untouched — voided, forwarded, still a pre-bill, or no longer present */
  skippedBillIds: Array<Scalars['Float']>;
};

export type MarkPaymentsAsLegacyReconciledInput = {
  paymentIds: Array<Scalars['String']>;
};

export type MatterEntriesSummary = {
  __typename?: 'MatterEntriesSummary';
  /** Case number */
  caseNumber?: Maybe<Scalars['String']>;
  /** Case/matter ID */
  id: Scalars['String'];
  /** Case title */
  title?: Maybe<Scalars['String']>;
  /** Time/amount summary per user */
  usersTimeEntries: Array<UserTimeEntrySummary>;
};

export type Metadata = {
  __typename?: 'Metadata';
  amount?: Maybe<Scalars['String']>;
  billId?: Maybe<Scalars['Float']>;
  client?: Maybe<Scalars['String']>;
  clientRole?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['String']>;
  cumulativeInterest?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['String']>;
  newDueDate?: Maybe<Scalars['String']>;
  newStatus?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  previousDueDate?: Maybe<Scalars['String']>;
  previousStatus?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

export type MfaAuthEnrollmentPayload = {
  __typename?: 'MfaAuthEnrollmentPayload';
  otpauthUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
  secret?: Maybe<Scalars['String']>;
};

/** The multi-factor authentication method enabled for the user */
export enum MfaMethod {
  Auth = 'AUTH',
  Email = 'EMAIL'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateUser: UserPayload;
  addUserCaseTask: UserCaseTaskPayload;
  addUsersToCase: CasePayload;
  applyCredits: ResponsePayloadResponse;
  approveBillByAttorney: ApproveBillByAttorneyPayload;
  approveBillByDepartmentHead: ApproveBillByDepartmentHeadPayload;
  archiveBill: FetchBillDetailsPayload;
  archiveCase: CasePayload;
  archiveDocPage: DocPagePayload;
  assignCaseToExternalUser: CasePayload;
  assignCourtToExternalUser: CourtPayload;
  billBulkActions: BulkActionPayload;
  bulkInsertCategories: Scalars['Boolean'];
  cancelPrintJob: PrintJobPayload;
  cancelReport: ReportSelectionPayload;
  changePassword: UserPayload;
  clearReconciliationSessionItems: ReconciliationSession;
  /** Close an accounting period (month). If December, automatically triggers year-end close. If accountId provided, closes only that account; otherwise closes all accounts. */
  closeAccountingPeriod: AccountingPeriod;
  commitReconciliationSession: ReconciliationSession;
  confirmMfaAuthEnrollment: UserPayload;
  convertFlatFeeCaseToHourly: ResponsePayloadResponse;
  createAccount: AccountPayload;
  createAccountPayable: AccountPayablePayload;
  createAddress: AddressPayload;
  createAttachmentData: AttachmentPayload;
  createCarriedForwardInterest: CreateCarriedForwardInterestPayload;
  createCase: CasePayload;
  createCaseEvent: CaseEventPayload;
  createCaseType: CaseTypePayload;
  createCategory: CategoryPayload;
  createCourt: CourtPayload;
  createDepartment: DepartmentPayload;
  createDocPage: DocPagePayload;
  createExternalUser: ExternalUserPayload;
  createFeeType: FeeTypePayload;
  createFirmPayment: PaymentPayload;
  createFundRequest: CreateFundRequestPayload;
  createLawType: LawTypePayload;
  createManualEntry: EntryPayload;
  createManualJournalEntries: CreateManualJournalEntriesPayload;
  createNote: NotePayload;
  createNoteType: NoteType;
  createOffice: OfficePayload;
  createPayableRefund: PayableRefundPayload;
  createPrintJob: PrintJobPayload;
  createReference: ReferencePayload;
  createReferralSource: ReferralSource;
  createTask: TaskPayload;
  createVendor: VendorPayload;
  deactivateUser: UserPayload;
  deactivateVendor: VendorPayload;
  deleteCase: CasePayload;
  deleteCaseEvent: CaseEventPayload;
  deleteCaseType: CaseTypePayload;
  deleteCategory: ResponsePayload;
  deleteDepartment: ResponsePayload;
  deleteDocPage: DocPagePayload;
  deleteEntry: EntryPayload;
  deleteExternalUser: ResponsePayloadResponse;
  deleteFeeType: Scalars['Boolean'];
  deleteInterestEntries: DeleteInterestEntriesPayload;
  deleteLawType: LawTypePayload;
  deleteManualJournalEntry: ResponsePayloadResponse;
  deleteNote: NotePayload;
  deleteNoteType: Scalars['Boolean'];
  deleteOffice: ResponsePayload;
  deleteReference: Scalars['Boolean'];
  deleteReferralSource: Scalars['Boolean'];
  deleteTask: TaskPayload;
  deleteUserCaseTask: UserCaseTaskPayload;
  discardReconciliationSession: ReconciliationSession;
  downloadReconciliationDocument: ReconciliationDocumentPayload;
  forgotPassword: ForgotPasswordPayload;
  generateBillsForAttorneys: GeneratePreBillsPayload;
  generateConsultCaseBill: ConsultCaseBillPayload;
  generateContingencyFinalBill: ContingencyFinalBillPayload;
  generateContingencyFundRequest: ContingencyFundRequestPayload;
  generateInitialPaymentBill: GeneratePreBillsPayload;
  generatePreBills: GeneratePreBillsPayload;
  generatePreBillsForAllAttorneys: GeneratePreBillsPayload;
  generateQuickBill: GenerateQuickBillPayload;
  generateReport: ReportSelectionPayload;
  login: AccessUserPayload;
  markBillAsDelivered: ResponsePayloadResponse;
  markBillsAsDelivered: MarkBillsAsDeliveredPayload;
  markPayableAsPaid: AccountPayablePayload;
  markPaymentsAsLegacyReconciled: ResponsePayloadResponse;
  markPrintJobBillsAsDelivered: PrintJobPayload;
  pauseOrResumeTimer: EntryPayload;
  pauseQueue: QueueActionPayload;
  publishDocPage: DocPagePayload;
  /** Re-close a previously closed fiscal year */
  reCloseYear: YearEndClose;
  reactivateVendor: VendorPayload;
  reconcileGroupedPaymentsByProfitCenter: ReconciliationResponse;
  reconcilePayments: ReconciliationResponse;
  recordClientCredits: RecordClientCreditsPayload;
  recordManualPayment: FetchBillDetailsPayload;
  recordPayment: ResponsePayloadResponse;
  refundPayment: ResponsePayloadResponse;
  regenerateBillClientCopy: BillSnapshotDownloadPayload;
  registerUser: UserPayload;
  removeAssigneeFromCase: CasePayload;
  removeAttachmentData: AttachmentPayload;
  removeCasesMedia: Scalars['Boolean'];
  removeCourt: CourtPayload;
  removeExternalUserFromCourt: ResponsePayloadResponse;
  removeQueueJob: QueueActionPayload;
  removeUser: UserPayload;
  reorderDocPages: DocPagesPayload;
  rescanBillEmailBatch: RescanBatchPayload;
  resendBillEmailBatchItem: ResendBatchItemPayload;
  resendBillToClient: ResponsePayloadResponse;
  resendMessage: Scalars['Boolean'];
  resendMfaOtp: AccessUserPayload;
  resendVerificationEmail: UserPayload;
  resetPassword: UserPayload;
  resumeQueue: QueueActionPayload;
  retryBillEmailBatchItem: RetryBatchItemPayload;
  retryPrintJob: PrintJobPayload;
  retryQueueJob: QueueActionPayload;
  retryReport: ReportSelectionPayload;
  returnCheckPayment: ReversePaymentPayload;
  reversePayment: ReversePaymentPayload;
  saveDocPageDraft: DocPagePayload;
  sendBillToAttorney: SendBillToAttorneyPayload;
  sendBillToClient: SendBillToClientPayload;
  sendReminderToClient: ResponsePayloadResponse;
  softDeletePayable: ResponsePayloadResponse;
  startMfaAuthEnrollment: MfaAuthEnrollmentPayload;
  startOrResumeReconciliationSession: ReconciliationSession;
  startTimer: EntryPayload;
  stopTimer: EntryPayload;
  switchMfaMethod: AccessUserPayload;
  toggleArchiveAccount: AccountPayload;
  toggleBillEmailBatchItemExclusion: ToggleBatchItemExclusionPayload;
  transferFundsBetweenAccounts: PaymentPayload;
  triggerBillEmailBatch: TriggerBatchPayload;
  unarchiveDocPage: DocPagePayload;
  /** Unclose an accounting period (month). Removes balance snapshots and reopens period. */
  uncloseAccountingPeriod: Scalars['Boolean'];
  undoReconciliation: ReconciliationResponse;
  unlockUser: UserPayload;
  updateAccount: AccountPayload;
  updateAccountPayable: AccountPayablePayload;
  updateAttachmentData: AttachmentPayload;
  updateBill: ResponsePayloadResponse;
  updateBillDueDate: ResponsePayloadResponse;
  updateCase: CasePayload;
  updateCaseBillingType: CasePayload;
  updateCaseCaseType: CasePayload;
  updateCaseCourt: CasePayload;
  updateCaseEvent: CaseEventPayload;
  updateCaseType: CaseTypePayload;
  updateCategory: CategoryPayload;
  updateCourt: CourtPayload;
  updateDepartment: DepartmentPayload;
  updateDocPage: DocPagePayload;
  updateEntry: EntryPayload;
  updateExternalUser: ExternalUserPayload;
  updateExternalUserAddress: ExternalUserPayload;
  updateFeeType: FeeTypePayload;
  updateFundRequest: UpdateFundRequestPayload;
  updateLawType: LawTypePayload;
  updateMfaSettings: UserPayload;
  updateNote: NotePayload;
  updateNoteType: NoteType;
  updateOffice: OfficePayload;
  updatePassword: UserPayload;
  updatePayment: PaymentPayload;
  updateReconciliationSession: ReconciliationSession;
  updateReconciliationSessionViewPreferences: ReconciliationSessionViewPreferences;
  updateReference: ReferencePayload;
  updateReferralSource: ReferralSource;
  updateRole: UserPayload;
  updateTask: TaskPayload;
  updateUser: UserPayload;
  updateUserCasesTask: TaskPayload;
  updateUserGeneralInfo: UserPayload;
  updateUserMfaSettings: UserPayload;
  updateVendor: VendorPayload;
  verifyEmail: UserPayload;
  verifyEmailAndSetPassword: UserPayload;
  verifyMfaOtp: AccessUserPayload;
  voidAndDuplicatePayable: VoidAndDuplicatePayablePayload;
  voidAndReissueCheck: VoidAndReissueCheckPayload;
  voidBill: FetchBillDetailsPayload;
  voidPayable: AccountPayablePayload;
  writeOffBills: ResponsePayloadResponse;
};


export type MutationActivateUserArgs = {
  user: UserIdInput;
};


export type MutationAddUserCaseTaskArgs = {
  userCaseTaskInput: UserCaseTaskInput;
};


export type MutationAddUsersToCaseArgs = {
  addUsersToCaseInput: AddUsersToCaseInput;
};


export type MutationApplyCreditsArgs = {
  applyCreditsInput: ApplyCreditsInput;
};


export type MutationApproveBillByAttorneyArgs = {
  approveBillByAttorneyInput: ApproveBillByAttorneyInput;
};


export type MutationApproveBillByDepartmentHeadArgs = {
  approveBillByDepartmentHeadInput: ApproveBillByDepartmentHeadInput;
};


export type MutationArchiveBillArgs = {
  archiveBillInput: ArchiveBillInput;
};


export type MutationArchiveCaseArgs = {
  archiveCase: ArchiveCase;
};


export type MutationArchiveDocPageArgs = {
  id: Scalars['String'];
};


export type MutationAssignCaseToExternalUserArgs = {
  assignCaseInput: AssignExternalUserToCase;
};


export type MutationAssignCourtToExternalUserArgs = {
  assignCourtInput: AssignExternalUserToCourt;
};


export type MutationBillBulkActionsArgs = {
  bulkInput: BillBulkInput;
};


export type MutationBulkInsertCategoriesArgs = {
  categories: Array<CreateCategoryInput>;
};


export type MutationCancelPrintJobArgs = {
  id: Scalars['String'];
};


export type MutationCancelReportArgs = {
  reportId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  changePassword: ChangePasswordInput;
};


export type MutationClearReconciliationSessionItemsArgs = {
  input: ClearReconciliationSessionInput;
};


export type MutationCloseAccountingPeriodArgs = {
  input: CloseAccountingPeriodInput;
};


export type MutationCommitReconciliationSessionArgs = {
  sessionId: Scalars['Int'];
};


export type MutationConfirmMfaAuthEnrollmentArgs = {
  confirmMfaAuthEnrollment: ConfirmMfaAuthEnrollmentInput;
};


export type MutationConvertFlatFeeCaseToHourlyArgs = {
  caseId: Scalars['String'];
};


export type MutationCreateAccountArgs = {
  createAccountInput: CreateAccountInput;
};


export type MutationCreateAccountPayableArgs = {
  input: CreatePayableInput;
};


export type MutationCreateAddressArgs = {
  createAddressInput: CreateAddressForExtUserInput;
};


export type MutationCreateAttachmentDataArgs = {
  createAttachmentInput: CreateAttachmentInput;
};


export type MutationCreateCarriedForwardInterestArgs = {
  createCarriedForwardInterestInput: CreateCarriedForwardInterestInput;
};


export type MutationCreateCaseArgs = {
  createCaseInput: CreateCaseInput;
};


export type MutationCreateCaseEventArgs = {
  createCaseEventInput: CreateCaseEventInput;
};


export type MutationCreateCaseTypeArgs = {
  createCaseTypeInput: CreateCaseTypeInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateCourtArgs = {
  createCourtInput: CreateCourtInput;
};


export type MutationCreateDepartmentArgs = {
  createDepartmentInput: CreateDepartmentInput;
};


export type MutationCreateDocPageArgs = {
  createDocPageInput: CreateDocPageInput;
};


export type MutationCreateExternalUserArgs = {
  createExternalUserInput: CreateExternalUser;
};


export type MutationCreateFeeTypeArgs = {
  feeType: Scalars['String'];
};


export type MutationCreateFirmPaymentArgs = {
  input: CreateFirmPaymentInput;
};


export type MutationCreateFundRequestArgs = {
  createFundRequestInput: Array<CreateFundRequestInput>;
};


export type MutationCreateLawTypeArgs = {
  createLawTypeInput: CreateLawTypeInput;
};


export type MutationCreateManualEntryArgs = {
  input: CreateManualEntryInput;
};


export type MutationCreateManualJournalEntriesArgs = {
  input: CreateManualJournalEntriesInput;
};


export type MutationCreateNoteArgs = {
  createNoteInput: CreateNoteInput;
};


export type MutationCreateNoteTypeArgs = {
  noteType: Scalars['String'];
};


export type MutationCreateOfficeArgs = {
  createOfficeInput: CreateOfficeInput;
};


export type MutationCreatePayableRefundArgs = {
  input: CreatePayableRefundInput;
};


export type MutationCreatePrintJobArgs = {
  input: CreatePrintJobInput;
};


export type MutationCreateReferenceArgs = {
  createReferenceInput: CreateReferenceInput;
};


export type MutationCreateReferralSourceArgs = {
  sourceType: Scalars['String'];
};


export type MutationCreateTaskArgs = {
  createTaskInput: CreateTaskInput;
};


export type MutationCreateVendorArgs = {
  createVendorInput: CreateVendorInput;
};


export type MutationDeactivateUserArgs = {
  user: UserIdInput;
};


export type MutationDeactivateVendorArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCaseArgs = {
  deleteCaseInput: DeleteCase;
};


export type MutationDeleteCaseEventArgs = {
  deleteCaseEventInput: DeleteCaseEvent;
};


export type MutationDeleteCaseTypeArgs = {
  deleteCaseTypeInput: DeleteCaseType;
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDepartmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDocPageArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEntryArgs = {
  entryId: Scalars['String'];
};


export type MutationDeleteExternalUserArgs = {
  deleteExternalUser: DeleteExternalUser;
};


export type MutationDeleteFeeTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInterestEntriesArgs = {
  deleteInterestEntriesInput: DeleteInterestEntriesInput;
};


export type MutationDeleteLawTypeArgs = {
  deleteLawTypeInput: DeleteLawType;
};


export type MutationDeleteManualJournalEntryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNoteArgs = {
  deleteNoteInput: DeleteNote;
};


export type MutationDeleteNoteTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOfficeArgs = {
  addressId: Scalars['String'];
  id: Scalars['Float'];
};


export type MutationDeleteReferenceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReferralSourceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTaskArgs = {
  deleteTaskInput: DeleteTask;
};


export type MutationDeleteUserCaseTaskArgs = {
  deleteUserCaseTaskInput: DeleteUserCaseTask;
};


export type MutationDiscardReconciliationSessionArgs = {
  sessionId: Scalars['Int'];
};


export type MutationDownloadReconciliationDocumentArgs = {
  reconciliationDocumentInput: ReconciliationDocumentInput;
};


export type MutationForgotPasswordArgs = {
  forgotPassword: ForgotPasswordInput;
};


export type MutationGenerateBillsForAttorneysArgs = {
  generateBillsForAttorneysInput: GenerateBillsForAttorneysInput;
};


export type MutationGenerateConsultCaseBillArgs = {
  generateConsultCaseBillInput: ConsultCaseBillInput;
};


export type MutationGenerateContingencyFinalBillArgs = {
  generateContingencyFinalBillInput: ContingencyFinalBillInput;
};


export type MutationGenerateContingencyFundRequestArgs = {
  generateContingencyFundRequestInput: ContingencyFundRequestInput;
};


export type MutationGenerateInitialPaymentBillArgs = {
  caseId: Scalars['String'];
};


export type MutationGeneratePreBillsArgs = {
  alsoSendForAttorneyApproval?: InputMaybe<Scalars['Boolean']>;
  generatePreBillsInput: Array<GeneratePreBillInput>;
};


export type MutationGeneratePreBillsForAllAttorneysArgs = {
  generateAllPreBillsInput: GenerateAllPreBillsInput;
};


export type MutationGenerateQuickBillArgs = {
  generateQuickBillInput: GenerateQuickBillInput;
};


export type MutationGenerateReportArgs = {
  createReportInput: CreateReportInput;
};


export type MutationLoginArgs = {
  loginUser: LoginUserInput;
};


export type MutationMarkBillAsDeliveredArgs = {
  billId: Scalars['Int'];
};


export type MutationMarkBillsAsDeliveredArgs = {
  billIds: Array<Scalars['Int']>;
};


export type MutationMarkPayableAsPaidArgs = {
  id: Scalars['String'];
};


export type MutationMarkPaymentsAsLegacyReconciledArgs = {
  input: MarkPaymentsAsLegacyReconciledInput;
};


export type MutationMarkPrintJobBillsAsDeliveredArgs = {
  id: Scalars['String'];
};


export type MutationPauseOrResumeTimerArgs = {
  timeEntryId: Scalars['String'];
};


export type MutationPauseQueueArgs = {
  queueNameInput: QueueNameInput;
};


export type MutationPublishDocPageArgs = {
  publishDocPageInput: PublishDocPageInput;
};


export type MutationReactivateVendorArgs = {
  id: Scalars['Int'];
};


export type MutationReconcileGroupedPaymentsByProfitCenterArgs = {
  reconcileGroupedPayments: ReconcileGroupedPaymentsByProfitCenterInput;
};


export type MutationReconcilePaymentsArgs = {
  reconcilePaymentInput: ReconcilePaymentInput;
};


export type MutationRecordClientCreditsArgs = {
  recordClientCreditsInput: RecordClientCreditsInput;
};


export type MutationRecordManualPaymentArgs = {
  recordManualPaymentInput: RecordManualPaymentInput;
};


export type MutationRecordPaymentArgs = {
  recordPaymentInput: RecordPaymentInput;
};


export type MutationRefundPaymentArgs = {
  refundPaymentInput: RefundPaymentInput;
};


export type MutationRegenerateBillClientCopyArgs = {
  billId: Scalars['Int'];
};


export type MutationRegisterUserArgs = {
  user: RegisterUserInput;
};


export type MutationRemoveAssigneeFromCaseArgs = {
  removeAssigneeFromCaseInput: RemoveUsersFromCaseInput;
};


export type MutationRemoveAttachmentDataArgs = {
  removeAttachment: RemoveAttachment;
};


export type MutationRemoveCasesMediaArgs = {
  removeAttachment: RemoveCasesMediaInput;
};


export type MutationRemoveCourtArgs = {
  removeCourtInput: RemoveCourt;
};


export type MutationRemoveExternalUserFromCourtArgs = {
  removeExternalUserFromCourtInput: RemoveExternalUserFromCourt;
};


export type MutationRemoveQueueJobArgs = {
  queueJobActionInput: QueueJobActionInput;
};


export type MutationRemoveUserArgs = {
  user: UserIdInput;
};


export type MutationReorderDocPagesArgs = {
  reorderDocPagesInput: ReorderDocPagesInput;
};


export type MutationRescanBillEmailBatchArgs = {
  input: RescanBatchInput;
};


export type MutationResendBillEmailBatchItemArgs = {
  input: ResendBatchItemInput;
};


export type MutationResendBillToClientArgs = {
  resendBillToClient: ResendBillToClient;
};


export type MutationResendMessageArgs = {
  caseId: Scalars['String'];
  externalUserId: Scalars['String'];
};


export type MutationResendMfaOtpArgs = {
  resendMfaOtp: ResendMfaOtpInput;
};


export type MutationResendVerificationEmailArgs = {
  resendVerificationEmail: ResendVerificationEmail;
};


export type MutationResetPasswordArgs = {
  resetPassword: ResetPasswordInput;
};


export type MutationResumeQueueArgs = {
  queueNameInput: QueueNameInput;
};


export type MutationRetryBillEmailBatchItemArgs = {
  input: RetryBatchItemInput;
};


export type MutationRetryPrintJobArgs = {
  id: Scalars['String'];
};


export type MutationRetryQueueJobArgs = {
  queueJobActionInput: QueueJobActionInput;
};


export type MutationRetryReportArgs = {
  reportId: Scalars['String'];
};


export type MutationReturnCheckPaymentArgs = {
  returnCheckInput: ReturnCheckInput;
};


export type MutationReversePaymentArgs = {
  reversePaymentInput: ReversePaymentInput;
};


export type MutationSaveDocPageDraftArgs = {
  saveDocPageDraftInput: SaveDocPageDraftInput;
};


export type MutationSendBillToAttorneyArgs = {
  sendBillToAttorneyInput: SendBillToAttorneyInput;
};


export type MutationSendBillToClientArgs = {
  sendBillToClientInput: SendBillToClientInput;
};


export type MutationSendReminderToClientArgs = {
  sendReminderToClientInput: SendBillToClientInput;
};


export type MutationSoftDeletePayableArgs = {
  id: Scalars['String'];
};


export type MutationStartOrResumeReconciliationSessionArgs = {
  input: StartReconciliationSessionInput;
};


export type MutationStartTimerArgs = {
  input: StartTimerInput;
};


export type MutationStopTimerArgs = {
  timeEntryId: Scalars['String'];
};


export type MutationSwitchMfaMethodArgs = {
  switchMfaMethod: SwitchMfaMethodInput;
};


export type MutationToggleArchiveAccountArgs = {
  id: Scalars['String'];
};


export type MutationToggleBillEmailBatchItemExclusionArgs = {
  input: ToggleBatchItemExclusionInput;
};


export type MutationTransferFundsBetweenAccountsArgs = {
  transferFundsBetweenAccountsInput: TransferFundsBetweenAccountsInput;
};


export type MutationTriggerBillEmailBatchArgs = {
  input: TriggerBatchInput;
};


export type MutationUnarchiveDocPageArgs = {
  id: Scalars['String'];
};


export type MutationUncloseAccountingPeriodArgs = {
  input: UncloseAccountingPeriodInput;
};


export type MutationUndoReconciliationArgs = {
  id: Scalars['Float'];
};


export type MutationUnlockUserArgs = {
  user: UserIdInput;
};


export type MutationUpdateAccountArgs = {
  updateAccountInput: UpdateAccountInput;
};


export type MutationUpdateAccountPayableArgs = {
  input: UpdatePayableEntryInput;
};


export type MutationUpdateAttachmentDataArgs = {
  updateAttachmentInput: UpdateAttachmentInput;
};


export type MutationUpdateBillArgs = {
  updateBillRequestInput: UpdateBillRequestInput;
};


export type MutationUpdateBillDueDateArgs = {
  updateBillDueDateInput: UpdateBillDueDateInput;
};


export type MutationUpdateCaseArgs = {
  updateCaseInput: UpdateCaseInput;
};


export type MutationUpdateCaseBillingTypeArgs = {
  updateCaseBillingTypeInput: UpdateCaseBillingTypeInput;
};


export type MutationUpdateCaseCaseTypeArgs = {
  updateCaseCaseInput: UpdateCaseCaseTypeInput;
};


export type MutationUpdateCaseCourtArgs = {
  updateCaseCourtInput: UpdateCaseCourtInput;
};


export type MutationUpdateCaseEventArgs = {
  updateCaseEventInput: UpdateCaseEventInput;
};


export type MutationUpdateCaseTypeArgs = {
  updateCaseTypeInput: UpdateCaseTypeInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateCourtArgs = {
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateDepartmentArgs = {
  updateDepartmentInput: UpdateDepartmentInput;
};


export type MutationUpdateDocPageArgs = {
  updateDocPageInput: UpdateDocPageInput;
};


export type MutationUpdateEntryArgs = {
  input: UpdateEntryInput;
};


export type MutationUpdateExternalUserArgs = {
  updateExternalUserInput: UpdateExternalUserInput;
};


export type MutationUpdateExternalUserAddressArgs = {
  updateExternalUserAddress: UpdateExternalUserAddress;
};


export type MutationUpdateFeeTypeArgs = {
  feeType: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateFundRequestArgs = {
  updateFundRequestInput: UpdateFundRequestInput;
};


export type MutationUpdateLawTypeArgs = {
  updateLawTypeInput: UpdateLawTypeInput;
};


export type MutationUpdateMfaSettingsArgs = {
  mfaSettings: UpdateMfaSettingsInput;
};


export type MutationUpdateNoteArgs = {
  updateNoteInput: UpdateNoteInput;
};


export type MutationUpdateNoteTypeArgs = {
  id: Scalars['String'];
  noteType: Scalars['String'];
};


export type MutationUpdateOfficeArgs = {
  updateOfficeInput: UpdateOfficeInput;
};


export type MutationUpdatePasswordArgs = {
  updatePasswordInput: UpdatePasswordInput;
};


export type MutationUpdatePaymentArgs = {
  updatePaymentInput: UpdatePaymentInput;
};


export type MutationUpdateReconciliationSessionArgs = {
  input: UpdateReconciliationSessionInput;
};


export type MutationUpdateReconciliationSessionViewPreferencesArgs = {
  input: UpdateReconciliationSessionViewPreferencesInput;
};


export type MutationUpdateReferenceArgs = {
  updateReferenceInput: UpdateReferenceInput;
};


export type MutationUpdateReferralSourceArgs = {
  id: Scalars['String'];
  sourceType: Scalars['String'];
};


export type MutationUpdateRoleArgs = {
  user: UpdateRoleInput;
};


export type MutationUpdateTaskArgs = {
  updateTaskInput: UpdateTaskInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};


export type MutationUpdateUserCasesTaskArgs = {
  updateUserCasesTaskInput: UpdateUserCaseTaskInput;
};


export type MutationUpdateUserGeneralInfoArgs = {
  user: UpdateGeneralInput;
};


export type MutationUpdateUserMfaSettingsArgs = {
  mfaSettings: UpdateUserMfaSettingsInput;
};


export type MutationUpdateVendorArgs = {
  updateVendorInput: UpdateVendorInput;
};


export type MutationVerifyEmailArgs = {
  verifyEmail: VerifyEmailInput;
};


export type MutationVerifyEmailAndSetPasswordArgs = {
  verifyEmailAndSetPassword: VerifyUserAndUpdatePasswordInput;
};


export type MutationVerifyMfaOtpArgs = {
  verifyMfaOtp: VerifyMfaOtpInput;
};


export type MutationVoidAndDuplicatePayableArgs = {
  id: Scalars['String'];
};


export type MutationVoidAndReissueCheckArgs = {
  input: VoidAndReissueCheckInput;
};


export type MutationVoidBillArgs = {
  voidBillInput: VoidBillInput;
};


export type MutationVoidPayableArgs = {
  creditClients?: InputMaybe<Array<VoidCreditClientInput>>;
  id: Scalars['String'];
};


export type MutationWriteOffBillsArgs = {
  writeOffBillsInput: WriteOffBillsInput;
};

export type NextMatterNoPayload = {
  __typename?: 'NextMatterNoPayload';
  matterNo: Scalars['String'];
  response?: Maybe<ResponsePayload>;
};

export type NextVendorIdPayload = {
  __typename?: 'NextVendorIdPayload';
  nextVendorId: Scalars['String'];
  response?: Maybe<ResponsePayload>;
};

export type Note = {
  __typename?: 'Note';
  case?: Maybe<Case>;
  caseId: Scalars['String'];
  createdAt: Scalars['String'];
  description: Scalars['String'];
  externalUser?: Maybe<ExternalUser>;
  id: Scalars['String'];
  isClientNote: Scalars['Boolean'];
  isSmsNote: Scalars['Boolean'];
  noteType: NoteType;
  noteTypeId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type NoteInput = {
  id: Scalars['String'];
};

export type NotePayload = {
  __typename?: 'NotePayload';
  note?: Maybe<Note>;
  response?: Maybe<ResponsePayload>;
};

export type NoteType = {
  __typename?: 'NoteType';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  noteType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NoteTypesPayload = {
  __typename?: 'NoteTypesPayload';
  noteTypes?: Maybe<Array<Maybe<NoteType>>>;
  response?: Maybe<ResponsePayload>;
};

export type NotesByCaseInput = {
  caseId: Scalars['String'];
};

export type NotesByUserInput = {
  userId: Scalars['String'];
};

export type NotesPayload = {
  __typename?: 'NotesPayload';
  notes?: Maybe<Array<Maybe<Note>>>;
  response?: Maybe<ResponsePayload>;
};

export type Office = {
  __typename?: 'Office';
  accountsPayableLineItems?: Maybe<Array<AccountsPayableLineItem>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  cases?: Maybe<Array<Case>>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  isLocationOpen: Scalars['Boolean'];
  journalEntryLineItems?: Maybe<Array<JournalEntryLineItem>>;
  locationOfCases?: Maybe<Array<Case>>;
  name: Scalars['String'];
  officeNumber?: Maybe<Scalars['String']>;
  payableRefunds?: Maybe<Array<PayableRefund>>;
  payments?: Maybe<Array<Payment>>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<OfficeType>;
  updatedAt: Scalars['String'];
  users?: Maybe<Array<User>>;
  vendors?: Maybe<Array<Vendor>>;
};

export type OfficePayload = {
  __typename?: 'OfficePayload';
  office: Office;
  response?: Maybe<ResponsePayload>;
};

/** The office type */
export enum OfficeType {
  Location = 'LOCATION',
  ProfitCenter = 'PROFIT_CENTER'
}

export type OfficesPayload = {
  __typename?: 'OfficesPayload';
  offices?: Maybe<Array<Maybe<Office>>>;
  response?: Maybe<ResponsePayload>;
};

/** Order Case Input */
export enum OrderCaseBy {
  Court = 'COURT',
  MatterNo = 'MATTER_NO',
  Recent = 'RECENT',
  Title = 'TITLE'
}

/** Sort direction for payment list */
export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Order External Users Input */
export enum OrderExternalUsersBy {
  ClientId = 'CLIENT_ID',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  Recent = 'RECENT'
}

/** Order Case Input */
export enum OrderPaymentBy {
  Amount = 'AMOUNT',
  CheckNo = 'CHECK_NO',
  Date = 'DATE',
  Location = 'LOCATION',
  Method = 'METHOD'
}

export type OutstandingBillDetail = {
  __typename?: 'OutstandingBillDetail';
  billId: Scalars['Float'];
  clientId?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  interestDue: Scalars['Float'];
  principalBalance: Scalars['Float'];
  totalDue: Scalars['Float'];
  totalPaid: Scalars['Float'];
  totalPayable: Scalars['Float'];
  totalWrittenOff: Scalars['Float'];
};

export type OutstandingBillsPayload = {
  __typename?: 'OutstandingBillsPayload';
  outstandingBills: Array<OutstandingBillDetail>;
  previousBalance: Scalars['Float'];
  response?: Maybe<ResponsePayload>;
};

export type PaginatedAccountPaymentsInput = {
  accountId: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaginatedAccountPaymentsPayload = {
  __typename?: 'PaginatedAccountPaymentsPayload';
  pagination: PaginationPayload;
  payments: Array<PaymentWithRunningBalance>;
  response?: Maybe<ResponsePayload>;
};

export type PaginatedPrintJobsPayload = {
  __typename?: 'PaginatedPrintJobsPayload';
  pagination?: Maybe<PaginationPayload>;
  printJobs?: Maybe<Array<Maybe<PrintJob>>>;
  response?: Maybe<ResponsePayload>;
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

export type PaginationPayload = {
  __typename?: 'PaginationPayload';
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayableActionMetadata = {
  __typename?: 'PayableActionMetadata';
  action: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type PayableByCheckNumberPayload = {
  __typename?: 'PayableByCheckNumberPayload';
  accountPayableEntry?: Maybe<AccountsPayable>;
  response?: Maybe<ResponsePayload>;
};

export type PayableRefund = {
  __typename?: 'PayableRefund';
  account?: Maybe<Account>;
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Account>;
  id: Scalars['String'];
  office?: Maybe<Office>;
  payable: AccountsPayable;
  paymentMethod: PaymentMethod;
  referenceNo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PayableRefundPayload = {
  __typename?: 'PayableRefundPayload';
  payableRefund?: Maybe<PayableRefund>;
  response?: Maybe<ResponsePayload>;
};

/** Current status of the payable */
export enum PayableStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID',
  Voided = 'VOIDED'
}

export type PayableVoidPreviewPayload = {
  __typename?: 'PayableVoidPreviewPayload';
  items: Array<VoidPreviewItem>;
  response?: Maybe<ResponsePayload>;
};

export type Payment = {
  __typename?: 'Payment';
  account?: Maybe<Account>;
  advRefno?: Maybe<Scalars['String']>;
  advTransactionType?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  bill?: Maybe<Bill>;
  billAccessToken?: Maybe<Scalars['String']>;
  case?: Maybe<Case>;
  client?: Maybe<ExternalUser>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  journalEntries?: Maybe<Array<JournalEntry>>;
  journalEntry?: Maybe<JournalEntry>;
  /** This links source account -> destination account payments */
  linkedPayment?: Maybe<Payment>;
  notes?: Maybe<Scalars['String']>;
  office?: Maybe<Office>;
  payable?: Maybe<AccountsPayable>;
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  paymentMethod: PaymentMethod;
  paymentSource?: Maybe<PaymentSource>;
  paymentType: PaymentType;
  reconciledAt?: Maybe<Scalars['String']>;
  reconciledBy?: Maybe<User>;
  reconciliation?: Maybe<Reconciliation>;
  referenceNumber?: Maybe<Scalars['String']>;
  returnAmount?: Maybe<Scalars['Float']>;
  returnNotes?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<Scalars['DateTime']>;
  returnedBy?: Maybe<User>;
  returnedPayment?: Maybe<Payment>;
  returnedPaymentId?: Maybe<Scalars['String']>;
  slipNumber?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
  updatedAt: Scalars['String'];
  vendor?: Maybe<Vendor>;
  voidedPayable?: Maybe<AccountsPayable>;
  voidedPayableId?: Maybe<Scalars['String']>;
};

export type PaymentAllocation = {
  __typename?: 'PaymentAllocation';
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  /** Whether this allocation decreases or increases the bill balance. Default: decrease. */
  balanceEffect: PaymentAllocationBalanceEffect;
  bill: Bill;
  client: ExternalUser;
  cost?: Maybe<Scalars['Float']>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  expense?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  payment: Payment;
  paymentDate: Scalars['DateTime'];
  type: PaymentAllocationType;
  updatedAt: Scalars['String'];
};

/** Whether this allocation decreases or increases the bill balance */
export enum PaymentAllocationBalanceEffect {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

/** Payment allocation type */
export enum PaymentAllocationType {
  Interest = 'INTEREST',
  Principal = 'PRINCIPAL'
}

export type PaymentGroupedByDate = {
  __typename?: 'PaymentGroupedByDate';
  amount: Scalars['Float'];
  creditAmount?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  debitAmount?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  officeName?: Maybe<Scalars['String']>;
  paymentIds: Array<Scalars['String']>;
  slipNumber?: Maybe<Scalars['String']>;
};

export type PaymentGroupedByDateResponse = {
  __typename?: 'PaymentGroupedByDateResponse';
  payments: Array<PaymentGroupedByDate>;
  response?: Maybe<ResponsePayload>;
};

/** Payment method used to make the payment */
export enum PaymentMethod {
  Ach = 'ACH',
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  Eft = 'EFT',
  Other = 'OTHER',
  WireTransfer = 'WIRE_TRANSFER'
}

export type PaymentPayload = {
  __typename?: 'PaymentPayload';
  payment?: Maybe<Payment>;
  response?: Maybe<ResponsePayload>;
};

/** Source/category of the payment for filtering and reporting */
export enum PaymentSource {
  BillPayment = 'BILL_PAYMENT',
  ClientCreditPayment = 'CLIENT_CREDIT_PAYMENT',
  FirmPayment = 'FIRM_PAYMENT',
  RefundPayment = 'REFUND_PAYMENT',
  TrustPayment = 'TRUST_PAYMENT',
  VendorPayment = 'VENDOR_PAYMENT',
  VoidedPayableCredit = 'VOIDED_PAYABLE_CREDIT',
  VoidedPayableSettlement = 'VOIDED_PAYABLE_SETTLEMENT'
}

/** Payment type */
export enum PaymentType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type PaymentWithRunningBalance = {
  __typename?: 'PaymentWithRunningBalance';
  account?: Maybe<Account>;
  advRefno?: Maybe<Scalars['String']>;
  advTransactionType?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  bill?: Maybe<Bill>;
  billAccessToken?: Maybe<Scalars['String']>;
  case?: Maybe<Case>;
  client?: Maybe<ExternalUser>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  journalEntries?: Maybe<Array<JournalEntry>>;
  journalEntry?: Maybe<JournalEntry>;
  /** This links source account -> destination account payments */
  linkedPayment?: Maybe<Payment>;
  notes?: Maybe<Scalars['String']>;
  office?: Maybe<Office>;
  payable?: Maybe<AccountsPayable>;
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  paymentMethod: PaymentMethod;
  paymentSource?: Maybe<PaymentSource>;
  paymentType: PaymentType;
  reconciledAt?: Maybe<Scalars['String']>;
  reconciledBy?: Maybe<User>;
  reconciliation?: Maybe<Reconciliation>;
  referenceNumber?: Maybe<Scalars['String']>;
  returnAmount?: Maybe<Scalars['Float']>;
  returnNotes?: Maybe<Scalars['String']>;
  returnedAt?: Maybe<Scalars['DateTime']>;
  returnedBy?: Maybe<User>;
  returnedPayment?: Maybe<Payment>;
  returnedPaymentId?: Maybe<Scalars['String']>;
  runningBalance: Scalars['Float'];
  slipNumber?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
  updatedAt: Scalars['String'];
  vendor?: Maybe<Vendor>;
  voidedPayable?: Maybe<AccountsPayable>;
  voidedPayableId?: Maybe<Scalars['String']>;
};

export type PaymentsPayload = {
  __typename?: 'PaymentsPayload';
  pagination: PaginationPayload;
  payments: Array<Payment>;
  response?: Maybe<ResponsePayload>;
};

/** Status of accounting period (open or closed) */
export enum PeriodStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type PreBill = {
  __typename?: 'PreBill';
  accessTokens?: Maybe<Array<BillAccessToken>>;
  account?: Maybe<Account>;
  advInvoiceNo?: Maybe<Scalars['String']>;
  advRefno?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  amountPaid?: Maybe<Scalars['Float']>;
  approvedByResponsibleAttorney?: Maybe<User>;
  attorneyApprovedAt?: Maybe<Scalars['DateTime']>;
  billCopies?: Maybe<Array<BillCopy>>;
  billItems?: Maybe<Array<BillItem>>;
  billTimelines?: Maybe<Array<BillTimeline>>;
  billingPeriodDate?: Maybe<Scalars['DateTime']>;
  case: Case;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  creditBalance?: Maybe<Scalars['Float']>;
  departmentApprovedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  finalApprover?: Maybe<User>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  interests?: Maybe<Array<Interest>>;
  isDepartmentHead: Scalars['Boolean'];
  issueDate?: Maybe<Scalars['DateTime']>;
  journalEntries?: Maybe<Array<JournalEntry>>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
  outstandingBalance?: Maybe<Scalars['Float']>;
  payOffAmount?: Maybe<Scalars['Float']>;
  paymentAllocations?: Maybe<Array<PaymentAllocation>>;
  payments?: Maybe<Array<Payment>>;
  pdfSnapshotS3Key?: Maybe<Scalars['String']>;
  sendToClient: Scalars['Boolean'];
  status: BillStatus;
  trustBalance?: Maybe<Scalars['Float']>;
  type: BillType;
  updatedAt: Scalars['String'];
  writtenOffInterest?: Maybe<Scalars['Float']>;
  writtenOffPrincipal?: Maybe<Scalars['Float']>;
  writtenOffReason?: Maybe<Scalars['String']>;
};

export type PreBillsPayload = {
  __typename?: 'PreBillsPayload';
  pagination: PaginationPayload;
  preBills: Array<PreBill>;
  response?: Maybe<ResponsePayload>;
};

export type PreviewCheckAssignmentsInput = {
  bankAccountId?: InputMaybe<Scalars['String']>;
  startingCheckNo?: InputMaybe<Scalars['String']>;
  vouchers: Array<Scalars['String']>;
};

/** Filter payables by whether a check has been printed for them */
export enum PrintFilter {
  All = 'ALL',
  NonPrinted = 'NON_PRINTED',
  Printed = 'PRINTED'
}

export type PrintJob = {
  __typename?: 'PrintJob';
  attorneyIds?: Maybe<Array<Scalars['String']>>;
  /** UserType role to match the attorney against (e.g. responsibleAttorney1). "any" means any legal team role. */
  attorneyRole?: Maybe<Scalars['String']>;
  attorneys?: Maybe<Array<User>>;
  /** Batch ID for PRINT_BATCH print job type */
  batchId?: Maybe<Scalars['Float']>;
  billIds?: Maybe<Array<Scalars['Float']>>;
  /** POTENTIAL_BILLS only: which billing cycle to preview. Drives the entry cutoff date exactly as real bill generation does (mid-month = the 15th, end-of-month = the last day of last month, custom = customDate). */
  billingCycle?: Maybe<BillingCycle>;
  /** DELINQUENT_BILLS only: matter billing types to include. Null means no billing-type restriction, which is what every job created before this column did. */
  billingTypes?: Maybe<Array<BillingType>>;
  /** Case/matter ID for BY_MATTER print job type */
  caseId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<PrintJob>>;
  chunkIndex?: Maybe<Scalars['Float']>;
  chunkSize: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  creator?: Maybe<User>;
  /** POTENTIAL_BILLS only: cutoff date when billingCycle is CUSTOM_DATE. */
  customDate?: Maybe<Scalars['String']>;
  /** DELINQUENT_BILLS only: bill delivery methods to include. Null means Paper only (the default for every other job type). All three methods means no delivery-method restriction at all, so matters with no delivery method set are included too. */
  deliveryMethods?: Maybe<Array<BillDeliveryMethod>>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** DELINQUENT_BILLS only: render the matter billing (proforma) notes, as pre-bills do. */
  includeProformaNotes?: Maybe<Scalars['Boolean']>;
  /** POTENTIAL_BILLS only: also preview matters with no new billable work but an unpaid or open bill, which the scheduled monthly run bills at $0 to re-state the outstanding balance. */
  includeZeroDollarBills?: Maybe<Scalars['Boolean']>;
  /** DELINQUENT_BILLS only: restrict to matters that have paid nothing against their aged bills, only those that have part-paid them, or both. Null means no restriction, which is what every job created before this column did. */
  paymentStatuses?: Maybe<Array<DelinquentPaymentStatus>>;
  printJobType: PrintJobType;
  processedBills: Scalars['Float'];
  resolvedBillIds?: Maybe<Array<Scalars['Float']>>;
  sentToClientAt?: Maybe<Scalars['DateTime']>;
  /** Skipped bills: [{ billId, error }] */
  skippedBills?: Maybe<Scalars['JSON']>;
  /** Sort bills by attorney or caseNumber */
  sortBy?: Maybe<Scalars['String']>;
  /** Sort direction ASC/DESC */
  sortDir?: Maybe<Scalars['String']>;
  status: PrintJobStatus;
  totalBills?: Maybe<Scalars['Float']>;
  /** PRINT_BATCH / PRINT_BATCH_ALL only: restrict the run to bills whose matter is holding trust money, or to those whose matter is not. Null (or ALL) means no restriction, which is what every job created before this column did. */
  trustScope?: Maybe<PrintJobTrustScope>;
  updatedAt: Scalars['DateTime'];
};

export type PrintJobDownloadPayload = {
  __typename?: 'PrintJobDownloadPayload';
  /** Pre-signed URL to download the PDF */
  preSignedUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

export type PrintJobPayload = {
  __typename?: 'PrintJobPayload';
  printJob?: Maybe<PrintJob>;
  response?: Maybe<ResponsePayload>;
};

/** Sort order for printed bills */
export enum PrintJobSortBy {
  Attorney = 'ATTORNEY',
  CaseNumber = 'CASE_NUMBER',
  DueDate = 'DUE_DATE'
}

/** Sort direction */
export enum PrintJobSortDir {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Print job status */
export enum PrintJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Requested = 'REQUESTED'
}

/** Restrict a batch print run by whether the bill's matter is holding trust money */
export enum PrintJobTrustScope {
  All = 'ALL',
  WithoutTrust = 'WITHOUT_TRUST',
  WithTrust = 'WITH_TRUST'
}

/** Type of print job */
export enum PrintJobType {
  Bills = 'BILLS',
  ByMatter = 'BY_MATTER',
  Custom = 'CUSTOM',
  DelinquentBills = 'DELINQUENT_BILLS',
  NewBills = 'NEW_BILLS',
  PotentialBills = 'POTENTIAL_BILLS',
  PreBills = 'PRE_BILLS',
  PrintBatch = 'PRINT_BATCH',
  PrintBatchAll = 'PRINT_BATCH_ALL'
}

export type PublishDocPageInput = {
  changeSummary?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Fetch a specific accounting period by fiscal year and month */
  accountingPeriod: AccountingPeriod;
  /** Fetch accounting periods for a fiscal year (or all if year not specified) */
  accountingPeriods: Array<AccountingPeriod>;
  checkConflicts: ConflictResponse;
  docPage: DocPagePayload;
  docPageRevisions: DocPageRevisionsPayload;
  docPagesTree: DocPagesPayload;
  downloadBillSnapshot: BillSnapshotDownloadPayload;
  downloadPrintJob: PrintJobDownloadPayload;
  downloadReport: ReportMediaPayload;
  fetchAccountById: AccountPayload;
  fetchAccountReconciliation: AccountReconciliationResponse;
  fetchAccountsPayables: AccountsPayablePayload;
  fetchAccountsReceivable: FetchAccountsReceivablePayload;
  fetchAchOrEftNoOfEntry: AchOrEftNumberPayload;
  fetchActivities: ActivityPayload;
  fetchAllAccounts: AccountsPayload;
  fetchAllAssignedTasks: UserTasksPayload;
  fetchAllCaseEvents: CaseEventsPayload;
  fetchAllCaseNotes: NotesPayload;
  fetchAllCaseTasks: UserTasksPayload;
  fetchAllCaseTypes: CaseTypesPayload;
  fetchAllCaseTypesByLawId: CaseTypesPayload;
  fetchAllCases: CasesPayload;
  fetchAllCasesLight: CasesPayload;
  fetchAllCategories: CategoriesPayload;
  fetchAllCourts: CourtsPayload;
  fetchAllDepartments: DepartmentsPayload;
  fetchAllEntries: EntriesPayload;
  fetchAllExternalUserRoles: ExternalUserRolesPayload;
  fetchAllExternalUsers: ExternalUsersPayload;
  fetchAllFeeTypes: FeeTypesPayload;
  fetchAllHourlyCases: HourlyCasesPayload;
  fetchAllLawTypes: LawTypesPayload;
  fetchAllMattersWithoutJoin: CasesPayload;
  fetchAllNoteTypes: NoteTypesPayload;
  fetchAllOffices: OfficesPayload;
  fetchAllPayments: PaymentsPayload;
  fetchAllPaymentsForReconciliation: PaymentsPayload;
  fetchAllReferences: ReferencesPayload;
  fetchAllReferralSources: ReferralSourcesPayload;
  fetchAllRoles: RolesPayload;
  fetchAllTasks: TasksPayload;
  fetchAllUserNotes: NotesPayload;
  fetchAllUsers: UsersPayload;
  fetchAllVendors: VendorsPayload;
  fetchAssigneeCourts: CourtsPayload;
  fetchBillDetails: FetchBillDetailsPayload;
  fetchBillDetailsByMatter: FetchBillDetailsPayload;
  fetchBillPayments: BillPaymentsPayload;
  fetchBillableCases: BillableCasesPayload;
  fetchCarriableVoidedBills: CarriableVoidedBillsPayload;
  fetchCase: CasePayload;
  fetchCaseChartsSummary: CaseChartsSummaryPayload;
  fetchCaseEntriesByFeeTypes: CaseEntriesByFeeTypesPayload;
  fetchCaseEvent: CaseEventPayload;
  fetchCaseFinancialTimeline: CaseFinancialTimelinePayload;
  fetchCaseFinancials: CaseFinancialsPayload;
  fetchCaseType: CaseTypePayload;
  fetchCategoriesBalances: CategoriesBalancesPayload;
  fetchClientLedger: ClientLedgerPayload;
  fetchCourt: CourtPayload;
  fetchCourtDates: CourtDatesPayload;
  fetchDataForRecordPayments: FetchDataForRecordPaymentsPayload;
  fetchDepartmentUsersByLawType: DepartmentUsersPayload;
  fetchExternalUser: ExternalUserPayload;
  fetchFinalBills: FinalBillsPayload;
  fetchFirmDashboardAccounting: FirmDashboardAccountingPayload;
  fetchFirmDashboardBilling: FirmDashboardBillingPayload;
  fetchFirmDashboardMatters: FirmDashboardMattersPayload;
  fetchFundRequest: FetchFundRequestPayload;
  fetchFundRequests: FetchFundRequestsPayload;
  fetchInterestEntries: InterestEntriesPayload;
  fetchJournalEntries: FetchJournalEntriesPayload;
  fetchJournalEntry: JournalEntry;
  fetchLawType: LawTypePayload;
  fetchMostRecentClient: ExternalUserPayload;
  fetchMyReconciliationSessions: Array<ReconciliationSession>;
  fetchNote: NotePayload;
  fetchNoteTypeById: NoteType;
  fetchOperatingAccount: Account;
  fetchOutstandingBills: OutstandingBillsPayload;
  fetchPaginatedAccountPayments: PaginatedAccountPaymentsPayload;
  fetchPayableRefunds: FetchPayableRefundsPayload;
  fetchPaymentById: PaymentPayload;
  fetchPaymentsByProfitCenter: PaymentGroupedByDateResponse;
  fetchPendingFundRequest: FetchFundRequestPayload;
  fetchPreBills: PreBillsPayload;
  fetchPrintJob: PrintJobPayload;
  fetchPrintJobs: PaginatedPrintJobsPayload;
  fetchPublicBillDetails: FetchPublicBillDetailsPayload;
  fetchPublicOutstandingBills: OutstandingBillsPayload;
  fetchQuickBillDetails: FetchQuickBillDetailsPayload;
  fetchRecentCase: NextMatterNoPayload;
  fetchRecentFundRequest: FetchFundRequestPayload;
  fetchReconciliation: Reconciliation;
  fetchReconciliationDocumentStatus: ReconciliationDocumentStatusPayload;
  fetchReconciliationSession: ReconciliationSession;
  fetchReconciliations: ReconciliationsResponse;
  fetchRemainingFlatFee: FetchRemainingFlatFeePayload;
  fetchReplacementBillToken: ReplacementBillTokenPayload;
  fetchReportCreators: Array<User>;
  fetchReports: ReportsPayload;
  fetchRetainerAccount: Account;
  fetchTask: TaskPayload;
  fetchUser: UserPayload;
  fetchUsersByIds: UsersPayload;
  fetchVoucherOfPayableEntry: VoucherPayload;
  fetchZescrowAccount: Account;
  findOneCategory: CategoryPayload;
  findOneUser: UserPayload;
  findPayableByCheckNumber: PayableByCheckNumberPayload;
  generateGeneralLedger: LedgerReportPayload;
  getAccountPayableByVoucher: AccountPayablePayload;
  getAttachment: AttachmentMediaPayload;
  getAttachments: AttachmentsPayload;
  getBillEmailBatch: GetBatchPayload;
  getBillEmailBatches: GetBatchesPayload;
  getBillInterest: BillInterestPayload;
  getCaseBillingPauseDate: CaseNextBillingDatePayload;
  getCaseClients: GetCaseClientsPayload;
  getCaseNextBillingDate: CaseNextBillingDatePayload;
  getCasesWithLowTrustBalance: CasesWithLowTrustBalancePayload;
  getClientBalanceInAccount: GetClientBalanceInAccountPayload;
  getClientByClientNumber: ExternalUserPayload;
  getClientCreditBalance: GetClientCreditBalancePayload;
  getClientTrustBalance: GetClientTrustBalancePayload;
  getCreditBalanceSummary: CreditBalanceSummaryPayload;
  getDepartmentHeadForCase: GetDepartmentHeadForCasePayload;
  getFeeTypeById: FeeTypePayload;
  getHourlyAmountLoggedForCase: HourlyAmountLoggedForCasePayload;
  getInitialPaymentLock: InitialPaymentLockPayload;
  getNextClientNumber: FetchClientNoPayload;
  getNextVendorId: NextVendorIdPayload;
  getPublicClientTrustBalance: GetClientTrustBalancePayload;
  getPublicCreditBalanceSummary: CreditBalanceSummaryPayload;
  getReportTemplates: Array<ReportGroup>;
  getRunningTimers: EntriesPayload;
  getTrustBalanceSummary: TrustBalanceSummaryPayload;
  isDepartmentHeadForCase: DepartmentHeadPayload;
  me: UserPayload;
  payableVoidPreview: PayableVoidPreviewPayload;
  previewCheckAssignments: CheckAssignmentPlanPayload;
  queueJobs: QueueJobsPayload;
  queuesOverview: QueuesOverviewPayload;
  recentDocPages: DocPagesPayload;
  searchDocPages: DocPageSearchPayload;
  searchMatters: SearchMattersPayload;
  searchUser: UsersPayload;
  voidedPayableCredits: VoidedPayableCreditsPayload;
  /** Fetch a specific year-end close record by fiscal year */
  yearEndClose?: Maybe<YearEndClose>;
  /** Fetch year-end close records for a fiscal year (or all if year not specified) */
  yearEndCloses: Array<YearEndClose>;
};


export type QueryAccountingPeriodArgs = {
  fiscalYear: Scalars['Int'];
  month: Scalars['Int'];
};


export type QueryAccountingPeriodsArgs = {
  fiscalYear?: InputMaybe<Scalars['Int']>;
};


export type QueryCheckConflictsArgs = {
  checkConflictsInput: CheckConflictsInput;
};


export type QueryDocPageArgs = {
  fetchDocPageInput: FetchDocPageInput;
};


export type QueryDocPageRevisionsArgs = {
  pageId: Scalars['String'];
};


export type QueryDocPagesTreeArgs = {
  scope?: InputMaybe<DocPageScope>;
};


export type QueryDownloadBillSnapshotArgs = {
  billId: Scalars['Int'];
  copyIndex?: InputMaybe<Scalars['Int']>;
};


export type QueryDownloadPrintJobArgs = {
  id: Scalars['String'];
};


export type QueryDownloadReportArgs = {
  reportDownloadInput: ReportDownloadInput;
};


export type QueryFetchAccountByIdArgs = {
  id: Scalars['String'];
};


export type QueryFetchAccountReconciliationArgs = {
  fetchAccountReconciliationInput: AccountReconciliationInput;
};


export type QueryFetchAccountsPayablesArgs = {
  input: FetchAccountsPayableInput;
};


export type QueryFetchAccountsReceivableArgs = {
  input: FetchAccountsReceivableInput;
};


export type QueryFetchAchOrEftNoOfEntryArgs = {
  method: Scalars['String'];
};


export type QueryFetchActivitiesArgs = {
  fetchActivityInput: FetchLogsInput;
};


export type QueryFetchAllAccountsArgs = {
  accountsInput: AccountsInput;
};


export type QueryFetchAllAssignedTasksArgs = {
  tasksInput: TasksByAssigneeInput;
};


export type QueryFetchAllCaseEventsArgs = {
  caseEventsInput: CaseEventsByCaseInput;
};


export type QueryFetchAllCaseNotesArgs = {
  notesInput: NotesByCaseInput;
};


export type QueryFetchAllCaseTasksArgs = {
  tasksInput: TasksByCaseInput;
};


export type QueryFetchAllCaseTypesByLawIdArgs = {
  caseTypesInput: CaseTypesInput;
};


export type QueryFetchAllCasesArgs = {
  casesInput: CasesInput;
};


export type QueryFetchAllCasesLightArgs = {
  casesLightInput: CasesLightInput;
};


export type QueryFetchAllCategoriesArgs = {
  fetchCategoriesInput: FetchCategoriesInput;
};


export type QueryFetchAllCourtsArgs = {
  courtsInput: CourtsInput;
};


export type QueryFetchAllDepartmentsArgs = {
  fetchDepartmentsInput: FetchDepartmentsInput;
};


export type QueryFetchAllEntriesArgs = {
  fetchEntriesInput: FetchEntriesInput;
};


export type QueryFetchAllExternalUsersArgs = {
  externalUsersInput: ExternalUsersInput;
};


export type QueryFetchAllFeeTypesArgs = {
  fetchFeeTypes: FetchFeeTypeInput;
};


export type QueryFetchAllHourlyCasesArgs = {
  fetchHourlyCasesInput: FetchHourlyCasesInput;
};


export type QueryFetchAllMattersWithoutJoinArgs = {
  casesInput: CasesInput;
};


export type QueryFetchAllOfficesArgs = {
  fetchOfficesInput: FetchAllOfficesInput;
};


export type QueryFetchAllPaymentsArgs = {
  fetchAllPaymentsInput: FetchPaymentsInput;
};


export type QueryFetchAllPaymentsForReconciliationArgs = {
  fetchAllPaymentsInput: FetchPaymentsInput;
};


export type QueryFetchAllReferencesArgs = {
  fetchAllReferences: FetchAllReferencesInput;
};


export type QueryFetchAllReferralSourcesArgs = {
  fetchAllSources: FetchAllReferralSourceInput;
};


export type QueryFetchAllTasksArgs = {
  tasksInput: TasksInput;
};


export type QueryFetchAllUserNotesArgs = {
  notesInput: NotesByUserInput;
};


export type QueryFetchAllUsersArgs = {
  userInput: UsersInput;
};


export type QueryFetchAllVendorsArgs = {
  fetchVendorsInput: FetchAllVendorsInput;
};


export type QueryFetchAssigneeCourtsArgs = {
  courtsInput: CourtsInput;
};


export type QueryFetchBillDetailsArgs = {
  fetchBillDetailsInput: FetchBillDetailsInput;
};


export type QueryFetchBillDetailsByMatterArgs = {
  fetchBillDetailsByMatterInput: FetchBillDetailsByMatterInput;
};


export type QueryFetchBillPaymentsArgs = {
  billPaymentsInput: BillPaymentsInput;
};


export type QueryFetchBillableCasesArgs = {
  fetchBillableCasesInput: FetchBillableCasesInput;
};


export type QueryFetchCarriableVoidedBillsArgs = {
  fetchCarriableVoidedBillsInput: FetchCarriableVoidedBillsInput;
};


export type QueryFetchCaseArgs = {
  caseInput: CaseInput;
};


export type QueryFetchCaseChartsSummaryArgs = {
  caseId: Scalars['String'];
};


export type QueryFetchCaseEntriesByFeeTypesArgs = {
  caseEntriesByFeeTypesInput: CaseEntriesByFeeTypesInput;
};


export type QueryFetchCaseEventArgs = {
  caseEventInput: CaseEventInput;
};


export type QueryFetchCaseFinancialTimelineArgs = {
  caseId: Scalars['String'];
};


export type QueryFetchCaseFinancialsArgs = {
  caseId: Scalars['String'];
};


export type QueryFetchCaseTypeArgs = {
  caseTypeInput: CaseTypeInput;
};


export type QueryFetchClientLedgerArgs = {
  input: FetchClientLedgerInput;
};


export type QueryFetchCourtArgs = {
  courtInput: GetCourt;
};


export type QueryFetchCourtDatesArgs = {
  courtDatesInput: CourtDatesInput;
};


export type QueryFetchDataForRecordPaymentsArgs = {
  fetchDataForRecordPaymentsInput: FetchDataForRecordPaymentsInput;
};


export type QueryFetchDepartmentUsersByLawTypeArgs = {
  fetchDepartmentUsersByLawTypeInput: FetchDepartmentUsersByLawTypeInput;
};


export type QueryFetchExternalUserArgs = {
  externalUserInput: ExternalUserInput;
};


export type QueryFetchFinalBillsArgs = {
  fetchFinalBillsInput: FetchFinalBillsInput;
};


export type QueryFetchFirmDashboardAccountingArgs = {
  input: FirmDashboardDateRangeInput;
};


export type QueryFetchFirmDashboardBillingArgs = {
  input: FirmDashboardDateRangeInput;
};


export type QueryFetchFirmDashboardMattersArgs = {
  input: FirmDashboardDateRangeInput;
};


export type QueryFetchFundRequestArgs = {
  billId: Scalars['Float'];
};


export type QueryFetchFundRequestsArgs = {
  fetchFundRequestsInput: FetchFundRequestsInput;
};


export type QueryFetchInterestEntriesArgs = {
  fetchInterestEntriesInput: FetchInterestEntriesInput;
};


export type QueryFetchJournalEntriesArgs = {
  input: FetchJournalEntriesInput;
};


export type QueryFetchJournalEntryArgs = {
  id: Scalars['String'];
};


export type QueryFetchLawTypeArgs = {
  lawTypeInput: LawTypeInput;
};


export type QueryFetchNoteArgs = {
  noteInput: NoteInput;
};


export type QueryFetchNoteTypeByIdArgs = {
  id: Scalars['String'];
};


export type QueryFetchOutstandingBillsArgs = {
  fetchOutstandingBillsInput: FetchOutstandingBillsInput;
};


export type QueryFetchPaginatedAccountPaymentsArgs = {
  fetchPaginatedAccountPaymentsInput: PaginatedAccountPaymentsInput;
};


export type QueryFetchPayableRefundsArgs = {
  input: FetchPayableRefundsInput;
};


export type QueryFetchPaymentByIdArgs = {
  paymentId: Scalars['String'];
};


export type QueryFetchPaymentsByProfitCenterArgs = {
  input: FetchPaymentsByProfitCenterInput;
};


export type QueryFetchPendingFundRequestArgs = {
  caseId: Scalars['String'];
};


export type QueryFetchPreBillsArgs = {
  fetchPreBillsInput: FetchPreBillsInput;
};


export type QueryFetchPrintJobArgs = {
  id: Scalars['String'];
};


export type QueryFetchPrintJobsArgs = {
  input: FetchPrintJobsInput;
};


export type QueryFetchPublicBillDetailsArgs = {
  fetchPublicBillDetailsInput: FetchPublicBillDetailsInput;
};


export type QueryFetchPublicOutstandingBillsArgs = {
  fetchOutstandingBillsInput: FetchOutstandingBillsInput;
};


export type QueryFetchQuickBillDetailsArgs = {
  fetchQuickBillDetailsInput: FetchQuickBillDetailsInput;
};


export type QueryFetchRecentCaseArgs = {
  isConsultMatter: Scalars['Boolean'];
};


export type QueryFetchRecentFundRequestArgs = {
  caseId: Scalars['String'];
};


export type QueryFetchReconciliationArgs = {
  id: Scalars['Float'];
};


export type QueryFetchReconciliationDocumentStatusArgs = {
  id: Scalars['Int'];
};


export type QueryFetchReconciliationSessionArgs = {
  sessionId: Scalars['Int'];
};


export type QueryFetchReconciliationsArgs = {
  fetchAllReconciliationInput: FetchReconciliationsInput;
};


export type QueryFetchRemainingFlatFeeArgs = {
  fetchRemainingFlatFeeInput: FetchRemainingFlatFeeInput;
};


export type QueryFetchReplacementBillTokenArgs = {
  token: Scalars['String'];
};


export type QueryFetchReportsArgs = {
  reportsInput: ReportsInput;
};


export type QueryFetchTaskArgs = {
  taskInput: TaskInput;
};


export type QueryFetchUsersByIdsArgs = {
  userIdsInput: UserIdsInput;
};


export type QueryFindOneCategoryArgs = {
  id: Scalars['String'];
};


export type QueryFindOneUserArgs = {
  id: Scalars['String'];
};


export type QueryFindPayableByCheckNumberArgs = {
  bankAccountId: Scalars['String'];
  checkNumber: Scalars['String'];
};


export type QueryGenerateGeneralLedgerArgs = {
  input: FetchGeneralLedgerInput;
};


export type QueryGetAccountPayableByVoucherArgs = {
  voucherNo: Scalars['String'];
};


export type QueryGetAttachmentArgs = {
  getMedia: GetMedia;
};


export type QueryGetAttachmentsArgs = {
  getAttachment: GetAttachment;
};


export type QueryGetBillEmailBatchArgs = {
  input: GetBatchInput;
};


export type QueryGetBillInterestArgs = {
  billInterestInput: BillInterestInput;
};


export type QueryGetCaseBillingPauseDateArgs = {
  advancePayment: Scalars['Float'];
  caseId: Scalars['String'];
};


export type QueryGetCaseClientsArgs = {
  getCaseClientsInput: GetCaseClientsInput;
};


export type QueryGetCaseNextBillingDateArgs = {
  caseId: Scalars['String'];
};


export type QueryGetCasesWithLowTrustBalanceArgs = {
  casesWithLowTrustBalanceInput?: InputMaybe<CasesWithLowTrustBalanceInput>;
};


export type QueryGetClientBalanceInAccountArgs = {
  getClientBalanceInAccountInput: GetClientBalanceInAccountInput;
};


export type QueryGetClientByClientNumberArgs = {
  clientNumber: Scalars['String'];
};


export type QueryGetClientCreditBalanceArgs = {
  getClientCreditBalanceInput: GetClientCreditBalanceInput;
};


export type QueryGetClientTrustBalanceArgs = {
  getClientTrustBalanceInput: GetClientTrustBalanceInput;
};


export type QueryGetCreditBalanceSummaryArgs = {
  getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput;
};


export type QueryGetDepartmentHeadForCaseArgs = {
  caseId: Scalars['String'];
};


export type QueryGetFeeTypeByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetHourlyAmountLoggedForCaseArgs = {
  caseId: Scalars['String'];
};


export type QueryGetInitialPaymentLockArgs = {
  caseId: Scalars['String'];
};


export type QueryGetNextClientNumberArgs = {
  isConsultClient: Scalars['Boolean'];
};


export type QueryGetPublicClientTrustBalanceArgs = {
  getClientTrustBalanceInput: GetClientTrustBalanceInput;
};


export type QueryGetPublicCreditBalanceSummaryArgs = {
  getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput;
};


export type QueryGetTrustBalanceSummaryArgs = {
  getTrustBalanceSummaryInput: GetTrustBalanceSummaryInput;
};


export type QueryIsDepartmentHeadForCaseArgs = {
  fetchDepartmentHeadInput: FetchDepartmentHeadInput;
};


export type QueryPayableVoidPreviewArgs = {
  creditClients?: InputMaybe<Array<VoidCreditClientInput>>;
  id: Scalars['String'];
};


export type QueryPreviewCheckAssignmentsArgs = {
  input: PreviewCheckAssignmentsInput;
};


export type QueryQueueJobsArgs = {
  fetchQueueJobsInput: FetchQueueJobsInput;
};


export type QueryRecentDocPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<DocPageScope>;
};


export type QuerySearchDocPagesArgs = {
  searchDocPagesInput: SearchDocPagesInput;
};


export type QuerySearchMattersArgs = {
  searchMattersInput: SearchMattersInput;
};


export type QuerySearchUserArgs = {
  searchUserInput: SearchUserInput;
};


export type QueryVoidedPayableCreditsArgs = {
  payableId: Scalars['String'];
};


export type QueryYearEndCloseArgs = {
  fiscalYear: Scalars['Int'];
};


export type QueryYearEndClosesArgs = {
  fiscalYear?: InputMaybe<Scalars['Int']>;
};

export type QueueActionPayload = {
  __typename?: 'QueueActionPayload';
  isPaused: Scalars['Boolean'];
  name: Scalars['String'];
  response?: Maybe<ResponsePayload>;
};

export type QueueCounts = {
  __typename?: 'QueueCounts';
  active: Scalars['Int'];
  completed: Scalars['Int'];
  delayed: Scalars['Int'];
  failed: Scalars['Int'];
  paused: Scalars['Int'];
  waiting: Scalars['Int'];
};

export type QueueJob = {
  __typename?: 'QueueJob';
  attemptsMade: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  failedReason?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  processedAt?: Maybe<Scalars['DateTime']>;
  progress?: Maybe<Scalars['Int']>;
  stacktrace?: Maybe<Scalars['String']>;
};

export type QueueJobActionInput = {
  jobId: Scalars['String'];
  queueName: Scalars['String'];
};

export enum QueueJobState {
  Active = 'active',
  Completed = 'completed',
  Delayed = 'delayed',
  Failed = 'failed',
  Paused = 'paused',
  Waiting = 'waiting'
}

export type QueueJobsPayload = {
  __typename?: 'QueueJobsPayload';
  jobs: Array<QueueJob>;
  response?: Maybe<ResponsePayload>;
  total: Scalars['Int'];
};

export type QueueNameInput = {
  queueName: Scalars['String'];
};

export type QueueOverview = {
  __typename?: 'QueueOverview';
  counts: QueueCounts;
  isPaused: Scalars['Boolean'];
  name: Scalars['String'];
};

export type QueuesOverviewPayload = {
  __typename?: 'QueuesOverviewPayload';
  queues: Array<QueueOverview>;
  response?: Maybe<ResponsePayload>;
};

export type ReconcileGroupedPaymentsByProfitCenterInput = {
  accountId: Scalars['String'];
  dateAndOfficeIds: Array<DateAndOfficeIds>;
  monthOfYear: Scalars['String'];
  statementBalance: Scalars['Float'];
};

export type ReconcilePaymentInput = {
  accountId: Scalars['String'];
  monthOfYear?: InputMaybe<Scalars['String']>;
  paymentIds: Array<Scalars['String']>;
  statementBalance: Scalars['Float'];
};

export type Reconciliation = {
  __typename?: 'Reconciliation';
  account: Account;
  beginningBalance: Scalars['Float'];
  clearedBalance: Scalars['Float'];
  createdAt: Scalars['String'];
  csvStatus?: Maybe<ReconciliationDocumentStatus>;
  difference: Scalars['Float'];
  documentErrorMessage?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  finished: Scalars['Boolean'];
  id: Scalars['Float'];
  payments?: Maybe<Array<Payment>>;
  pdfStatus?: Maybe<ReconciliationDocumentStatus>;
  previousReconciliation?: Maybe<Reconciliation>;
  reconciledBy?: Maybe<User>;
  startDate: Scalars['String'];
  statementBalance: Scalars['Float'];
  unreconciledAt?: Maybe<Scalars['String']>;
  unreconciledBy?: Maybe<User>;
  unreconciledPaymentIds?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['String'];
};

/** Downloadable formats for a bank reconciliation document */
export enum ReconciliationDocumentFileFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ReconciliationDocumentInput = {
  fileFormat: ReconciliationDocumentFileFormat;
  reconciliationId: Scalars['Int'];
  userTimezone?: InputMaybe<Scalars['String']>;
};

export type ReconciliationDocumentPayload = {
  __typename?: 'ReconciliationDocumentPayload';
  preSignedUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
  status: ReconciliationDocumentStatus;
};

/** Generation status of a reconciliation PDF/CSV document */
export enum ReconciliationDocumentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ReconciliationDocumentStatusPayload = {
  __typename?: 'ReconciliationDocumentStatusPayload';
  csvStatus?: Maybe<ReconciliationDocumentStatus>;
  documentErrorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  pdfStatus?: Maybe<ReconciliationDocumentStatus>;
};

export type ReconciliationResponse = {
  __typename?: 'ReconciliationResponse';
  reconciliation: Reconciliation;
  response?: Maybe<ResponsePayload>;
};

export type ReconciliationSession = {
  __typename?: 'ReconciliationSession';
  account: Account;
  beginningBalance: Scalars['Float'];
  clearedBalance: Scalars['Float'];
  committedReconciliation?: Maybe<Reconciliation>;
  createdAt: Scalars['String'];
  createdBy: User;
  creditTotal: Scalars['Float'];
  debitTotal: Scalars['Float'];
  difference: Scalars['Float'];
  id: Scalars['Float'];
  itemCount: Scalars['Int'];
  items: Array<ReconciliationSessionItem>;
  removedItemCount?: Maybe<Scalars['Int']>;
  statementBalance?: Maybe<Scalars['Float']>;
  statementMonth: Scalars['String'];
  status: ReconciliationSessionStatus;
  updatedAt: Scalars['String'];
  version: Scalars['Float'];
  viewPreferences?: Maybe<ReconciliationSessionViewPreferences>;
};

export type ReconciliationSessionItem = {
  __typename?: 'ReconciliationSessionItem';
  amount: Scalars['Float'];
  paymentId: Scalars['String'];
  paymentType: PaymentType;
};

export type ReconciliationSessionItemInput = {
  amount: Scalars['Float'];
  paymentId: Scalars['String'];
  paymentType: PaymentType;
};

/** Lifecycle state of a bank-reconciliation draft session */
export enum ReconciliationSessionStatus {
  Committed = 'COMMITTED',
  Discarded = 'DISCARDED',
  Open = 'OPEN'
}

export type ReconciliationSessionViewPreferences = {
  __typename?: 'ReconciliationSessionViewPreferences';
  lineItems?: Maybe<Scalars['Boolean']>;
  office?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  orderDirection?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
};

export type ReconciliationSessionViewPreferencesInput = {
  lineItems?: InputMaybe<Scalars['Boolean']>;
  office?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
};

export type ReconciliationsResponse = {
  __typename?: 'ReconciliationsResponse';
  pagination?: Maybe<PaginationPayload>;
  reconciliations?: Maybe<Array<Maybe<Reconciliation>>>;
  response?: Maybe<ResponsePayload>;
};

export type RecordClientCreditsInput = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  caseId: Scalars['String'];
  clientId: Scalars['String'];
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  paymentMethod: PaymentMethod;
  referenceNo: Scalars['String'];
  slipNumber?: InputMaybe<Scalars['String']>;
};

export type RecordClientCreditsPayload = {
  __typename?: 'RecordClientCreditsPayload';
  paymentId?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

export type RecordManualPaymentInput = {
  advancePaymentAmount?: InputMaybe<Scalars['Float']>;
  amount: Scalars['Float'];
  billId?: InputMaybe<Scalars['Float']>;
  caseId?: InputMaybe<Scalars['String']>;
  clientId: Scalars['String'];
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  destinationAccountId: Scalars['String'];
  generateClientBillCopy?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Float'];
  pauseBillingUntil?: InputMaybe<Scalars['DateTime']>;
  paymentMethod: PaymentMethod;
  referenceNo: Scalars['String'];
  slipNumber?: InputMaybe<Scalars['String']>;
};

export type RecordPaymentInput = {
  accountType: AccountType;
  advancePaymentAmount?: InputMaybe<Scalars['Float']>;
  amount: Scalars['Float'];
  bankAccountToken?: InputMaybe<Scalars['String']>;
  bankData?: InputMaybe<BankDataInput>;
  billAccessToken: Scalars['String'];
  cardData?: InputMaybe<CardDataInput>;
  cardToken?: InputMaybe<Scalars['String']>;
  method: PaymentMethod;
};

export type Reference = {
  __typename?: 'Reference';
  active: Scalars['Boolean'];
  caseReferences?: Maybe<Array<Maybe<CaseReference>>>;
  createdAt: Scalars['String'];
  eligibleFor1099Report: Scalars['Boolean'];
  id: Scalars['String'];
  referral: Scalars['String'];
  referralSource: ReferralSource;
  referralSourceId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type ReferenceInput = {
  percentage?: InputMaybe<Scalars['Float']>;
  referenceId?: InputMaybe<Scalars['String']>;
};

export type ReferencePayload = {
  __typename?: 'ReferencePayload';
  reference?: Maybe<Reference>;
  response?: Maybe<ResponsePayload>;
};

export type ReferencesPayload = {
  __typename?: 'ReferencesPayload';
  pagination?: Maybe<PaginationPayload>;
  references?: Maybe<Array<Maybe<Reference>>>;
  response?: Maybe<ResponsePayload>;
};

export type ReferralSource = {
  __typename?: 'ReferralSource';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  sourceType: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ReferralSourcesPayload = {
  __typename?: 'ReferralSourcesPayload';
  pagination?: Maybe<PaginationPayload>;
  referralSources?: Maybe<Array<Maybe<ReferralSource>>>;
  response?: Maybe<ResponsePayload>;
};

export type RefundPaymentInput = {
  caseId: Scalars['String'];
  clientId: Scalars['String'];
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  destinationAccountId: Scalars['String'];
  locationId: Scalars['Float'];
  paymentMethod: PaymentMethod;
  referenceNo: Scalars['String'];
  refundAmount: Scalars['Float'];
  slipNumber?: InputMaybe<Scalars['String']>;
};

export type RegisterUserInput = {
  delegateIds?: InputMaybe<Array<Scalars['String']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  initials?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Send Investor Type from the ENUM - Sign-up */
  roleType: UserRole;
};

export type RemoveAttachment = {
  id?: InputMaybe<Scalars['String']>;
};

export type RemoveCasesMediaInput = {
  attachmentId: Scalars['String'];
  caseId: Scalars['String'];
};

export type RemoveCourt = {
  id: Scalars['String'];
};

export type RemoveExternalUserFromCourt = {
  courtId: Scalars['String'];
  externalUserId: Scalars['String'];
};

export type RemoveUsersFromCaseInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type ReorderDocPageItem = {
  id: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
};

export type ReorderDocPagesInput = {
  items: Array<ReorderDocPageItem>;
};

export type ReplacementBillTokenPayload = {
  __typename?: 'ReplacementBillTokenPayload';
  billId?: Maybe<Scalars['Float']>;
  response?: Maybe<ResponsePayload>;
  token?: Maybe<Scalars['String']>;
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime'];
  creator: User;
  /** Selection fields with human-readable labels (IDs resolved to names) */
  displaySelectionFields?: Maybe<Scalars['JSON']>;
  errorMessage?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  reportGroup: Scalars['String'];
  reportSelection: Scalars['String'];
  /** Selection fields as key-value */
  selectionFields?: Maybe<Scalars['JSON']>;
  /** Sort fields in order */
  sortFields?: Maybe<Array<ReportSort>>;
  status: ReportStatus;
  updatedAt: Scalars['DateTime'];
};

export type ReportDownloadInput = {
  fileType: ReportFileType;
  id: Scalars['String'];
  userTimezone?: InputMaybe<Scalars['String']>;
};

export enum ReportFileType {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ReportGroup = {
  __typename?: 'ReportGroup';
  description?: Maybe<Scalars['String']>;
  group: Scalars['String'];
  label: Scalars['String'];
  selections: Array<ReportSelection>;
};

export type ReportMediaPayload = {
  __typename?: 'ReportMediaPayload';
  preSignedUrl?: Maybe<Scalars['String']>;
  response?: Maybe<ResponsePayload>;
};

export type ReportSelection = {
  __typename?: 'ReportSelection';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  selection: Scalars['String'];
  selectionFields: Array<SelectionField>;
  sortFields: Array<Scalars['String']>;
};

export type ReportSelectionPayload = {
  __typename?: 'ReportSelectionPayload';
  report: Scalars['String'];
  response?: Maybe<ResponsePayload>;
};

export type ReportSort = {
  __typename?: 'ReportSort';
  direction: Scalars['String'];
  field: Scalars['String'];
};

export type ReportSortInput = {
  direction: Scalars['String'];
  field: Scalars['String'];
};

/** Report status */
export enum ReportStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type ReportsInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  reportGroup?: InputMaybe<Scalars['String']>;
  reportSelection?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ReportsPayload = {
  __typename?: 'ReportsPayload';
  pagination?: Maybe<PaginationPayload>;
  reports?: Maybe<Array<Maybe<Report>>>;
  response?: Maybe<ResponsePayload>;
};

export type RescanBatchInput = {
  batchId: Scalars['Int'];
};

export type RescanBatchPayload = {
  __typename?: 'RescanBatchPayload';
  added: Scalars['Int'];
  removed: Scalars['Int'];
  updated: Scalars['Int'];
};

export type ResendBatchItemInput = {
  itemId: Scalars['Int'];
};

export type ResendBatchItemPayload = {
  __typename?: 'ResendBatchItemPayload';
  item: BillEmailBatchItem;
};

export type ResendBillToClient = {
  billId: Scalars['Float'];
  clientName: Scalars['String'];
  clientRole: ExternalUserCaseRole;
  mode: BillDeliveryMethod;
};

export type ResendMfaOtpInput = {
  mfaToken: Scalars['String'];
};

export type ResendVerificationEmail = {
  email?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResponsePayload = {
  __typename?: 'ResponsePayload';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Float']>;
};

export type ResponsePayloadResponse = {
  __typename?: 'ResponsePayloadResponse';
  response?: Maybe<ResponsePayload>;
};

export type RetryBatchItemInput = {
  itemId: Scalars['Int'];
};

export type RetryBatchItemPayload = {
  __typename?: 'RetryBatchItemPayload';
  item: BillEmailBatchItem;
};

export type ReturnCheckInput = {
  paymentId: Scalars['String'];
  /** Calendar date the BANK debited the returned check, as YYYY-MM-DD. This is the date the reversal is recorded on — the bank statement shows the deposit on one day and the give-back on another, often in a different month, and the reconciliation can only tie if we use the real one rather than the moment the user pressed the button. */
  returnDate: Scalars['String'];
  returnNotes?: InputMaybe<Scalars['String']>;
};

export type ReversePaymentInput = {
  paymentId: Scalars['String'];
};

export type ReversePaymentPayload = {
  __typename?: 'ReversePaymentPayload';
  response?: Maybe<ResponsePayload>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  role: UserRole;
  updatedAt: Scalars['String'];
};

export type RolesPayload = {
  __typename?: 'RolesPayload';
  response?: Maybe<ResponsePayload>;
  roles?: Maybe<Array<Maybe<Role>>>;
};

export type SaveDocPageDraftInput = {
  draftContent?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type SearchDocPagesInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  scope?: InputMaybe<DocPageScope>;
};

export type SearchMattersInput = {
  /** Bill ID */
  billId?: InputMaybe<Scalars['String']>;
  /** Filter matters where billing is paused (pauseBillingUntil is set and in the future) */
  billingPaused?: InputMaybe<Scalars['Boolean']>;
  /** Client or Co-signer ID */
  clientId?: InputMaybe<Scalars['String']>;
  /** Matter ID (caseNumber or consultMatterNumber) */
  matterId?: InputMaybe<Scalars['String']>;
  /** Filter matters with no billing type set (no CaseBilling record) */
  noBillingDetails?: InputMaybe<Scalars['Boolean']>;
  paginationOptions?: InputMaybe<PaginationInput>;
  /** Free-text search across matter #, title, adv case # and client name/number */
  search?: InputMaybe<Scalars['String']>;
  /** Case status filter */
  status?: InputMaybe<CaseStatus>;
  /** Matter Title (partial or full match) */
  title?: InputMaybe<Scalars['String']>;
};

export type SearchMattersPayload = {
  __typename?: 'SearchMattersPayload';
  cases?: Maybe<Array<Maybe<Case>>>;
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
};

export type SearchUserInput = {
  roles: Array<UserRole>;
  searchTerm: Scalars['String'];
  status?: InputMaybe<SearchUserStatusFilter>;
};

/** Filter users by status for search */
export enum SearchUserStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Deactivated = 'DEACTIVATED'
}

export type SelectionField = {
  __typename?: 'SelectionField';
  defaultValue?: Maybe<Scalars['JSON']>;
  field: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  maxDate?: Maybe<Scalars['String']>;
  minDate?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Scalars['Boolean']>;
  type: SelectionFieldType;
  visibilityRules?: Maybe<Array<VisibilityRule>>;
};

export enum SelectionFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  DateRange = 'DATE_RANGE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING'
}

export type SendBillToAttorneyInput = {
  billId: Scalars['Float'];
};

export type SendBillToAttorneyPayload = {
  __typename?: 'SendBillToAttorneyPayload';
  bill: Bill;
  response?: Maybe<ResponsePayload>;
};

export type SendBillToClientInput = {
  billId: Scalars['Float'];
};

export type SendBillToClientPayload = {
  __typename?: 'SendBillToClientPayload';
  bill: Bill;
  response?: Maybe<ResponsePayload>;
};

export type SettlementCheck = {
  __typename?: 'SettlementCheck';
  amount: Scalars['Float'];
  checkNo: Scalars['String'];
  date: Scalars['String'];
  memo?: Maybe<Scalars['String']>;
};

export type SpecialPayment = {
  __typename?: 'SpecialPayment';
  amount: Scalars['Float'];
  date: Scalars['String'];
  isBilled?: Maybe<Scalars['Boolean']>;
};

export type SpecialPaymentInput = {
  amount: Scalars['Float'];
  date: Scalars['String'];
};

export type StartReconciliationSessionInput = {
  accountId: Scalars['String'];
  statementMonth: Scalars['String'];
};

export type StartTimerInput = {
  amount?: InputMaybe<Scalars['Float']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  entryType?: InputMaybe<EntryType>;
  feeTypeId?: InputMaybe<Scalars['String']>;
  isSystemGenerated?: InputMaybe<Scalars['Boolean']>;
  payableId?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  rateType?: InputMaybe<EntryRateType>;
  sendNotesToMatterNotes?: InputMaybe<Scalars['Boolean']>;
  showOnBill?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<EntryStatus>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserRole>;
};

export type SubtotalTemplate = {
  __typename?: 'SubtotalTemplate';
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type SwitchMfaMethodInput = {
  method: MfaMethod;
  mfaToken: Scalars['String'];
};

export type Task = {
  __typename?: 'Task';
  assignedTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<TaskType>;
  updatedAt: Scalars['String'];
  userCasesTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
};

export type TaskInput = {
  id: Scalars['String'];
};

export type TaskPayload = {
  __typename?: 'TaskPayload';
  litigation?: Maybe<Case>;
  response?: Maybe<ResponsePayload>;
  task?: Maybe<Task>;
};

/** Task type */
export enum TaskType {
  Custom = 'CUSTOM',
  PreDefined = 'PRE_DEFINED',
  Temporary = 'TEMPORARY'
}

export type TasksByAssigneeInput = {
  assigneeId: Scalars['String'];
  /** YYYY-MM-DD HH:MM */
  from?: InputMaybe<Scalars['String']>;
  /** YYYY-MM-DD HH:MM */
  to?: InputMaybe<Scalars['String']>;
};

export type TasksByCaseInput = {
  caseId: Scalars['String'];
};

export type TasksPayload = {
  __typename?: 'TasksPayload';
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
  tasks?: Maybe<Array<Maybe<Task>>>;
};

export type TimeEntryFilters = {
  caseId?: InputMaybe<Array<Scalars['String']>>;
  categoryId?: InputMaybe<Array<Scalars['String']>>;
  entryType?: InputMaybe<EntryType>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<EntryStatus>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ToggleBatchItemExclusionInput = {
  itemId: Scalars['Int'];
};

export type ToggleBatchItemExclusionPayload = {
  __typename?: 'ToggleBatchItemExclusionPayload';
  item: BillEmailBatchItem;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float'];
  bankData?: Maybe<BankData>;
  cardData?: Maybe<CardData>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  payment: Payment;
  settledAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<TransactionStatus>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

/** Transaction status */
export enum TransactionStatus {
  ApprovedReview = 'APPROVED_REVIEW',
  AuthorizedPendingCapture = 'AUTHORIZED_PENDING_CAPTURE',
  CapturedPendingSettlement = 'CAPTURED_PENDING_SETTLEMENT',
  CommunicationError = 'COMMUNICATION_ERROR',
  CouldNotVoid = 'COULD_NOT_VOID',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  FailedReview = 'FAILED_REVIEW',
  FdsAuthorizedPendingReview = 'FDS_AUTHORIZED_PENDING_REVIEW',
  FdsPendingReview = 'FDS_PENDING_REVIEW',
  GeneralError = 'GENERAL_ERROR',
  RefundPendingSettlement = 'REFUND_PENDING_SETTLEMENT',
  RefundSettledSuccessfully = 'REFUND_SETTLED_SUCCESSFULLY',
  ReturnedItem = 'RETURNED_ITEM',
  SettledSuccessfully = 'SETTLED_SUCCESSFULLY',
  SettlementError = 'SETTLEMENT_ERROR',
  UnderReview = 'UNDER_REVIEW',
  Voided = 'VOIDED'
}

export type TransferFundsBetweenAccountsInput = {
  amount: Scalars['Float'];
  caseId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  destinationAccountId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
  referenceNumber?: InputMaybe<Scalars['String']>;
  slipNumber?: InputMaybe<Scalars['String']>;
  sourceAccountId: Scalars['String'];
};

export type TriggerBatchInput = {
  attorneyIds?: InputMaybe<Array<Scalars['String']>>;
  attorneyRole?: InputMaybe<Scalars['String']>;
  batchId: Scalars['Int'];
  billingType?: InputMaybe<BillingType>;
  trustScope?: InputMaybe<PrintJobTrustScope>;
};

export type TriggerBatchPayload = {
  __typename?: 'TriggerBatchPayload';
  batch: BillEmailBatch;
};

export type TrustBalanceClientPayload = {
  __typename?: 'TrustBalanceClientPayload';
  clientId: Scalars['String'];
  name: Scalars['String'];
  settlementCheck?: Maybe<SettlementCheck>;
  trustBalance: Scalars['Float'];
};

export type TrustBalanceSummaryPayload = {
  __typename?: 'TrustBalanceSummaryPayload';
  escrowBalanceSummary: EscrowBalanceSummaryPayload;
  ioltaBalanceSummary: IoltaBalanceSummaryPayload;
  response?: Maybe<ResponsePayload>;
};

export type UncloseAccountingPeriodInput = {
  fiscalYear: Scalars['Int'];
  month: Scalars['Int'];
};

export type UpdateAccountInput = {
  accountNo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  institution?: InputMaybe<Scalars['String']>;
  isBankAccount?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  openingBalance?: InputMaybe<Scalars['Float']>;
  parentAccountId?: InputMaybe<Scalars['String']>;
  routingNo?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAttachmentInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** enum type for module type - Upload Media */
  type?: InputMaybe<AttachmentType>;
  typeId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateBillDueDateInput = {
  billId: Scalars['Float'];
  /** Calendar date the bill falls due, as YYYY-MM-DD. Deliberately not a DateTime: the due date is a calendar day, and sending an instant would shift it by a day whenever the client and server sit in different timezones. */
  dueDate: Scalars['String'];
};

export type UpdateBillEntriesInput = {
  deleted: Array<Scalars['String']>;
  new: Array<CreateManualEntryInput>;
  updated: Array<UpdateEntryInput>;
};

export type UpdateBillRequestInput = {
  billId: Scalars['Float'];
  billingNotes: Array<Scalars['String']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  entries: UpdateBillEntriesInput;
  totalAmount: Scalars['Float'];
};

export type UpdateCaseBillingInput = {
  advTotalContractFee?: InputMaybe<Scalars['Float']>;
  billApproverId?: InputMaybe<Scalars['String']>;
  billEntireFlatFeeUpfront?: InputMaybe<Scalars['Boolean']>;
  billGenerationAmount?: InputMaybe<Scalars['Float']>;
  billGenerationHours?: InputMaybe<Scalars['Float']>;
  billGenerationLimitEnabled?: InputMaybe<Scalars['Boolean']>;
  billGenerationType?: InputMaybe<BillGenerationType>;
  billingCycle?: InputMaybe<BillingCycle>;
  billingCycleCustomDate?: InputMaybe<Scalars['Float']>;
  billingType?: InputMaybe<BillingType>;
  consultationFee?: InputMaybe<Scalars['Float']>;
  contingencySettlementAmount?: InputMaybe<Scalars['Float']>;
  contingencyShare?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountPercentage?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  flatFee?: InputMaybe<Scalars['Float']>;
  increaseInterestRateOnFirstLatePayment?: InputMaybe<Scalars['Boolean']>;
  interestRates?: InputMaybe<Array<InterestRateInput>>;
  isFlatFeeHoursExhausted?: InputMaybe<Scalars['Boolean']>;
  minimumFundsThreshold?: InputMaybe<Scalars['Float']>;
  monthlyFlatFee?: InputMaybe<Scalars['Float']>;
  pauseBillingUntil?: InputMaybe<Scalars['DateTime']>;
  paymentPlanStartDate?: InputMaybe<Scalars['DateTime']>;
  retainerAccountId?: InputMaybe<Scalars['String']>;
  retainerAmount?: InputMaybe<Scalars['Float']>;
  skipDeptHeadApproval?: InputMaybe<Scalars['Boolean']>;
  specialPayments?: InputMaybe<Array<SpecialPaymentInput>>;
  splitBillEnabled?: InputMaybe<Scalars['Boolean']>;
  upfrontFlatFee?: InputMaybe<Scalars['Float']>;
  writeOffInterest?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCaseBillingTypeInput = {
  billingType: BillingType;
  id: Scalars['String'];
};

export type UpdateCaseCaseTypeInput = {
  caseTypeId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateCaseCourtInput = {
  courtId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateCaseEventInput = {
  caseId?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  hearingAt?: InputMaybe<Scalars['String']>;
  hearingEndsAt?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  nextHearingAt?: InputMaybe<Scalars['String']>;
  nextHearingAtTime?: InputMaybe<Scalars['String']>;
  outlookEventId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCaseInput = {
  accidentDate?: InputMaybe<Scalars['String']>;
  advantageCode?: InputMaybe<Scalars['String']>;
  assigneeId?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  billing?: InputMaybe<UpdateCaseBillingInput>;
  caseNumber?: InputMaybe<Scalars['String']>;
  caseParties?: InputMaybe<Array<CasePartyInput>>;
  caseTypeId?: InputMaybe<Scalars['String']>;
  ccEmailBillsTo?: InputMaybe<Scalars['String']>;
  closeDate?: InputMaybe<Scalars['String']>;
  completedDate?: InputMaybe<Scalars['String']>;
  consultAttorneyId?: InputMaybe<Scalars['String']>;
  consultMatterNumber?: InputMaybe<Scalars['String']>;
  courtId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  docketNo?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isConsultMatter?: InputMaybe<Scalars['Boolean']>;
  isInternalMatter?: InputMaybe<Scalars['Boolean']>;
  judge?: InputMaybe<CreateExternalUser>;
  judgeUserId?: InputMaybe<Scalars['String']>;
  judgeUserRoleId?: InputMaybe<Scalars['String']>;
  legalTeam?: InputMaybe<Array<CaseLegalTeamInput>>;
  locationId?: InputMaybe<Scalars['Float']>;
  oldJudgeUserId?: InputMaybe<Scalars['String']>;
  openDate?: InputMaybe<Scalars['String']>;
  openedBy?: InputMaybe<Scalars['String']>;
  profitCenterId?: InputMaybe<Scalars['Float']>;
  references?: InputMaybe<Array<ReferenceInput>>;
  setting?: InputMaybe<UpdateCaseSettingInput>;
  settlementChecks?: InputMaybe<Array<UpdateSettlementCheckInput>>;
  status?: InputMaybe<CaseStatus>;
  title?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};

export type UpdateCaseSettingInput = {
  flatFeeHoursNotificationThreshold?: InputMaybe<Scalars['Float']>;
  sendFlatFeeHoursExhaustedNotification?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCaseTypeInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  syncWithOutlook?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCourtInput = {
  addresses?: InputMaybe<Array<CreateAddressForExtUserInput>>;
  chiefAdmin?: InputMaybe<Scalars['String']>;
  closeTime?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  courtCode?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  externalUserRoleId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  municipality?: InputMaybe<Scalars['String']>;
  mvcCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openTime?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateDepartmentInput = {
  departmentHeadId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  lawTypeIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDocPageInput = {
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<DocPageScope>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEntryInput = {
  amount?: InputMaybe<Scalars['Float']>;
  billable?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  entryId: Scalars['String'];
  entryType?: InputMaybe<EntryType>;
  feeTypeId?: InputMaybe<Scalars['String']>;
  isSystemGenerated?: InputMaybe<Scalars['Boolean']>;
  payableId?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Float']>;
  rate?: InputMaybe<Scalars['Float']>;
  rateType?: InputMaybe<EntryRateType>;
  sendNotesToMatterNotes?: InputMaybe<Scalars['Boolean']>;
  showOnBill?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<EntryStatus>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserRole>;
};

export type UpdateExternalUserAddress = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  /** Provide only when adding a new address to existing externalUser */
  externalUserId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isInternational?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateExternalUserInput = {
  alienId?: InputMaybe<Scalars['String']>;
  arrearsBalance?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  contractBalance?: InputMaybe<Scalars['String']>;
  dateOfArrival?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  homePhone?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  initials?: InputMaybe<Scalars['String']>;
  insurance?: InputMaybe<Scalars['String']>;
  isConsultClient?: InputMaybe<Scalars['Boolean']>;
  isInternational?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastPayAmount?: InputMaybe<Scalars['String']>;
  lastPayDate?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  personalPhone?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberExtension?: InputMaybe<Scalars['String']>;
  residualBalance?: InputMaybe<Scalars['String']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  ssn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ExternalUserStatus>;
  suffix?: InputMaybe<Scalars['String']>;
  trustBalance?: InputMaybe<Scalars['String']>;
};

export type UpdateFundRequestInput = {
  amount: Scalars['Float'];
  caseId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  retainerAccountId?: InputMaybe<Scalars['String']>;
  sendToClient?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFundRequestPayload = {
  __typename?: 'UpdateFundRequestPayload';
  fundRequest: Bill;
  response?: Maybe<ResponsePayload>;
};

export type UpdateGeneralInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  initials?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
};

export type UpdateLawTypeInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  syncWithOutlook?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMfaSettingsInput = {
  mfaAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  mfaEmailEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNoteInput = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type UpdateOfficeInput = {
  addressId?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<CreateAddressForOfficeInput>>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  isLocationOpen?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  officeNumber?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OfficeType>;
};

export type UpdatePasswordInput = {
  id: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdatePayableEntryInput = {
  amount?: InputMaybe<Scalars['Float']>;
  bankAccountId?: InputMaybe<Scalars['String']>;
  checkOrAchNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  lineItems: Array<UpdatePayableLineItemInput>;
  lineItemsToDelete?: InputMaybe<Array<Scalars['String']>>;
  payDate?: InputMaybe<Scalars['DateTime']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableStatus>;
  vendorId?: InputMaybe<Scalars['Float']>;
  voucherNo?: InputMaybe<Scalars['String']>;
};

export type UpdatePayableLineItemInput = {
  advRefno?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fromAdv?: InputMaybe<Scalars['Boolean']>;
  glAccountId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  litigationId?: InputMaybe<Scalars['String']>;
  officeId: Scalars['Float'];
};

export type UpdatePaymentInput = {
  caseId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  destinationAccountId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  locationId?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  slipNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateReconciliationSessionInput = {
  add?: InputMaybe<Array<ReconciliationSessionItemInput>>;
  remove?: InputMaybe<Array<Scalars['String']>>;
  sessionId: Scalars['Int'];
  statementBalance?: InputMaybe<Scalars['Float']>;
  statementMonth?: InputMaybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type UpdateReconciliationSessionViewPreferencesInput = {
  preferences: ReconciliationSessionViewPreferencesInput;
  sessionId: Scalars['Int'];
};

export type UpdateReferenceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  eligibleFor1099Report?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  reference?: InputMaybe<Scalars['String']>;
  sourceTypeId?: InputMaybe<Scalars['String']>;
};

export type UpdateRoleInput = {
  delegateIds?: InputMaybe<Array<Scalars['String']>>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  roles: Array<UserRole>;
};

export type UpdateSettlementCheckInput = {
  amount: Scalars['Float'];
  checkNo: Scalars['String'];
  clientId: Scalars['String'];
  date: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
  type: TaskType;
};

export type UpdateUserCaseTaskInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  caseId?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  status?: InputMaybe<UserCasesTaskStatus>;
  taskId?: InputMaybe<Scalars['String']>;
  taskTitle?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TaskType>;
};

export type UpdateUserInput = {
  delegateIds?: InputMaybe<Array<Scalars['String']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  initials?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateUserMfaSettingsInput = {
  mfaAuthEnabled?: InputMaybe<Scalars['Boolean']>;
  mfaEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UpdateVendorInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  addressId?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<CreateAddressForVendorInput>>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Float']>;
  parentVendor?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  required1099?: InputMaybe<Scalars['Boolean']>;
  separateCheckPerInvoice?: InputMaybe<Scalars['Boolean']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  sortCode?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  activities?: Maybe<Array<ActivityTracking>>;
  approvedBills?: Maybe<Array<Bill>>;
  approvedBillsAsAttorney?: Maybe<Array<Bill>>;
  approvedCaseBillings?: Maybe<Array<Maybe<CaseBilling>>>;
  assignedTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
  billTimelines?: Maybe<Array<BillTimeline>>;
  caseApproverHistories?: Maybe<Array<Maybe<CaseHistory>>>;
  caseRequestorHistories?: Maybe<Array<Maybe<CaseHistory>>>;
  caseToUsers?: Maybe<Array<Maybe<CaseToUser>>>;
  createdAccountPayables?: Maybe<Array<AccountsPayable>>;
  createdAccounts?: Maybe<Array<Account>>;
  createdAt: Scalars['String'];
  createdBills?: Maybe<Array<Maybe<Bill>>>;
  createdPayableRefunds?: Maybe<Array<PayableRefund>>;
  createdPayments?: Maybe<Array<Payment>>;
  createdReports?: Maybe<Array<Report>>;
  deletedAccountPayables?: Maybe<Array<AccountsPayable>>;
  deletedAccountPayablesLineItems?: Maybe<Array<AccountsPayableLineItem>>;
  deletedEntries?: Maybe<Array<Entry>>;
  deletedJournalEntries?: Maybe<Array<JournalEntry>>;
  deletedJournalEntryLineItems?: Maybe<Array<JournalEntryLineItem>>;
  deletedPaymentAllocations?: Maybe<Array<PaymentAllocation>>;
  deletedPayments?: Maybe<Array<Payment>>;
  deptToUsers?: Maybe<Array<Maybe<DepartmentToUsers>>>;
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fromAdv?: Maybe<Scalars['Boolean']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  initials?: Maybe<Scalars['String']>;
  journalEntries?: Maybe<Array<JournalEntry>>;
  lastName?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  mfaAuthEnabled?: Maybe<Scalars['Boolean']>;
  mfaEmailEnabled?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Array<Note>>;
  office?: Maybe<Office>;
  openedMatters?: Maybe<Array<Case>>;
  paralegals?: Maybe<Array<Maybe<User>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  reconciledPayments?: Maybe<Array<Payment>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  status: UserStatus;
  supervisingUsers?: Maybe<Array<Maybe<User>>>;
  updatedAt: Scalars['String'];
  userCasesTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
};

export type UserCaseTaskInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  caseId?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserCasesTaskStatus>;
  taskId?: InputMaybe<Scalars['String']>;
  taskTitle?: InputMaybe<Scalars['String']>;
  type: TaskType;
};

export type UserCaseTaskPayload = {
  __typename?: 'UserCaseTaskPayload';
  litigation?: Maybe<Case>;
  response?: Maybe<ResponsePayload>;
  userCaseTask?: Maybe<UserCaseTasks>;
};

export type UserCaseTasks = {
  __typename?: 'UserCaseTasks';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['String']>;
  caseId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  litigation?: Maybe<Case>;
  status?: Maybe<UserCasesTaskStatus>;
  task?: Maybe<Task>;
  taskId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

/** Task status */
export enum UserCasesTaskStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type UserIdInput = {
  userId: Scalars['String'];
};

export type UserIdsInput = {
  userIds: Array<Scalars['String']>;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  response?: Maybe<ResponsePayload>;
  user?: Maybe<User>;
};

/** The user role assigned */
export enum UserRole {
  Accountant = 'ACCOUNTANT',
  Admin = 'ADMIN',
  Attorney = 'ATTORNEY',
  Dcpp = 'DCPP',
  Investigator = 'INVESTIGATOR',
  Paralegal = 'PARALEGAL',
  Staff = 'STAFF',
  SuperAdmin = 'SUPER_ADMIN'
}

/** The user status */
export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type UserTasksPayload = {
  __typename?: 'UserTasksPayload';
  response?: Maybe<ResponsePayload>;
  userCaseTasks?: Maybe<Array<Maybe<UserCaseTasks>>>;
};

export type UserTimeEntrySummary = {
  __typename?: 'UserTimeEntrySummary';
  /** Number of entries */
  entryCount: Scalars['Int'];
  /** User first name */
  firstName?: Maybe<Scalars['String']>;
  /** User ID */
  id: Scalars['String'];
  /** User last name */
  lastName?: Maybe<Scalars['String']>;
  /** Average rate for this user in the period */
  rate: Scalars['Float'];
  /** Total amount logged */
  totalAmount: Scalars['Float'];
  /** Total amount billed */
  totalBilledAmount: Scalars['Float'];
  /** Total duration logged in hours */
  totalDuration: Scalars['Float'];
  /** Total duration billed in hours */
  totalDurationBilled: Scalars['Float'];
};

/** User type(who is creating and to whom it's being assigned) */
export enum UserType {
  AssignedTo = 'ASSIGNED_TO',
  Attorney = 'ATTORNEY',
  Creator = 'CREATOR',
  Investigator = 'INVESTIGATOR',
  OriginatorAttorney = 'ORIGINATOR_ATTORNEY',
  Paralegal = 'PARALEGAL',
  ResponsibleAttorney_1 = 'RESPONSIBLE_ATTORNEY_1',
  ResponsibleAttorney_2 = 'RESPONSIBLE_ATTORNEY_2',
  ResponsibleAttorney_3 = 'RESPONSIBLE_ATTORNEY_3',
  ResponsibleAttorney_4 = 'RESPONSIBLE_ATTORNEY_4',
  ResponsibleAttorney_5 = 'RESPONSIBLE_ATTORNEY_5',
  ResponsibleAttorney_6 = 'RESPONSIBLE_ATTORNEY_6',
  SupervisingAttorney = 'SUPERVISING_ATTORNEY'
}

export type UsersInput = {
  from?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  paginationOptions: PaginationInput;
  roles?: InputMaybe<Array<UserRole>>;
  status?: InputMaybe<UserStatus>;
  to?: InputMaybe<Scalars['String']>;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type Vendor = {
  __typename?: 'Vendor';
  accountNumber?: Maybe<Scalars['String']>;
  accountsPayable?: Maybe<Array<Maybe<AccountsPayable>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  childVendors?: Maybe<Array<Vendor>>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  glAccount?: Maybe<Account>;
  id: Scalars['Float'];
  journalEntries?: Maybe<Array<Maybe<JournalEntry>>>;
  name: Scalars['String'];
  office?: Maybe<Office>;
  parentVendor?: Maybe<Vendor>;
  payments?: Maybe<Array<Payment>>;
  phone?: Maybe<Scalars['String']>;
  required1099: Scalars['Boolean'];
  separateCheckPerInvoice: Scalars['Boolean'];
  socialSecurityNumber?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  vendorId: Scalars['String'];
};

export type VendorPayload = {
  __typename?: 'VendorPayload';
  response?: Maybe<ResponsePayload>;
  vendor: Vendor;
};

export type VendorsPayload = {
  __typename?: 'VendorsPayload';
  pagination?: Maybe<PaginationPayload>;
  response?: Maybe<ResponsePayload>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
};

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyMfaOtpInput = {
  mfaToken: Scalars['String'];
  otp: Scalars['String'];
};

export type VerifyUserAndUpdatePasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type VisibilityRule = {
  __typename?: 'VisibilityRule';
  dependsOn: Scalars['String'];
  operator: VisibilityRuleOperator;
  value: Scalars['JSON'];
};

export enum VisibilityRuleOperator {
  Equals = 'EQUALS',
  Exists = 'EXISTS',
  In = 'IN',
  NotEquals = 'NOT_EQUALS',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN'
}

export type VoidAndDuplicatePayablePayload = {
  __typename?: 'VoidAndDuplicatePayablePayload';
  duplicatePayable: AccountsPayable;
  response?: Maybe<ResponsePayload>;
  voidedPayable: AccountsPayable;
};

export type VoidAndReissueCheckInput = {
  id: Scalars['String'];
  payDate?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  voidDate?: InputMaybe<Scalars['DateTime']>;
};

export type VoidAndReissueCheckPayload = {
  __typename?: 'VoidAndReissueCheckPayload';
  reissuedPayable: AccountsPayable;
  response?: Maybe<ResponsePayload>;
  voidedPayable: AccountsPayable;
};

export type VoidBillInput = {
  billId: Scalars['Float'];
  markBillEntriesUnbilled?: InputMaybe<Scalars['Boolean']>;
};

export type VoidCreditClientInput = {
  caseId: Scalars['String'];
  clientId: Scalars['String'];
};

/** Filter payables by voided status */
export enum VoidFilter {
  All = 'ALL',
  NonVoided = 'NON_VOIDED',
  VoidedOnly = 'VOIDED_ONLY'
}

export type VoidPreviewClientOption = {
  __typename?: 'VoidPreviewClientOption';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VoidPreviewItem = {
  __typename?: 'VoidPreviewItem';
  amount: Scalars['Float'];
  billId?: Maybe<Scalars['Float']>;
  billStatus?: Maybe<BillStatus>;
  caseId: Scalars['String'];
  clientId?: Maybe<Scalars['String']>;
  clientOptions: Array<VoidPreviewClientOption>;
  creditAmount: Scalars['Float'];
  entryId: Scalars['String'];
  matterNumber?: Maybe<Scalars['String']>;
  needsClientChoice: Scalars['Boolean'];
  outcome: VoidedExpenseOutcome;
  settlementAmount: Scalars['Float'];
  uncollectedAmount: Scalars['Float'];
};

/** What voiding a cheque does to one of its matter expense entries */
export enum VoidedExpenseOutcome {
  FinalBill = 'FINAL_BILL',
  PreBill = 'PRE_BILL',
  Unbilled = 'UNBILLED'
}

export type VoidedPayableCredit = {
  __typename?: 'VoidedPayableCredit';
  amount: Scalars['Float'];
  appliedAmount: Scalars['Float'];
  billId?: Maybe<Scalars['Float']>;
  clientName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  kind: VoidedPayableCreditKind;
  matterNumber?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
};

/** A client credit or a settlement issued by voiding a billed cheque */
export enum VoidedPayableCreditKind {
  Credit = 'CREDIT',
  Settlement = 'SETTLEMENT'
}

export type VoidedPayableCreditsPayload = {
  __typename?: 'VoidedPayableCreditsPayload';
  credits: Array<VoidedPayableCredit>;
  response?: Maybe<ResponsePayload>;
};

export type VoucherPayload = {
  __typename?: 'VoucherPayload';
  response?: Maybe<ResponsePayload>;
  voucherNo: Scalars['String'];
};

/** The Week days */
export enum WeekDays {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type WriteOffBillInput = {
  billId: Scalars['Float'];
  clientId: Scalars['String'];
  writtenOffInterest?: InputMaybe<Scalars['Float']>;
  writtenOffPrincipal?: InputMaybe<Scalars['Float']>;
};

export type WriteOffBillsInput = {
  bills: Array<WriteOffBillInput>;
  writtenOffReason?: InputMaybe<Scalars['String']>;
};

export type YearEndClose = {
  __typename?: 'YearEndClose';
  closedAt: Scalars['DateTime'];
  closedBy: User;
  closingJournalEntry?: Maybe<JournalEntry>;
  createdAt: Scalars['DateTime'];
  fiscalYear: Scalars['Float'];
  id: Scalars['String'];
  netIncome: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
};

export type TasksInput = {
  paginationOptions?: InputMaybe<PaginationInput>;
  searchValue?: InputMaybe<Scalars['String']>;
  taskType?: InputMaybe<TaskType>;
};

export type CreateAccountMutationVariables = Exact<{
  createAccountInput: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'AccountPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, account?: { __typename?: 'Account', id: string, type?: AccountType | null, category: AccountCategory, active: boolean, name: string, sortCode: string, accountNo?: string | null, isBankAccount: boolean, institution?: string | null, description?: string | null, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, parentAccount?: { __typename?: 'Account', id: string, name: string } | null, childAccounts?: Array<{ __typename?: 'Account', id: string, name: string }> | null, bills?: Array<{ __typename?: 'Bill', id: number, amount: number }> | null, caseBilling?: Array<{ __typename?: 'CaseBilling', id: string, billingType: BillingType }> | null } | null } };

export type FetchAllAccountsQueryVariables = Exact<{
  accountsInput: AccountsInput;
}>;


export type FetchAllAccountsQuery = { __typename?: 'Query', fetchAllAccounts: { __typename?: 'AccountsPayload', accounts?: Array<{ __typename?: 'Account', id: string, type?: AccountType | null, category: AccountCategory, active: boolean, name: string, sortCode: string, accountNo?: string | null, isBankAccount: boolean, institution?: string | null, description?: string | null, currentBalance?: number | null, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, parentAccount?: { __typename?: 'Account', id: string, name: string } | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null } };

export type FetchAccountByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FetchAccountByIdQuery = { __typename?: 'Query', fetchAccountById: { __typename?: 'AccountPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, account?: { __typename?: 'Account', id: string, type?: AccountType | null, category: AccountCategory, active: boolean, name: string, sortCode: string, accountNo?: string | null, isBankAccount: boolean, institution?: string | null, description?: string | null, openingBalance?: number | null, currentBalance?: number | null, routingNo?: string | null, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, parentAccount?: { __typename?: 'Account', id: string, name: string } | null } | null } };

export type UpdateAccountMutationVariables = Exact<{
  updateAccountInput: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'AccountPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, account?: { __typename?: 'Account', id: string, type?: AccountType | null, category: AccountCategory, active: boolean, name: string, sortCode: string, accountNo?: string | null, isBankAccount: boolean, institution?: string | null, description?: string | null, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, parentAccount?: { __typename?: 'Account', id: string, name: string } | null } | null } };

export type ToggleArchiveAccountMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleArchiveAccountMutation = { __typename?: 'Mutation', toggleArchiveAccount: { __typename?: 'AccountPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, account?: { __typename?: 'Account', id: string, type?: AccountType | null, category: AccountCategory, active: boolean, name: string, sortCode: string, accountNo?: string | null, isBankAccount: boolean, institution?: string | null, description?: string | null, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, parentAccount?: { __typename?: 'Account', id: string, name: string } | null } | null } };

export type FetchAllPaymentsQueryVariables = Exact<{
  fetchAllPaymentsInput: FetchPaymentsInput;
}>;


export type FetchAllPaymentsQuery = { __typename?: 'Query', fetchAllPayments: { __typename?: 'PaymentsPayload', payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: PaymentMethod, referenceNumber?: string | null, slipNumber?: string | null, notes?: string | null, reconciledAt?: string | null, date: any, amount: number, returnAmount?: number | null, returnNotes?: string | null, returnedAt?: any | null, createdAt: string, paymentType: PaymentType, paymentSource?: PaymentSource | null, fromAdv?: boolean | null, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null } | null, reconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, client?: { __typename?: 'ExternalUser', id: string, lastName: string, email?: string | null, firstName: string, displayName?: string | null, initials?: string | null, clientNumber?: string | null, middleName?: string | null, suffix?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string, sortCode?: string | null } | null, linkedPayment?: { __typename?: 'Payment', id: string, account?: { __typename?: 'Account', id: string, name: string } | null } | null, creator?: { __typename?: 'User', id: string, email: string, lastName?: string | null, firstName?: string | null } | null, bill?: { __typename?: 'Bill', id: number, status: BillStatus, type: BillType, amount: number } | null, office?: { __typename?: 'Office', id: number, name: string } | null, account?: { __typename?: 'Account', id: string, name: string } | null }>, pagination: { __typename?: 'PaginationPayload', totalPages?: number | null, totalCount?: number | null, page?: number | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchPaymentsByProfitCenterQueryVariables = Exact<{
  input: FetchPaymentsByProfitCenterInput;
}>;


export type FetchPaymentsByProfitCenterQuery = { __typename?: 'Query', fetchPaymentsByProfitCenter: { __typename?: 'PaymentGroupedByDateResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, payments: Array<{ __typename?: 'PaymentGroupedByDate', date: any, amount: number, creditAmount?: number | null, debitAmount?: number | null, officeId?: number | null, officeName?: string | null, slipNumber?: string | null, paymentIds: Array<string> }> } };

export type ReconcilePaymentsMutationVariables = Exact<{
  reconcilePaymentInput: ReconcilePaymentInput;
}>;


export type ReconcilePaymentsMutation = { __typename?: 'Mutation', reconcilePayments: { __typename?: 'ReconciliationResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type MarkPaymentsAsLegacyReconciledMutationVariables = Exact<{
  input: MarkPaymentsAsLegacyReconciledInput;
}>;


export type MarkPaymentsAsLegacyReconciledMutation = { __typename?: 'Mutation', markPaymentsAsLegacyReconciled: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateGeneralLedgerQueryVariables = Exact<{
  input: FetchGeneralLedgerInput;
}>;


export type GenerateGeneralLedgerQuery = { __typename?: 'Query', generateGeneralLedger: { __typename?: 'LedgerReportPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null }, reports: Array<{ __typename?: 'LedgerReport', accountId: string, accountName: string, accountCode: string, date: any, type: string, amount: number, description: string, bill?: { __typename?: 'Bill', id: number, amount: number, status: BillStatus } | null, matter?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null } | null, client?: { __typename?: 'ExternalUser', id: string, firstName: string, middleName?: string | null, lastName: string, displayName?: string | null, email?: string | null, initials?: string | null } | null, payable?: { __typename?: 'AccountsPayable', id: string, voucherNo: string, paymentMethod: PaymentMethod, amount: number, description?: string | null } | null }> } };

export type ReconcileGroupedPaymentsByProfitCenterMutationVariables = Exact<{
  reconcileGroupedPayments: ReconcileGroupedPaymentsByProfitCenterInput;
}>;


export type ReconcileGroupedPaymentsByProfitCenterMutation = { __typename?: 'Mutation', reconcileGroupedPaymentsByProfitCenter: { __typename?: 'ReconciliationResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CloseAccountingPeriodMutationVariables = Exact<{
  input: CloseAccountingPeriodInput;
}>;


export type CloseAccountingPeriodMutation = { __typename?: 'Mutation', closeAccountingPeriod: { __typename?: 'AccountingPeriod', id: string, fiscalYear: number, month: number, periodStart: string, periodEnd: string, status: PeriodStatus, closedAt?: any | null, unclosedAt?: any | null, notes?: string | null, createdAt: any, updatedAt: any, closedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, unclosedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type UncloseAccountingPeriodMutationVariables = Exact<{
  input: UncloseAccountingPeriodInput;
}>;


export type UncloseAccountingPeriodMutation = { __typename?: 'Mutation', uncloseAccountingPeriod: boolean };

export type AccountingPeriodsQueryVariables = Exact<{
  fiscalYear?: InputMaybe<Scalars['Int']>;
}>;


export type AccountingPeriodsQuery = { __typename?: 'Query', accountingPeriods: Array<{ __typename?: 'AccountingPeriod', id: string, fiscalYear: number, month: number, periodStart: string, periodEnd: string, status: PeriodStatus, closedAt?: any | null, unclosedAt?: any | null, notes?: string | null, createdAt: any, updatedAt: any, closedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, unclosedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null }> };

export type AccountingPeriodQueryVariables = Exact<{
  fiscalYear: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type AccountingPeriodQuery = { __typename?: 'Query', accountingPeriod: { __typename?: 'AccountingPeriod', id: string, fiscalYear: number, month: number, periodStart: string, periodEnd: string, status: PeriodStatus, closedAt?: any | null, unclosedAt?: any | null, notes?: string | null, createdAt: any, updatedAt: any, closedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, unclosedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type YearEndClosesQueryVariables = Exact<{
  fiscalYear?: InputMaybe<Scalars['Int']>;
}>;


export type YearEndClosesQuery = { __typename?: 'Query', yearEndCloses: Array<{ __typename?: 'YearEndClose', id: string, fiscalYear: number, netIncome: number, closedAt: any, notes?: string | null, createdAt: any, closedBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, closingJournalEntry?: { __typename?: 'JournalEntry', id: string, journalEntryNumber: number, notes?: string | null, date: any } | null }> };

export type YearEndCloseQueryVariables = Exact<{
  fiscalYear: Scalars['Int'];
}>;


export type YearEndCloseQuery = { __typename?: 'Query', yearEndClose?: { __typename?: 'YearEndClose', id: string, fiscalYear: number, netIncome: number, closedAt: any, notes?: string | null, createdAt: any, closedBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }, closingJournalEntry?: { __typename?: 'JournalEntry', id: string, journalEntryNumber: number, notes?: string | null, date: any } | null } | null };

export type ReCloseYearMutationVariables = Exact<{ [key: string]: never; }>;


export type ReCloseYearMutation = { __typename?: 'Mutation', reCloseYear: { __typename?: 'YearEndClose', id: string, fiscalYear: number, netIncome: number, closedAt: any } };

export type CreateAccountPayableMutationVariables = Exact<{
  input: CreatePayableInput;
}>;


export type CreateAccountPayableMutation = { __typename?: 'Mutation', createAccountPayable: { __typename?: 'AccountPayablePayload', accountPayableEntry: { __typename?: 'AccountsPayable', id: string }, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type MarkPayableAsPaidMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type MarkPayableAsPaidMutation = { __typename?: 'Mutation', markPayableAsPaid: { __typename?: 'AccountPayablePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type SoftDeletePayableMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftDeletePayableMutation = { __typename?: 'Mutation', softDeletePayable: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type VoidPayableMutationVariables = Exact<{
  id: Scalars['String'];
  creditClients?: InputMaybe<Array<VoidCreditClientInput> | VoidCreditClientInput>;
}>;


export type VoidPayableMutation = { __typename?: 'Mutation', voidPayable: { __typename?: 'AccountPayablePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type PayableVoidPreviewQueryVariables = Exact<{
  id: Scalars['String'];
  creditClients?: InputMaybe<Array<VoidCreditClientInput> | VoidCreditClientInput>;
}>;


export type PayableVoidPreviewQuery = { __typename?: 'Query', payableVoidPreview: { __typename?: 'PayableVoidPreviewPayload', items: Array<{ __typename?: 'VoidPreviewItem', entryId: string, caseId: string, matterNumber?: string | null, outcome: VoidedExpenseOutcome, amount: number, billId?: number | null, billStatus?: BillStatus | null, clientId?: string | null, needsClientChoice: boolean, creditAmount: number, settlementAmount: number, uncollectedAmount: number, clientOptions: Array<{ __typename?: 'VoidPreviewClientOption', id: string, name: string }> }>, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type VoidAndDuplicatePayableMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type VoidAndDuplicatePayableMutation = { __typename?: 'Mutation', voidAndDuplicatePayable: { __typename?: 'VoidAndDuplicatePayablePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, voidedPayable: { __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus }, duplicatePayable: { __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus } } };

export type VoidAndReissueCheckMutationVariables = Exact<{
  input: VoidAndReissueCheckInput;
}>;


export type VoidAndReissueCheckMutation = { __typename?: 'Mutation', voidAndReissueCheck: { __typename?: 'VoidAndReissueCheckPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, voidedPayable: { __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus, checkOrAchNumber?: string | null }, reissuedPayable: { __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus, checkOrAchNumber?: string | null, payDate: any } } };

export type FetchVoucherOfPayableEntryQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchVoucherOfPayableEntryQuery = { __typename?: 'Query', fetchVoucherOfPayableEntry: { __typename?: 'VoucherPayload', voucherNo: string } };

export type FetchAccountsPayablesQueryVariables = Exact<{
  input: FetchAccountsPayableInput;
}>;


export type FetchAccountsPayablesQuery = { __typename?: 'Query', fetchAccountsPayables: { __typename?: 'AccountsPayablePayload', totalAmount: number, pagination: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null }, apEntries: Array<{ __typename?: 'AccountsPayable', id: string, voucherNo: string, paymentMethod: PaymentMethod, status: PayableStatus, description?: string | null, amount: number, invoiceDate: any, payDate: any, printedAt?: any | null, checkOrAchNumber?: string | null, isReconciled?: boolean | null, reconciledAt?: string | null, reconciledOn?: any | null, billedCaseIds?: Array<string> | null, lineItems?: Array<{ __typename?: 'AccountsPayableLineItem', id: string, amount: number, description?: string | null, office: { __typename?: 'Office', id: number, name: string }, litigation?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null } | null, glAccount: { __typename?: 'Account', id: string, name: string, sortCode: string }, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null } | null }> | null, vendor?: { __typename?: 'Vendor', id: number, name: string, vendorId: string } | null, account?: { __typename?: 'Account', id: string, name: string, sortCode: string, currentBalance?: number | null } | null }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetAccountPayableByVoucherQueryVariables = Exact<{
  voucherNo: Scalars['String'];
}>;


export type GetAccountPayableByVoucherQuery = { __typename?: 'Query', getAccountPayableByVoucher: { __typename?: 'AccountPayablePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, accountPayableEntry: { __typename?: 'AccountsPayable', id: string, voucherNo: string, paymentMethod: PaymentMethod, status: PayableStatus, description?: string | null, amount: number, invoiceDate: any, payDate: any, createdAt: string, updatedAt: string, isReconciled?: boolean | null, reconciledAt?: string | null, reconciledOn?: any | null, billedCaseIds?: Array<string> | null, checkOrAchNumber?: string | null, printedAt?: any | null, lineItems?: Array<{ __typename?: 'AccountsPayableLineItem', id: string, amount: number, description?: string | null, office: { __typename?: 'Office', id: number, name: string }, litigation?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null } | null, glAccount: { __typename?: 'Account', id: string, type?: AccountType | null, sortCode: string, name: string, isBankAccount: boolean } }> | null, vendor?: { __typename?: 'Vendor', id: number, name: string, vendorId: string } | null, account?: { __typename?: 'Account', id: string, name: string, currentBalance?: number | null } | null, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, reissues?: Array<{ __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus }> | null, reissuedFrom?: { __typename?: 'AccountsPayable', id: string, voucherNo: string, status: PayableStatus } | null, actionDetails?: { __typename?: 'PayableActionMetadata', date?: string | null, action: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null } } };

export type FindPayableByCheckNumberQueryVariables = Exact<{
  checkNumber: Scalars['String'];
  bankAccountId: Scalars['String'];
}>;


export type FindPayableByCheckNumberQuery = { __typename?: 'Query', findPayableByCheckNumber: { __typename?: 'PayableByCheckNumberPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, accountPayableEntry?: { __typename?: 'AccountsPayable', id: string, voucherNo: string } | null } };

export type FetchAchOrEftNoOfEntryQueryVariables = Exact<{
  method: Scalars['String'];
}>;


export type FetchAchOrEftNoOfEntryQuery = { __typename?: 'Query', fetchAchOrEftNoOfEntry: { __typename?: 'AchOrEftNumberPayload', achOrEftNo: string, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateAccountPayableMutationVariables = Exact<{
  input: UpdatePayableEntryInput;
}>;


export type UpdateAccountPayableMutation = { __typename?: 'Mutation', updateAccountPayable: { __typename?: 'AccountPayablePayload', accountPayableEntry: { __typename?: 'AccountsPayable', id: string }, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type PreviewCheckAssignmentsQueryVariables = Exact<{
  input: PreviewCheckAssignmentsInput;
}>;


export type PreviewCheckAssignmentsQuery = { __typename?: 'Query', previewCheckAssignments: { __typename?: 'CheckAssignmentPlanPayload', canPrint: boolean, firstCheckNo?: string | null, lastCheckNo?: string | null, printableCount: number, nextAvailableCheckNo?: string | null, suggestion?: string | null, rows: Array<{ __typename?: 'CheckAssignmentRow', voucherNo: string, vendorName?: string | null, amount: number, paymentMethod?: PaymentMethod | null, status?: PayableStatus | null, existingCheckNo?: string | null, checkNo?: string | null, printedAt?: any | null, issue: CheckAssignmentIssue, issueMessage?: string | null, conflict?: { __typename?: 'CheckAssignmentConflict', source: CheckConflictSource, voucherNo?: string | null, vendorName?: string | null, description?: string | null, amount?: number | null, date?: any | null, state?: string | null } | null }>, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type FetchAccountsReceivableQueryVariables = Exact<{
  input: FetchAccountsReceivableInput;
}>;


export type FetchAccountsReceivableQuery = { __typename?: 'Query', fetchAccountsReceivable: { __typename?: 'FetchAccountsReceivablePayload', arEntries: Array<{ __typename?: 'AccountsReceivableEntry', total: number, paid: number, balance: number, bill?: { __typename?: 'Bill', id: number, issueDate?: any | null, dueDate?: any | null, discount?: number | null, status: BillStatus, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, accessTokens?: Array<{ __typename?: 'BillAccessToken', id: string, amount: number, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, client?: { __typename?: 'ExternalUser', id: string } | null }> | null } | null, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, billing?: { __typename?: 'CaseBilling', splitBillEnabled?: boolean | null } | null } | null, caseExternalUserToExternalUserRoles?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, splitBillShare?: number | null, caseRole?: ExternalUserCaseRole | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, email?: string | null } | null } }> | null, paymentAllocations?: Array<{ __typename?: 'PaymentAllocation', id: string, amount: number, paymentDate: any, balanceEffect: PaymentAllocationBalanceEffect, client: { __typename?: 'ExternalUser', id: string } }> | null, clientsInterest: Array<{ __typename?: 'ClientsInterest', clientId: string, interestDue: number, interestAccrued: number }> }>, summary: { __typename?: 'AccountsReceivableSummary', totalARs: number, totalInvoiced: number }, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type LoginMutationVariables = Exact<{
  loginUserInput: LoginUserInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AccessUserPayload', access_token?: string | null, mfaRequired?: boolean | null, mfaMethod?: MfaMethod | null, mfaAvailableMethods?: Array<MfaMethod> | null, mfaToken?: string | null, remainingLoginAttempts?: number | null, maxLoginAttempts?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string }> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type VerifyMfaOtpMutationVariables = Exact<{
  verifyMfaOtpInput: VerifyMfaOtpInput;
}>;


export type VerifyMfaOtpMutation = { __typename?: 'Mutation', verifyMfaOtp: { __typename?: 'AccessUserPayload', access_token?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string }> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ResendMfaOtpMutationVariables = Exact<{
  resendMfaOtpInput: ResendMfaOtpInput;
}>;


export type ResendMfaOtpMutation = { __typename?: 'Mutation', resendMfaOtp: { __typename?: 'AccessUserPayload', mfaToken?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SwitchMfaMethodMutationVariables = Exact<{
  switchMfaMethodInput: SwitchMfaMethodInput;
}>;


export type SwitchMfaMethodMutation = { __typename?: 'Mutation', switchMfaMethod: { __typename?: 'AccessUserPayload', mfaMethod?: MfaMethod | null, mfaAvailableMethods?: Array<MfaMethod> | null, mfaToken?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type StartMfaAuthEnrollmentMutationVariables = Exact<{ [key: string]: never; }>;


export type StartMfaAuthEnrollmentMutation = { __typename?: 'Mutation', startMfaAuthEnrollment: { __typename?: 'MfaAuthEnrollmentPayload', secret?: string | null, otpauthUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ConfirmMfaAuthEnrollmentMutationVariables = Exact<{
  confirmMfaAuthEnrollmentInput: ConfirmMfaAuthEnrollmentInput;
}>;


export type ConfirmMfaAuthEnrollmentMutation = { __typename?: 'Mutation', confirmMfaAuthEnrollment: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null } | null } };

export type UpdateMfaSettingsMutationVariables = Exact<{
  mfaSettingsInput: UpdateMfaSettingsInput;
}>;


export type UpdateMfaSettingsMutation = { __typename?: 'Mutation', updateMfaSettings: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ChangePasswordMutationVariables = Exact<{
  changePasswordInput: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string } | null } };

export type VerifyEmailAndSetPasswordMutationVariables = Exact<{
  verifyUserAndUpdatePasswordInput: VerifyUserAndUpdatePasswordInput;
}>;


export type VerifyEmailAndSetPasswordMutation = { __typename?: 'Mutation', verifyEmailAndSetPassword: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type LoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedInUserQuery = { __typename?: 'Query', me: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, phoneNumber?: string | null, initials?: string | null, hourlyRate?: number | null, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null, supervisingUsers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, hourlyRate?: number | null, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null> | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, litigation?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, caseTypeId: string, courtId?: string | null, createdAt: string, updatedAt: string } | null } | null> | null, office?: { __typename?: 'Office', id: number, name: string, createdAt: string, updatedAt: string, isLocationOpen: boolean } | null, deptToUsers?: Array<{ __typename?: 'DepartmentToUsers', createdAt: any, departmentId: string, updatedAt: any, userId: string, department: { __typename?: 'Department', departmentHeadId?: string | null, id: string, name: string } } | null> | null } | null } };

export type GetBillEmailBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillEmailBatchesQuery = { __typename?: 'Query', getBillEmailBatches: { __typename?: 'GetBatchesPayload', batches: Array<{ __typename?: 'BillEmailBatch', id: number, billingCycle: string, periodYear: number, periodMonth: number, status: BillEmailBatchStatus, createdAt: string, updatedAt: string }> } };

export type GetBillEmailBatchQueryVariables = Exact<{
  input: GetBatchInput;
}>;


export type GetBillEmailBatchQuery = { __typename?: 'Query', getBillEmailBatch: { __typename?: 'GetBatchPayload', batch: { __typename?: 'BillEmailBatch', id: number, billingCycle: string, periodYear: number, periodMonth: number, status: BillEmailBatchStatus, createdAt: string, updatedAt: string, items?: Array<{ __typename?: 'BillEmailBatchItem', id: number, type: BillEmailBatchItemType, recipientEmail?: string | null, recipientName?: string | null, status: BillEmailBatchItemStatus, sendGridMessageId?: string | null, errorMessage?: string | null, sentAt?: any | null, createdAt: string, bill: { __typename?: 'Bill', id: number, status: BillStatus, dueDate?: any | null, case: { __typename?: 'Case', id: string, caseNumber?: string | null, title?: string | null } } }> | null } } };

export type TriggerBillEmailBatchMutationVariables = Exact<{
  input: TriggerBatchInput;
}>;


export type TriggerBillEmailBatchMutation = { __typename?: 'Mutation', triggerBillEmailBatch: { __typename?: 'TriggerBatchPayload', batch: { __typename?: 'BillEmailBatch', id: number, status: BillEmailBatchStatus } } };

export type RetryBillEmailBatchItemMutationVariables = Exact<{
  input: RetryBatchItemInput;
}>;


export type RetryBillEmailBatchItemMutation = { __typename?: 'Mutation', retryBillEmailBatchItem: { __typename?: 'RetryBatchItemPayload', item: { __typename?: 'BillEmailBatchItem', id: number, status: BillEmailBatchItemStatus } } };

export type ToggleBillEmailBatchItemExclusionMutationVariables = Exact<{
  input: ToggleBatchItemExclusionInput;
}>;


export type ToggleBillEmailBatchItemExclusionMutation = { __typename?: 'Mutation', toggleBillEmailBatchItemExclusion: { __typename?: 'ToggleBatchItemExclusionPayload', item: { __typename?: 'BillEmailBatchItem', id: number, status: BillEmailBatchItemStatus } } };

export type FetchPreBillsQueryVariables = Exact<{
  fetchPreBillsInput: FetchPreBillsInput;
}>;


export type FetchPreBillsQuery = { __typename?: 'Query', fetchPreBills: { __typename?: 'PreBillsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, preBills: Array<{ __typename?: 'PreBill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, description?: string | null, payOffAmount?: number | null, attorneyApprovedAt?: any | null, departmentApprovedAt?: any | null, lastSentAt?: any | null, isDepartmentHead: boolean, trustBalance?: number | null, creditBalance?: number | null, outstandingBalance?: number | null, sendToClient: boolean, createdAt: string, updatedAt: string, case: { __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, advCaseNumber?: string | null, billing?: { __typename?: 'CaseBilling', billingType: BillingType, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null }, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }>, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null } } };

export type FetchBillableCasesQueryVariables = Exact<{
  fetchBillableCasesInput: FetchBillableCasesInput;
}>;


export type FetchBillableCasesQuery = { __typename?: 'Query', fetchBillableCases: { __typename?: 'BillableCasesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, cases: { __typename?: 'BillableCasesByType', flatFee?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, hourly?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, contingencyHybrid?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, contingency?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, hybrid?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, proBono?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null, consult?: Array<{ __typename?: 'BillableCaseDetail', caseId: string, caseNumber?: string | null, consultMatterNumber?: string | null, title: string, billingType: BillingType, totalUnbilledHours: number, totalAmount: number, discount: number, discountPercentage?: number | null, payoffAmount?: number | null, entries: Array<{ __typename?: 'BillableEntry', id: string, amount: number, type: EntryType }> }> | null } } };

export type FetchBillDetailsQueryVariables = Exact<{
  fetchBillDetailsInput: FetchBillDetailsInput;
}>;


export type FetchBillDetailsQuery = { __typename?: 'Query', fetchBillDetails: { __typename?: 'FetchBillDetailsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, description?: string | null, payOffAmount?: number | null, attorneyApprovedAt?: any | null, departmentApprovedAt?: any | null, lastSentAt?: any | null, discount?: number | null, discountPercentage?: number | null, sendToClient: boolean, pdfSnapshotS3Key?: string | null, createdAt: string, updatedAt: string, billCopies?: Array<{ __typename?: 'BillCopy', generatedAt?: string | null, generatedBy?: string | null, generatedByName?: string | null, source?: string | null }> | null, case: { __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, description?: string | null, ccEmailBillsTo?: string | null, billing?: { __typename?: 'CaseBilling', splitBillEnabled?: boolean | null, skipDeptHeadApproval?: boolean | null, billingType: BillingType, discountPercentage?: number | null, flatFee?: number | null, upfrontFlatFee?: number | null, monthlyFlatFee?: number | null, isFlatFeeHoursExhausted?: boolean | null, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, retainerAccount?: { __typename?: 'Account', id: string, name: string } | null, specialPayments?: Array<{ __typename?: 'SpecialPayment', amount: number, date: string }> | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', caseRole?: ExternalUserCaseRole | null, splitBillShare?: number | null, billingAddress?: string | null, billingEmail?: string | null, billingPhoneNumber?: string | null, billDeliveryMethods?: Array<BillDeliveryMethod> | null, isArchived: boolean, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null } | null> | null } | null } }> | null }, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, approvedByResponsibleAttorney?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, finalApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, billItems?: Array<{ __typename?: 'BillItem', id: string, amount?: number | null, entry: { __typename?: 'Entry', id: string, amount?: number | null, qty?: number | null, unitPrice?: number | null, description?: string | null, date: any, duration?: string | null, rate: number, entryType?: EntryType | null, billable: boolean, showOnBill: boolean, caseId: string, creatorId?: string | null, isSystemGenerated?: boolean | null, sendNotesToMatterNotes?: boolean | null, category?: { __typename?: 'Category', id: string, name: string } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string, createdAt: any, updatedAt: any } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } }> | null, billTimelines?: Array<{ __typename?: 'BillTimeline', id: string, action: BillTimelineAction, description: string, createdAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, deliveryMetadata?: { __typename?: 'DeliveryMetadata', content?: string | null, status?: string | null, mode?: string | null, details?: string | null } | null, metadata?: { __typename?: 'Metadata', amount?: string | null, email?: string | null, emails?: string | null, client?: string | null, clientRole?: string | null } | null }> | null, accessTokens?: Array<{ __typename?: 'BillAccessToken', id: string, amount: number, token: string, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, createdAt: string, updatedAt: string, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, email?: string | null, clientNumber?: string | null } | null }> | null, account?: { __typename?: 'Account', id: string, name: string, accountNo?: string | null } | null, paymentAllocations?: Array<{ __typename?: 'PaymentAllocation', id: string, amount: number, paymentDate: any, type: PaymentAllocationType, balanceEffect: PaymentAllocationBalanceEffect, client: { __typename?: 'ExternalUser', id: string }, payment: { __typename?: 'Payment', id: string, linkedPayment?: { __typename?: 'Payment', id: string } | null } }> | null } } };

export type FetchBillDetailsByMatterQueryVariables = Exact<{
  fetchBillDetailsByMatterInput: FetchBillDetailsByMatterInput;
}>;


export type FetchBillDetailsByMatterQuery = { __typename?: 'Query', fetchBillDetailsByMatter: { __typename?: 'FetchBillDetailsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, description?: string | null, payOffAmount?: number | null, attorneyApprovedAt?: any | null, departmentApprovedAt?: any | null, lastSentAt?: any | null, discount?: number | null, discountPercentage?: number | null, sendToClient: boolean, pdfSnapshotS3Key?: string | null, createdAt: string, updatedAt: string, billCopies?: Array<{ __typename?: 'BillCopy', generatedAt?: string | null, generatedBy?: string | null, generatedByName?: string | null, source?: string | null }> | null, case: { __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, description?: string | null, ccEmailBillsTo?: string | null, billing?: { __typename?: 'CaseBilling', splitBillEnabled?: boolean | null, skipDeptHeadApproval?: boolean | null, billingType: BillingType, discountPercentage?: number | null, flatFee?: number | null, upfrontFlatFee?: number | null, monthlyFlatFee?: number | null, isFlatFeeHoursExhausted?: boolean | null, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, retainerAccount?: { __typename?: 'Account', id: string, name: string } | null, specialPayments?: Array<{ __typename?: 'SpecialPayment', amount: number, date: string }> | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', caseRole?: ExternalUserCaseRole | null, splitBillShare?: number | null, billingAddress?: string | null, billingEmail?: string | null, billingPhoneNumber?: string | null, billDeliveryMethods?: Array<BillDeliveryMethod> | null, isArchived: boolean, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null } | null> | null } | null } }> | null }, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, approvedByResponsibleAttorney?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, finalApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, billItems?: Array<{ __typename?: 'BillItem', id: string, amount?: number | null, entry: { __typename?: 'Entry', id: string, amount?: number | null, qty?: number | null, unitPrice?: number | null, description?: string | null, date: any, duration?: string | null, rate: number, entryType?: EntryType | null, billable: boolean, showOnBill: boolean, caseId: string, creatorId?: string | null, isSystemGenerated?: boolean | null, category?: { __typename?: 'Category', id: string, name: string } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string, createdAt: any, updatedAt: any } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } }> | null, billTimelines?: Array<{ __typename?: 'BillTimeline', id: string, action: BillTimelineAction, description: string, createdAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, deliveryMetadata?: { __typename?: 'DeliveryMetadata', content?: string | null, status?: string | null, mode?: string | null, details?: string | null } | null, metadata?: { __typename?: 'Metadata', amount?: string | null, email?: string | null, emails?: string | null, client?: string | null, clientRole?: string | null } | null }> | null, accessTokens?: Array<{ __typename?: 'BillAccessToken', id: string, amount: number, token: string, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, createdAt: string, updatedAt: string, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, email?: string | null, clientNumber?: string | null } | null }> | null, account?: { __typename?: 'Account', id: string, name: string, accountNo?: string | null } | null, paymentAllocations?: Array<{ __typename?: 'PaymentAllocation', id: string, amount: number, paymentDate: any, type: PaymentAllocationType, balanceEffect: PaymentAllocationBalanceEffect, client: { __typename?: 'ExternalUser', id: string }, payment: { __typename?: 'Payment', id: string, linkedPayment?: { __typename?: 'Payment', id: string } | null } }> | null } } };

export type FetchFinalBillsQueryVariables = Exact<{
  fetchFinalBillsInput: FetchFinalBillsInput;
}>;


export type FetchFinalBillsQuery = { __typename?: 'Query', fetchFinalBills: { __typename?: 'FinalBillsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bills: Array<{ __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, description?: string | null, payOffAmount?: number | null, attorneyApprovedAt?: any | null, departmentApprovedAt?: any | null, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, lastSentAt?: any | null, sendToClient: boolean, trustBalance?: number | null, creditBalance?: number | null, outstandingBalance?: number | null, pdfSnapshotS3Key?: string | null, createdAt: string, updatedAt: string, billCopies?: Array<{ __typename?: 'BillCopy', generatedAt?: string | null, generatedBy?: string | null, generatedByName?: string | null, source?: string | null }> | null, case: { __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, advCaseNumber?: string | null, billing?: { __typename?: 'CaseBilling', skipDeptHeadApproval?: boolean | null, billingType: BillingType, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null }, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }>, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null } } };

export type FetchPublicBillDetailsQueryVariables = Exact<{
  fetchPublicBillDetailsInput: FetchPublicBillDetailsInput;
}>;


export type FetchPublicBillDetailsQuery = { __typename?: 'Query', fetchPublicBillDetails: { __typename?: 'FetchPublicBillDetailsPayload', amountDue: number, bill: { __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, description?: string | null, payOffAmount?: number | null, discount?: number | null, discountPercentage?: number | null, createdAt: string, updatedAt: string, case: { __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, description?: string | null, billing?: { __typename?: 'CaseBilling', splitBillEnabled?: boolean | null, discountPercentage?: number | null, billingType: BillingType, flatFee?: number | null, upfrontFlatFee?: number | null, monthlyFlatFee?: number | null, isFlatFeeHoursExhausted?: boolean | null, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, specialPayments?: Array<{ __typename?: 'SpecialPayment', amount: number, date: string }> | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', caseRole?: ExternalUserCaseRole | null, splitBillShare?: number | null, billingAddress?: string | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null } | null> | null } | null } }> | null }, accessTokens?: Array<{ __typename?: 'BillAccessToken', id: string, amount: number, token: string, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, client?: { __typename?: 'ExternalUser', id: string } | null }> | null, approvedByResponsibleAttorney?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, finalApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, billItems?: Array<{ __typename?: 'BillItem', id: string, amount?: number | null, entry: { __typename?: 'Entry', id: string, amount?: number | null, qty?: number | null, unitPrice?: number | null, description?: string | null, date: any, duration?: string | null, rate: number, entryType?: EntryType | null, billable: boolean, showOnBill: boolean, caseId: string, creatorId?: string | null, isSystemGenerated?: boolean | null, category?: { __typename?: 'Category', id: string, name: string } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string, createdAt: any, updatedAt: any } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } }> | null, account?: { __typename?: 'Account', id: string, name: string, accountNo?: string | null } | null, paymentAllocations?: Array<{ __typename?: 'PaymentAllocation', id: string, amount: number, paymentDate: any, type: PaymentAllocationType, balanceEffect: PaymentAllocationBalanceEffect, client: { __typename?: 'ExternalUser', id: string }, payment: { __typename?: 'Payment', id: string, linkedPayment?: { __typename?: 'Payment', id: string } | null } }> | null }, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, email?: string | null, clientNumber?: string | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchRemainingFlatFeeQueryVariables = Exact<{
  fetchRemainingFlatFeeInput: FetchRemainingFlatFeeInput;
}>;


export type FetchRemainingFlatFeeQuery = { __typename?: 'Query', fetchRemainingFlatFee: { __typename?: 'FetchRemainingFlatFeePayload', remainingFlatFee: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchQuickBillDetailsQueryVariables = Exact<{
  fetchQuickBillDetailsInput: FetchQuickBillDetailsInput;
}>;


export type FetchQuickBillDetailsQuery = { __typename?: 'Query', fetchQuickBillDetails: { __typename?: 'FetchQuickBillDetailsPayload', case: { __typename?: 'Case', id: string, caseNumber?: string | null, title?: string | null, description?: string | null, billing?: { __typename?: 'CaseBilling', billingType: BillingType, discountPercentage?: number | null, flatFee?: number | null, isFlatFeeHoursExhausted?: boolean | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null> | null }, entries: Array<{ __typename?: 'Entry', id: string, amount?: number | null, qty?: number | null, unitPrice?: number | null, description?: string | null, date: any, duration?: string | null, rate: number, entryType?: EntryType | null, billable: boolean, showOnBill: boolean, caseId: string, creatorId?: string | null, isSystemGenerated?: boolean | null, sendNotesToMatterNotes?: boolean | null, category?: { __typename?: 'Category', id: string, name: string } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string, createdAt: any, updatedAt: any } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchOutstandingBillsQueryVariables = Exact<{
  fetchOutstandingBillsInput: FetchOutstandingBillsInput;
}>;


export type FetchOutstandingBillsQuery = { __typename?: 'Query', fetchOutstandingBills: { __typename?: 'OutstandingBillsPayload', previousBalance: number, outstandingBills: Array<{ __typename?: 'OutstandingBillDetail', billId: number, dueDate?: any | null, clientId?: string | null, totalPayable: number, principalBalance: number, totalPaid: number, interestDue: number, totalDue: number, totalWrittenOff: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchPublicOutstandingBillsQueryVariables = Exact<{
  fetchOutstandingBillsInput: FetchOutstandingBillsInput;
}>;


export type FetchPublicOutstandingBillsQuery = { __typename?: 'Query', fetchPublicOutstandingBills: { __typename?: 'OutstandingBillsPayload', previousBalance: number, outstandingBills: Array<{ __typename?: 'OutstandingBillDetail', billId: number, dueDate?: any | null, clientId?: string | null, totalPayable: number, principalBalance: number, totalPaid: number, interestDue: number, totalDue: number, totalWrittenOff: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SendBillToAttorneyMutationVariables = Exact<{
  sendBillToAttorneyInput: SendBillToAttorneyInput;
}>;


export type SendBillToAttorneyMutation = { __typename?: 'Mutation', sendBillToAttorney: { __typename?: 'SendBillToAttorneyPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, status: BillStatus } } };

export type VoidBillMutationVariables = Exact<{
  voidBillInput: VoidBillInput;
}>;


export type VoidBillMutation = { __typename?: 'Mutation', voidBill: { __typename?: 'FetchBillDetailsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GeneratePreBillsMutationVariables = Exact<{
  generatePreBillsInput: Array<GeneratePreBillInput> | GeneratePreBillInput;
  alsoSendForAttorneyApproval?: InputMaybe<Scalars['Boolean']>;
}>;


export type GeneratePreBillsMutation = { __typename?: 'Mutation', generatePreBills: { __typename?: 'GeneratePreBillsPayload', billIds: Array<number>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateInitialPaymentBillMutationVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type GenerateInitialPaymentBillMutation = { __typename?: 'Mutation', generateInitialPaymentBill: { __typename?: 'GeneratePreBillsPayload', billIds: Array<number>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateBillMutationVariables = Exact<{
  updateBillRequestInput: UpdateBillRequestInput;
}>;


export type UpdateBillMutation = { __typename?: 'Mutation', updateBill: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ApproveBillByAttorneyMutationVariables = Exact<{
  approveBillByAttorneyInput: ApproveBillByAttorneyInput;
}>;


export type ApproveBillByAttorneyMutation = { __typename?: 'Mutation', approveBillByAttorney: { __typename?: 'ApproveBillByAttorneyPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, status: BillStatus } } };

export type ApproveBillByDepartmentHeadMutationVariables = Exact<{
  approveBillByDepartmentHeadInput: ApproveBillByDepartmentHeadInput;
}>;


export type ApproveBillByDepartmentHeadMutation = { __typename?: 'Mutation', approveBillByDepartmentHead: { __typename?: 'ApproveBillByDepartmentHeadPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, status: BillStatus } } };

export type ArchiveBillMutationVariables = Exact<{
  archiveBillInput: ArchiveBillInput;
}>;


export type ArchiveBillMutation = { __typename?: 'Mutation', archiveBill: { __typename?: 'FetchBillDetailsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SendBillToClientMutationVariables = Exact<{
  sendBillToClientInput: SendBillToClientInput;
}>;


export type SendBillToClientMutation = { __typename?: 'Mutation', sendBillToClient: { __typename?: 'SendBillToClientPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, bill: { __typename?: 'Bill', id: number, status: BillStatus, dueDate?: any | null, lastSentAt?: any | null } } };

export type RecordPaymentMutationVariables = Exact<{
  recordPaymentInput: RecordPaymentInput;
}>;


export type RecordPaymentMutation = { __typename?: 'Mutation', recordPayment: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RecordManualPaymentMutationVariables = Exact<{
  recordManualPaymentInput: RecordManualPaymentInput;
}>;


export type RecordManualPaymentMutation = { __typename?: 'Mutation', recordManualPayment: { __typename?: 'FetchBillDetailsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RecordClientCreditsMutationVariables = Exact<{
  recordClientCreditsInput: RecordClientCreditsInput;
}>;


export type RecordClientCreditsMutation = { __typename?: 'Mutation', recordClientCredits: { __typename?: 'RecordClientCreditsPayload', paymentId?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ApplyCreditsMutationVariables = Exact<{
  applyCreditsInput: ApplyCreditsInput;
}>;


export type ApplyCreditsMutation = { __typename?: 'Mutation', applyCredits: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type BillBulkActionsMutationVariables = Exact<{
  bulkInput: BillBulkInput;
}>;


export type BillBulkActionsMutation = { __typename?: 'Mutation', billBulkActions: { __typename?: 'BulkActionPayload', results: Array<{ __typename?: 'BulkActionResult', success: boolean, error?: string | null, billId: number }>, response: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } } };

export type UpdateBillDueDateMutationVariables = Exact<{
  updateBillDueDateInput: UpdateBillDueDateInput;
}>;


export type UpdateBillDueDateMutation = { __typename?: 'Mutation', updateBillDueDate: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type MarkBillsAsDeliveredMutationVariables = Exact<{
  billIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type MarkBillsAsDeliveredMutation = { __typename?: 'Mutation', markBillsAsDelivered: { __typename?: 'MarkBillsAsDeliveredPayload', markedBillIds: Array<number>, skippedBillIds: Array<number>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GeneratePreBillsForAllAttorneysMutationVariables = Exact<{
  generateAllPreBillsInput: GenerateAllPreBillsInput;
}>;


export type GeneratePreBillsForAllAttorneysMutation = { __typename?: 'Mutation', generatePreBillsForAllAttorneys: { __typename?: 'GeneratePreBillsPayload', billIds: Array<number>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateBillsForAttorneysMutationVariables = Exact<{
  generateBillsForAttorneysInput: GenerateBillsForAttorneysInput;
}>;


export type GenerateBillsForAttorneysMutation = { __typename?: 'Mutation', generateBillsForAttorneys: { __typename?: 'GeneratePreBillsPayload', billIds: Array<number>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RefundPaymentMutationVariables = Exact<{
  refundPaymentInput: RefundPaymentInput;
}>;


export type RefundPaymentMutation = { __typename?: 'Mutation', refundPayment: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ReversePaymentMutationVariables = Exact<{
  reversePaymentInput: ReversePaymentInput;
}>;


export type ReversePaymentMutation = { __typename?: 'Mutation', reversePayment: { __typename?: 'ReversePaymentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ReturnCheckPaymentMutationVariables = Exact<{
  returnCheckInput: ReturnCheckInput;
}>;


export type ReturnCheckPaymentMutation = { __typename?: 'Mutation', returnCheckPayment: { __typename?: 'ReversePaymentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SendReminderToClientMutationVariables = Exact<{
  sendReminderToClientInput: SendBillToClientInput;
}>;


export type SendReminderToClientMutation = { __typename?: 'Mutation', sendReminderToClient: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type ResendBillToClientMutationVariables = Exact<{
  resendBillToClient: ResendBillToClient;
}>;


export type ResendBillToClientMutation = { __typename?: 'Mutation', resendBillToClient: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateQuickBillMutationVariables = Exact<{
  generateQuickBillInput: GenerateQuickBillInput;
}>;


export type GenerateQuickBillMutation = { __typename?: 'Mutation', generateQuickBill: { __typename?: 'GenerateQuickBillPayload', billId: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateContingencyFinalBillMutationVariables = Exact<{
  generateContingencyFinalBillInput: ContingencyFinalBillInput;
}>;


export type GenerateContingencyFinalBillMutation = { __typename?: 'Mutation', generateContingencyFinalBill: { __typename?: 'ContingencyFinalBillPayload', billId: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GenerateConsultCaseBillMutationVariables = Exact<{
  generateConsultCaseBillInput: ConsultCaseBillInput;
}>;


export type GenerateConsultCaseBillMutation = { __typename?: 'Mutation', generateConsultCaseBill: { __typename?: 'ConsultCaseBillPayload', billId: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type WriteOffBillsMutationVariables = Exact<{
  writeOffBillsInput: WriteOffBillsInput;
}>;


export type WriteOffBillsMutation = { __typename?: 'Mutation', writeOffBills: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DownloadBillSnapshotQueryVariables = Exact<{
  billId: Scalars['Int'];
  copyIndex?: InputMaybe<Scalars['Int']>;
}>;


export type DownloadBillSnapshotQuery = { __typename?: 'Query', downloadBillSnapshot: { __typename?: 'BillSnapshotDownloadPayload', preSignedUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RegenerateBillClientCopyMutationVariables = Exact<{
  billId: Scalars['Int'];
}>;


export type RegenerateBillClientCopyMutation = { __typename?: 'Mutation', regenerateBillClientCopy: { __typename?: 'BillSnapshotDownloadPayload', preSignedUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateCaseMutationVariables = Exact<{
  createCaseInput: CreateCaseInput;
}>;


export type CreateCaseMutation = { __typename?: 'Mutation', createCase: { __typename?: 'CasePayload', case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, createdAt: string, updatedAt: string, deletedAt?: string | null, caseTypeId: string, courtId?: string | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateCaseEventMutationVariables = Exact<{
  createCaseEventInput: CreateCaseEventInput;
}>;


export type CreateCaseEventMutation = { __typename?: 'Mutation', createCaseEvent: { __typename?: 'CaseEventPayload', caseEvent?: { __typename?: 'CaseEvent', id: string, eventType: EventType, title?: string | null, hearingAt?: string | null, hearingEndsAt?: string | null, createdAt: string, updatedAt: string, outlookEventId?: string | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateCaseMutationVariables = Exact<{
  updateCaseInput: UpdateCaseInput;
}>;


export type UpdateCaseMutation = { __typename?: 'Mutation', updateCase: { __typename?: 'CasePayload', case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, dueDate?: string | null, accidentDate?: string | null, createdAt: string, caseTypeId: string, updatedAt: string, deletedAt?: string | null, docketNo?: string | null, courtId?: string | null, openDate?: string | null, closeDate?: string | null, completedDate?: string | null, isInternalMatter?: boolean | null, billing?: { __typename?: 'CaseBilling', id: string, billingType: BillingType, flatFee?: number | null, retainerAmount?: number | null, billingCycle?: BillingCycle | null, billingCycleCustomDate?: number | null, upfrontFlatFee?: number | null, monthlyFlatFee?: number | null, billEntireFlatFeeUpfront?: boolean | null, pauseBillingUntil?: any | null, contingencyShare?: number | null, contingencySettlementAmount?: number | null, billGenerationLimitEnabled?: boolean | null, billGenerationType?: BillGenerationType | null, billGenerationAmount?: number | null, billGenerationHours?: number | null, writeOffInterest?: boolean | null, increaseInterestRateOnFirstLatePayment?: boolean | null, splitBillEnabled?: boolean | null, discountAmount?: number | null, discountPercentage?: number | null, discountType?: DiscountType | null, consultationFee?: number | null, minimumFundsThreshold?: number | null, paymentPlanStartDate?: any | null, createdAt: string, updatedAt: string, specialPayments?: Array<{ __typename?: 'SpecialPayment', amount: number, date: string }> | null, retainerAccount?: { __typename?: 'Account', id: string, name: string, active: boolean, category: AccountCategory, sortCode: string, isBankAccount: boolean, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, emailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string } | null } | null, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, email: string, emailVerified: boolean, hourlyRate?: number | null, createdAt: string, updatedAt: string } | null, interestRates?: Array<{ __typename?: 'InterestRate', rate?: number | null, applicableDays?: number | null }> | null } | null, setting?: { __typename?: 'CaseSetting', id: string, flatFeeHoursNotificationThreshold?: number | null, sendFlatFeeHoursExhaustedNotification?: boolean | null } | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, hourlyRate?: number | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, splitBillShare?: number | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingEmail?: string | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, ssn?: string | null, phoneNumber?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, phoneNumberExtension?: string | null, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, hourlyRate?: number | null, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllCaseTypesByLawIdQueryVariables = Exact<{
  caseTypesInput: CaseTypesInput;
}>;


export type FetchAllCaseTypesByLawIdQuery = { __typename?: 'Query', fetchAllCaseTypesByLawId: { __typename?: 'CaseTypesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, caseTypes?: Array<{ __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null> | null } };

export type CreateExternalUserMutationVariables = Exact<{
  createExternalUserInput: CreateExternalUser;
}>;


export type CreateExternalUserMutation = { __typename?: 'Mutation', createExternalUser: { __typename?: 'ExternalUserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, createdAt: string, updatedAt: string, clientNumber?: string | null, email?: string | null } | null } };

export type FetchAllExternalUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllExternalUserRolesQuery = { __typename?: 'Query', fetchAllExternalUserRoles: { __typename?: 'ExternalUserRolesPayload', externalUserRoles?: Array<{ __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllExternalUsersQueryVariables = Exact<{
  externalUsersInput: ExternalUsersInput;
}>;


export type FetchAllExternalUsersQuery = { __typename?: 'Query', fetchAllExternalUsers: { __typename?: 'ExternalUsersPayload', externalUsers?: Array<{ __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, businessName?: string | null, createdAt: string, updatedAt: string, email?: string | null, phoneNumber?: string | null, phoneNumberExtension?: string | null, clientNumber?: string | null, contractBalance?: string | null, arrearsBalance?: string | null, residualBalance?: string | null, trustBalance?: string | null, lastPayDate?: string | null, lastPayAmount?: string | null, socialSecurityNumber?: string | null, driverLicenseNumber?: string | null, isInternational?: boolean | null, language?: string | null, dateOfBirth?: any | null, initials?: string | null, middleName?: string | null, personalPhone?: string | null, suffix?: string | null, homePhone?: string | null, courtToExternalUserToExternalUserRole?: Array<{ __typename?: 'CourtToExternalUserToExternalUserRole', id: string, courtId: string, externalUserId: string, isArchived: boolean, createdAt: string, updatedAt: string, court?: { __typename?: 'Court', id: string, name: string, createdAt: string, updatedAt: string } | null } | null> | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, caseRole?: ExternalUserCaseRole | null, createdAt: string, updatedAt: string, isArchived: boolean, isArchivedAt?: string | null, externalUserToExternalUserRoleId: string, litigationId: string, litigation?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, status: CaseStatus, dueDate?: string | null, accidentDate?: string | null, caseTypeId: string, courtId?: string | null, deletedAt?: string | null, createdAt: string, updatedAt: string, isConsultMatter?: boolean | null } | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, createdAt: string, externalUserId: string, externalUserRoleId: string, updatedAt: string } } | null> | null } | null> | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null } };

export type DeleteExternalUserMutationVariables = Exact<{
  deleteExternalUser: DeleteExternalUser;
}>;


export type DeleteExternalUserMutation = { __typename?: 'Mutation', deleteExternalUser: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateExternalUserAddressMutationVariables = Exact<{
  updateExternalUserAddress: UpdateExternalUserAddress;
}>;


export type UpdateExternalUserAddressMutation = { __typename?: 'Mutation', updateExternalUserAddress: { __typename?: 'ExternalUserPayload', response?: { __typename?: 'ResponsePayload', name?: string | null, error?: string | null } | null, externalUser?: { __typename?: 'ExternalUser', lastName: string, firstName: string, displayName?: string | null, isInternational?: boolean | null, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null } | null } };

export type CreateAddressMutationVariables = Exact<{
  createAddressInput: CreateAddressForExtUserInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'AddressPayload', address?: { __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, createdAt: string, updatedAt: string } | null } | null } };

export type FetchCaseQueryVariables = Exact<{
  caseInput: CaseInput;
}>;


export type FetchCaseQuery = { __typename?: 'Query', fetchCase: { __typename?: 'CasePayload', case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, convertedToNormalMatter?: string | null, status: CaseStatus, dueDate?: string | null, courtId?: string | null, accidentDate?: string | null, caseTypeId: string, createdAt: string, updatedAt: string, docketNo?: string | null, openDate?: string | null, closeDate?: string | null, completedDate?: string | null, isConsultMatter?: boolean | null, isInternalMatter?: boolean | null, isDelinquent?: boolean | null, ccEmailBillsTo?: string | null, deletedAt?: string | null, convertedToNormalMatterBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, profitCenter?: { __typename?: 'Office', id: number, name: string } | null, location?: { __typename?: 'Office', id: number, name: string } | null, billing?: { __typename?: 'CaseBilling', id: string, billingType: BillingType, flatFee?: number | null, retainerAmount?: number | null, billingCycle?: BillingCycle | null, billingCycleCustomDate?: number | null, upfrontFlatFee?: number | null, monthlyFlatFee?: number | null, pauseBillingUntil?: any | null, billEntireFlatFeeUpfront?: boolean | null, contingencyShare?: number | null, contingencySettlementAmount?: number | null, billGenerationLimitEnabled?: boolean | null, billGenerationType?: BillGenerationType | null, billGenerationAmount?: number | null, billGenerationHours?: number | null, writeOffInterest?: boolean | null, increaseInterestRateOnFirstLatePayment?: boolean | null, splitBillEnabled?: boolean | null, discountAmount?: number | null, discountPercentage?: number | null, discountType?: DiscountType | null, consultationFee?: number | null, isFlatFeeHoursExhausted?: boolean | null, minimumFundsThreshold?: number | null, paymentPlanStartDate?: any | null, createdAt: string, updatedAt: string, skipDeptHeadApproval?: boolean | null, specialPayments?: Array<{ __typename?: 'SpecialPayment', amount: number, date: string }> | null, retainerAccount?: { __typename?: 'Account', id: string, name: string, active: boolean, category: AccountCategory, sortCode: string, isBankAccount: boolean, createdAt: string, updatedAt: string, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, emailVerified: boolean, status: UserStatus, createdAt: string, updatedAt: string } | null } | null, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, email: string, emailVerified: boolean, hourlyRate?: number | null, createdAt: string, updatedAt: string } | null, interestRates?: Array<{ __typename?: 'InterestRate', rate?: number | null, applicableDays?: number | null }> | null } | null, setting?: { __typename?: 'CaseSetting', id: string, flatFeeHoursNotificationThreshold?: number | null, sendFlatFeeHoursExhaustedNotification?: boolean | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, createdAt: string, updatedAt: string, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, title?: string | null, isLocked: boolean, type: AttachmentType, typeId: string, url?: string | null, createdAt: string, updatedAt: string } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, title?: string | null, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, caseRole?: ExternalUserCaseRole | null, splitBillShare?: number | null, trustBalance?: number | null, billDeliveryMethods?: Array<BillDeliveryMethod> | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingEmail?: string | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, middleName?: string | null, lastName: string, displayName?: string | null, suffix?: string | null, email?: string | null, phoneNumber?: string | null, clientNumber?: string | null, contractBalance?: string | null, arrearsBalance?: string | null, residualBalance?: string | null, trustBalance?: string | null, lastPayDate?: string | null, lastPayAmount?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string, courtToExternalUserToExternalUserRole?: Array<{ __typename?: 'CourtToExternalUserToExternalUserRole', id: string, courtId: string, externalUserId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, phoneNumber?: string | null, email?: string | null, createdAt: string, updatedAt: string } | null } | null> | null } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null, caseReferences?: Array<{ __typename?: 'CaseReference', id: string, percentage?: number | null, reference: { __typename?: 'Reference', id: string, referral: string, referralSourceId?: string | null, referralSource: { __typename?: 'ReferralSource', id: string, sourceType: string } } } | null> | null, bills?: Array<{ __typename?: 'Bill', id: number, status: BillStatus, issueDate?: any | null, amount: number, amountPaid?: number | null, writtenOffPrincipal?: number | null, type: BillType, billTimelines?: Array<{ __typename?: 'BillTimeline', action: BillTimelineAction, description: string, createdAt: string, metadata?: { __typename?: 'Metadata', client?: string | null, clientRole?: string | null, email?: string | null } | null, deliveryMetadata?: { __typename?: 'DeliveryMetadata', status?: string | null, mode?: string | null, details?: string | null, content?: string | null } | null }> | null } | null> | null, openedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null } | null, consultAttorney?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCaseBillingQueryVariables = Exact<{
  caseInput: CaseInput;
}>;


export type FetchCaseBillingQuery = { __typename?: 'Query', fetchCase: { __typename?: 'CasePayload', case?: { __typename?: 'Case', id: string, billing?: { __typename?: 'CaseBilling', id: string, billingType: BillingType, isFlatFeeHoursExhausted?: boolean | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type AddUsersToCaseMutationVariables = Exact<{
  addUsersToCaseInput: AddUsersToCaseInput;
}>;


export type AddUsersToCaseMutation = { __typename?: 'Mutation', addUsersToCase: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, dueDate?: string | null, accidentDate?: string | null, createdAt: string, updatedAt: string, caseTypeId: string, courtId?: string | null, docketNo?: string | null, deletedAt?: string | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, hourlyRate?: number | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, ssn?: string | null, phoneNumber?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null } | null } };

export type UpdateCaseCaseTypeMutationVariables = Exact<{
  updateCaseCaseTypeInput: UpdateCaseCaseTypeInput;
}>;


export type UpdateCaseCaseTypeMutation = { __typename?: 'Mutation', updateCaseCaseType: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, dueDate?: string | null, accidentDate?: string | null, createdAt: string, updatedAt: string, caseTypeId: string, courtId?: string | null, docketNo?: string | null, deletedAt?: string | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, hourlyRate?: number | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, ssn?: string | null, phoneNumber?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null } | null } };

export type RemoveAssigneeFromCaseMutationVariables = Exact<{
  removeAssigneeFromCaseInput: RemoveUsersFromCaseInput;
}>;


export type RemoveAssigneeFromCaseMutation = { __typename?: 'Mutation', removeAssigneeFromCase: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, dueDate?: string | null, courtId?: string | null, accidentDate?: string | null, caseTypeId: string, createdAt: string, updatedAt: string, docketNo?: string | null, deletedAt?: string | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, hourlyRate?: number | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, ssn?: string | null, phoneNumber?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null } | null } };

export type RemoveAttachmentDataMutationVariables = Exact<{
  removeAttachment: RemoveAttachment;
}>;


export type RemoveAttachmentDataMutation = { __typename?: 'Mutation', removeAttachmentData: { __typename?: 'AttachmentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, isLocked: boolean, type: AttachmentType, typeId: string, createdAt: string, updatedAt: string } | null } };

export type RemoveCasesMediaMutationVariables = Exact<{
  removeAttachment: RemoveCasesMediaInput;
}>;


export type RemoveCasesMediaMutation = { __typename?: 'Mutation', removeCasesMedia: boolean };

export type FetchAllTasksQueryVariables = Exact<{
  tasksInput: TasksInput;
}>;


export type FetchAllTasksQuery = { __typename?: 'Query', fetchAllTasks: { __typename?: 'TasksPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, tasks?: Array<{ __typename?: 'Task', id: string, title: string, type?: TaskType | null, createdAt: string, updatedAt: string } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null } };

export type AddUserCaseTaskMutationVariables = Exact<{
  userCaseTaskInput: UserCaseTaskInput;
}>;


export type AddUserCaseTaskMutation = { __typename?: 'Mutation', addUserCaseTask: { __typename?: 'UserCaseTaskPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, userCaseTask?: { __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, createdAt: string, updatedAt: string, followUpDate?: string | null, task?: { __typename?: 'Task', id: string, title: string, type?: TaskType | null, createdAt: string, updatedAt: string } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null } };

export type CreateTaskMutationVariables = Exact<{
  createTaskInput: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'TaskPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string } | null } };

export type UpdateTaskMutationVariables = Exact<{
  updateTaskInput: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'TaskPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null } | null, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, description?: string | null, type?: TaskType | null } | null } };

export type DeleteTaskMutationVariables = Exact<{
  deleteTaskInput: DeleteTask;
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'TaskPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, name?: string | null, message?: string | null } | null } };

export type FetchAllCaseTaskQueryVariables = Exact<{
  tasksByCaseInput: TasksByCaseInput;
}>;


export type FetchAllCaseTaskQuery = { __typename?: 'Query', fetchAllCaseTasks: { __typename?: 'UserTasksPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, userCaseTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, createdAt: string, updatedAt: string, followUpDate?: string | null, task?: { __typename?: 'Task', id: string, title: string, type?: TaskType | null, createdAt: string, updatedAt: string } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null } };

export type UpdateUserCasesTaskMutationVariables = Exact<{
  updateUserCasesTaskInput: UpdateUserCaseTaskInput;
}>;


export type UpdateUserCasesTaskMutation = { __typename?: 'Mutation', updateUserCasesTask: { __typename?: 'TaskPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null, name?: string | null, error?: string | null } | null, task?: { __typename?: 'Task', id: string, title: string, description?: string | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null } | null } };

export type UpdateCaseEventMutationVariables = Exact<{
  updateCaseEventInput: UpdateCaseEventInput;
}>;


export type UpdateCaseEventMutation = { __typename?: 'Mutation', updateCaseEvent: { __typename?: 'CaseEventPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, caseEvent?: { __typename?: 'CaseEvent', id: string, title?: string | null, hearingAt?: string | null, eventType: EventType, hearingEndsAt?: string | null, nextHearingAt?: string | null, outlookEventId?: string | null, createdAt: string, updatedAt: string } | null } };

export type DeleteCaseEventMutationVariables = Exact<{
  deleteCaseEvent: DeleteCaseEvent;
}>;


export type DeleteCaseEventMutation = { __typename?: 'Mutation', deleteCaseEvent: { __typename?: 'CaseEventPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllCaseEventsQueryVariables = Exact<{
  caseEventsByCaseInput: CaseEventsByCaseInput;
}>;


export type FetchAllCaseEventsQuery = { __typename?: 'Query', fetchAllCaseEvents: { __typename?: 'CaseEventsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, title?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, hearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null } };

export type FetchCourtDatesQueryVariables = Exact<{
  courtDatesInput: CourtDatesInput;
}>;


export type FetchCourtDatesQuery = { __typename?: 'Query', fetchCourtDates: { __typename?: 'CourtDatesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, courtDates: Array<{ __typename?: 'CourtDate', id: string, title?: string | null, hearingAt: string, hearingEndsAt?: string | null, caseId: string, caseNumber?: string | null, consultMatterNumber?: string | null, isConsultMatter?: boolean | null, caseTitle?: string | null, caseStatus: CaseStatus, clientName?: string | null, courtName?: string | null, responsibleAttorneyId?: string | null, responsibleAttorneyName?: string | null }> } };

export type GetAttachmentQueryVariables = Exact<{
  getMedia: GetMedia;
}>;


export type GetAttachmentQuery = { __typename?: 'Query', getAttachment: { __typename?: 'AttachmentMediaPayload', preSignedUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type AssignCaseToExternalUserMutationVariables = Exact<{
  assignExternalUserToCase: AssignExternalUserToCase;
}>;


export type AssignCaseToExternalUserMutation = { __typename?: 'Mutation', assignCaseToExternalUser: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, case?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, dueDate?: string | null, courtId?: string | null, accidentDate?: string | null, caseTypeId: string, createdAt: string, updatedAt: string, deletedAt?: string | null, userCasesTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, taskId?: string | null, followUpDate?: string | null, createdAt: string, updatedAt: string, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string, type?: TaskType | null } | null, assignee?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, initials?: string | null, hourlyRate?: number | null, createdAt: string, updatedAt: string, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, title?: string | null, isLocked: boolean, type: AttachmentType, typeId: string, url?: string | null, createdAt: string, updatedAt: string } | null> | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, title?: string | null, eventType: EventType, hearingAt?: string | null, outlookEventId?: string | null, hearingEndsAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, email?: string | null, firstName: string, lastName: string, displayName?: string | null, ssn?: string | null, phoneNumber?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } | null } | null } };

export type UpdateExternalUserMutationVariables = Exact<{
  updateExternalUserInput: UpdateExternalUserInput;
}>;


export type UpdateExternalUserMutation = { __typename?: 'Mutation', updateExternalUser: { __typename?: 'ExternalUserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, businessName?: string | null, createdAt: string, updatedAt: string, email?: string | null, phoneNumber?: string | null, phoneNumberExtension?: string | null, clientNumber?: string | null, contractBalance?: string | null, arrearsBalance?: string | null, residualBalance?: string | null, trustBalance?: string | null, lastPayDate?: string | null, lastPayAmount?: string | null, isInternational?: boolean | null, language?: string | null, dateOfBirth?: any | null, initials?: string | null, middleName?: string | null, personalPhone?: string | null, suffix?: string | null, homePhone?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null } | null } };

export type ArchiveCaseMutationVariables = Exact<{
  archiveCase: ArchiveCase;
}>;


export type ArchiveCaseMutation = { __typename?: 'Mutation', archiveCase: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DeleteCaseMutationVariables = Exact<{
  deleteCaseInput: DeleteCase;
}>;


export type DeleteCaseMutation = { __typename?: 'Mutation', deleteCase: { __typename?: 'CasePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, error?: string | null, status?: number | null } | null } };

export type ResendMessageMutationVariables = Exact<{
  externalUserId: Scalars['String'];
  caseId: Scalars['String'];
}>;


export type ResendMessageMutation = { __typename?: 'Mutation', resendMessage: boolean };

export type FetchAllReferralSourcesQueryVariables = Exact<{
  fetchAllSources: FetchAllReferralSourceInput;
}>;


export type FetchAllReferralSourcesQuery = { __typename?: 'Query', fetchAllReferralSources: { __typename?: 'ReferralSourcesPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, referralSources?: Array<{ __typename?: 'ReferralSource', id: string, sourceType: string } | null> | null, pagination?: { __typename?: 'PaginationPayload', totalPages?: number | null, totalCount?: number | null, page?: number | null } | null } };

export type CreateReferralSourceMutationVariables = Exact<{
  sourceType: Scalars['String'];
}>;


export type CreateReferralSourceMutation = { __typename?: 'Mutation', createReferralSource: { __typename?: 'ReferralSource', id: string, sourceType: string } };

export type CheckConflictsQueryVariables = Exact<{
  checkConflictsInput: CheckConflictsInput;
}>;


export type CheckConflictsQuery = { __typename?: 'Query', checkConflicts: { __typename?: 'ConflictResponse', conflicts: Array<{ __typename?: 'ExternalUsersConflict', role: string, caseRole?: string | null, case?: { __typename?: 'Case', title?: string | null, id: string, caseNumber?: string | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userType: UserType, user?: { __typename?: 'User', lastName?: string | null, firstName?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null> | null } | null, contact: { __typename?: 'ExternalUser', lastName: string, firstName: string, middleName?: string | null, suffix?: string | null, phoneNumber?: string | null, email?: string | null, addresses?: Array<{ __typename?: 'Address', state?: string | null, address1?: string | null, city?: string | null, country?: string | null, zipCode?: string | null } | null> | null } }>, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, totalPages?: number | null, page?: number | null } | null } };

export type FetchRecentCaseQueryVariables = Exact<{
  isConsultMatter: Scalars['Boolean'];
}>;


export type FetchRecentCaseQuery = { __typename?: 'Query', fetchRecentCase: { __typename?: 'NextMatterNoPayload', matterNo: string } };

export type FetchAllHourlyCasesQueryVariables = Exact<{
  fetchHourlyCasesInput: FetchHourlyCasesInput;
}>;


export type FetchAllHourlyCasesQuery = { __typename?: 'Query', fetchAllHourlyCases: { __typename?: 'HourlyCasesPayload', cases?: Array<{ __typename?: 'Case', id: string, title?: string | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, totalPages?: number | null, page?: number | null } | null } };

export type FetchCaseFinancialTimelineQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type FetchCaseFinancialTimelineQuery = { __typename?: 'Query', fetchCaseFinancialTimeline: { __typename?: 'CaseFinancialTimelinePayload', startDate?: any | null, events: Array<{ __typename?: 'FinancialTimelineEvent', id: string, date: any, category: FinancialTimelineCategory, label: string, description?: string | null, amount?: number | null, billId?: number | null, actorName?: string | null }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCaseChartsSummaryQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type FetchCaseChartsSummaryQuery = { __typename?: 'Query', fetchCaseChartsSummary: { __typename?: 'CaseChartsSummaryPayload', arBalance?: number | null, financialSummary: { __typename?: 'CaseChartsFinancialSummary', paidToDate: number, writtenOff: number, expenses: number, investigatorTime: number, interestIncome: number, moneyInTrust: number }, flatFeeSummary?: { __typename?: 'FlatFeeSummary', contractFee: number, discount: number, paidAmount: number, unpaidAmount: number, residualBalance: number, hybridFlatFeeUsed: number } | null, hoursSummary?: { __typename?: 'CaseChartsHoursSummary', billed: number, unbilled: number, onPreBill: number, wip: number, accommodated: number, total: number, byPerson: Array<{ __typename?: 'CaseChartsPersonHours', userId?: string | null, name: string, role: CaseChartsHoursRole, legalTeamPosition?: UserType | null, billed: number, unbilled: number, onPreBill: number, wip: number, accommodated: number, total: number }> } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCaseFinancialsQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type FetchCaseFinancialsQuery = { __typename?: 'Query', fetchCaseFinancials: { __typename?: 'CaseFinancialsPayload', timeEntriesSummary: { __typename?: 'EntriesSummary', time: number, amount: number }, costEntriesSummary: { __typename?: 'EntriesSummary', time: number, amount: number }, expensesSummary: { __typename?: 'EntriesSummary', time: number, amount: number }, legalFeeSummary: { __typename?: 'EntriesSummary', time: number, amount: number }, flatFeeSummary?: { __typename?: 'FlatFeeSummary', contractFee: number, discount: number, paidAmount: number, unpaidAmount: number, residualBalance: number, hybridFlatFeeUsed: number, payoffAmount?: number | null } | null, billingSummary?: { __typename?: 'BillingSummary', lastPaymentDate?: any | null, lastPaymentAmount?: number | null, paidToDate?: number | null, totalRefunds?: number | null, lastBillDate?: any | null, advArBalance?: number | null, arBalance?: number | null } | null, costSummary?: { __typename?: 'CostSummary', costBilled: number, costPaidToDate: number, costUnpaid: number } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateReferralSourceMutationVariables = Exact<{
  updateReferralSourceId: Scalars['String'];
  sourceType: Scalars['String'];
}>;


export type UpdateReferralSourceMutation = { __typename?: 'Mutation', updateReferralSource: { __typename?: 'ReferralSource', id: string, sourceType: string, createdAt: string, updatedAt: string } };

export type DeleteReferralSourceMutationVariables = Exact<{
  deleteReferralSourceId: Scalars['String'];
}>;


export type DeleteReferralSourceMutation = { __typename?: 'Mutation', deleteReferralSource: boolean };

export type ConvertFlatFeeCaseToHourlyMutationVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type ConvertFlatFeeCaseToHourlyMutation = { __typename?: 'Mutation', convertFlatFeeCaseToHourly: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateCaseBillingTypeMutationVariables = Exact<{
  updateCaseBillingTypeInput: UpdateCaseBillingTypeInput;
}>;


export type UpdateCaseBillingTypeMutation = { __typename?: 'Mutation', updateCaseBillingType: { __typename?: 'CasePayload', case?: { __typename?: 'Case', id: string, billing?: { __typename?: 'CaseBilling', id: string, billingType: BillingType } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllMattersWithoutJoinQueryVariables = Exact<{
  casesInput: CasesInput;
}>;


export type FetchAllMattersWithoutJoinQuery = { __typename?: 'Query', fetchAllMattersWithoutJoin: { __typename?: 'CasesPayload', pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, cases?: Array<{ __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, status: CaseStatus, dueDate?: string | null, deletedAt?: string | null, createdAt: string, updatedAt: string, isConsultMatter?: boolean | null, advCaseNumber?: string | null, caseTypeId: string, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null } | null> | null } };

export type SearchMattersQueryVariables = Exact<{
  searchMattersInput: SearchMattersInput;
}>;


export type SearchMattersQuery = { __typename?: 'Query', searchMatters: { __typename?: 'SearchMattersPayload', cases?: Array<{ __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, advCaseNumber?: string | null, title?: string | null, status: CaseStatus, openDate?: string | null, completedDate?: string | null, closeDate?: string | null, createdAt: string, updatedAt: string, isConsultMatter?: boolean | null, billing?: { __typename?: 'CaseBilling', pauseBillingUntil?: any | null } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, createdAt: string, syncWithOutlook: boolean, updatedAt: string } | null } | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchDataForRecordPaymentsQueryVariables = Exact<{
  fetchDataForRecordPaymentsInput: FetchDataForRecordPaymentsInput;
}>;


export type FetchDataForRecordPaymentsQuery = { __typename?: 'Query', fetchDataForRecordPayments: { __typename?: 'FetchDataForRecordPaymentsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, cases?: Array<{ __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, advCaseNumber?: string | null, title?: string | null, status: CaseStatus, caseTypeId: string, openDate?: string | null, completedDate?: string | null, closeDate?: string | null, createdAt: string, updatedAt: string, isConsultMatter?: boolean | null, billing?: { __typename?: 'CaseBilling', billingType: BillingType } | null, caseType?: { __typename?: 'CaseType', id: string, name: string } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', caseRole?: ExternalUserCaseRole | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null } | null } }> | null, bills?: Array<{ __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, description?: string | null, payOffAmount?: number | null, writtenOffPrincipal?: number | null, writtenOffInterest?: number | null, lastSentAt?: any | null, sendToClient: boolean, createdAt: string, updatedAt: string } | null> | null } | null> | null, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, email?: string | null, phoneNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null> | null } | null } };

export type GetCaseBillingPauseDateQueryVariables = Exact<{
  caseId: Scalars['String'];
  advancePayment: Scalars['Float'];
}>;


export type GetCaseBillingPauseDateQuery = { __typename?: 'Query', getCaseBillingPauseDate: { __typename?: 'CaseNextBillingDatePayload', date: any, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type GetInitialPaymentLockQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type GetInitialPaymentLockQuery = { __typename?: 'Query', getInitialPaymentLock: { __typename?: 'InitialPaymentLockPayload', state: InitialPaymentLockState, canEdit: boolean, message?: string | null, billId?: number | null, billStatus?: BillStatus | null, canGenerateBill: boolean, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type GetClientTrustBalanceQueryVariables = Exact<{
  getClientTrustBalanceInput: GetClientTrustBalanceInput;
}>;


export type GetClientTrustBalanceQuery = { __typename?: 'Query', getClientTrustBalance: { __typename?: 'GetClientTrustBalancePayload', trustBalance?: number | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetPublicClientTrustBalanceQueryVariables = Exact<{
  getClientTrustBalanceInput: GetClientTrustBalanceInput;
}>;


export type GetPublicClientTrustBalanceQuery = { __typename?: 'Query', getPublicClientTrustBalance: { __typename?: 'GetClientTrustBalancePayload', trustBalance?: number | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetTrustBalanceSummaryQueryVariables = Exact<{
  getTrustBalanceSummaryInput: GetTrustBalanceSummaryInput;
}>;


export type GetTrustBalanceSummaryQuery = { __typename?: 'Query', getTrustBalanceSummary: { __typename?: 'TrustBalanceSummaryPayload', ioltaBalanceSummary: { __typename?: 'IOLTABalanceSummaryPayload', balance: number, retainerAccount?: { __typename?: 'Account', id: string, name: string, accountNo?: string | null } | null, clients: Array<{ __typename?: 'TrustBalanceClientPayload', clientId: string, name: string, trustBalance: number, settlementCheck?: { __typename?: 'SettlementCheck', checkNo: string, date: string, memo?: string | null, amount: number } | null }> }, escrowBalanceSummary: { __typename?: 'EscrowBalanceSummaryPayload', balance: number, clients: Array<{ __typename?: 'TrustBalanceClientPayload', clientId: string, name: string, trustBalance: number }> }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetCasesWithLowTrustBalanceQueryVariables = Exact<{
  casesWithLowTrustBalanceInput?: InputMaybe<CasesWithLowTrustBalanceInput>;
}>;


export type GetCasesWithLowTrustBalanceQuery = { __typename?: 'Query', getCasesWithLowTrustBalance: { __typename?: 'CasesWithLowTrustBalancePayload', cases: Array<{ __typename?: 'CaseWithLowTrustBalancePayload', id: string, caseNumber: string, title: string, minimumFundsThreshold: number, totalTrustBalance: number, retainerAmount: number, amountToBill: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetClientBalanceInAccountQueryVariables = Exact<{
  getClientBalanceInAccountInput: GetClientBalanceInAccountInput;
}>;


export type GetClientBalanceInAccountQuery = { __typename?: 'Query', getClientBalanceInAccount: { __typename?: 'GetClientBalanceInAccountPayload', balance: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetCaseClientsQueryVariables = Exact<{
  getCaseClientsInput: GetCaseClientsInput;
}>;


export type GetCaseClientsQuery = { __typename?: 'Query', getCaseClients: { __typename?: 'GetCaseClientsPayload', clients: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, caseRole?: ExternalUserCaseRole | null, splitBillShare?: number | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null } | null } }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchExternalUserQueryVariables = Exact<{
  externalUserInput: ExternalUserInput;
}>;


export type FetchExternalUserQuery = { __typename?: 'Query', fetchExternalUser: { __typename?: 'ExternalUserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, createdAt: string, updatedAt: string, email?: string | null, phoneNumber?: string | null, phoneNumberExtension?: string | null, clientNumber?: string | null, contractBalance?: string | null, arrearsBalance?: string | null, residualBalance?: string | null, trustBalance?: string | null, lastPayDate?: string | null, lastPayAmount?: string | null, socialSecurityNumber?: string | null, driverLicenseNumber?: string | null, isInternational?: boolean | null, language?: string | null, dateOfBirth?: any | null, initials?: string | null, middleName?: string | null, personalPhone?: string | null, suffix?: string | null, homePhone?: string | null, businessName?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, caseRole?: ExternalUserCaseRole | null, createdAt: string, updatedAt: string, isArchived: boolean, externalUserToExternalUserRoleId: string, litigationId: string, litigation?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, status: CaseStatus, caseTypeId: string, isConsultMatter?: boolean | null, createdAt: string, updatedAt: string } | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, createdAt: string, externalUserId: string, externalUserRoleId: string, updatedAt: string } } | null> | null } | null> | null } | null } };

export type GetClientCreditBalanceQueryVariables = Exact<{
  getClientCreditBalanceInput: GetClientCreditBalanceInput;
}>;


export type GetClientCreditBalanceQuery = { __typename?: 'Query', getClientCreditBalance: { __typename?: 'GetClientCreditBalancePayload', creditBalance: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetCreditBalanceSummaryQueryVariables = Exact<{
  getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput;
}>;


export type GetCreditBalanceSummaryQuery = { __typename?: 'Query', getCreditBalanceSummary: { __typename?: 'CreditBalanceSummaryPayload', totalCreditBalance: number, voidedPayableCredit?: number | null, clients: Array<{ __typename?: 'CreditBalanceClientPayload', clientId: string, name: string, creditBalance: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetPublicCreditBalanceSummaryQueryVariables = Exact<{
  getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput;
}>;


export type GetPublicCreditBalanceSummaryQuery = { __typename?: 'Query', getPublicCreditBalanceSummary: { __typename?: 'CreditBalanceSummaryPayload', totalCreditBalance: number, clients: Array<{ __typename?: 'CreditBalanceClientPayload', clientId: string, name: string, creditBalance: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCategoriesBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCategoriesBalancesQuery = { __typename?: 'Query', fetchCategoriesBalances: { __typename?: 'CategoriesBalancesPayload', asset: number, liability: number, equity: number, revenue: number, expense: number } };

export type FetchZescrowAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchZescrowAccountQuery = { __typename?: 'Query', fetchZescrowAccount: { __typename?: 'Account', id: string, name: string, sortCode: string, currentBalance?: number | null } };

export type FetchRetainerAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRetainerAccountQuery = { __typename?: 'Query', fetchRetainerAccount: { __typename?: 'Account', id: string, name: string, sortCode: string, currentBalance?: number | null } };

export type FetchOperatingAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOperatingAccountQuery = { __typename?: 'Query', fetchOperatingAccount: { __typename?: 'Account', id: string, name: string, sortCode: string, currentBalance?: number | null } };

export type FetchClientLedgerQueryVariables = Exact<{
  input: FetchClientLedgerInput;
}>;


export type FetchClientLedgerQuery = { __typename?: 'Query', fetchClientLedger: { __typename?: 'ClientLedgerPayload', headers: Array<string>, rows: Array<any>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, matter?: { __typename?: 'ClientLedgerMatter', id: string, matterNumber?: string | null, matterTitle?: string | null, clientNumber?: string | null, clientName?: string | null, responsibleAttorney?: string | null } | null } };

export type FetchAllCourtsQueryVariables = Exact<{
  courtsInput: CourtsInput;
}>;


export type FetchAllCourtsQuery = { __typename?: 'Query', fetchAllCourts: { __typename?: 'CourtsPayload', courts?: Array<{ __typename?: 'Court', id: string, name: string, county?: string | null, totalCaseCount?: number | null, createdAt: string, updatedAt: string } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllAssigneeCourtsQueryVariables = Exact<{
  courtsInput: CourtsInput;
}>;


export type FetchAllAssigneeCourtsQuery = { __typename?: 'Query', fetchAssigneeCourts: { __typename?: 'CourtsPayload', courts?: Array<{ __typename?: 'Court', id: string, name: string, startDay?: WeekDays | null, endDay?: WeekDays | null, county?: string | null, totalCaseCount?: number | null, createdAt: string, updatedAt: string } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCourtQueryVariables = Exact<{
  courtInput: GetCourt;
}>;


export type FetchCourtQuery = { __typename?: 'Query', fetchCourt: { __typename?: 'CourtPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, court?: { __typename?: 'Court', id: string, name: string, county?: string | null, createdAt: string, updatedAt: string, litigations?: Array<{ __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, createdAt: string, updatedAt: string, caseTypeId: string, courtId?: string | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string } | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, createdAt: string, updatedAt: string, clientNumber?: string | null } | null, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } }> | null } | null> | null, courtToExternalUserToExternalUserRole?: Array<{ __typename?: 'CourtToExternalUserToExternalUserRole', id: string, courtId: string, externalUserId: string, externalUserToExternalUserRoleId?: string | null, isArchived: boolean, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, email?: string | null, createdAt: string, updatedAt: string, phoneNumber?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null } | null, externalUserToExternalUserRole?: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string } | null } | null> | null } | null } };

export type AssignCourtToExternalUserMutationVariables = Exact<{
  assignExternalUserToCourt: AssignExternalUserToCourt;
}>;


export type AssignCourtToExternalUserMutation = { __typename?: 'Mutation', assignCourtToExternalUser: { __typename?: 'CourtPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, court?: { __typename?: 'Court', id: string, name: string, createdAt: string, updatedAt: string } | null } };

export type RemoveExternalUserFromCourtMutationVariables = Exact<{
  removeExternalUserFromCourt: RemoveExternalUserFromCourt;
}>;


export type RemoveExternalUserFromCourtMutation = { __typename?: 'Mutation', removeExternalUserFromCourt: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateCourtMutationVariables = Exact<{
  createCourtInput: CreateCourtInput;
}>;


export type CreateCourtMutation = { __typename?: 'Mutation', createCourt: { __typename?: 'CourtPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, court?: { __typename?: 'Court', id: string, name: string, county?: string | null, createdAt: string, updatedAt: string } | null } };

export type UpdateCourtMutationVariables = Exact<{
  updateCourtInput: UpdateCourtInput;
}>;


export type UpdateCourtMutation = { __typename?: 'Mutation', updateCourt: { __typename?: 'CourtPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, court?: { __typename?: 'Court', id: string, name: string, county?: string | null, createdAt: string, updatedAt: string } | null } };

export type RemoveCourtMutationVariables = Exact<{
  removeCourt: RemoveCourt;
}>;


export type RemoveCourtMutation = { __typename?: 'Mutation', removeCourt: { __typename?: 'CourtPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, court?: { __typename?: 'Court', id: string, name: string, county?: string | null, createdAt: string, updatedAt: string } | null } };

export type FetchAllAssignedTasksQueryVariables = Exact<{
  tasksByAssigneeInput: TasksByAssigneeInput;
}>;


export type FetchAllAssignedTasksQuery = { __typename?: 'Query', fetchAllAssignedTasks: { __typename?: 'UserTasksPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, userCaseTasks?: Array<{ __typename?: 'UserCaseTasks', id: string, status?: UserCasesTaskStatus | null, createdAt: string, updatedAt: string, taskId?: string | null, followUpDate?: string | null, task?: { __typename?: 'Task', id: string, title: string, createdAt: string, updatedAt: string } | null, litigation?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, caseTypeId: string, courtId?: string | null, createdAt: string, updatedAt: string, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, createdAt: string, updatedAt: string, externalUserId: string, externalUserRoleId: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null } | null } | null> | null } };

export type FetchAllDepartmentsQueryVariables = Exact<{
  fetchDepartmentsInput: FetchDepartmentsInput;
}>;


export type FetchAllDepartmentsQuery = { __typename?: 'Query', fetchAllDepartments: { __typename?: 'DepartmentsPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, departments?: Array<{ __typename?: 'Department', id: string, name: string, description?: string | null, departmentHeadId?: string | null, departmentHead?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null } | null, departmentToLawTypes?: Array<{ __typename?: 'DepartmentToLawType', lawType: { __typename?: 'LawType', id: string, name: string } }> | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, totalPages?: number | null, page?: number | null } | null } };

export type IsDepartmentHeadForCaseQueryVariables = Exact<{
  fetchDepartmentHeadInput: FetchDepartmentHeadInput;
}>;


export type IsDepartmentHeadForCaseQuery = { __typename?: 'Query', isDepartmentHeadForCase: { __typename?: 'DepartmentHeadPayload', isDepartmentHead: boolean, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type GetDepartmentHeadForCaseQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type GetDepartmentHeadForCaseQuery = { __typename?: 'Query', getDepartmentHeadForCase: { __typename?: 'GetDepartmentHeadForCasePayload', departmentHead?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type FetchDepartmentUsersByLawTypeQueryVariables = Exact<{
  fetchDepartmentUsersByLawTypeInput: FetchDepartmentUsersByLawTypeInput;
}>;


export type FetchDepartmentUsersByLawTypeQuery = { __typename?: 'Query', fetchDepartmentUsersByLawType: { __typename?: 'DepartmentUsersPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, users: Array<{ __typename?: 'DepartmentUser', id: string, firstName?: string | null, lastName?: string | null, email: string, emailVerified: boolean, status: UserStatus, updatedAt: string, createdAt: string, departmentHead?: boolean | null }> } };

export type CreateDepartmentMutationVariables = Exact<{
  createDepartmentInput: CreateDepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment: { __typename?: 'DepartmentPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, department?: { __typename?: 'Department', description?: string | null, id: string, name: string, departmentHead?: { __typename?: 'User', id: string, lastName?: string | null, firstName?: string | null } | null } | null } };

export type UpdateDepartmentMutationVariables = Exact<{
  updateDepartmentInput: UpdateDepartmentInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'Mutation', updateDepartment: { __typename?: 'DepartmentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } };

export type DeleteDepartmentMutationVariables = Exact<{
  deleteDepartmentId: Scalars['String'];
}>;


export type DeleteDepartmentMutation = { __typename?: 'Mutation', deleteDepartment: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } };

export type DocPageSummaryFragment = { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, updatedAt: any, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };

export type DocPageDetailFragment = { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, content?: any | null, draftContent?: any | null, publishedAt?: any | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, publishedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };

export type DocPagesTreeQueryVariables = Exact<{
  scope?: InputMaybe<DocPageScope>;
}>;


export type DocPagesTreeQuery = { __typename?: 'Query', docPagesTree: { __typename?: 'DocPagesPayload', docPages?: Array<{ __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, updatedAt: any, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SearchDocPagesQueryVariables = Exact<{
  searchDocPagesInput: SearchDocPagesInput;
}>;


export type SearchDocPagesQuery = { __typename?: 'Query', searchDocPages: { __typename?: 'DocPageSearchPayload', total: number, page: number, limit: number, results?: Array<{ __typename?: 'DocPageSearchResult', titleMatch: boolean, snippet?: string | null, page: { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, updatedAt: any, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RecentDocPagesQueryVariables = Exact<{
  scope?: InputMaybe<DocPageScope>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RecentDocPagesQuery = { __typename?: 'Query', recentDocPages: { __typename?: 'DocPagesPayload', docPages?: Array<{ __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, updatedAt: any, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DocPageQueryVariables = Exact<{
  fetchDocPageInput: FetchDocPageInput;
}>;


export type DocPageQuery = { __typename?: 'Query', docPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, content?: any | null, draftContent?: any | null, publishedAt?: any | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, publishedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DocPageRevisionsQueryVariables = Exact<{
  pageId: Scalars['String'];
}>;


export type DocPageRevisionsQuery = { __typename?: 'Query', docPageRevisions: { __typename?: 'DocPageRevisionsPayload', revisions?: Array<{ __typename?: 'DocPageRevision', id: string, title: string, status: DocPageStatus, changeSummary?: string | null, content?: any | null, createdAt: any, editor?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateDocPageMutationVariables = Exact<{
  createDocPageInput: CreateDocPageInput;
}>;


export type CreateDocPageMutation = { __typename?: 'Mutation', createDocPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, content?: any | null, draftContent?: any | null, publishedAt?: any | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, publishedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateDocPageMutationVariables = Exact<{
  updateDocPageInput: UpdateDocPageInput;
}>;


export type UpdateDocPageMutation = { __typename?: 'Mutation', updateDocPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, content?: any | null, draftContent?: any | null, publishedAt?: any | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, publishedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SaveDocPageDraftMutationVariables = Exact<{
  saveDocPageDraftInput: SaveDocPageDraftInput;
}>;


export type SaveDocPageDraftMutation = { __typename?: 'Mutation', saveDocPageDraft: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, title: string, updatedAt: any } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type PublishDocPageMutationVariables = Exact<{
  publishDocPageInput: PublishDocPageInput;
}>;


export type PublishDocPageMutation = { __typename?: 'Mutation', publishDocPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, content?: any | null, draftContent?: any | null, publishedAt?: any | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, publishedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ArchiveDocPageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ArchiveDocPageMutation = { __typename?: 'Mutation', archiveDocPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, status: DocPageStatus } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UnarchiveDocPageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnarchiveDocPageMutation = { __typename?: 'Mutation', unarchiveDocPage: { __typename?: 'DocPagePayload', docPage?: { __typename?: 'DocPage', id: string, status: DocPageStatus } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DeleteDocPageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDocPageMutation = { __typename?: 'Mutation', deleteDocPage: { __typename?: 'DocPagePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ReorderDocPagesMutationVariables = Exact<{
  reorderDocPagesInput: ReorderDocPagesInput;
}>;


export type ReorderDocPagesMutation = { __typename?: 'Mutation', reorderDocPages: { __typename?: 'DocPagesPayload', docPages?: Array<{ __typename?: 'DocPage', id: string, title: string, slug: string, icon?: string | null, status: DocPageStatus, scope: DocPageScope, sortOrder: number, parentId?: string | null, updatedAt: any, updatedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllEntriesQueryVariables = Exact<{
  fetchTimeEntriesInput: FetchEntriesInput;
}>;


export type FetchAllEntriesQuery = { __typename?: 'Query', fetchAllEntries: { __typename?: 'EntriesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null } | null, entries?: Array<{ __typename?: 'Entry', id: string, billable: boolean, amount?: number | null, qty?: number | null, unitPrice?: number | null, caseId: string, date: any, description?: string | null, duration?: string | null, status: EntryStatus, userId?: string | null, creatorId?: string | null, rate: number, rateType?: EntryRateType | null, sendNotesToMatterNotes?: boolean | null, showOnBill: boolean, userType?: UserRole | null, entryType?: EntryType | null, categoryId?: string | null, feeTypeId?: string | null, isSystemGenerated?: boolean | null, startTime?: any | null, createdAt: any, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, isConsultMatter?: boolean | null, consultMatterNumber?: string | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, lastName: string, firstName: string, displayName?: string | null } | null } }> | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string } | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null } | null } };

export type CreateManualEntryMutationVariables = Exact<{
  input: CreateManualEntryInput;
}>;


export type CreateManualEntryMutation = { __typename?: 'Mutation', createManualEntry: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entry?: { __typename?: 'Entry', id: string, duration?: string | null, description?: string | null } | null } };

export type UpdateEntryMutationVariables = Exact<{
  input: UpdateEntryInput;
}>;


export type UpdateEntryMutation = { __typename?: 'Mutation', updateEntry: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entry?: { __typename?: 'Entry', id: string } | null } };

export type DeleteEntryMutationVariables = Exact<{
  entryId: Scalars['String'];
}>;


export type DeleteEntryMutation = { __typename?: 'Mutation', deleteEntry: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type StartTimerMutationVariables = Exact<{
  input: StartTimerInput;
}>;


export type StartTimerMutation = { __typename?: 'Mutation', startTimer: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entry?: { __typename?: 'Entry', id: string, startTime?: any | null, userId?: string | null, entryType?: EntryType | null, status: EntryStatus, pauseTime?: any | null, isTimerPaused?: boolean | null, totalPausedTime?: number | null, billable: boolean, showOnBill: boolean, caseId: string, date: any, description?: string | null, rate: number, rateType?: EntryRateType | null, sendNotesToMatterNotes?: boolean | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', lastName?: string | null, firstName?: string | null, id: string } | null, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, isConsultMatter?: boolean | null } | null } | null } };

export type StopTimerMutationVariables = Exact<{
  timeEntryId: Scalars['String'];
}>;


export type StopTimerMutation = { __typename?: 'Mutation', stopTimer: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entry?: { __typename?: 'Entry', id: string, case?: { __typename?: 'Case', title?: string | null } | null } | null } };

export type PauseOrResumeTimerMutationVariables = Exact<{
  timeEntryId: Scalars['String'];
}>;


export type PauseOrResumeTimerMutation = { __typename?: 'Mutation', pauseOrResumeTimer: { __typename?: 'EntryPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entry?: { __typename?: 'Entry', id: string, isTimerPaused?: boolean | null, pauseTime?: any | null, totalPausedTime?: number | null, startTime?: any | null } | null } };

export type GetRunningTimersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRunningTimersQuery = { __typename?: 'Query', getRunningTimers: { __typename?: 'EntriesPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, entries?: Array<{ __typename?: 'Entry', id: string, startTime?: any | null, userId?: string | null, creatorId?: string | null, pauseTime?: any | null, isTimerPaused?: boolean | null, totalPausedTime?: number | null, billable: boolean, showOnBill: boolean, rate: number, rateType?: EntryRateType | null, sendNotesToMatterNotes?: boolean | null, caseId: string, date: any, entryType?: EntryType | null, description?: string | null, user?: { __typename?: 'User', lastName?: string | null, firstName?: string | null, id: string } | null, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, isConsultMatter?: boolean | null } | null } | null> | null } };

export type FetchAllCategoriesQueryVariables = Exact<{
  fetchCategoriesInput: FetchCategoriesInput;
}>;


export type FetchAllCategoriesQuery = { __typename?: 'Query', fetchAllCategories: { __typename?: 'CategoriesPayload', categories?: Array<{ __typename?: 'Category', id: string, name: string, description?: string | null } | null> | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null } | null } };

export type CreateCategoryMutationVariables = Exact<{
  createCategoryInput: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryPayload', category?: { __typename?: 'Category', id: string, name: string, description?: string | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryInput: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryPayload', category?: { __typename?: 'Category', id: string, name: string, description?: string | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type DeleteCategoryMutationVariables = Exact<{
  deleteCategoryId: Scalars['String'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } };

export type FetchAllFeeTypesQueryVariables = Exact<{
  fetchFeeTypes: FetchFeeTypeInput;
}>;


export type FetchAllFeeTypesQuery = { __typename?: 'Query', fetchAllFeeTypes: { __typename?: 'FeeTypesPayload', feeTypes?: Array<{ __typename?: 'FeeType', id: string, feeType: string } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type FetchCaseEntriesByFeeTypesQueryVariables = Exact<{
  caseEntriesByFeeTypesInput: CaseEntriesByFeeTypesInput;
}>;


export type FetchCaseEntriesByFeeTypesQuery = { __typename?: 'Query', fetchCaseEntriesByFeeTypes: { __typename?: 'CaseEntriesByFeeTypesPayload', entries?: Array<{ __typename?: 'Entry', id: string, amount?: number | null, status: EntryStatus, billItems?: Array<{ __typename?: 'BillItem', bill: { __typename?: 'Bill', id: number, status: BillStatus } }> | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type GetHourlyAmountLoggedForCaseQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type GetHourlyAmountLoggedForCaseQuery = { __typename?: 'Query', getHourlyAmountLoggedForCase: { __typename?: 'HourlyAmountLoggedForCasePayload', hourlyAmountLogged: number, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type CreateFeeTypeMutationVariables = Exact<{
  feeType: Scalars['String'];
}>;


export type CreateFeeTypeMutation = { __typename?: 'Mutation', createFeeType: { __typename?: 'FeeTypePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, feeType?: { __typename?: 'FeeType', feeType: string, id: string } | null } };

export type DeleteFeeTypeMutationVariables = Exact<{
  deleteFeeTypeId: Scalars['String'];
}>;


export type DeleteFeeTypeMutation = { __typename?: 'Mutation', deleteFeeType: boolean };

export type UpdateFeeTypeMutationVariables = Exact<{
  updateFeeTypeId: Scalars['String'];
  feeType: Scalars['String'];
}>;


export type UpdateFeeTypeMutation = { __typename?: 'Mutation', updateFeeType: { __typename?: 'FeeTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, feeType?: { __typename?: 'FeeType', id: string, feeType: string } | null } };

export type FetchFirmDashboardMattersQueryVariables = Exact<{
  input: FirmDashboardDateRangeInput;
}>;


export type FetchFirmDashboardMattersQuery = { __typename?: 'Query', fetchFirmDashboardMatters: { __typename?: 'FirmDashboardMattersPayload', activeMatters: { __typename?: 'FirmDashboardStatusTotals', asOfToday: number, inRange: number }, workCompletedMatters: { __typename?: 'FirmDashboardStatusTotals', asOfToday: number, inRange: number }, closedMatters: { __typename?: 'FirmDashboardStatusTotals', asOfToday: number, inRange: number }, activeByBillingType: Array<{ __typename?: 'FirmDashboardMatterStatusCount', key: string, label: string, count: number, active: number, completed: number }>, activeByLawType: Array<{ __typename?: 'FirmDashboardMatterStatusCount', key: string, label: string, count: number, active: number, completed: number }>, activeByResponsibleAttorney: Array<{ __typename?: 'FirmDashboardCount', key: string, label: string, count: number }>, mattersCreated: { __typename?: 'FirmDashboardMattersCreated', total: number, direct: number, fromConsults: number }, consultsCreated: { __typename?: 'FirmDashboardConsultsCreated', total: number, converted: number, notConverted: number }, newMattersByBillingType: Array<{ __typename?: 'FirmDashboardCount', key: string, label: string, count: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchFirmDashboardBillingQueryVariables = Exact<{
  input: FirmDashboardDateRangeInput;
}>;


export type FetchFirmDashboardBillingQuery = { __typename?: 'Query', fetchFirmDashboardBilling: { __typename?: 'FirmDashboardBillingPayload', totalBillsCount: number, finalBillsCount: number, preBillsCount: number, totalBillsAmount: number, billsByBillingType: Array<{ __typename?: 'FirmDashboardCount', key: string, label: string, count: number }>, billsByStatus: Array<{ __typename?: 'FirmDashboardCount', key: string, label: string, count: number }>, billsByLawType: Array<{ __typename?: 'FirmDashboardCount', key: string, label: string, count: number }>, amountByBillingType: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, amountByCategory: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchFirmDashboardAccountingQueryVariables = Exact<{
  input: FirmDashboardDateRangeInput;
}>;


export type FetchFirmDashboardAccountingQuery = { __typename?: 'Query', fetchFirmDashboardAccounting: { __typename?: 'FirmDashboardAccountingPayload', incomingOperatingTotal: number, incomingTrustTotal: number, outgoingTotal: number, outgoingTrustTotal: number, outgoingOperatingTotal: number, incomingByOperatingAccount: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, incomingByBankAccount: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, incomingMonthly: Array<{ __typename?: 'FirmDashboardMonthlyAmounts', month: string, amounts: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }> }>, outgoingTrustByMethod: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, outgoingOperatingByMethod: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, outgoingByGlAccount: Array<{ __typename?: 'FirmDashboardAmount', key: string, label: string, amount: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchFundRequestsQueryVariables = Exact<{
  fetchFundRequestsInput: FetchFundRequestsInput;
}>;


export type FetchFundRequestsQuery = { __typename?: 'Query', fetchFundRequests: { __typename?: 'FetchFundRequestsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequests: Array<{ __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, dueDate?: any | null, issueDate?: any | null, amountPaid?: number | null, description?: string | null, attorneyApprovedAt?: any | null, departmentApprovedAt?: any | null, lastSentAt?: any | null, sendToClient: boolean, createdAt: string, updatedAt: string, case: { __typename?: 'Case', id: string, caseNumber?: string | null, title?: string | null, billing?: { __typename?: 'CaseBilling', billingType: BillingType, billApprover?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', userType: UserType, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null }, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }>, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null } } };

export type FetchFundRequestQueryVariables = Exact<{
  billId: Scalars['Float'];
}>;


export type FetchFundRequestQuery = { __typename?: 'Query', fetchFundRequest: { __typename?: 'FetchFundRequestPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequest?: { __typename?: 'Bill', id: number, amount: number, description?: string | null, sendToClient: boolean, account?: { __typename?: 'Account', id: string } | null, case: { __typename?: 'Case', id: string, title?: string | null } } | null } };

export type FetchPendingFundRequestQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type FetchPendingFundRequestQuery = { __typename?: 'Query', fetchPendingFundRequest: { __typename?: 'FetchFundRequestPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequest?: { __typename?: 'Bill', id: number, status: BillStatus, amount: number, description?: string | null, createdAt: string } | null } };

export type FetchRecentFundRequestQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;


export type FetchRecentFundRequestQuery = { __typename?: 'Query', fetchRecentFundRequest: { __typename?: 'FetchFundRequestPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequest?: { __typename?: 'Bill', id: number, status: BillStatus, amount: number, description?: string | null, createdAt: string } | null } };

export type CreateFundRequestMutationVariables = Exact<{
  createFundRequestInput: Array<CreateFundRequestInput> | CreateFundRequestInput;
}>;


export type CreateFundRequestMutation = { __typename?: 'Mutation', createFundRequest: { __typename?: 'CreateFundRequestPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequests: Array<{ __typename?: 'Bill', id: number }> } };

export type UpdateFundRequestMutationVariables = Exact<{
  updateFundRequestInput: UpdateFundRequestInput;
}>;


export type UpdateFundRequestMutation = { __typename?: 'Mutation', updateFundRequest: { __typename?: 'UpdateFundRequestPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, fundRequest: { __typename?: 'Bill', id: number } } };

export type GenerateContingencyFundRequestMutationVariables = Exact<{
  generateContingencyFundRequestInput: ContingencyFundRequestInput;
}>;


export type GenerateContingencyFundRequestMutation = { __typename?: 'Mutation', generateContingencyFundRequest: { __typename?: 'ContingencyFundRequestPayload', fundRequestId: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DeleteInterestEntriesMutationVariables = Exact<{
  deleteInterestEntriesInput: DeleteInterestEntriesInput;
}>;


export type DeleteInterestEntriesMutation = { __typename?: 'Mutation', deleteInterestEntries: { __typename?: 'DeleteInterestEntriesPayload', deletedCount: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchCarriableVoidedBillsQueryVariables = Exact<{
  fetchCarriableVoidedBillsInput: FetchCarriableVoidedBillsInput;
}>;


export type FetchCarriableVoidedBillsQuery = { __typename?: 'Query', fetchCarriableVoidedBills: { __typename?: 'CarriableVoidedBillsPayload', bills: Array<{ __typename?: 'CarriableVoidedBill', billId: number, voidedAt?: any | null, fromDate?: any | null, toDate?: any | null, accruedInterest: number }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateCarriedForwardInterestMutationVariables = Exact<{
  createCarriedForwardInterestInput: CreateCarriedForwardInterestInput;
}>;


export type CreateCarriedForwardInterestMutation = { __typename?: 'Mutation', createCarriedForwardInterest: { __typename?: 'CreateCarriedForwardInterestPayload', createdCount: number, totalCarried: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type GetBillInterestQueryVariables = Exact<{
  billInterestInput: BillInterestInput;
}>;


export type GetBillInterestQuery = { __typename?: 'Query', getBillInterest: { __typename?: 'BillInterestPayload', interestDue: number, interestAccrued: number, rate: number, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchInterestEntriesQueryVariables = Exact<{
  fetchInterestEntriesInput: FetchInterestEntriesInput;
}>;


export type FetchInterestEntriesQuery = { __typename?: 'Query', fetchInterestEntries: { __typename?: 'InterestEntriesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, interestEntries: Array<{ __typename?: 'Interest', id: string, date: any, accruedInterest: number, cumulativeInterest: number, principal: number, days: number, rate: number, advRefno?: string | null, fromAdv?: boolean | null, createdAt: string, bill: { __typename?: 'Bill', id: number, status: BillStatus, case: { __typename?: 'Case', id: string, caseNumber?: string | null, title?: string | null, billing?: { __typename?: 'CaseBilling', writeOffInterest?: boolean | null } | null } }, client: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, businessName?: string | null, clientNumber?: string | null } }>, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null } } };

export type FetchJournalEntriesQueryVariables = Exact<{
  input: FetchJournalEntriesInput;
}>;


export type FetchJournalEntriesQuery = { __typename?: 'Query', fetchJournalEntries: { __typename?: 'FetchJournalEntriesPayload', journalEntries?: Array<{ __typename?: 'JournalEntry', id: string, date: any, notes?: string | null, journalEntryNumber: number, advJournalRef?: string | null, isSystemGenerated: boolean, closedAt?: any | null, createdAt: string, updatedAt: string, bill?: { __typename?: 'Bill', id: number } | null, case?: { __typename?: 'Case', id: string, caseNumber?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, vendorId: string } | null, creator?: { __typename?: 'User', id: string } | null, lineItems?: Array<{ __typename?: 'JournalEntryLineItem', id: string, amount: number, type: JournalEntryType, account: { __typename?: 'Account', id: string, name: string, category: AccountCategory, sortCode: string }, office?: { __typename?: 'Office', id: number, name: string } | null }> | null }> | null, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, totalPages?: number | null, limit?: number | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchJournalEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FetchJournalEntryQuery = { __typename?: 'Query', fetchJournalEntry: { __typename?: 'JournalEntry', id: string, date: any, notes?: string | null, journalEntryNumber: number, closedAt?: any | null, isSystemGenerated: boolean, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems?: Array<{ __typename?: 'JournalEntryLineItem', id: string, amount: number, type: JournalEntryType, office?: { __typename?: 'Office', id: number, name: string } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string } }> | null } };

export type CreateManualJournalEntriesMutationVariables = Exact<{
  input: CreateManualJournalEntriesInput;
}>;


export type CreateManualJournalEntriesMutation = { __typename?: 'Mutation', createManualJournalEntries: { __typename?: 'CreateManualJournalEntriesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, journalEntry: { __typename?: 'JournalEntry', id: string } } };

export type DeleteManualJournalEntryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteManualJournalEntryMutation = { __typename?: 'Mutation', deleteManualJournalEntry: { __typename?: 'ResponsePayloadResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllLawTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllLawTypesQuery = { __typename?: 'Query', fetchAllLawTypes: { __typename?: 'LawTypesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, lawTypes?: Array<{ __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string, caseTypes?: Array<{ __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string }> | null } | null> | null } };

export type FetchLawTypeQueryVariables = Exact<{
  lawTypeInput: LawTypeInput;
}>;


export type FetchLawTypeQuery = { __typename?: 'Query', fetchLawType: { __typename?: 'LawTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string, caseTypes?: Array<{ __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, totalCaseCount?: number | null, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null }> | null } | null } };

export type CreateLawTypeMutationVariables = Exact<{
  createLawTypeInput: CreateLawTypeInput;
}>;


export type CreateLawTypeMutation = { __typename?: 'Mutation', createLawType: { __typename?: 'LawTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } };

export type DeleteLawTypeMutationVariables = Exact<{
  deleteLawTypeInput: DeleteLawType;
}>;


export type DeleteLawTypeMutation = { __typename?: 'Mutation', deleteLawType: { __typename?: 'LawTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null } };

export type UpdateLawTypeMutationVariables = Exact<{
  updateLawTypeInput: UpdateLawTypeInput;
}>;


export type UpdateLawTypeMutation = { __typename?: 'Mutation', updateLawType: { __typename?: 'LawTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, lawType?: { __typename?: 'LawType', id: string, name: string, syncWithOutlook: boolean, createdAt: string, updatedAt: string } | null } };

export type CreateCaseTypeMutationVariables = Exact<{
  createCaseTypeInput: CreateCaseTypeInput;
}>;


export type CreateCaseTypeMutation = { __typename?: 'Mutation', createCaseType: { __typename?: 'CaseTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, caseType?: { __typename?: 'CaseType', id: string, name: string } | null } };

export type DeleteCaseTypeMutationVariables = Exact<{
  deleteCaseTypeInput: DeleteCaseType;
}>;


export type DeleteCaseTypeMutation = { __typename?: 'Mutation', deleteCaseType: { __typename?: 'CaseTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null } };

export type UpdateCaseTypeMutationVariables = Exact<{
  updateCaseTypeInput: UpdateCaseTypeInput;
}>;


export type UpdateCaseTypeMutation = { __typename?: 'Mutation', updateCaseType: { __typename?: 'CaseTypePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null, name?: string | null } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, createdAt: string, updatedAt: string, lawTypeId: string } | null } };

export type FetchAllCaseNotesQueryVariables = Exact<{
  notesInput: NotesByCaseInput;
}>;


export type FetchAllCaseNotesQuery = { __typename?: 'Query', fetchAllCaseNotes: { __typename?: 'NotesPayload', notes?: Array<{ __typename?: 'Note', id: string, description: string, userId?: string | null, caseId: string, createdAt: string, updatedAt: string, noteTypeId?: string | null, noteType: { __typename?: 'NoteType', id: string, noteType: string, createdAt: any, updatedAt: any }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null, externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, phoneNumber?: string | null, ssn?: string | null, clientNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, id: string, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllUserNotesQueryVariables = Exact<{
  notesInput: NotesByUserInput;
}>;


export type FetchAllUserNotesQuery = { __typename?: 'Query', fetchAllUserNotes: { __typename?: 'NotesPayload', notes?: Array<{ __typename?: 'Note', id: string, description: string, noteTypeId?: string | null, userId?: string | null, caseId: string, createdAt: string, updatedAt: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateNoteMutationVariables = Exact<{
  createNoteInput: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'NotePayload', note?: { __typename?: 'Note', description: string, id: string, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, initials?: string | null, roles?: Array<{ __typename?: 'Role', role: UserRole } | null> | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DeleteNoteMutationVariables = Exact<{
  deleteNoteInput: DeleteNote;
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'NotePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateNoteMutationVariables = Exact<{
  updateNoteInput: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'NotePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type NoteTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type NoteTypesQuery = { __typename?: 'Query', fetchAllNoteTypes: { __typename?: 'NoteTypesPayload', noteTypes?: Array<{ __typename?: 'NoteType', id: string, noteType: string, createdAt: any, updatedAt: any } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type FetchAllOfficesQueryVariables = Exact<{
  fetchOfficesInput: FetchAllOfficesInput;
}>;


export type FetchAllOfficesQuery = { __typename?: 'Query', fetchAllOffices: { __typename?: 'OfficesPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, offices?: Array<{ __typename?: 'Office', id: number, name: string, phone?: string | null, email?: string | null, description?: string | null, isLocationOpen: boolean, type?: OfficeType | null, officeNumber?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null } | null> | null } | null> | null } };

export type CreateOfficeMutationVariables = Exact<{
  createOfficeInput: CreateOfficeInput;
}>;


export type CreateOfficeMutation = { __typename?: 'Mutation', createOffice: { __typename?: 'OfficePayload', office: { __typename?: 'Office', id: number, name: string, phone?: string | null, description?: string | null } } };

export type UpdateOfficeMutationVariables = Exact<{
  updateOfficeInput: UpdateOfficeInput;
}>;


export type UpdateOfficeMutation = { __typename?: 'Mutation', updateOffice: { __typename?: 'OfficePayload', office: { __typename?: 'Office', id: number, name: string, phone?: string | null, description?: string | null } } };

export type DeleteOfficeMutationVariables = Exact<{
  deleteOfficeId: Scalars['Float'];
  addressId: Scalars['String'];
}>;


export type DeleteOfficeMutation = { __typename?: 'Mutation', deleteOffice: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } };

export type CreatePayableRefundMutationVariables = Exact<{
  input: CreatePayableRefundInput;
}>;


export type CreatePayableRefundMutation = { __typename?: 'Mutation', createPayableRefund: { __typename?: 'PayableRefundPayload', payableRefund?: { __typename?: 'PayableRefund', id: string } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type FetchPayableRefundsQueryVariables = Exact<{
  input: FetchPayableRefundsInput;
}>;


export type FetchPayableRefundsQuery = { __typename?: 'Query', fetchPayableRefunds: { __typename?: 'FetchPayableRefundsPayload', payableRefunds: Array<{ __typename?: 'PayableRefund', id: string, amount: number, date: any, paymentMethod: PaymentMethod, description?: string | null, createdAt: string, payable: { __typename?: 'AccountsPayable', id: string, voucherNo: string, amount: number, vendor?: { __typename?: 'Vendor', id: number, name: string, vendorId: string } | null }, office?: { __typename?: 'Office', id: number, name: string } | null, account?: { __typename?: 'Account', id: string, name: string, sortCode: string } | null, glAccount?: { __typename?: 'Account', id: string, name: string, sortCode: string } | null }>, pagination: { __typename?: 'PaginationPayload', totalCount?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllPaymentsForReconciliationQueryVariables = Exact<{
  fetchAllPaymentsInput: FetchPaymentsInput;
}>;


export type FetchAllPaymentsForReconciliationQuery = { __typename?: 'Query', fetchAllPaymentsForReconciliation: { __typename?: 'PaymentsPayload', payments: Array<{ __typename?: 'Payment', id: string, paymentMethod: PaymentMethod, referenceNumber?: string | null, slipNumber?: string | null, reconciledAt?: string | null, date: any, amount: number, createdAt: string, paymentType: PaymentType, reconciliation?: { __typename?: 'Reconciliation', id: number } | null, reconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, client?: { __typename?: 'ExternalUser', id: string, lastName: string, email?: string | null, firstName: string, displayName?: string | null, initials?: string | null, clientNumber?: string | null, middleName?: string | null, suffix?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string, sortCode?: string | null } | null, payable?: { __typename?: 'AccountsPayable', id: string, voucherNo: string, checkOrAchNumber?: string | null } | null, office?: { __typename?: 'Office', id: number, name: string } | null }>, pagination: { __typename?: 'PaginationPayload', totalPages?: number | null, totalCount?: number | null, page?: number | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchPaginatedAccountPaymentsQueryVariables = Exact<{
  PaginatedAccountPaymentsInput: PaginatedAccountPaymentsInput;
}>;


export type FetchPaginatedAccountPaymentsQuery = { __typename?: 'Query', fetchPaginatedAccountPayments: { __typename?: 'PaginatedAccountPaymentsPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null, pagination: { __typename?: 'PaginationPayload', totalPages?: number | null, totalCount?: number | null, page?: number | null }, payments: Array<{ __typename?: 'PaymentWithRunningBalance', id: string, amount: number, date: any, paymentType: PaymentType, runningBalance: number, paymentMethod: PaymentMethod, createdAt: string, updatedAt: string, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string } | null, case?: { __typename?: 'Case', id: string, caseNumber?: string | null, title?: string | null } | null, bill?: { __typename?: 'Bill', id: number } | null, linkedPayment?: { __typename?: 'Payment', account?: { __typename?: 'Account', id: string, name: string } | null } | null }> } };

export type FetchBillPaymentsQueryVariables = Exact<{
  BillPaymentsInput: BillPaymentsInput;
}>;


export type FetchBillPaymentsQuery = { __typename?: 'Query', fetchBillPayments: { __typename?: 'BillPaymentsPayload', payments: Array<{ __typename?: 'Payment', id: string, amount: number, returnAmount?: number | null, returnNotes?: string | null, returnedAt?: any | null, returnedPaymentId?: string | null, date: any, paymentType: PaymentType, paymentMethod: PaymentMethod, referenceNumber?: string | null, slipNumber?: string | null, createdAt: string, paymentSource?: PaymentSource | null, reconciledAt?: string | null, office?: { __typename?: 'Office', id: number, name: string } | null, account?: { __typename?: 'Account', id: string, type?: AccountType | null, name: string, sortCode: string } | null, linkedPayment?: { __typename?: 'Payment', id: string, account?: { __typename?: 'Account', id: string, name: string, sortCode: string, type?: AccountType | null } | null } | null, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string } | null, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, transaction?: { __typename?: 'Transaction', id: string, amount: number, status?: TransactionStatus | null, transactionId?: string | null, settledAt?: any | null, createdAt: string, cardData?: { __typename?: 'CardData', cardNumber: string, customerFirstName?: string | null, customerLastName?: string | null } | null, bankData?: { __typename?: 'BankData', nameOnAccount: string, accountNumber: string, routingNumber: string, accountType?: string | null } | null } | null, paymentAllocations?: Array<{ __typename?: 'PaymentAllocation', id: string, amount: number, type: PaymentAllocationType, fee?: number | null, cost?: number | null, expense?: number | null, paymentDate: any, bill: { __typename?: 'Bill', id: number } }> | null }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type TransferFundsBetweenAccountsMutationVariables = Exact<{
  TransferFundsBetweenAccountsInput: TransferFundsBetweenAccountsInput;
}>;


export type TransferFundsBetweenAccountsMutation = { __typename?: 'Mutation', transferFundsBetweenAccounts: { __typename?: 'PaymentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, payment?: { __typename?: 'Payment', id: string } | null } };

export type FetchPaymentByIdQueryVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type FetchPaymentByIdQuery = { __typename?: 'Query', fetchPaymentById: { __typename?: 'PaymentPayload', payment?: { __typename?: 'Payment', id: string, amount: number, returnAmount?: number | null, returnNotes?: string | null, returnedAt?: any | null, date: any, paymentMethod: PaymentMethod, paymentType: PaymentType, paymentSource?: PaymentSource | null, referenceNumber?: string | null, slipNumber?: string | null, notes?: string | null, reconciledAt?: string | null, createdAt: string, updatedAt: string, account?: { __typename?: 'Account', id: string, name: string, currentBalance?: number | null, isBankAccount: boolean, sortCode: string, type?: AccountType | null } | null, office?: { __typename?: 'Office', id: number, name: string } | null, bill?: { __typename?: 'Bill', id: number, status: BillStatus, type: BillType, amount: number } | null, case?: { __typename?: 'Case', id: string, title?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null } | null, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, middleName?: string | null, email?: string | null, clientNumber?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string, vendorId: string } | null, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, reconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, linkedPayment?: { __typename?: 'Payment', id: string, account?: { __typename?: 'Account', id: string, name: string } | null } | null, transaction?: { __typename?: 'Transaction', id: string, status?: TransactionStatus | null, transactionId?: string | null, amount: number, settledAt?: any | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdatePaymentMutationVariables = Exact<{
  updatePaymentInput: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'PaymentPayload', payment?: { __typename?: 'Payment', id: string, amount: number, date: any, paymentMethod: PaymentMethod, referenceNumber?: string | null, slipNumber?: string | null, notes?: string | null, account?: { __typename?: 'Account', id: string, name: string } | null, office?: { __typename?: 'Office', id: number, name: string } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreateFirmPaymentMutationVariables = Exact<{
  input: CreateFirmPaymentInput;
}>;


export type CreateFirmPaymentMutation = { __typename?: 'Mutation', createFirmPayment: { __typename?: 'PaymentPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CancelPrintJobMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelPrintJobMutation = { __typename?: 'Mutation', cancelPrintJob: { __typename?: 'PrintJobPayload', printJob?: { __typename?: 'PrintJob', id: string, status: PrintJobStatus } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RetryPrintJobMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RetryPrintJobMutation = { __typename?: 'Mutation', retryPrintJob: { __typename?: 'PrintJobPayload', printJob?: { __typename?: 'PrintJob', id: string, status: PrintJobStatus } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type CreatePrintJobMutationVariables = Exact<{
  input: CreatePrintJobInput;
}>;


export type CreatePrintJobMutation = { __typename?: 'Mutation', createPrintJob: { __typename?: 'PrintJobPayload', printJob?: { __typename?: 'PrintJob', id: string, printJobType: PrintJobType, status: PrintJobStatus, totalBills?: number | null, processedBills: number, errorMessage?: string | null, batchId?: number | null, createdAt: any, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchPrintJobsQueryVariables = Exact<{
  input: FetchPrintJobsInput;
}>;


export type FetchPrintJobsQuery = { __typename?: 'Query', fetchPrintJobs: { __typename?: 'PaginatedPrintJobsPayload', printJobs?: Array<{ __typename?: 'PrintJob', id: string, printJobType: PrintJobType, status: PrintJobStatus, billIds?: Array<number> | null, attorneyIds?: Array<string> | null, attorneyRole?: string | null, totalBills?: number | null, processedBills: number, errorMessage?: string | null, skippedBills?: any | null, sortBy?: string | null, sortDir?: string | null, caseId?: string | null, batchId?: number | null, trustScope?: PrintJobTrustScope | null, deliveryMethods?: Array<BillDeliveryMethod> | null, billingTypes?: Array<BillingType> | null, paymentStatuses?: Array<DelinquentPaymentStatus> | null, includeProformaNotes?: boolean | null, sentToClientAt?: any | null, createdAt: any, updatedAt: any, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, attorneys?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchPrintJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FetchPrintJobQuery = { __typename?: 'Query', fetchPrintJob: { __typename?: 'PrintJobPayload', printJob?: { __typename?: 'PrintJob', id: string, printJobType: PrintJobType, status: PrintJobStatus, totalBills?: number | null, processedBills: number, errorMessage?: string | null, skippedBills?: any | null, sortBy?: string | null, sortDir?: string | null, createdAt: any, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DownloadPrintJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DownloadPrintJobQuery = { __typename?: 'Query', downloadPrintJob: { __typename?: 'PrintJobDownloadPayload', preSignedUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type QueuesOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type QueuesOverviewQuery = { __typename?: 'Query', queuesOverview: { __typename?: 'QueuesOverviewPayload', queues: Array<{ __typename?: 'QueueOverview', name: string, isPaused: boolean, counts: { __typename?: 'QueueCounts', waiting: number, active: number, completed: number, failed: number, delayed: number, paused: number } }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type QueueJobsQueryVariables = Exact<{
  fetchQueueJobsInput: FetchQueueJobsInput;
}>;


export type QueueJobsQuery = { __typename?: 'Query', queueJobs: { __typename?: 'QueueJobsPayload', total: number, jobs: Array<{ __typename?: 'QueueJob', id: string, name: string, attemptsMade: number, createdAt?: any | null, processedAt?: any | null, finishedAt?: any | null, progress?: number | null, failedReason?: string | null, stacktrace?: string | null, data?: string | null }>, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type PauseQueueMutationVariables = Exact<{
  queueNameInput: QueueNameInput;
}>;


export type PauseQueueMutation = { __typename?: 'Mutation', pauseQueue: { __typename?: 'QueueActionPayload', name: string, isPaused: boolean, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ResumeQueueMutationVariables = Exact<{
  queueNameInput: QueueNameInput;
}>;


export type ResumeQueueMutation = { __typename?: 'Mutation', resumeQueue: { __typename?: 'QueueActionPayload', name: string, isPaused: boolean, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RetryQueueJobMutationVariables = Exact<{
  queueJobActionInput: QueueJobActionInput;
}>;


export type RetryQueueJobMutation = { __typename?: 'Mutation', retryQueueJob: { __typename?: 'QueueActionPayload', name: string, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RemoveQueueJobMutationVariables = Exact<{
  queueJobActionInput: QueueJobActionInput;
}>;


export type RemoveQueueJobMutation = { __typename?: 'Mutation', removeQueueJob: { __typename?: 'QueueActionPayload', name: string, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAccountReconciliationQueryVariables = Exact<{
  fetchAccountReconciliationInput: AccountReconciliationInput;
}>;


export type FetchAccountReconciliationQuery = { __typename?: 'Query', fetchAccountReconciliation: { __typename?: 'AccountReconciliationResponse', openingBalance?: number | null, reconciliation?: { __typename?: 'Reconciliation', beginningBalance: number, statementBalance: number, clearedBalance: number, finished: boolean } | null, lastReconciliation?: { __typename?: 'Reconciliation', beginningBalance: number, statementBalance: number, clearedBalance: number, finished: boolean } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchReconciliationsQueryVariables = Exact<{
  fetchAllReconciliationInput: FetchReconciliationsInput;
}>;


export type FetchReconciliationsQuery = { __typename?: 'Query', fetchReconciliations: { __typename?: 'ReconciliationsResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, reconciliations?: Array<{ __typename?: 'Reconciliation', id: number, startDate: string, endDate: string, beginningBalance: number, statementBalance: number, clearedBalance: number, difference: number, finished: boolean, unreconciledAt?: string | null, createdAt: string, updatedAt: string, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, reconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, unreconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type FetchReconciliationQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type FetchReconciliationQuery = { __typename?: 'Query', fetchReconciliation: { __typename?: 'Reconciliation', id: number, startDate: string, endDate: string, beginningBalance: number, statementBalance: number, clearedBalance: number, difference: number, finished: boolean, unreconciledAt?: string | null, createdAt: string, updatedAt: string, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, reconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, unreconciledBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, payments?: Array<{ __typename?: 'Payment', id: string, paymentMethod: PaymentMethod, referenceNumber?: string | null, slipNumber?: string | null, reconciledAt?: string | null, date: any, amount: number, createdAt: string, paymentType: PaymentType, client?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null } | null, vendor?: { __typename?: 'Vendor', id: number, name: string, sortCode?: string | null } | null, office?: { __typename?: 'Office', id: number, name: string } | null, account?: { __typename?: 'Account', id: string, name: string } | null }> | null } };

export type DownloadReconciliationDocumentMutationVariables = Exact<{
  reconciliationDocumentInput: ReconciliationDocumentInput;
}>;


export type DownloadReconciliationDocumentMutation = { __typename?: 'Mutation', downloadReconciliationDocument: { __typename?: 'ReconciliationDocumentPayload', preSignedUrl?: string | null, status: ReconciliationDocumentStatus, response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type FetchReconciliationDocumentStatusQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchReconciliationDocumentStatusQuery = { __typename?: 'Query', fetchReconciliationDocumentStatus: { __typename?: 'ReconciliationDocumentStatusPayload', id: number, pdfStatus?: ReconciliationDocumentStatus | null, csvStatus?: ReconciliationDocumentStatus | null, documentErrorMessage?: string | null } };

export type UndoReconciliationMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type UndoReconciliationMutation = { __typename?: 'Mutation', undoReconciliation: { __typename?: 'ReconciliationResponse', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type ReconciliationSessionViewPrefsFragment = { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null };

export type ReconciliationSessionSummaryFragment = { __typename?: 'ReconciliationSession', id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null };

export type ReconciliationSessionFullFragment = { __typename?: 'ReconciliationSession', removedItemCount?: number | null, id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, items: Array<{ __typename?: 'ReconciliationSessionItem', paymentId: string, amount: number, paymentType: PaymentType }>, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null };

export type FetchMyReconciliationSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMyReconciliationSessionsQuery = { __typename?: 'Query', fetchMyReconciliationSessions: Array<{ __typename?: 'ReconciliationSession', id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null }> };

export type FetchReconciliationSessionQueryVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type FetchReconciliationSessionQuery = { __typename?: 'Query', fetchReconciliationSession: { __typename?: 'ReconciliationSession', removedItemCount?: number | null, id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, items: Array<{ __typename?: 'ReconciliationSessionItem', paymentId: string, amount: number, paymentType: PaymentType }>, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null } };

export type StartOrResumeReconciliationSessionMutationVariables = Exact<{
  input: StartReconciliationSessionInput;
}>;


export type StartOrResumeReconciliationSessionMutation = { __typename?: 'Mutation', startOrResumeReconciliationSession: { __typename?: 'ReconciliationSession', removedItemCount?: number | null, id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, items: Array<{ __typename?: 'ReconciliationSessionItem', paymentId: string, amount: number, paymentType: PaymentType }>, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null } };

export type UpdateReconciliationSessionMutationVariables = Exact<{
  input: UpdateReconciliationSessionInput;
}>;


export type UpdateReconciliationSessionMutation = { __typename?: 'Mutation', updateReconciliationSession: { __typename?: 'ReconciliationSession', id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null } };

export type UpdateReconciliationSessionViewPreferencesMutationVariables = Exact<{
  input: UpdateReconciliationSessionViewPreferencesInput;
}>;


export type UpdateReconciliationSessionViewPreferencesMutation = { __typename?: 'Mutation', updateReconciliationSessionViewPreferences: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } };

export type ClearReconciliationSessionItemsMutationVariables = Exact<{
  input: ClearReconciliationSessionInput;
}>;


export type ClearReconciliationSessionItemsMutation = { __typename?: 'Mutation', clearReconciliationSessionItems: { __typename?: 'ReconciliationSession', removedItemCount?: number | null, id: number, statementMonth: string, statementBalance?: number | null, beginningBalance: number, status: ReconciliationSessionStatus, version: number, itemCount: number, creditTotal: number, debitTotal: number, clearedBalance: number, difference: number, updatedAt: string, items: Array<{ __typename?: 'ReconciliationSessionItem', paymentId: string, amount: number, paymentType: PaymentType }>, viewPreferences?: { __typename?: 'ReconciliationSessionViewPreferences', lineItems?: boolean | null, orderBy?: string | null, orderDirection?: string | null, paymentMethod?: PaymentMethod | null, office?: string | null } | null, account: { __typename?: 'Account', id: string, name: string, sortCode: string }, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null } };

export type DiscardReconciliationSessionMutationVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type DiscardReconciliationSessionMutation = { __typename?: 'Mutation', discardReconciliationSession: { __typename?: 'ReconciliationSession', id: number, status: ReconciliationSessionStatus, version: number } };

export type CommitReconciliationSessionMutationVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type CommitReconciliationSessionMutation = { __typename?: 'Mutation', commitReconciliationSession: { __typename?: 'ReconciliationSession', id: number, status: ReconciliationSessionStatus, version: number, committedReconciliation?: { __typename?: 'Reconciliation', id: number } | null } };

export type FetchAllReferencesQueryVariables = Exact<{
  fetchAllReferences: FetchAllReferencesInput;
}>;


export type FetchAllReferencesQuery = { __typename?: 'Query', fetchAllReferences: { __typename?: 'ReferencesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, totalPages?: number | null, page?: number | null } | null, references?: Array<{ __typename?: 'Reference', updatedAt: string, id: string, createdAt: string, referral: string, active: boolean, eligibleFor1099Report: boolean, referralSource: { __typename?: 'ReferralSource', id: string, sourceType: string, createdAt: string, updatedAt: string } } | null> | null } };

export type DeleteReferenceMutationVariables = Exact<{
  deleteReferenceId: Scalars['String'];
}>;


export type DeleteReferenceMutation = { __typename?: 'Mutation', deleteReference: boolean };

export type CreateReferenceMutationVariables = Exact<{
  createReferenceInput: CreateReferenceInput;
}>;


export type CreateReferenceMutation = { __typename?: 'Mutation', createReference: { __typename?: 'ReferencePayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, reference?: { __typename?: 'Reference', id: string, referral: string, active: boolean, referralSourceId?: string | null } | null } };

export type UpdateReferenceMutationVariables = Exact<{
  updateReferenceInput: UpdateReferenceInput;
}>;


export type UpdateReferenceMutation = { __typename?: 'Mutation', updateReference: { __typename?: 'ReferencePayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, reference?: { __typename?: 'Reference', id: string, referral: string, active: boolean, referralSourceId?: string | null } | null } };

export type GetReportTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportTemplatesQuery = { __typename?: 'Query', getReportTemplates: Array<{ __typename?: 'ReportGroup', group: string, label: string, description?: string | null, selections: Array<{ __typename?: 'ReportSelection', selection: string, sortFields: Array<string>, label: string, description?: string | null, selectionFields: Array<{ __typename?: 'SelectionField', field: string, type: SelectionFieldType, options?: Array<string> | null, operator?: string | null, label?: string | null, required?: boolean | null, defaultValue?: any | null, minDate?: string | null, maxDate?: string | null, visibilityRules?: Array<{ __typename?: 'VisibilityRule', dependsOn: string, value: any, operator: VisibilityRuleOperator }> | null }> }> }> };

export type GenerateReportMutationVariables = Exact<{
  createReportInput: CreateReportInput;
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport: { __typename?: 'ReportSelectionPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type RetryReportMutationVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type RetryReportMutation = { __typename?: 'Mutation', retryReport: { __typename?: 'ReportSelectionPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type CancelReportMutationVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type CancelReportMutation = { __typename?: 'Mutation', cancelReport: { __typename?: 'ReportSelectionPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type FetchReportsQueryVariables = Exact<{
  input: ReportsInput;
}>;


export type FetchReportsQuery = { __typename?: 'Query', fetchReports: { __typename?: 'ReportsPayload', reports?: Array<{ __typename?: 'Report', id: string, reportGroup: string, reportSelection: string, status: ReportStatus, selectionFields?: any | null, displaySelectionFields?: any | null, fileName?: string | null, errorMessage?: string | null, createdAt: any, updatedAt: any, creator: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } } | null> | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, error?: string | null, message?: string | null } | null } };

export type DownloadReportQueryVariables = Exact<{
  reportDownloadInput: ReportDownloadInput;
}>;


export type DownloadReportQuery = { __typename?: 'Query', downloadReport: { __typename?: 'ReportMediaPayload', preSignedUrl?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchActivitiesQueryVariables = Exact<{
  fetchActivityInput: FetchLogsInput;
}>;


export type FetchActivitiesQuery = { __typename?: 'Query', fetchActivities: { __typename?: 'ActivityPayload', activities?: Array<{ __typename?: 'ActivityTracking', id: string, action: ActivityTrackingAction, entityType?: ActivityEntityType | null, entityId?: string | null, billId?: number | null, description?: string | null, actorName?: string | null, createdAt: any, creator?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole } | null> | null } | null } | null> | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type FetchReportCreatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchReportCreatorsQuery = { __typename?: 'Query', fetchReportCreators: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type RegisterUserMutationVariables = Exact<{
  registerUserInput: RegisterUserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null, error?: string | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null } | null } };

export type FetchAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllRolesQuery = { __typename?: 'Query', fetchAllRoles: { __typename?: 'RolesPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null, error?: string | null } | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } };

export type FetchAllUsersQueryVariables = Exact<{
  userInput: UsersInput;
}>;


export type FetchAllUsersQuery = { __typename?: 'Query', fetchAllUsers: { __typename?: 'UsersPayload', response?: { __typename?: 'ResponsePayload', name?: string | null, error?: string | null, status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, totalCount?: number | null, totalPages?: number | null, limit?: number | null } | null, users?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null, lockedAt?: any | null, office?: { __typename?: 'Office', id: number, name: string, isLocationOpen: boolean, createdAt: string, updatedAt: string } | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, paralegals?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null } | null> | null, deptToUsers?: Array<{ __typename?: 'DepartmentToUsers', departmentId: string, updatedAt: any, userId: string, createdAt: any, department: { __typename?: 'Department', id: string, name: string, description?: string | null }, user?: { __typename?: 'User', id: string, status: UserStatus, emailVerified: boolean, email: string, hourlyRate?: number | null, createdAt: string, updatedAt: string } | null } | null> | null } | null> | null } };

export type FetchUsersByIdsQueryVariables = Exact<{
  userIdsInput: UserIdsInput;
}>;


export type FetchUsersByIdsQuery = { __typename?: 'Query', fetchUsersByIds: { __typename?: 'UsersPayload', users?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null } | null> | null } };

export type ActivateUserMutationVariables = Exact<{
  user: UserIdInput;
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type UnlockUserMutationVariables = Exact<{
  user: UserIdInput;
}>;


export type UnlockUserMutation = { __typename?: 'Mutation', unlockUser: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, lockedAt?: any | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type DeactivateUserMutationVariables = Exact<{
  user: UserIdInput;
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null, response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null } };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleInput: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, status: UserStatus, firstName?: string | null, lastName?: string | null, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, paralegals?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null } | null> | null, notes?: Array<{ __typename?: 'Note', id: string, description: string, userId?: string | null, caseId: string, createdAt: string, updatedAt: string }> | null, deptToUsers?: Array<{ __typename?: 'DepartmentToUsers', departmentId: string, createdAt: any, updatedAt: any, userId: string, department: { __typename?: 'Department', id: string, name: string }, user?: { __typename?: 'User', id: string, lastName?: string | null } | null } | null> | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdatePasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, notes?: Array<{ __typename?: 'Note', id: string, description: string, userId?: string | null, caseId: string, createdAt: string, updatedAt: string }> | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type RemoveUserMutationVariables = Exact<{
  removeUserInput: UserIdInput;
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, notes?: Array<{ __typename?: 'Note', id: string, description: string, userId?: string | null, caseId: string, createdAt: string, updatedAt: string }> | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type SearchUserQueryVariables = Exact<{
  searchUserInput: SearchUserInput;
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser: { __typename?: 'UsersPayload', users?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null, lockedAt?: any | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, paralegals?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null } | null> | null, deptToUsers?: Array<{ __typename?: 'DepartmentToUsers', departmentId: string, updatedAt: any, userId: string, createdAt: any, department: { __typename?: 'Department', id: string, name: string, description?: string | null }, user?: { __typename?: 'User', id: string, status: UserStatus, emailVerified: boolean, email: string, hourlyRate?: number | null, createdAt: string, updatedAt: string } | null } | null> | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllCasesQueryVariables = Exact<{
  casesInput: CasesInput;
}>;


export type FetchAllCasesQuery = { __typename?: 'Query', fetchAllCases: { __typename?: 'CasesPayload', cases?: Array<{ __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, consultMatterNumber?: string | null, status: CaseStatus, dueDate?: string | null, accidentDate?: string | null, caseTypeId: string, courtId?: string | null, deletedAt?: string | null, createdAt: string, updatedAt: string, isConsultMatter?: boolean | null, advCaseNumber?: string | null, caseEvents?: Array<{ __typename?: 'CaseEvent', id: string, eventType: EventType, hearingAt?: string | null, nextHearingAt?: string | null, createdAt: string, updatedAt: string } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, litigationId: string, externalUserToExternalUserRoleId: string, isArchived: boolean, createdAt: string, updatedAt: string, caseRole?: ExternalUserCaseRole | null, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUser?: { __typename?: 'ExternalUser', id: string, initials?: string | null, lastName: string, firstName: string, displayName?: string | null, suffix?: string | null, middleName?: string | null, clientNumber?: string | null, dateOfBirth?: any | null, homePhone?: string | null, phoneNumber?: string | null, personalPhone?: string | null, email?: string | null, lastPayDate?: string | null, contractBalance?: string | null, lastPayAmount?: string | null, trustBalance?: string | null, arrearsBalance?: string | null, createdAt: string, updatedAt: string, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } }> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, hourlyRate?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null } | null } | null> | null, court?: { __typename?: 'Court', id: string, county?: string | null, name: string, createdAt: string, updatedAt: string } | null, caseType?: { __typename?: 'CaseType', id: string, name: string, lawTypeId: string, createdAt: string, updatedAt: string, lawType?: { __typename?: 'LawType', id: string, name: string, createdAt: string, syncWithOutlook: boolean, updatedAt: string } | null } | null, billing?: { __typename?: 'CaseBilling', id: string, billingType: BillingType, createdAt: string, updatedAt: string } | null, bills?: Array<{ __typename?: 'Bill', id: number, type: BillType, status: BillStatus, amount: number, sendToClient: boolean, createdAt: string, updatedAt: string, case: { __typename?: 'Case', id: string, caseTypeId: string, createdAt: string, updatedAt: string, status: CaseStatus } } | null> | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type FetchAllCasesLightQueryVariables = Exact<{
  casesLightInput: CasesLightInput;
}>;


export type FetchAllCasesLightQuery = { __typename?: 'Query', fetchAllCasesLight: { __typename?: 'CasesPayload', cases?: Array<{ __typename?: 'Case', id: string, caseNumber?: string | null, consultMatterNumber?: string | null, title?: string | null, isConsultMatter?: boolean | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, user?: { __typename?: 'User', id: string } | null } | null> | null, caseToExternalUserToExternalUserRole?: Array<{ __typename?: 'CaseToExternalUserToExternalUserRole', id: string, externalUserToExternalUserRole: { __typename?: 'ExternalUserToExternalUserRole', externalUser?: { __typename?: 'ExternalUser', id: string, firstName: string, lastName: string, displayName?: string | null, clientNumber?: string | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', externalUserRole?: { __typename?: 'ExternalUserRole', role: ExternalUserRoleRole } | null } | null> | null } | null } }> | null } | null> | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, pagination?: { __typename?: 'PaginationPayload', page?: number | null, limit?: number | null, totalCount?: number | null, totalPages?: number | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, createdAt: string, updatedAt: string, phoneNumber?: string | null, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole, createdAt: string, updatedAt: string } | null> | null, caseToUsers?: Array<{ __typename?: 'CaseToUser', id: string, userId: string, caseId: string, userType: UserType, createdAt: string, updatedAt: string, litigation?: { __typename?: 'Case', id: string, advantageCode?: string | null, title?: string | null, description?: string | null, caseNumber?: string | null, status: CaseStatus, caseTypeId: string, courtId?: string | null, createdAt: string, updatedAt: string } | null } | null> | null } | null } };

export type UpdateUserGeneralInfoMutationVariables = Exact<{
  user: UpdateGeneralInput;
}>;


export type UpdateUserGeneralInfoMutation = { __typename?: 'Mutation', updateUserGeneralInfo: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', message?: string | null, status?: number | null } | null, user?: { __typename?: 'User', email: string, id: string, lastName?: string | null, firstName?: string | null, initials?: string | null, office?: { __typename?: 'Office', id: number, name: string } | null } | null } };

export type FindOneUserQueryVariables = Exact<{
  findOneUserId: Scalars['String'];
}>;


export type FindOneUserQuery = { __typename?: 'Query', findOneUser: { __typename?: 'UserPayload', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, status: UserStatus, emailVerified: boolean, email: string, phoneNumber?: string | null, createdAt: string, updatedAt: string, initials?: string | null, hourlyRate?: number | null, roles?: Array<{ __typename?: 'Role', id: string, role: UserRole } | null> | null } | null } };

export type GetClientByClientNumberQueryVariables = Exact<{
  clientNumber: Scalars['String'];
}>;


export type GetClientByClientNumberQuery = { __typename?: 'Query', getClientByClientNumber: { __typename?: 'ExternalUserPayload', externalUser?: { __typename?: 'ExternalUser', id: string, initials?: string | null, lastName: string, firstName: string, displayName?: string | null, suffix?: string | null, middleName?: string | null, clientNumber?: string | null, dateOfBirth?: any | null, homePhone?: string | null, phoneNumber?: string | null, personalPhone?: string | null, email?: string | null, lastPayDate?: string | null, contractBalance?: string | null, lastPayAmount?: string | null, trustBalance?: string | null, arrearsBalance?: string | null, residualBalance?: string | null, businessName?: string | null, isInternational?: boolean | null, language?: string | null, socialSecurityNumber?: string | null, driverLicenseNumber?: string | null, createdAt: string, updatedAt: string, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null, createdAt: string, updatedAt: string } | null> | null, externalUserRoles?: Array<{ __typename?: 'ExternalUserToExternalUserRole', id: string, externalUserId: string, externalUserRoleId: string, createdAt: string, updatedAt: string, externalUserRole?: { __typename?: 'ExternalUserRole', id: string, role: ExternalUserRoleRole, createdAt: string, updatedAt: string } | null } | null> | null } | null } };

export type GetNextClientNumberQueryVariables = Exact<{
  isConsultClient: Scalars['Boolean'];
}>;


export type GetNextClientNumberQuery = { __typename?: 'Query', getNextClientNumber: { __typename?: 'FetchClientNoPayload', clientNo?: string | null, response?: { __typename?: 'ResponsePayload', status?: number | null } | null } };

export type UpdateUserMfaSettingsMutationVariables = Exact<{
  mfaSettingsInput: UpdateUserMfaSettingsInput;
}>;


export type UpdateUserMfaSettingsMutation = { __typename?: 'Mutation', updateUserMfaSettings: { __typename?: 'UserPayload', response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, user?: { __typename?: 'User', id: string, mfaEmailEnabled?: boolean | null, mfaAuthEnabled?: boolean | null } | null } };

export type CreateVendorMutationVariables = Exact<{
  createVendorInput: CreateVendorInput;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor: { __typename?: 'VendorPayload', vendor: { __typename?: 'Vendor', id: number, name: string }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type UpdateVendorMutationVariables = Exact<{
  updateVendorInput: UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'VendorPayload', vendor: { __typename?: 'Vendor', id: number, name: string }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type DeactivateVendorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeactivateVendorMutation = { __typename?: 'Mutation', deactivateVendor: { __typename?: 'VendorPayload', vendor: { __typename?: 'Vendor', id: number, deletedAt?: any | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type ReactivateVendorMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReactivateVendorMutation = { __typename?: 'Mutation', reactivateVendor: { __typename?: 'VendorPayload', vendor: { __typename?: 'Vendor', id: number, deletedAt?: any | null }, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export type FetchAllVendorsQueryVariables = Exact<{
  fetchVendorsInput: FetchAllVendorsInput;
}>;


export type FetchAllVendorsQuery = { __typename?: 'Query', fetchAllVendors: { __typename?: 'VendorsPayload', pagination?: { __typename?: 'PaginationPayload', totalCount?: number | null, totalPages?: number | null, page?: number | null } | null, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null, vendors?: Array<{ __typename?: 'Vendor', required1099: boolean, id: number, name: string, phone?: string | null, separateCheckPerInvoice: boolean, email?: string | null, socialSecurityNumber?: string | null, taxId?: string | null, sortCode?: string | null, description?: string | null, vendorId: string, deletedAt?: any | null, addresses?: Array<{ __typename?: 'Address', id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, county?: string | null, zipCode?: string | null } | null> | null, parentVendor?: { __typename?: 'Vendor', id: number, name: string } | null, glAccount?: { __typename?: 'Account', id: string, name: string, sortCode: string } | null, office?: { __typename?: 'Office', id: number, name: string } | null } | null> | null } };

export type GetNextVendorIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextVendorIdQuery = { __typename?: 'Query', getNextVendorId: { __typename?: 'NextVendorIdPayload', nextVendorId: string, response?: { __typename?: 'ResponsePayload', status?: number | null, message?: string | null } | null } };

export const DocPageSummaryFragmentDoc = gql`
    fragment DocPageSummary on DocPage {
  id
  title
  slug
  icon
  status
  scope
  sortOrder
  parentId
  updatedAt
  updatedBy {
    id
    firstName
    lastName
  }
}
    `;
export const DocPageDetailFragmentDoc = gql`
    fragment DocPageDetail on DocPage {
  id
  title
  slug
  icon
  status
  scope
  sortOrder
  parentId
  content
  draftContent
  publishedAt
  createdAt
  updatedAt
  createdBy {
    id
    firstName
    lastName
  }
  updatedBy {
    id
    firstName
    lastName
  }
  publishedBy {
    id
    firstName
    lastName
  }
}
    `;
export const ReconciliationSessionViewPrefsFragmentDoc = gql`
    fragment ReconciliationSessionViewPrefs on ReconciliationSessionViewPreferences {
  lineItems
  orderBy
  orderDirection
  paymentMethod
  office
}
    `;
export const ReconciliationSessionSummaryFragmentDoc = gql`
    fragment ReconciliationSessionSummary on ReconciliationSession {
  id
  statementMonth
  statementBalance
  beginningBalance
  status
  version
  itemCount
  creditTotal
  debitTotal
  clearedBalance
  difference
  updatedAt
  viewPreferences {
    ...ReconciliationSessionViewPrefs
  }
  account {
    id
    name
    sortCode
  }
  committedReconciliation {
    id
  }
}
    ${ReconciliationSessionViewPrefsFragmentDoc}`;
export const ReconciliationSessionFullFragmentDoc = gql`
    fragment ReconciliationSessionFull on ReconciliationSession {
  ...ReconciliationSessionSummary
  removedItemCount
  items {
    paymentId
    amount
    paymentType
  }
}
    ${ReconciliationSessionSummaryFragmentDoc}`;
export const CreateAccountDocument = gql`
    mutation CreateAccount($createAccountInput: CreateAccountInput!) {
  createAccount(createAccountInput: $createAccountInput) {
    response {
      status
      error
      message
      name
    }
    account {
      id
      type
      category
      active
      name
      sortCode
      accountNo
      isBankAccount
      institution
      description
      creator {
        id
        firstName
        lastName
        email
      }
      parentAccount {
        id
        name
      }
      childAccounts {
        id
        name
      }
      bills {
        id
        amount
      }
      caseBilling {
        id
        billingType
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      createAccountInput: // value for 'createAccountInput'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const FetchAllAccountsDocument = gql`
    query fetchAllAccounts($accountsInput: AccountsInput!) {
  fetchAllAccounts(accountsInput: $accountsInput) {
    accounts {
      id
      type
      category
      active
      name
      sortCode
      accountNo
      isBankAccount
      institution
      description
      currentBalance
      creator {
        id
        firstName
        lastName
        email
      }
      parentAccount {
        id
        name
      }
      createdAt
      updatedAt
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
    response {
      status
      error
      message
      name
    }
  }
}
    `;

/**
 * __useFetchAllAccountsQuery__
 *
 * To run a query within a React component, call `useFetchAllAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAccountsQuery({
 *   variables: {
 *      accountsInput: // value for 'accountsInput'
 *   },
 * });
 */
export function useFetchAllAccountsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllAccountsQuery, FetchAllAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAccountsQuery, FetchAllAccountsQueryVariables>(FetchAllAccountsDocument, options);
      }
export function useFetchAllAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAccountsQuery, FetchAllAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAccountsQuery, FetchAllAccountsQueryVariables>(FetchAllAccountsDocument, options);
        }
export type FetchAllAccountsQueryHookResult = ReturnType<typeof useFetchAllAccountsQuery>;
export type FetchAllAccountsLazyQueryHookResult = ReturnType<typeof useFetchAllAccountsLazyQuery>;
export type FetchAllAccountsQueryResult = Apollo.QueryResult<FetchAllAccountsQuery, FetchAllAccountsQueryVariables>;
export const FetchAccountByIdDocument = gql`
    query fetchAccountById($id: String!) {
  fetchAccountById(id: $id) {
    response {
      status
      error
      message
      name
    }
    account {
      id
      type
      category
      active
      name
      sortCode
      accountNo
      isBankAccount
      institution
      description
      openingBalance
      currentBalance
      routingNo
      creator {
        id
        firstName
        lastName
        email
      }
      parentAccount {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useFetchAccountByIdQuery__
 *
 * To run a query within a React component, call `useFetchAccountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAccountByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchAccountByIdQuery, FetchAccountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountByIdQuery, FetchAccountByIdQueryVariables>(FetchAccountByIdDocument, options);
      }
export function useFetchAccountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountByIdQuery, FetchAccountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountByIdQuery, FetchAccountByIdQueryVariables>(FetchAccountByIdDocument, options);
        }
export type FetchAccountByIdQueryHookResult = ReturnType<typeof useFetchAccountByIdQuery>;
export type FetchAccountByIdLazyQueryHookResult = ReturnType<typeof useFetchAccountByIdLazyQuery>;
export type FetchAccountByIdQueryResult = Apollo.QueryResult<FetchAccountByIdQuery, FetchAccountByIdQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($updateAccountInput: UpdateAccountInput!) {
  updateAccount(updateAccountInput: $updateAccountInput) {
    response {
      status
      error
      message
      name
    }
    account {
      id
      type
      category
      active
      name
      sortCode
      accountNo
      isBankAccount
      institution
      description
      creator {
        id
        firstName
        lastName
        email
      }
      parentAccount {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      updateAccountInput: // value for 'updateAccountInput'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const ToggleArchiveAccountDocument = gql`
    mutation toggleArchiveAccount($id: String!) {
  toggleArchiveAccount(id: $id) {
    response {
      status
      error
      message
      name
    }
    account {
      id
      type
      category
      active
      name
      sortCode
      accountNo
      isBankAccount
      institution
      description
      creator {
        id
        firstName
        lastName
        email
      }
      parentAccount {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type ToggleArchiveAccountMutationFn = Apollo.MutationFunction<ToggleArchiveAccountMutation, ToggleArchiveAccountMutationVariables>;

/**
 * __useToggleArchiveAccountMutation__
 *
 * To run a mutation, you first call `useToggleArchiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchiveAccountMutation, { data, loading, error }] = useToggleArchiveAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleArchiveAccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArchiveAccountMutation, ToggleArchiveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArchiveAccountMutation, ToggleArchiveAccountMutationVariables>(ToggleArchiveAccountDocument, options);
      }
export type ToggleArchiveAccountMutationHookResult = ReturnType<typeof useToggleArchiveAccountMutation>;
export type ToggleArchiveAccountMutationResult = Apollo.MutationResult<ToggleArchiveAccountMutation>;
export type ToggleArchiveAccountMutationOptions = Apollo.BaseMutationOptions<ToggleArchiveAccountMutation, ToggleArchiveAccountMutationVariables>;
export const FetchAllPaymentsDocument = gql`
    query FetchAllPayments($fetchAllPaymentsInput: FetchPaymentsInput!) {
  fetchAllPayments(fetchAllPaymentsInput: $fetchAllPaymentsInput) {
    payments {
      id
      paymentMethod
      referenceNumber
      slipNumber
      notes
      case {
        id
        title
        caseNumber
        consultMatterNumber
      }
      reconciledAt
      reconciledBy {
        id
        firstName
        lastName
      }
      client {
        id
        lastName
        email
        firstName
        displayName
        initials
        clientNumber
        middleName
        suffix
      }
      vendor {
        id
        name
        sortCode
      }
      linkedPayment {
        id
        account {
          id
          name
        }
      }
      date
      creator {
        id
        email
        lastName
        firstName
      }
      amount
      returnAmount
      returnNotes
      returnedAt
      bill {
        id
        status
        type
        amount
      }
      office {
        id
        name
      }
      createdAt
      client {
        id
        lastName
        email
        firstName
        displayName
        initials
        clientNumber
        middleName
        suffix
      }
      paymentType
      paymentSource
      fromAdv
      vendor {
        id
        name
      }
      office {
        id
        name
      }
      account {
        id
        name
      }
    }
    pagination {
      totalPages
      totalCount
      page
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllPaymentsQuery__
 *
 * To run a query within a React component, call `useFetchAllPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllPaymentsQuery({
 *   variables: {
 *      fetchAllPaymentsInput: // value for 'fetchAllPaymentsInput'
 *   },
 * });
 */
export function useFetchAllPaymentsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllPaymentsQuery, FetchAllPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllPaymentsQuery, FetchAllPaymentsQueryVariables>(FetchAllPaymentsDocument, options);
      }
export function useFetchAllPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllPaymentsQuery, FetchAllPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllPaymentsQuery, FetchAllPaymentsQueryVariables>(FetchAllPaymentsDocument, options);
        }
export type FetchAllPaymentsQueryHookResult = ReturnType<typeof useFetchAllPaymentsQuery>;
export type FetchAllPaymentsLazyQueryHookResult = ReturnType<typeof useFetchAllPaymentsLazyQuery>;
export type FetchAllPaymentsQueryResult = Apollo.QueryResult<FetchAllPaymentsQuery, FetchAllPaymentsQueryVariables>;
export const FetchPaymentsByProfitCenterDocument = gql`
    query FetchPaymentsByProfitCenter($input: FetchPaymentsByProfitCenterInput!) {
  fetchPaymentsByProfitCenter(input: $input) {
    response {
      status
      message
    }
    payments {
      date
      amount
      creditAmount
      debitAmount
      officeId
      officeName
      slipNumber
      paymentIds
    }
  }
}
    `;

/**
 * __useFetchPaymentsByProfitCenterQuery__
 *
 * To run a query within a React component, call `useFetchPaymentsByProfitCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentsByProfitCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentsByProfitCenterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchPaymentsByProfitCenterQuery(baseOptions: Apollo.QueryHookOptions<FetchPaymentsByProfitCenterQuery, FetchPaymentsByProfitCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentsByProfitCenterQuery, FetchPaymentsByProfitCenterQueryVariables>(FetchPaymentsByProfitCenterDocument, options);
      }
export function useFetchPaymentsByProfitCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentsByProfitCenterQuery, FetchPaymentsByProfitCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentsByProfitCenterQuery, FetchPaymentsByProfitCenterQueryVariables>(FetchPaymentsByProfitCenterDocument, options);
        }
export type FetchPaymentsByProfitCenterQueryHookResult = ReturnType<typeof useFetchPaymentsByProfitCenterQuery>;
export type FetchPaymentsByProfitCenterLazyQueryHookResult = ReturnType<typeof useFetchPaymentsByProfitCenterLazyQuery>;
export type FetchPaymentsByProfitCenterQueryResult = Apollo.QueryResult<FetchPaymentsByProfitCenterQuery, FetchPaymentsByProfitCenterQueryVariables>;
export const ReconcilePaymentsDocument = gql`
    mutation ReconcilePayments($reconcilePaymentInput: ReconcilePaymentInput!) {
  reconcilePayments(reconcilePaymentInput: $reconcilePaymentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ReconcilePaymentsMutationFn = Apollo.MutationFunction<ReconcilePaymentsMutation, ReconcilePaymentsMutationVariables>;

/**
 * __useReconcilePaymentsMutation__
 *
 * To run a mutation, you first call `useReconcilePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcilePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcilePaymentsMutation, { data, loading, error }] = useReconcilePaymentsMutation({
 *   variables: {
 *      reconcilePaymentInput: // value for 'reconcilePaymentInput'
 *   },
 * });
 */
export function useReconcilePaymentsMutation(baseOptions?: Apollo.MutationHookOptions<ReconcilePaymentsMutation, ReconcilePaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcilePaymentsMutation, ReconcilePaymentsMutationVariables>(ReconcilePaymentsDocument, options);
      }
export type ReconcilePaymentsMutationHookResult = ReturnType<typeof useReconcilePaymentsMutation>;
export type ReconcilePaymentsMutationResult = Apollo.MutationResult<ReconcilePaymentsMutation>;
export type ReconcilePaymentsMutationOptions = Apollo.BaseMutationOptions<ReconcilePaymentsMutation, ReconcilePaymentsMutationVariables>;
export const MarkPaymentsAsLegacyReconciledDocument = gql`
    mutation MarkPaymentsAsLegacyReconciled($input: MarkPaymentsAsLegacyReconciledInput!) {
  markPaymentsAsLegacyReconciled(input: $input) {
    response {
      status
      message
    }
  }
}
    `;
export type MarkPaymentsAsLegacyReconciledMutationFn = Apollo.MutationFunction<MarkPaymentsAsLegacyReconciledMutation, MarkPaymentsAsLegacyReconciledMutationVariables>;

/**
 * __useMarkPaymentsAsLegacyReconciledMutation__
 *
 * To run a mutation, you first call `useMarkPaymentsAsLegacyReconciledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPaymentsAsLegacyReconciledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPaymentsAsLegacyReconciledMutation, { data, loading, error }] = useMarkPaymentsAsLegacyReconciledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkPaymentsAsLegacyReconciledMutation(baseOptions?: Apollo.MutationHookOptions<MarkPaymentsAsLegacyReconciledMutation, MarkPaymentsAsLegacyReconciledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPaymentsAsLegacyReconciledMutation, MarkPaymentsAsLegacyReconciledMutationVariables>(MarkPaymentsAsLegacyReconciledDocument, options);
      }
export type MarkPaymentsAsLegacyReconciledMutationHookResult = ReturnType<typeof useMarkPaymentsAsLegacyReconciledMutation>;
export type MarkPaymentsAsLegacyReconciledMutationResult = Apollo.MutationResult<MarkPaymentsAsLegacyReconciledMutation>;
export type MarkPaymentsAsLegacyReconciledMutationOptions = Apollo.BaseMutationOptions<MarkPaymentsAsLegacyReconciledMutation, MarkPaymentsAsLegacyReconciledMutationVariables>;
export const GenerateGeneralLedgerDocument = gql`
    query GenerateGeneralLedger($input: FetchGeneralLedgerInput!) {
  generateGeneralLedger(input: $input) {
    response {
      status
      message
    }
    pagination {
      page
      totalCount
      totalPages
    }
    reports {
      accountId
      accountName
      accountCode
      date
      type
      amount
      description
      bill {
        id
        amount
        status
      }
      matter {
        id
        title
        caseNumber
        consultMatterNumber
      }
      client {
        id
        firstName
        middleName
        lastName
        displayName
        email
        initials
      }
      payable {
        id
        voucherNo
        paymentMethod
        amount
        description
      }
    }
  }
}
    `;

/**
 * __useGenerateGeneralLedgerQuery__
 *
 * To run a query within a React component, call `useGenerateGeneralLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateGeneralLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateGeneralLedgerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateGeneralLedgerQuery(baseOptions: Apollo.QueryHookOptions<GenerateGeneralLedgerQuery, GenerateGeneralLedgerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateGeneralLedgerQuery, GenerateGeneralLedgerQueryVariables>(GenerateGeneralLedgerDocument, options);
      }
export function useGenerateGeneralLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateGeneralLedgerQuery, GenerateGeneralLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateGeneralLedgerQuery, GenerateGeneralLedgerQueryVariables>(GenerateGeneralLedgerDocument, options);
        }
export type GenerateGeneralLedgerQueryHookResult = ReturnType<typeof useGenerateGeneralLedgerQuery>;
export type GenerateGeneralLedgerLazyQueryHookResult = ReturnType<typeof useGenerateGeneralLedgerLazyQuery>;
export type GenerateGeneralLedgerQueryResult = Apollo.QueryResult<GenerateGeneralLedgerQuery, GenerateGeneralLedgerQueryVariables>;
export const ReconcileGroupedPaymentsByProfitCenterDocument = gql`
    mutation ReconcileGroupedPaymentsByProfitCenter($reconcileGroupedPayments: ReconcileGroupedPaymentsByProfitCenterInput!) {
  reconcileGroupedPaymentsByProfitCenter(
    reconcileGroupedPayments: $reconcileGroupedPayments
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type ReconcileGroupedPaymentsByProfitCenterMutationFn = Apollo.MutationFunction<ReconcileGroupedPaymentsByProfitCenterMutation, ReconcileGroupedPaymentsByProfitCenterMutationVariables>;

/**
 * __useReconcileGroupedPaymentsByProfitCenterMutation__
 *
 * To run a mutation, you first call `useReconcileGroupedPaymentsByProfitCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileGroupedPaymentsByProfitCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileGroupedPaymentsByProfitCenterMutation, { data, loading, error }] = useReconcileGroupedPaymentsByProfitCenterMutation({
 *   variables: {
 *      reconcileGroupedPayments: // value for 'reconcileGroupedPayments'
 *   },
 * });
 */
export function useReconcileGroupedPaymentsByProfitCenterMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileGroupedPaymentsByProfitCenterMutation, ReconcileGroupedPaymentsByProfitCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileGroupedPaymentsByProfitCenterMutation, ReconcileGroupedPaymentsByProfitCenterMutationVariables>(ReconcileGroupedPaymentsByProfitCenterDocument, options);
      }
export type ReconcileGroupedPaymentsByProfitCenterMutationHookResult = ReturnType<typeof useReconcileGroupedPaymentsByProfitCenterMutation>;
export type ReconcileGroupedPaymentsByProfitCenterMutationResult = Apollo.MutationResult<ReconcileGroupedPaymentsByProfitCenterMutation>;
export type ReconcileGroupedPaymentsByProfitCenterMutationOptions = Apollo.BaseMutationOptions<ReconcileGroupedPaymentsByProfitCenterMutation, ReconcileGroupedPaymentsByProfitCenterMutationVariables>;
export const CloseAccountingPeriodDocument = gql`
    mutation CloseAccountingPeriod($input: CloseAccountingPeriodInput!) {
  closeAccountingPeriod(input: $input) {
    id
    fiscalYear
    month
    periodStart
    periodEnd
    status
    closedAt
    closedBy {
      id
      firstName
      lastName
      email
    }
    unclosedAt
    unclosedBy {
      id
      firstName
      lastName
      email
    }
    notes
    createdAt
    updatedAt
  }
}
    `;
export type CloseAccountingPeriodMutationFn = Apollo.MutationFunction<CloseAccountingPeriodMutation, CloseAccountingPeriodMutationVariables>;

/**
 * __useCloseAccountingPeriodMutation__
 *
 * To run a mutation, you first call `useCloseAccountingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAccountingPeriodMutation, { data, loading, error }] = useCloseAccountingPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseAccountingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CloseAccountingPeriodMutation, CloseAccountingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseAccountingPeriodMutation, CloseAccountingPeriodMutationVariables>(CloseAccountingPeriodDocument, options);
      }
export type CloseAccountingPeriodMutationHookResult = ReturnType<typeof useCloseAccountingPeriodMutation>;
export type CloseAccountingPeriodMutationResult = Apollo.MutationResult<CloseAccountingPeriodMutation>;
export type CloseAccountingPeriodMutationOptions = Apollo.BaseMutationOptions<CloseAccountingPeriodMutation, CloseAccountingPeriodMutationVariables>;
export const UncloseAccountingPeriodDocument = gql`
    mutation UncloseAccountingPeriod($input: UncloseAccountingPeriodInput!) {
  uncloseAccountingPeriod(input: $input)
}
    `;
export type UncloseAccountingPeriodMutationFn = Apollo.MutationFunction<UncloseAccountingPeriodMutation, UncloseAccountingPeriodMutationVariables>;

/**
 * __useUncloseAccountingPeriodMutation__
 *
 * To run a mutation, you first call `useUncloseAccountingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloseAccountingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloseAccountingPeriodMutation, { data, loading, error }] = useUncloseAccountingPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUncloseAccountingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UncloseAccountingPeriodMutation, UncloseAccountingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncloseAccountingPeriodMutation, UncloseAccountingPeriodMutationVariables>(UncloseAccountingPeriodDocument, options);
      }
export type UncloseAccountingPeriodMutationHookResult = ReturnType<typeof useUncloseAccountingPeriodMutation>;
export type UncloseAccountingPeriodMutationResult = Apollo.MutationResult<UncloseAccountingPeriodMutation>;
export type UncloseAccountingPeriodMutationOptions = Apollo.BaseMutationOptions<UncloseAccountingPeriodMutation, UncloseAccountingPeriodMutationVariables>;
export const AccountingPeriodsDocument = gql`
    query AccountingPeriods($fiscalYear: Int) {
  accountingPeriods(fiscalYear: $fiscalYear) {
    id
    fiscalYear
    month
    periodStart
    periodEnd
    status
    closedAt
    closedBy {
      id
      firstName
      lastName
      email
    }
    unclosedAt
    unclosedBy {
      id
      firstName
      lastName
      email
    }
    notes
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAccountingPeriodsQuery__
 *
 * To run a query within a React component, call `useAccountingPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingPeriodsQuery({
 *   variables: {
 *      fiscalYear: // value for 'fiscalYear'
 *   },
 * });
 */
export function useAccountingPeriodsQuery(baseOptions?: Apollo.QueryHookOptions<AccountingPeriodsQuery, AccountingPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingPeriodsQuery, AccountingPeriodsQueryVariables>(AccountingPeriodsDocument, options);
      }
export function useAccountingPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingPeriodsQuery, AccountingPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingPeriodsQuery, AccountingPeriodsQueryVariables>(AccountingPeriodsDocument, options);
        }
export type AccountingPeriodsQueryHookResult = ReturnType<typeof useAccountingPeriodsQuery>;
export type AccountingPeriodsLazyQueryHookResult = ReturnType<typeof useAccountingPeriodsLazyQuery>;
export type AccountingPeriodsQueryResult = Apollo.QueryResult<AccountingPeriodsQuery, AccountingPeriodsQueryVariables>;
export const AccountingPeriodDocument = gql`
    query AccountingPeriod($fiscalYear: Int!, $month: Int!) {
  accountingPeriod(fiscalYear: $fiscalYear, month: $month) {
    id
    fiscalYear
    month
    periodStart
    periodEnd
    status
    closedAt
    closedBy {
      id
      firstName
      lastName
      email
    }
    unclosedAt
    unclosedBy {
      id
      firstName
      lastName
      email
    }
    notes
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAccountingPeriodQuery__
 *
 * To run a query within a React component, call `useAccountingPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingPeriodQuery({
 *   variables: {
 *      fiscalYear: // value for 'fiscalYear'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useAccountingPeriodQuery(baseOptions: Apollo.QueryHookOptions<AccountingPeriodQuery, AccountingPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountingPeriodQuery, AccountingPeriodQueryVariables>(AccountingPeriodDocument, options);
      }
export function useAccountingPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountingPeriodQuery, AccountingPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountingPeriodQuery, AccountingPeriodQueryVariables>(AccountingPeriodDocument, options);
        }
export type AccountingPeriodQueryHookResult = ReturnType<typeof useAccountingPeriodQuery>;
export type AccountingPeriodLazyQueryHookResult = ReturnType<typeof useAccountingPeriodLazyQuery>;
export type AccountingPeriodQueryResult = Apollo.QueryResult<AccountingPeriodQuery, AccountingPeriodQueryVariables>;
export const YearEndClosesDocument = gql`
    query YearEndCloses($fiscalYear: Int) {
  yearEndCloses(fiscalYear: $fiscalYear) {
    id
    fiscalYear
    netIncome
    closedAt
    closedBy {
      id
      firstName
      lastName
      email
    }
    closingJournalEntry {
      id
      journalEntryNumber
      notes
      date
    }
    notes
    createdAt
  }
}
    `;

/**
 * __useYearEndClosesQuery__
 *
 * To run a query within a React component, call `useYearEndClosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearEndClosesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearEndClosesQuery({
 *   variables: {
 *      fiscalYear: // value for 'fiscalYear'
 *   },
 * });
 */
export function useYearEndClosesQuery(baseOptions?: Apollo.QueryHookOptions<YearEndClosesQuery, YearEndClosesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearEndClosesQuery, YearEndClosesQueryVariables>(YearEndClosesDocument, options);
      }
export function useYearEndClosesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearEndClosesQuery, YearEndClosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearEndClosesQuery, YearEndClosesQueryVariables>(YearEndClosesDocument, options);
        }
export type YearEndClosesQueryHookResult = ReturnType<typeof useYearEndClosesQuery>;
export type YearEndClosesLazyQueryHookResult = ReturnType<typeof useYearEndClosesLazyQuery>;
export type YearEndClosesQueryResult = Apollo.QueryResult<YearEndClosesQuery, YearEndClosesQueryVariables>;
export const YearEndCloseDocument = gql`
    query YearEndClose($fiscalYear: Int!) {
  yearEndClose(fiscalYear: $fiscalYear) {
    id
    fiscalYear
    netIncome
    closedAt
    closedBy {
      id
      firstName
      lastName
      email
    }
    closingJournalEntry {
      id
      journalEntryNumber
      notes
      date
    }
    notes
    createdAt
  }
}
    `;

/**
 * __useYearEndCloseQuery__
 *
 * To run a query within a React component, call `useYearEndCloseQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearEndCloseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearEndCloseQuery({
 *   variables: {
 *      fiscalYear: // value for 'fiscalYear'
 *   },
 * });
 */
export function useYearEndCloseQuery(baseOptions: Apollo.QueryHookOptions<YearEndCloseQuery, YearEndCloseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearEndCloseQuery, YearEndCloseQueryVariables>(YearEndCloseDocument, options);
      }
export function useYearEndCloseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearEndCloseQuery, YearEndCloseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearEndCloseQuery, YearEndCloseQueryVariables>(YearEndCloseDocument, options);
        }
export type YearEndCloseQueryHookResult = ReturnType<typeof useYearEndCloseQuery>;
export type YearEndCloseLazyQueryHookResult = ReturnType<typeof useYearEndCloseLazyQuery>;
export type YearEndCloseQueryResult = Apollo.QueryResult<YearEndCloseQuery, YearEndCloseQueryVariables>;
export const ReCloseYearDocument = gql`
    mutation ReCloseYear {
  reCloseYear {
    id
    fiscalYear
    netIncome
    closedAt
  }
}
    `;
export type ReCloseYearMutationFn = Apollo.MutationFunction<ReCloseYearMutation, ReCloseYearMutationVariables>;

/**
 * __useReCloseYearMutation__
 *
 * To run a mutation, you first call `useReCloseYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReCloseYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reCloseYearMutation, { data, loading, error }] = useReCloseYearMutation({
 *   variables: {
 *   },
 * });
 */
export function useReCloseYearMutation(baseOptions?: Apollo.MutationHookOptions<ReCloseYearMutation, ReCloseYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReCloseYearMutation, ReCloseYearMutationVariables>(ReCloseYearDocument, options);
      }
export type ReCloseYearMutationHookResult = ReturnType<typeof useReCloseYearMutation>;
export type ReCloseYearMutationResult = Apollo.MutationResult<ReCloseYearMutation>;
export type ReCloseYearMutationOptions = Apollo.BaseMutationOptions<ReCloseYearMutation, ReCloseYearMutationVariables>;
export const CreateAccountPayableDocument = gql`
    mutation CreateAccountPayable($input: CreatePayableInput!) {
  createAccountPayable(input: $input) {
    accountPayableEntry {
      id
    }
    response {
      message
      status
    }
  }
}
    `;
export type CreateAccountPayableMutationFn = Apollo.MutationFunction<CreateAccountPayableMutation, CreateAccountPayableMutationVariables>;

/**
 * __useCreateAccountPayableMutation__
 *
 * To run a mutation, you first call `useCreateAccountPayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountPayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountPayableMutation, { data, loading, error }] = useCreateAccountPayableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountPayableMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountPayableMutation, CreateAccountPayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountPayableMutation, CreateAccountPayableMutationVariables>(CreateAccountPayableDocument, options);
      }
export type CreateAccountPayableMutationHookResult = ReturnType<typeof useCreateAccountPayableMutation>;
export type CreateAccountPayableMutationResult = Apollo.MutationResult<CreateAccountPayableMutation>;
export type CreateAccountPayableMutationOptions = Apollo.BaseMutationOptions<CreateAccountPayableMutation, CreateAccountPayableMutationVariables>;
export const MarkPayableAsPaidDocument = gql`
    mutation MarkPayableAsPaid($id: String!) {
  markPayableAsPaid(id: $id) {
    response {
      message
      status
    }
  }
}
    `;
export type MarkPayableAsPaidMutationFn = Apollo.MutationFunction<MarkPayableAsPaidMutation, MarkPayableAsPaidMutationVariables>;

/**
 * __useMarkPayableAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkPayableAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPayableAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPayableAsPaidMutation, { data, loading, error }] = useMarkPayableAsPaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkPayableAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkPayableAsPaidMutation, MarkPayableAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPayableAsPaidMutation, MarkPayableAsPaidMutationVariables>(MarkPayableAsPaidDocument, options);
      }
export type MarkPayableAsPaidMutationHookResult = ReturnType<typeof useMarkPayableAsPaidMutation>;
export type MarkPayableAsPaidMutationResult = Apollo.MutationResult<MarkPayableAsPaidMutation>;
export type MarkPayableAsPaidMutationOptions = Apollo.BaseMutationOptions<MarkPayableAsPaidMutation, MarkPayableAsPaidMutationVariables>;
export const SoftDeletePayableDocument = gql`
    mutation SoftDeletePayable($id: String!) {
  softDeletePayable(id: $id) {
    response {
      message
      status
    }
  }
}
    `;
export type SoftDeletePayableMutationFn = Apollo.MutationFunction<SoftDeletePayableMutation, SoftDeletePayableMutationVariables>;

/**
 * __useSoftDeletePayableMutation__
 *
 * To run a mutation, you first call `useSoftDeletePayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeletePayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeletePayableMutation, { data, loading, error }] = useSoftDeletePayableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftDeletePayableMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeletePayableMutation, SoftDeletePayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeletePayableMutation, SoftDeletePayableMutationVariables>(SoftDeletePayableDocument, options);
      }
export type SoftDeletePayableMutationHookResult = ReturnType<typeof useSoftDeletePayableMutation>;
export type SoftDeletePayableMutationResult = Apollo.MutationResult<SoftDeletePayableMutation>;
export type SoftDeletePayableMutationOptions = Apollo.BaseMutationOptions<SoftDeletePayableMutation, SoftDeletePayableMutationVariables>;
export const VoidPayableDocument = gql`
    mutation VoidPayable($id: String!, $creditClients: [VoidCreditClientInput!]) {
  voidPayable(id: $id, creditClients: $creditClients) {
    response {
      message
      status
    }
  }
}
    `;
export type VoidPayableMutationFn = Apollo.MutationFunction<VoidPayableMutation, VoidPayableMutationVariables>;

/**
 * __useVoidPayableMutation__
 *
 * To run a mutation, you first call `useVoidPayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidPayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidPayableMutation, { data, loading, error }] = useVoidPayableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      creditClients: // value for 'creditClients'
 *   },
 * });
 */
export function useVoidPayableMutation(baseOptions?: Apollo.MutationHookOptions<VoidPayableMutation, VoidPayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidPayableMutation, VoidPayableMutationVariables>(VoidPayableDocument, options);
      }
export type VoidPayableMutationHookResult = ReturnType<typeof useVoidPayableMutation>;
export type VoidPayableMutationResult = Apollo.MutationResult<VoidPayableMutation>;
export type VoidPayableMutationOptions = Apollo.BaseMutationOptions<VoidPayableMutation, VoidPayableMutationVariables>;
export const PayableVoidPreviewDocument = gql`
    query PayableVoidPreview($id: String!, $creditClients: [VoidCreditClientInput!]) {
  payableVoidPreview(id: $id, creditClients: $creditClients) {
    items {
      entryId
      caseId
      matterNumber
      outcome
      amount
      billId
      billStatus
      clientId
      clientOptions {
        id
        name
      }
      needsClientChoice
      creditAmount
      settlementAmount
      uncollectedAmount
    }
    response {
      message
      status
    }
  }
}
    `;

/**
 * __usePayableVoidPreviewQuery__
 *
 * To run a query within a React component, call `usePayableVoidPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayableVoidPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayableVoidPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      creditClients: // value for 'creditClients'
 *   },
 * });
 */
export function usePayableVoidPreviewQuery(baseOptions: Apollo.QueryHookOptions<PayableVoidPreviewQuery, PayableVoidPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayableVoidPreviewQuery, PayableVoidPreviewQueryVariables>(PayableVoidPreviewDocument, options);
      }
export function usePayableVoidPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayableVoidPreviewQuery, PayableVoidPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayableVoidPreviewQuery, PayableVoidPreviewQueryVariables>(PayableVoidPreviewDocument, options);
        }
export type PayableVoidPreviewQueryHookResult = ReturnType<typeof usePayableVoidPreviewQuery>;
export type PayableVoidPreviewLazyQueryHookResult = ReturnType<typeof usePayableVoidPreviewLazyQuery>;
export type PayableVoidPreviewQueryResult = Apollo.QueryResult<PayableVoidPreviewQuery, PayableVoidPreviewQueryVariables>;
export const VoidAndDuplicatePayableDocument = gql`
    mutation VoidAndDuplicatePayable($id: String!) {
  voidAndDuplicatePayable(id: $id) {
    response {
      message
      status
    }
    voidedPayable {
      id
      voucherNo
      status
    }
    duplicatePayable {
      id
      voucherNo
      status
    }
  }
}
    `;
export type VoidAndDuplicatePayableMutationFn = Apollo.MutationFunction<VoidAndDuplicatePayableMutation, VoidAndDuplicatePayableMutationVariables>;

/**
 * __useVoidAndDuplicatePayableMutation__
 *
 * To run a mutation, you first call `useVoidAndDuplicatePayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidAndDuplicatePayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidAndDuplicatePayableMutation, { data, loading, error }] = useVoidAndDuplicatePayableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoidAndDuplicatePayableMutation(baseOptions?: Apollo.MutationHookOptions<VoidAndDuplicatePayableMutation, VoidAndDuplicatePayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidAndDuplicatePayableMutation, VoidAndDuplicatePayableMutationVariables>(VoidAndDuplicatePayableDocument, options);
      }
export type VoidAndDuplicatePayableMutationHookResult = ReturnType<typeof useVoidAndDuplicatePayableMutation>;
export type VoidAndDuplicatePayableMutationResult = Apollo.MutationResult<VoidAndDuplicatePayableMutation>;
export type VoidAndDuplicatePayableMutationOptions = Apollo.BaseMutationOptions<VoidAndDuplicatePayableMutation, VoidAndDuplicatePayableMutationVariables>;
export const VoidAndReissueCheckDocument = gql`
    mutation VoidAndReissueCheck($input: VoidAndReissueCheckInput!) {
  voidAndReissueCheck(input: $input) {
    response {
      message
      status
    }
    voidedPayable {
      id
      voucherNo
      status
      checkOrAchNumber
    }
    reissuedPayable {
      id
      voucherNo
      status
      checkOrAchNumber
      payDate
    }
  }
}
    `;
export type VoidAndReissueCheckMutationFn = Apollo.MutationFunction<VoidAndReissueCheckMutation, VoidAndReissueCheckMutationVariables>;

/**
 * __useVoidAndReissueCheckMutation__
 *
 * To run a mutation, you first call `useVoidAndReissueCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidAndReissueCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidAndReissueCheckMutation, { data, loading, error }] = useVoidAndReissueCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidAndReissueCheckMutation(baseOptions?: Apollo.MutationHookOptions<VoidAndReissueCheckMutation, VoidAndReissueCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidAndReissueCheckMutation, VoidAndReissueCheckMutationVariables>(VoidAndReissueCheckDocument, options);
      }
export type VoidAndReissueCheckMutationHookResult = ReturnType<typeof useVoidAndReissueCheckMutation>;
export type VoidAndReissueCheckMutationResult = Apollo.MutationResult<VoidAndReissueCheckMutation>;
export type VoidAndReissueCheckMutationOptions = Apollo.BaseMutationOptions<VoidAndReissueCheckMutation, VoidAndReissueCheckMutationVariables>;
export const FetchVoucherOfPayableEntryDocument = gql`
    query FetchVoucherOfPayableEntry {
  fetchVoucherOfPayableEntry {
    voucherNo
  }
}
    `;

/**
 * __useFetchVoucherOfPayableEntryQuery__
 *
 * To run a query within a React component, call `useFetchVoucherOfPayableEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchVoucherOfPayableEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchVoucherOfPayableEntryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchVoucherOfPayableEntryQuery(baseOptions?: Apollo.QueryHookOptions<FetchVoucherOfPayableEntryQuery, FetchVoucherOfPayableEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchVoucherOfPayableEntryQuery, FetchVoucherOfPayableEntryQueryVariables>(FetchVoucherOfPayableEntryDocument, options);
      }
export function useFetchVoucherOfPayableEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchVoucherOfPayableEntryQuery, FetchVoucherOfPayableEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchVoucherOfPayableEntryQuery, FetchVoucherOfPayableEntryQueryVariables>(FetchVoucherOfPayableEntryDocument, options);
        }
export type FetchVoucherOfPayableEntryQueryHookResult = ReturnType<typeof useFetchVoucherOfPayableEntryQuery>;
export type FetchVoucherOfPayableEntryLazyQueryHookResult = ReturnType<typeof useFetchVoucherOfPayableEntryLazyQuery>;
export type FetchVoucherOfPayableEntryQueryResult = Apollo.QueryResult<FetchVoucherOfPayableEntryQuery, FetchVoucherOfPayableEntryQueryVariables>;
export const FetchAccountsPayablesDocument = gql`
    query FetchAccountsPayables($input: FetchAccountsPayableInput!) {
  fetchAccountsPayables(input: $input) {
    pagination {
      page
      totalCount
      totalPages
    }
    totalAmount
    apEntries {
      id
      voucherNo
      paymentMethod
      status
      description
      amount
      invoiceDate
      payDate
      printedAt
      checkOrAchNumber
      isReconciled
      reconciledAt
      reconciledOn
      billedCaseIds
      lineItems {
        id
        amount
        description
        office {
          id
          name
        }
        litigation {
          id
          title
          caseNumber
          consultMatterNumber
        }
        glAccount {
          id
          name
          sortCode
        }
        client {
          id
          firstName
          lastName
          displayName
        }
      }
      vendor {
        id
        name
        vendorId
      }
      account {
        id
        name
        sortCode
        currentBalance
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAccountsPayablesQuery__
 *
 * To run a query within a React component, call `useFetchAccountsPayablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountsPayablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountsPayablesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchAccountsPayablesQuery(baseOptions: Apollo.QueryHookOptions<FetchAccountsPayablesQuery, FetchAccountsPayablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountsPayablesQuery, FetchAccountsPayablesQueryVariables>(FetchAccountsPayablesDocument, options);
      }
export function useFetchAccountsPayablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountsPayablesQuery, FetchAccountsPayablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountsPayablesQuery, FetchAccountsPayablesQueryVariables>(FetchAccountsPayablesDocument, options);
        }
export type FetchAccountsPayablesQueryHookResult = ReturnType<typeof useFetchAccountsPayablesQuery>;
export type FetchAccountsPayablesLazyQueryHookResult = ReturnType<typeof useFetchAccountsPayablesLazyQuery>;
export type FetchAccountsPayablesQueryResult = Apollo.QueryResult<FetchAccountsPayablesQuery, FetchAccountsPayablesQueryVariables>;
export const GetAccountPayableByVoucherDocument = gql`
    query GetAccountPayableByVoucher($voucherNo: String!) {
  getAccountPayableByVoucher(voucherNo: $voucherNo) {
    response {
      status
      message
    }
    accountPayableEntry {
      id
      voucherNo
      paymentMethod
      status
      description
      amount
      invoiceDate
      payDate
      createdAt
      updatedAt
      isReconciled
      reconciledAt
      reconciledOn
      billedCaseIds
      lineItems {
        id
        amount
        description
        office {
          id
          name
        }
        litigation {
          id
          title
          caseNumber
          consultMatterNumber
        }
        glAccount {
          id
          type
          sortCode
          name
          isBankAccount
        }
      }
      vendor {
        id
        name
        vendorId
      }
      account {
        id
        name
        currentBalance
      }
      creator {
        id
        firstName
        lastName
        email
      }
      checkOrAchNumber
      printedAt
      reissues {
        id
        voucherNo
        status
      }
      reissuedFrom {
        id
        voucherNo
        status
      }
      actionDetails {
        date
        user {
          id
          firstName
          lastName
          email
        }
        action
      }
    }
  }
}
    `;

/**
 * __useGetAccountPayableByVoucherQuery__
 *
 * To run a query within a React component, call `useGetAccountPayableByVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPayableByVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPayableByVoucherQuery({
 *   variables: {
 *      voucherNo: // value for 'voucherNo'
 *   },
 * });
 */
export function useGetAccountPayableByVoucherQuery(baseOptions: Apollo.QueryHookOptions<GetAccountPayableByVoucherQuery, GetAccountPayableByVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountPayableByVoucherQuery, GetAccountPayableByVoucherQueryVariables>(GetAccountPayableByVoucherDocument, options);
      }
export function useGetAccountPayableByVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountPayableByVoucherQuery, GetAccountPayableByVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountPayableByVoucherQuery, GetAccountPayableByVoucherQueryVariables>(GetAccountPayableByVoucherDocument, options);
        }
export type GetAccountPayableByVoucherQueryHookResult = ReturnType<typeof useGetAccountPayableByVoucherQuery>;
export type GetAccountPayableByVoucherLazyQueryHookResult = ReturnType<typeof useGetAccountPayableByVoucherLazyQuery>;
export type GetAccountPayableByVoucherQueryResult = Apollo.QueryResult<GetAccountPayableByVoucherQuery, GetAccountPayableByVoucherQueryVariables>;
export const FindPayableByCheckNumberDocument = gql`
    query FindPayableByCheckNumber($checkNumber: String!, $bankAccountId: String!) {
  findPayableByCheckNumber(
    checkNumber: $checkNumber
    bankAccountId: $bankAccountId
  ) {
    response {
      status
      message
    }
    accountPayableEntry {
      id
      voucherNo
    }
  }
}
    `;

/**
 * __useFindPayableByCheckNumberQuery__
 *
 * To run a query within a React component, call `useFindPayableByCheckNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPayableByCheckNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPayableByCheckNumberQuery({
 *   variables: {
 *      checkNumber: // value for 'checkNumber'
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useFindPayableByCheckNumberQuery(baseOptions: Apollo.QueryHookOptions<FindPayableByCheckNumberQuery, FindPayableByCheckNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPayableByCheckNumberQuery, FindPayableByCheckNumberQueryVariables>(FindPayableByCheckNumberDocument, options);
      }
export function useFindPayableByCheckNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPayableByCheckNumberQuery, FindPayableByCheckNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPayableByCheckNumberQuery, FindPayableByCheckNumberQueryVariables>(FindPayableByCheckNumberDocument, options);
        }
export type FindPayableByCheckNumberQueryHookResult = ReturnType<typeof useFindPayableByCheckNumberQuery>;
export type FindPayableByCheckNumberLazyQueryHookResult = ReturnType<typeof useFindPayableByCheckNumberLazyQuery>;
export type FindPayableByCheckNumberQueryResult = Apollo.QueryResult<FindPayableByCheckNumberQuery, FindPayableByCheckNumberQueryVariables>;
export const FetchAchOrEftNoOfEntryDocument = gql`
    query FetchAchOrEftNoOfEntry($method: String!) {
  fetchAchOrEftNoOfEntry(method: $method) {
    achOrEftNo
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAchOrEftNoOfEntryQuery__
 *
 * To run a query within a React component, call `useFetchAchOrEftNoOfEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAchOrEftNoOfEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAchOrEftNoOfEntryQuery({
 *   variables: {
 *      method: // value for 'method'
 *   },
 * });
 */
export function useFetchAchOrEftNoOfEntryQuery(baseOptions: Apollo.QueryHookOptions<FetchAchOrEftNoOfEntryQuery, FetchAchOrEftNoOfEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAchOrEftNoOfEntryQuery, FetchAchOrEftNoOfEntryQueryVariables>(FetchAchOrEftNoOfEntryDocument, options);
      }
export function useFetchAchOrEftNoOfEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAchOrEftNoOfEntryQuery, FetchAchOrEftNoOfEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAchOrEftNoOfEntryQuery, FetchAchOrEftNoOfEntryQueryVariables>(FetchAchOrEftNoOfEntryDocument, options);
        }
export type FetchAchOrEftNoOfEntryQueryHookResult = ReturnType<typeof useFetchAchOrEftNoOfEntryQuery>;
export type FetchAchOrEftNoOfEntryLazyQueryHookResult = ReturnType<typeof useFetchAchOrEftNoOfEntryLazyQuery>;
export type FetchAchOrEftNoOfEntryQueryResult = Apollo.QueryResult<FetchAchOrEftNoOfEntryQuery, FetchAchOrEftNoOfEntryQueryVariables>;
export const UpdateAccountPayableDocument = gql`
    mutation UpdateAccountPayable($input: UpdatePayableEntryInput!) {
  updateAccountPayable(input: $input) {
    accountPayableEntry {
      id
    }
    response {
      message
      status
    }
  }
}
    `;
export type UpdateAccountPayableMutationFn = Apollo.MutationFunction<UpdateAccountPayableMutation, UpdateAccountPayableMutationVariables>;

/**
 * __useUpdateAccountPayableMutation__
 *
 * To run a mutation, you first call `useUpdateAccountPayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountPayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountPayableMutation, { data, loading, error }] = useUpdateAccountPayableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountPayableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountPayableMutation, UpdateAccountPayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountPayableMutation, UpdateAccountPayableMutationVariables>(UpdateAccountPayableDocument, options);
      }
export type UpdateAccountPayableMutationHookResult = ReturnType<typeof useUpdateAccountPayableMutation>;
export type UpdateAccountPayableMutationResult = Apollo.MutationResult<UpdateAccountPayableMutation>;
export type UpdateAccountPayableMutationOptions = Apollo.BaseMutationOptions<UpdateAccountPayableMutation, UpdateAccountPayableMutationVariables>;
export const PreviewCheckAssignmentsDocument = gql`
    query PreviewCheckAssignments($input: PreviewCheckAssignmentsInput!) {
  previewCheckAssignments(input: $input) {
    canPrint
    firstCheckNo
    lastCheckNo
    printableCount
    nextAvailableCheckNo
    suggestion
    rows {
      voucherNo
      vendorName
      amount
      paymentMethod
      status
      existingCheckNo
      checkNo
      printedAt
      issue
      issueMessage
      conflict {
        source
        voucherNo
        vendorName
        description
        amount
        date
        state
      }
    }
    response {
      message
      status
    }
  }
}
    `;

/**
 * __usePreviewCheckAssignmentsQuery__
 *
 * To run a query within a React component, call `usePreviewCheckAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCheckAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCheckAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewCheckAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<PreviewCheckAssignmentsQuery, PreviewCheckAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewCheckAssignmentsQuery, PreviewCheckAssignmentsQueryVariables>(PreviewCheckAssignmentsDocument, options);
      }
export function usePreviewCheckAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewCheckAssignmentsQuery, PreviewCheckAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewCheckAssignmentsQuery, PreviewCheckAssignmentsQueryVariables>(PreviewCheckAssignmentsDocument, options);
        }
export type PreviewCheckAssignmentsQueryHookResult = ReturnType<typeof usePreviewCheckAssignmentsQuery>;
export type PreviewCheckAssignmentsLazyQueryHookResult = ReturnType<typeof usePreviewCheckAssignmentsLazyQuery>;
export type PreviewCheckAssignmentsQueryResult = Apollo.QueryResult<PreviewCheckAssignmentsQuery, PreviewCheckAssignmentsQueryVariables>;
export const FetchAccountsReceivableDocument = gql`
    query FetchAccountsReceivable($input: FetchAccountsReceivableInput!) {
  fetchAccountsReceivable(input: $input) {
    arEntries {
      total
      paid
      balance
      bill {
        id
        issueDate
        dueDate
        discount
        status
        writtenOffPrincipal
        writtenOffInterest
        accessTokens {
          id
          amount
          writtenOffPrincipal
          writtenOffInterest
          client {
            id
          }
        }
      }
      case {
        id
        title
        caseNumber
        consultMatterNumber
        billing {
          splitBillEnabled
        }
      }
      caseExternalUserToExternalUserRoles {
        id
        splitBillShare
        caseRole
        externalUserToExternalUserRole {
          externalUser {
            id
            firstName
            lastName
            displayName
            email
          }
        }
      }
      paymentAllocations {
        id
        amount
        client {
          id
        }
      }
      paymentAllocations {
        id
        paymentDate
        amount
        balanceEffect
        client {
          id
        }
      }
      clientsInterest {
        clientId
        interestDue
        interestAccrued
      }
    }
    summary {
      totalARs
      totalInvoiced
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAccountsReceivableQuery__
 *
 * To run a query within a React component, call `useFetchAccountsReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountsReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountsReceivableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchAccountsReceivableQuery(baseOptions: Apollo.QueryHookOptions<FetchAccountsReceivableQuery, FetchAccountsReceivableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountsReceivableQuery, FetchAccountsReceivableQueryVariables>(FetchAccountsReceivableDocument, options);
      }
export function useFetchAccountsReceivableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountsReceivableQuery, FetchAccountsReceivableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountsReceivableQuery, FetchAccountsReceivableQueryVariables>(FetchAccountsReceivableDocument, options);
        }
export type FetchAccountsReceivableQueryHookResult = ReturnType<typeof useFetchAccountsReceivableQuery>;
export type FetchAccountsReceivableLazyQueryHookResult = ReturnType<typeof useFetchAccountsReceivableLazyQuery>;
export type FetchAccountsReceivableQueryResult = Apollo.QueryResult<FetchAccountsReceivableQuery, FetchAccountsReceivableQueryVariables>;
export const LoginDocument = gql`
    mutation login($loginUserInput: LoginUserInput!) {
  login(loginUser: $loginUserInput) {
    access_token
    mfaRequired
    mfaMethod
    mfaAvailableMethods
    mfaToken
    remainingLoginAttempts
    maxLoginAttempts
    roles {
      id
      role
      createdAt
      updatedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginUserInput: // value for 'loginUserInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const VerifyMfaOtpDocument = gql`
    mutation verifyMfaOtp($verifyMfaOtpInput: VerifyMfaOtpInput!) {
  verifyMfaOtp(verifyMfaOtp: $verifyMfaOtpInput) {
    access_token
    roles {
      id
      role
      createdAt
      updatedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type VerifyMfaOtpMutationFn = Apollo.MutationFunction<VerifyMfaOtpMutation, VerifyMfaOtpMutationVariables>;

/**
 * __useVerifyMfaOtpMutation__
 *
 * To run a mutation, you first call `useVerifyMfaOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMfaOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMfaOtpMutation, { data, loading, error }] = useVerifyMfaOtpMutation({
 *   variables: {
 *      verifyMfaOtpInput: // value for 'verifyMfaOtpInput'
 *   },
 * });
 */
export function useVerifyMfaOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyMfaOtpMutation, VerifyMfaOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyMfaOtpMutation, VerifyMfaOtpMutationVariables>(VerifyMfaOtpDocument, options);
      }
export type VerifyMfaOtpMutationHookResult = ReturnType<typeof useVerifyMfaOtpMutation>;
export type VerifyMfaOtpMutationResult = Apollo.MutationResult<VerifyMfaOtpMutation>;
export type VerifyMfaOtpMutationOptions = Apollo.BaseMutationOptions<VerifyMfaOtpMutation, VerifyMfaOtpMutationVariables>;
export const ResendMfaOtpDocument = gql`
    mutation resendMfaOtp($resendMfaOtpInput: ResendMfaOtpInput!) {
  resendMfaOtp(resendMfaOtp: $resendMfaOtpInput) {
    mfaToken
    response {
      status
      message
    }
  }
}
    `;
export type ResendMfaOtpMutationFn = Apollo.MutationFunction<ResendMfaOtpMutation, ResendMfaOtpMutationVariables>;

/**
 * __useResendMfaOtpMutation__
 *
 * To run a mutation, you first call `useResendMfaOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMfaOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMfaOtpMutation, { data, loading, error }] = useResendMfaOtpMutation({
 *   variables: {
 *      resendMfaOtpInput: // value for 'resendMfaOtpInput'
 *   },
 * });
 */
export function useResendMfaOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendMfaOtpMutation, ResendMfaOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMfaOtpMutation, ResendMfaOtpMutationVariables>(ResendMfaOtpDocument, options);
      }
export type ResendMfaOtpMutationHookResult = ReturnType<typeof useResendMfaOtpMutation>;
export type ResendMfaOtpMutationResult = Apollo.MutationResult<ResendMfaOtpMutation>;
export type ResendMfaOtpMutationOptions = Apollo.BaseMutationOptions<ResendMfaOtpMutation, ResendMfaOtpMutationVariables>;
export const SwitchMfaMethodDocument = gql`
    mutation switchMfaMethod($switchMfaMethodInput: SwitchMfaMethodInput!) {
  switchMfaMethod(switchMfaMethod: $switchMfaMethodInput) {
    mfaMethod
    mfaAvailableMethods
    mfaToken
    response {
      status
      message
    }
  }
}
    `;
export type SwitchMfaMethodMutationFn = Apollo.MutationFunction<SwitchMfaMethodMutation, SwitchMfaMethodMutationVariables>;

/**
 * __useSwitchMfaMethodMutation__
 *
 * To run a mutation, you first call `useSwitchMfaMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchMfaMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchMfaMethodMutation, { data, loading, error }] = useSwitchMfaMethodMutation({
 *   variables: {
 *      switchMfaMethodInput: // value for 'switchMfaMethodInput'
 *   },
 * });
 */
export function useSwitchMfaMethodMutation(baseOptions?: Apollo.MutationHookOptions<SwitchMfaMethodMutation, SwitchMfaMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchMfaMethodMutation, SwitchMfaMethodMutationVariables>(SwitchMfaMethodDocument, options);
      }
export type SwitchMfaMethodMutationHookResult = ReturnType<typeof useSwitchMfaMethodMutation>;
export type SwitchMfaMethodMutationResult = Apollo.MutationResult<SwitchMfaMethodMutation>;
export type SwitchMfaMethodMutationOptions = Apollo.BaseMutationOptions<SwitchMfaMethodMutation, SwitchMfaMethodMutationVariables>;
export const StartMfaAuthEnrollmentDocument = gql`
    mutation startMfaAuthEnrollment {
  startMfaAuthEnrollment {
    secret
    otpauthUrl
    response {
      status
      message
    }
  }
}
    `;
export type StartMfaAuthEnrollmentMutationFn = Apollo.MutationFunction<StartMfaAuthEnrollmentMutation, StartMfaAuthEnrollmentMutationVariables>;

/**
 * __useStartMfaAuthEnrollmentMutation__
 *
 * To run a mutation, you first call `useStartMfaAuthEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMfaAuthEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMfaAuthEnrollmentMutation, { data, loading, error }] = useStartMfaAuthEnrollmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartMfaAuthEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<StartMfaAuthEnrollmentMutation, StartMfaAuthEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMfaAuthEnrollmentMutation, StartMfaAuthEnrollmentMutationVariables>(StartMfaAuthEnrollmentDocument, options);
      }
export type StartMfaAuthEnrollmentMutationHookResult = ReturnType<typeof useStartMfaAuthEnrollmentMutation>;
export type StartMfaAuthEnrollmentMutationResult = Apollo.MutationResult<StartMfaAuthEnrollmentMutation>;
export type StartMfaAuthEnrollmentMutationOptions = Apollo.BaseMutationOptions<StartMfaAuthEnrollmentMutation, StartMfaAuthEnrollmentMutationVariables>;
export const ConfirmMfaAuthEnrollmentDocument = gql`
    mutation confirmMfaAuthEnrollment($confirmMfaAuthEnrollmentInput: ConfirmMfaAuthEnrollmentInput!) {
  confirmMfaAuthEnrollment(
    confirmMfaAuthEnrollment: $confirmMfaAuthEnrollmentInput
  ) {
    response {
      status
      message
    }
    user {
      id
      mfaEmailEnabled
      mfaAuthEnabled
    }
  }
}
    `;
export type ConfirmMfaAuthEnrollmentMutationFn = Apollo.MutationFunction<ConfirmMfaAuthEnrollmentMutation, ConfirmMfaAuthEnrollmentMutationVariables>;

/**
 * __useConfirmMfaAuthEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmMfaAuthEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMfaAuthEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMfaAuthEnrollmentMutation, { data, loading, error }] = useConfirmMfaAuthEnrollmentMutation({
 *   variables: {
 *      confirmMfaAuthEnrollmentInput: // value for 'confirmMfaAuthEnrollmentInput'
 *   },
 * });
 */
export function useConfirmMfaAuthEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMfaAuthEnrollmentMutation, ConfirmMfaAuthEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMfaAuthEnrollmentMutation, ConfirmMfaAuthEnrollmentMutationVariables>(ConfirmMfaAuthEnrollmentDocument, options);
      }
export type ConfirmMfaAuthEnrollmentMutationHookResult = ReturnType<typeof useConfirmMfaAuthEnrollmentMutation>;
export type ConfirmMfaAuthEnrollmentMutationResult = Apollo.MutationResult<ConfirmMfaAuthEnrollmentMutation>;
export type ConfirmMfaAuthEnrollmentMutationOptions = Apollo.BaseMutationOptions<ConfirmMfaAuthEnrollmentMutation, ConfirmMfaAuthEnrollmentMutationVariables>;
export const UpdateMfaSettingsDocument = gql`
    mutation updateMfaSettings($mfaSettingsInput: UpdateMfaSettingsInput!) {
  updateMfaSettings(mfaSettings: $mfaSettingsInput) {
    response {
      status
      message
    }
    user {
      id
      mfaEmailEnabled
      mfaAuthEnabled
    }
  }
}
    `;
export type UpdateMfaSettingsMutationFn = Apollo.MutationFunction<UpdateMfaSettingsMutation, UpdateMfaSettingsMutationVariables>;

/**
 * __useUpdateMfaSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateMfaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMfaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMfaSettingsMutation, { data, loading, error }] = useUpdateMfaSettingsMutation({
 *   variables: {
 *      mfaSettingsInput: // value for 'mfaSettingsInput'
 *   },
 * });
 */
export function useUpdateMfaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMfaSettingsMutation, UpdateMfaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMfaSettingsMutation, UpdateMfaSettingsMutationVariables>(UpdateMfaSettingsDocument, options);
      }
export type UpdateMfaSettingsMutationHookResult = ReturnType<typeof useUpdateMfaSettingsMutation>;
export type UpdateMfaSettingsMutationResult = Apollo.MutationResult<UpdateMfaSettingsMutation>;
export type UpdateMfaSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateMfaSettingsMutation, UpdateMfaSettingsMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($forgotPasswordInput: ForgotPasswordInput!) {
  forgotPassword(forgotPassword: $forgotPasswordInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      forgotPasswordInput: // value for 'forgotPasswordInput'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($resetPasswordInput: ResetPasswordInput!) {
  resetPassword(resetPassword: $resetPasswordInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetPasswordInput: // value for 'resetPasswordInput'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($changePasswordInput: ChangePasswordInput!) {
  changePassword(changePassword: $changePasswordInput) {
    response {
      status
      message
    }
    user {
      id
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      changePasswordInput: // value for 'changePasswordInput'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const VerifyEmailAndSetPasswordDocument = gql`
    mutation verifyEmailAndSetPassword($verifyUserAndUpdatePasswordInput: VerifyUserAndUpdatePasswordInput!) {
  verifyEmailAndSetPassword(
    verifyEmailAndSetPassword: $verifyUserAndUpdatePasswordInput
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type VerifyEmailAndSetPasswordMutationFn = Apollo.MutationFunction<VerifyEmailAndSetPasswordMutation, VerifyEmailAndSetPasswordMutationVariables>;

/**
 * __useVerifyEmailAndSetPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyEmailAndSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailAndSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailAndSetPasswordMutation, { data, loading, error }] = useVerifyEmailAndSetPasswordMutation({
 *   variables: {
 *      verifyUserAndUpdatePasswordInput: // value for 'verifyUserAndUpdatePasswordInput'
 *   },
 * });
 */
export function useVerifyEmailAndSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailAndSetPasswordMutation, VerifyEmailAndSetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailAndSetPasswordMutation, VerifyEmailAndSetPasswordMutationVariables>(VerifyEmailAndSetPasswordDocument, options);
      }
export type VerifyEmailAndSetPasswordMutationHookResult = ReturnType<typeof useVerifyEmailAndSetPasswordMutation>;
export type VerifyEmailAndSetPasswordMutationResult = Apollo.MutationResult<VerifyEmailAndSetPasswordMutation>;
export type VerifyEmailAndSetPasswordMutationOptions = Apollo.BaseMutationOptions<VerifyEmailAndSetPasswordMutation, VerifyEmailAndSetPasswordMutationVariables>;
export const LoggedInUserDocument = gql`
    query LoggedInUser {
  me {
    response {
      status
      message
    }
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      createdAt
      updatedAt
      phoneNumber
      initials
      hourlyRate
      mfaEmailEnabled
      mfaAuthEnabled
      supervisingUsers {
        id
        firstName
        lastName
        status
        emailVerified
        email
        hourlyRate
        phoneNumber
        createdAt
        updatedAt
        initials
        roles {
          id
          role
          createdAt
          updatedAt
        }
      }
      roles {
        id
        role
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        caseId
        userType
        createdAt
        updatedAt
        litigation {
          id
          advantageCode
          title
          description
          caseNumber
          status
          caseTypeId
          courtId
          createdAt
          updatedAt
        }
      }
      office {
        id
        name
        createdAt
        updatedAt
        isLocationOpen
      }
      deptToUsers {
        createdAt
        departmentId
        updatedAt
        userId
        department {
          departmentHeadId
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useLoggedInUserQuery__
 *
 * To run a query within a React component, call `useLoggedInUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedInUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedInUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedInUserQuery(baseOptions?: Apollo.QueryHookOptions<LoggedInUserQuery, LoggedInUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedInUserQuery, LoggedInUserQueryVariables>(LoggedInUserDocument, options);
      }
export function useLoggedInUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedInUserQuery, LoggedInUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedInUserQuery, LoggedInUserQueryVariables>(LoggedInUserDocument, options);
        }
export type LoggedInUserQueryHookResult = ReturnType<typeof useLoggedInUserQuery>;
export type LoggedInUserLazyQueryHookResult = ReturnType<typeof useLoggedInUserLazyQuery>;
export type LoggedInUserQueryResult = Apollo.QueryResult<LoggedInUserQuery, LoggedInUserQueryVariables>;
export const GetBillEmailBatchesDocument = gql`
    query GetBillEmailBatches {
  getBillEmailBatches {
    batches {
      id
      billingCycle
      periodYear
      periodMonth
      status
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetBillEmailBatchesQuery__
 *
 * To run a query within a React component, call `useGetBillEmailBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillEmailBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillEmailBatchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillEmailBatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetBillEmailBatchesQuery, GetBillEmailBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillEmailBatchesQuery, GetBillEmailBatchesQueryVariables>(GetBillEmailBatchesDocument, options);
      }
export function useGetBillEmailBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillEmailBatchesQuery, GetBillEmailBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillEmailBatchesQuery, GetBillEmailBatchesQueryVariables>(GetBillEmailBatchesDocument, options);
        }
export type GetBillEmailBatchesQueryHookResult = ReturnType<typeof useGetBillEmailBatchesQuery>;
export type GetBillEmailBatchesLazyQueryHookResult = ReturnType<typeof useGetBillEmailBatchesLazyQuery>;
export type GetBillEmailBatchesQueryResult = Apollo.QueryResult<GetBillEmailBatchesQuery, GetBillEmailBatchesQueryVariables>;
export const GetBillEmailBatchDocument = gql`
    query GetBillEmailBatch($input: GetBatchInput!) {
  getBillEmailBatch(input: $input) {
    batch {
      id
      billingCycle
      periodYear
      periodMonth
      status
      createdAt
      updatedAt
      items {
        id
        type
        recipientEmail
        recipientName
        status
        sendGridMessageId
        errorMessage
        sentAt
        createdAt
        bill {
          id
          status
          dueDate
          case {
            id
            caseNumber
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBillEmailBatchQuery__
 *
 * To run a query within a React component, call `useGetBillEmailBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillEmailBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillEmailBatchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBillEmailBatchQuery(baseOptions: Apollo.QueryHookOptions<GetBillEmailBatchQuery, GetBillEmailBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillEmailBatchQuery, GetBillEmailBatchQueryVariables>(GetBillEmailBatchDocument, options);
      }
export function useGetBillEmailBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillEmailBatchQuery, GetBillEmailBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillEmailBatchQuery, GetBillEmailBatchQueryVariables>(GetBillEmailBatchDocument, options);
        }
export type GetBillEmailBatchQueryHookResult = ReturnType<typeof useGetBillEmailBatchQuery>;
export type GetBillEmailBatchLazyQueryHookResult = ReturnType<typeof useGetBillEmailBatchLazyQuery>;
export type GetBillEmailBatchQueryResult = Apollo.QueryResult<GetBillEmailBatchQuery, GetBillEmailBatchQueryVariables>;
export const TriggerBillEmailBatchDocument = gql`
    mutation TriggerBillEmailBatch($input: TriggerBatchInput!) {
  triggerBillEmailBatch(input: $input) {
    batch {
      id
      status
    }
  }
}
    `;
export type TriggerBillEmailBatchMutationFn = Apollo.MutationFunction<TriggerBillEmailBatchMutation, TriggerBillEmailBatchMutationVariables>;

/**
 * __useTriggerBillEmailBatchMutation__
 *
 * To run a mutation, you first call `useTriggerBillEmailBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBillEmailBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBillEmailBatchMutation, { data, loading, error }] = useTriggerBillEmailBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerBillEmailBatchMutation(baseOptions?: Apollo.MutationHookOptions<TriggerBillEmailBatchMutation, TriggerBillEmailBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerBillEmailBatchMutation, TriggerBillEmailBatchMutationVariables>(TriggerBillEmailBatchDocument, options);
      }
export type TriggerBillEmailBatchMutationHookResult = ReturnType<typeof useTriggerBillEmailBatchMutation>;
export type TriggerBillEmailBatchMutationResult = Apollo.MutationResult<TriggerBillEmailBatchMutation>;
export type TriggerBillEmailBatchMutationOptions = Apollo.BaseMutationOptions<TriggerBillEmailBatchMutation, TriggerBillEmailBatchMutationVariables>;
export const RetryBillEmailBatchItemDocument = gql`
    mutation RetryBillEmailBatchItem($input: RetryBatchItemInput!) {
  retryBillEmailBatchItem(input: $input) {
    item {
      id
      status
    }
  }
}
    `;
export type RetryBillEmailBatchItemMutationFn = Apollo.MutationFunction<RetryBillEmailBatchItemMutation, RetryBillEmailBatchItemMutationVariables>;

/**
 * __useRetryBillEmailBatchItemMutation__
 *
 * To run a mutation, you first call `useRetryBillEmailBatchItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryBillEmailBatchItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryBillEmailBatchItemMutation, { data, loading, error }] = useRetryBillEmailBatchItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryBillEmailBatchItemMutation(baseOptions?: Apollo.MutationHookOptions<RetryBillEmailBatchItemMutation, RetryBillEmailBatchItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryBillEmailBatchItemMutation, RetryBillEmailBatchItemMutationVariables>(RetryBillEmailBatchItemDocument, options);
      }
export type RetryBillEmailBatchItemMutationHookResult = ReturnType<typeof useRetryBillEmailBatchItemMutation>;
export type RetryBillEmailBatchItemMutationResult = Apollo.MutationResult<RetryBillEmailBatchItemMutation>;
export type RetryBillEmailBatchItemMutationOptions = Apollo.BaseMutationOptions<RetryBillEmailBatchItemMutation, RetryBillEmailBatchItemMutationVariables>;
export const ToggleBillEmailBatchItemExclusionDocument = gql`
    mutation ToggleBillEmailBatchItemExclusion($input: ToggleBatchItemExclusionInput!) {
  toggleBillEmailBatchItemExclusion(input: $input) {
    item {
      id
      status
    }
  }
}
    `;
export type ToggleBillEmailBatchItemExclusionMutationFn = Apollo.MutationFunction<ToggleBillEmailBatchItemExclusionMutation, ToggleBillEmailBatchItemExclusionMutationVariables>;

/**
 * __useToggleBillEmailBatchItemExclusionMutation__
 *
 * To run a mutation, you first call `useToggleBillEmailBatchItemExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBillEmailBatchItemExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBillEmailBatchItemExclusionMutation, { data, loading, error }] = useToggleBillEmailBatchItemExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleBillEmailBatchItemExclusionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleBillEmailBatchItemExclusionMutation, ToggleBillEmailBatchItemExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleBillEmailBatchItemExclusionMutation, ToggleBillEmailBatchItemExclusionMutationVariables>(ToggleBillEmailBatchItemExclusionDocument, options);
      }
export type ToggleBillEmailBatchItemExclusionMutationHookResult = ReturnType<typeof useToggleBillEmailBatchItemExclusionMutation>;
export type ToggleBillEmailBatchItemExclusionMutationResult = Apollo.MutationResult<ToggleBillEmailBatchItemExclusionMutation>;
export type ToggleBillEmailBatchItemExclusionMutationOptions = Apollo.BaseMutationOptions<ToggleBillEmailBatchItemExclusionMutation, ToggleBillEmailBatchItemExclusionMutationVariables>;
export const FetchPreBillsDocument = gql`
    query FetchPreBills($fetchPreBillsInput: FetchPreBillsInput!) {
  fetchPreBills(fetchPreBillsInput: $fetchPreBillsInput) {
    response {
      status
      message
    }
    preBills {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      description
      payOffAmount
      attorneyApprovedAt
      departmentApprovedAt
      lastSentAt
      isDepartmentHead
      trustBalance
      creditBalance
      outstandingBalance
      sendToClient
      case {
        id
        caseNumber
        consultMatterNumber
        title
        advCaseNumber
        billing {
          billingType
          billApprover {
            id
            firstName
            lastName
          }
        }
        caseToUsers {
          userType
          user {
            id
            firstName
            lastName
          }
        }
      }
      creator {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchPreBillsQuery__
 *
 * To run a query within a React component, call `useFetchPreBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreBillsQuery({
 *   variables: {
 *      fetchPreBillsInput: // value for 'fetchPreBillsInput'
 *   },
 * });
 */
export function useFetchPreBillsQuery(baseOptions: Apollo.QueryHookOptions<FetchPreBillsQuery, FetchPreBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPreBillsQuery, FetchPreBillsQueryVariables>(FetchPreBillsDocument, options);
      }
export function useFetchPreBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPreBillsQuery, FetchPreBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPreBillsQuery, FetchPreBillsQueryVariables>(FetchPreBillsDocument, options);
        }
export type FetchPreBillsQueryHookResult = ReturnType<typeof useFetchPreBillsQuery>;
export type FetchPreBillsLazyQueryHookResult = ReturnType<typeof useFetchPreBillsLazyQuery>;
export type FetchPreBillsQueryResult = Apollo.QueryResult<FetchPreBillsQuery, FetchPreBillsQueryVariables>;
export const FetchBillableCasesDocument = gql`
    query FetchBillableCases($fetchBillableCasesInput: FetchBillableCasesInput!) {
  fetchBillableCases(fetchBillableCasesInput: $fetchBillableCasesInput) {
    response {
      status
      message
    }
    cases {
      flatFee {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      hourly {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      contingencyHybrid {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      contingency {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      hybrid {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      proBono {
        caseId
        caseNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
      consult {
        caseId
        caseNumber
        consultMatterNumber
        title
        billingType
        totalUnbilledHours
        totalAmount
        discount
        discountPercentage
        payoffAmount
        entries {
          id
          amount
          type
        }
      }
    }
  }
}
    `;

/**
 * __useFetchBillableCasesQuery__
 *
 * To run a query within a React component, call `useFetchBillableCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillableCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillableCasesQuery({
 *   variables: {
 *      fetchBillableCasesInput: // value for 'fetchBillableCasesInput'
 *   },
 * });
 */
export function useFetchBillableCasesQuery(baseOptions: Apollo.QueryHookOptions<FetchBillableCasesQuery, FetchBillableCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillableCasesQuery, FetchBillableCasesQueryVariables>(FetchBillableCasesDocument, options);
      }
export function useFetchBillableCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillableCasesQuery, FetchBillableCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillableCasesQuery, FetchBillableCasesQueryVariables>(FetchBillableCasesDocument, options);
        }
export type FetchBillableCasesQueryHookResult = ReturnType<typeof useFetchBillableCasesQuery>;
export type FetchBillableCasesLazyQueryHookResult = ReturnType<typeof useFetchBillableCasesLazyQuery>;
export type FetchBillableCasesQueryResult = Apollo.QueryResult<FetchBillableCasesQuery, FetchBillableCasesQueryVariables>;
export const FetchBillDetailsDocument = gql`
    query FetchBillDetails($fetchBillDetailsInput: FetchBillDetailsInput!) {
  fetchBillDetails(fetchBillDetailsInput: $fetchBillDetailsInput) {
    response {
      status
      message
    }
    bill {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      writtenOffPrincipal
      writtenOffInterest
      description
      payOffAmount
      attorneyApprovedAt
      departmentApprovedAt
      lastSentAt
      discount
      discountPercentage
      sendToClient
      pdfSnapshotS3Key
      billCopies {
        generatedAt
        generatedBy
        generatedByName
        source
      }
      case {
        id
        caseNumber
        consultMatterNumber
        title
        description
        ccEmailBillsTo
        billing {
          splitBillEnabled
          skipDeptHeadApproval
          billApprover {
            id
            firstName
            lastName
          }
          retainerAccount {
            id
            name
          }
          billingType
          discountPercentage
          flatFee
          upfrontFlatFee
          monthlyFlatFee
          specialPayments {
            amount
            date
          }
          isFlatFeeHoursExhausted
        }
        caseToUsers {
          userType
          hourlyRate
          user {
            id
            firstName
            lastName
            roles {
              role
            }
          }
        }
        caseToExternalUserToExternalUserRole {
          caseRole
          splitBillShare
          billingAddress
          billingEmail
          billingPhoneNumber
          externalUserToExternalUserRole {
            externalUser {
              id
              firstName
              lastName
              displayName
              clientNumber
              addresses {
                id
                address1
                address2
                city
                state
                country
                zipCode
              }
            }
          }
          billDeliveryMethods
          isArchived
        }
      }
      creator {
        id
        firstName
        lastName
      }
      approvedByResponsibleAttorney {
        id
        firstName
        lastName
      }
      finalApprover {
        id
        firstName
        lastName
      }
      billItems {
        id
        amount
        entry {
          id
          amount
          qty
          unitPrice
          description
          date
          duration
          rate
          entryType
          billable
          showOnBill
          caseId
          creatorId
          isSystemGenerated
          sendNotesToMatterNotes
          category {
            id
            name
          }
          feeType {
            id
            feeType
            createdAt
            updatedAt
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
      billTimelines {
        id
        action
        description
        createdAt
        user {
          id
          firstName
          lastName
        }
        deliveryMetadata {
          content
          status
          mode
          details
        }
        metadata {
          amount
          email
          emails
          client
          clientRole
        }
      }
      accessTokens {
        id
        amount
        token
        writtenOffPrincipal
        writtenOffInterest
        client {
          id
          firstName
          lastName
          displayName
          email
          clientNumber
        }
        createdAt
        updatedAt
      }
      account {
        id
        name
        accountNo
      }
      paymentAllocations {
        id
        amount
        paymentDate
        type
        balanceEffect
        client {
          id
        }
        payment {
          id
          linkedPayment {
            id
          }
        }
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useFetchBillDetailsQuery__
 *
 * To run a query within a React component, call `useFetchBillDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillDetailsQuery({
 *   variables: {
 *      fetchBillDetailsInput: // value for 'fetchBillDetailsInput'
 *   },
 * });
 */
export function useFetchBillDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchBillDetailsQuery, FetchBillDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillDetailsQuery, FetchBillDetailsQueryVariables>(FetchBillDetailsDocument, options);
      }
export function useFetchBillDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillDetailsQuery, FetchBillDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillDetailsQuery, FetchBillDetailsQueryVariables>(FetchBillDetailsDocument, options);
        }
export type FetchBillDetailsQueryHookResult = ReturnType<typeof useFetchBillDetailsQuery>;
export type FetchBillDetailsLazyQueryHookResult = ReturnType<typeof useFetchBillDetailsLazyQuery>;
export type FetchBillDetailsQueryResult = Apollo.QueryResult<FetchBillDetailsQuery, FetchBillDetailsQueryVariables>;
export const FetchBillDetailsByMatterDocument = gql`
    query FetchBillDetailsByMatter($fetchBillDetailsByMatterInput: FetchBillDetailsByMatterInput!) {
  fetchBillDetailsByMatter(
    fetchBillDetailsByMatterInput: $fetchBillDetailsByMatterInput
  ) {
    response {
      status
      message
    }
    bill {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      writtenOffPrincipal
      writtenOffInterest
      description
      payOffAmount
      attorneyApprovedAt
      departmentApprovedAt
      lastSentAt
      discount
      discountPercentage
      sendToClient
      pdfSnapshotS3Key
      billCopies {
        generatedAt
        generatedBy
        generatedByName
        source
      }
      case {
        id
        caseNumber
        consultMatterNumber
        title
        description
        ccEmailBillsTo
        billing {
          splitBillEnabled
          skipDeptHeadApproval
          billApprover {
            id
            firstName
            lastName
          }
          retainerAccount {
            id
            name
          }
          billingType
          discountPercentage
          flatFee
          upfrontFlatFee
          monthlyFlatFee
          specialPayments {
            amount
            date
          }
          isFlatFeeHoursExhausted
        }
        caseToUsers {
          userType
          hourlyRate
          user {
            id
            firstName
            lastName
            roles {
              role
            }
          }
        }
        caseToExternalUserToExternalUserRole {
          caseRole
          splitBillShare
          billingAddress
          billingEmail
          billingPhoneNumber
          externalUserToExternalUserRole {
            externalUser {
              id
              firstName
              lastName
              displayName
              clientNumber
              addresses {
                id
                address1
                address2
                city
                state
                country
                zipCode
              }
            }
          }
          billDeliveryMethods
          isArchived
        }
      }
      creator {
        id
        firstName
        lastName
      }
      approvedByResponsibleAttorney {
        id
        firstName
        lastName
      }
      finalApprover {
        id
        firstName
        lastName
      }
      billItems {
        id
        amount
        entry {
          id
          amount
          qty
          unitPrice
          description
          date
          duration
          rate
          entryType
          billable
          showOnBill
          caseId
          creatorId
          isSystemGenerated
          category {
            id
            name
          }
          feeType {
            id
            feeType
            createdAt
            updatedAt
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
      billTimelines {
        id
        action
        description
        createdAt
        user {
          id
          firstName
          lastName
        }
        deliveryMetadata {
          content
          status
          mode
          details
        }
        metadata {
          amount
          email
          emails
          client
          clientRole
        }
      }
      accessTokens {
        id
        amount
        token
        writtenOffPrincipal
        writtenOffInterest
        client {
          id
          firstName
          lastName
          displayName
          email
          clientNumber
        }
        createdAt
        updatedAt
      }
      account {
        id
        name
        accountNo
      }
      paymentAllocations {
        id
        amount
        paymentDate
        type
        balanceEffect
        client {
          id
        }
        payment {
          id
          linkedPayment {
            id
          }
        }
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useFetchBillDetailsByMatterQuery__
 *
 * To run a query within a React component, call `useFetchBillDetailsByMatterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillDetailsByMatterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillDetailsByMatterQuery({
 *   variables: {
 *      fetchBillDetailsByMatterInput: // value for 'fetchBillDetailsByMatterInput'
 *   },
 * });
 */
export function useFetchBillDetailsByMatterQuery(baseOptions: Apollo.QueryHookOptions<FetchBillDetailsByMatterQuery, FetchBillDetailsByMatterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillDetailsByMatterQuery, FetchBillDetailsByMatterQueryVariables>(FetchBillDetailsByMatterDocument, options);
      }
export function useFetchBillDetailsByMatterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillDetailsByMatterQuery, FetchBillDetailsByMatterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillDetailsByMatterQuery, FetchBillDetailsByMatterQueryVariables>(FetchBillDetailsByMatterDocument, options);
        }
export type FetchBillDetailsByMatterQueryHookResult = ReturnType<typeof useFetchBillDetailsByMatterQuery>;
export type FetchBillDetailsByMatterLazyQueryHookResult = ReturnType<typeof useFetchBillDetailsByMatterLazyQuery>;
export type FetchBillDetailsByMatterQueryResult = Apollo.QueryResult<FetchBillDetailsByMatterQuery, FetchBillDetailsByMatterQueryVariables>;
export const FetchFinalBillsDocument = gql`
    query FetchFinalBills($fetchFinalBillsInput: FetchFinalBillsInput!) {
  fetchFinalBills(fetchFinalBillsInput: $fetchFinalBillsInput) {
    response {
      status
      message
    }
    bills {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      description
      payOffAmount
      attorneyApprovedAt
      departmentApprovedAt
      writtenOffPrincipal
      writtenOffInterest
      lastSentAt
      sendToClient
      trustBalance
      creditBalance
      outstandingBalance
      pdfSnapshotS3Key
      billCopies {
        generatedAt
        generatedBy
        generatedByName
        source
      }
      case {
        id
        caseNumber
        consultMatterNumber
        title
        advCaseNumber
        billing {
          skipDeptHeadApproval
          billingType
          billApprover {
            id
            firstName
            lastName
          }
        }
        caseToUsers {
          userType
          user {
            id
            firstName
            lastName
          }
        }
      }
      creator {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchFinalBillsQuery__
 *
 * To run a query within a React component, call `useFetchFinalBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFinalBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFinalBillsQuery({
 *   variables: {
 *      fetchFinalBillsInput: // value for 'fetchFinalBillsInput'
 *   },
 * });
 */
export function useFetchFinalBillsQuery(baseOptions: Apollo.QueryHookOptions<FetchFinalBillsQuery, FetchFinalBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFinalBillsQuery, FetchFinalBillsQueryVariables>(FetchFinalBillsDocument, options);
      }
export function useFetchFinalBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFinalBillsQuery, FetchFinalBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFinalBillsQuery, FetchFinalBillsQueryVariables>(FetchFinalBillsDocument, options);
        }
export type FetchFinalBillsQueryHookResult = ReturnType<typeof useFetchFinalBillsQuery>;
export type FetchFinalBillsLazyQueryHookResult = ReturnType<typeof useFetchFinalBillsLazyQuery>;
export type FetchFinalBillsQueryResult = Apollo.QueryResult<FetchFinalBillsQuery, FetchFinalBillsQueryVariables>;
export const FetchPublicBillDetailsDocument = gql`
    query FetchPublicBillDetails($fetchPublicBillDetailsInput: FetchPublicBillDetailsInput!) {
  fetchPublicBillDetails(
    fetchPublicBillDetailsInput: $fetchPublicBillDetailsInput
  ) {
    bill {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      writtenOffPrincipal
      writtenOffInterest
      description
      payOffAmount
      discount
      discountPercentage
      case {
        id
        caseNumber
        consultMatterNumber
        title
        description
        billing {
          splitBillEnabled
          discountPercentage
          billApprover {
            id
            firstName
            lastName
          }
          billingType
          flatFee
          upfrontFlatFee
          monthlyFlatFee
          specialPayments {
            amount
            date
          }
          isFlatFeeHoursExhausted
        }
        caseToUsers {
          userType
          hourlyRate
          user {
            id
            firstName
            lastName
            roles {
              role
            }
          }
        }
        caseToExternalUserToExternalUserRole {
          caseRole
          splitBillShare
          billingAddress
          externalUserToExternalUserRole {
            externalUser {
              id
              firstName
              lastName
              displayName
              clientNumber
              addresses {
                id
                address1
                address2
                city
                state
                country
                zipCode
              }
            }
          }
        }
      }
      accessTokens {
        id
        amount
        token
        writtenOffPrincipal
        writtenOffInterest
        client {
          id
        }
      }
      approvedByResponsibleAttorney {
        id
        firstName
        lastName
      }
      finalApprover {
        id
        firstName
        lastName
      }
      billItems {
        id
        amount
        entry {
          id
          amount
          qty
          unitPrice
          description
          date
          duration
          rate
          entryType
          billable
          showOnBill
          caseId
          creatorId
          isSystemGenerated
          category {
            id
            name
          }
          feeType {
            id
            feeType
            createdAt
            updatedAt
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
      account {
        id
        name
        accountNo
      }
      paymentAllocations {
        id
        amount
        paymentDate
        type
        balanceEffect
        client {
          id
        }
        payment {
          id
          linkedPayment {
            id
          }
        }
      }
      createdAt
      updatedAt
    }
    client {
      id
      firstName
      lastName
      displayName
      email
      clientNumber
    }
    amountDue
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPublicBillDetailsQuery__
 *
 * To run a query within a React component, call `useFetchPublicBillDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPublicBillDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPublicBillDetailsQuery({
 *   variables: {
 *      fetchPublicBillDetailsInput: // value for 'fetchPublicBillDetailsInput'
 *   },
 * });
 */
export function useFetchPublicBillDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchPublicBillDetailsQuery, FetchPublicBillDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPublicBillDetailsQuery, FetchPublicBillDetailsQueryVariables>(FetchPublicBillDetailsDocument, options);
      }
export function useFetchPublicBillDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPublicBillDetailsQuery, FetchPublicBillDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPublicBillDetailsQuery, FetchPublicBillDetailsQueryVariables>(FetchPublicBillDetailsDocument, options);
        }
export type FetchPublicBillDetailsQueryHookResult = ReturnType<typeof useFetchPublicBillDetailsQuery>;
export type FetchPublicBillDetailsLazyQueryHookResult = ReturnType<typeof useFetchPublicBillDetailsLazyQuery>;
export type FetchPublicBillDetailsQueryResult = Apollo.QueryResult<FetchPublicBillDetailsQuery, FetchPublicBillDetailsQueryVariables>;
export const FetchRemainingFlatFeeDocument = gql`
    query FetchRemainingFlatFee($fetchRemainingFlatFeeInput: FetchRemainingFlatFeeInput!) {
  fetchRemainingFlatFee(fetchRemainingFlatFeeInput: $fetchRemainingFlatFeeInput) {
    response {
      status
      message
    }
    remainingFlatFee
  }
}
    `;

/**
 * __useFetchRemainingFlatFeeQuery__
 *
 * To run a query within a React component, call `useFetchRemainingFlatFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRemainingFlatFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRemainingFlatFeeQuery({
 *   variables: {
 *      fetchRemainingFlatFeeInput: // value for 'fetchRemainingFlatFeeInput'
 *   },
 * });
 */
export function useFetchRemainingFlatFeeQuery(baseOptions: Apollo.QueryHookOptions<FetchRemainingFlatFeeQuery, FetchRemainingFlatFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRemainingFlatFeeQuery, FetchRemainingFlatFeeQueryVariables>(FetchRemainingFlatFeeDocument, options);
      }
export function useFetchRemainingFlatFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRemainingFlatFeeQuery, FetchRemainingFlatFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRemainingFlatFeeQuery, FetchRemainingFlatFeeQueryVariables>(FetchRemainingFlatFeeDocument, options);
        }
export type FetchRemainingFlatFeeQueryHookResult = ReturnType<typeof useFetchRemainingFlatFeeQuery>;
export type FetchRemainingFlatFeeLazyQueryHookResult = ReturnType<typeof useFetchRemainingFlatFeeLazyQuery>;
export type FetchRemainingFlatFeeQueryResult = Apollo.QueryResult<FetchRemainingFlatFeeQuery, FetchRemainingFlatFeeQueryVariables>;
export const FetchQuickBillDetailsDocument = gql`
    query FetchQuickBillDetails($fetchQuickBillDetailsInput: FetchQuickBillDetailsInput!) {
  fetchQuickBillDetails(fetchQuickBillDetailsInput: $fetchQuickBillDetailsInput) {
    case {
      id
      caseNumber
      title
      description
      billing {
        billingType
        discountPercentage
        flatFee
        isFlatFeeHoursExhausted
      }
      caseToUsers {
        userType
        hourlyRate
        user {
          id
          firstName
          lastName
          roles {
            role
          }
        }
      }
    }
    entries {
      id
      amount
      qty
      unitPrice
      description
      date
      duration
      rate
      entryType
      billable
      showOnBill
      caseId
      creatorId
      isSystemGenerated
      sendNotesToMatterNotes
      category {
        id
        name
      }
      feeType {
        id
        feeType
        createdAt
        updatedAt
      }
      user {
        id
        firstName
        lastName
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchQuickBillDetailsQuery__
 *
 * To run a query within a React component, call `useFetchQuickBillDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuickBillDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuickBillDetailsQuery({
 *   variables: {
 *      fetchQuickBillDetailsInput: // value for 'fetchQuickBillDetailsInput'
 *   },
 * });
 */
export function useFetchQuickBillDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchQuickBillDetailsQuery, FetchQuickBillDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchQuickBillDetailsQuery, FetchQuickBillDetailsQueryVariables>(FetchQuickBillDetailsDocument, options);
      }
export function useFetchQuickBillDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchQuickBillDetailsQuery, FetchQuickBillDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchQuickBillDetailsQuery, FetchQuickBillDetailsQueryVariables>(FetchQuickBillDetailsDocument, options);
        }
export type FetchQuickBillDetailsQueryHookResult = ReturnType<typeof useFetchQuickBillDetailsQuery>;
export type FetchQuickBillDetailsLazyQueryHookResult = ReturnType<typeof useFetchQuickBillDetailsLazyQuery>;
export type FetchQuickBillDetailsQueryResult = Apollo.QueryResult<FetchQuickBillDetailsQuery, FetchQuickBillDetailsQueryVariables>;
export const FetchOutstandingBillsDocument = gql`
    query FetchOutstandingBills($fetchOutstandingBillsInput: FetchOutstandingBillsInput!) {
  fetchOutstandingBills(fetchOutstandingBillsInput: $fetchOutstandingBillsInput) {
    outstandingBills {
      billId
      dueDate
      clientId
      totalPayable
      principalBalance
      totalPaid
      interestDue
      totalDue
      totalWrittenOff
    }
    previousBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchOutstandingBillsQuery__
 *
 * To run a query within a React component, call `useFetchOutstandingBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOutstandingBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOutstandingBillsQuery({
 *   variables: {
 *      fetchOutstandingBillsInput: // value for 'fetchOutstandingBillsInput'
 *   },
 * });
 */
export function useFetchOutstandingBillsQuery(baseOptions: Apollo.QueryHookOptions<FetchOutstandingBillsQuery, FetchOutstandingBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOutstandingBillsQuery, FetchOutstandingBillsQueryVariables>(FetchOutstandingBillsDocument, options);
      }
export function useFetchOutstandingBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOutstandingBillsQuery, FetchOutstandingBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOutstandingBillsQuery, FetchOutstandingBillsQueryVariables>(FetchOutstandingBillsDocument, options);
        }
export type FetchOutstandingBillsQueryHookResult = ReturnType<typeof useFetchOutstandingBillsQuery>;
export type FetchOutstandingBillsLazyQueryHookResult = ReturnType<typeof useFetchOutstandingBillsLazyQuery>;
export type FetchOutstandingBillsQueryResult = Apollo.QueryResult<FetchOutstandingBillsQuery, FetchOutstandingBillsQueryVariables>;
export const FetchPublicOutstandingBillsDocument = gql`
    query FetchPublicOutstandingBills($fetchOutstandingBillsInput: FetchOutstandingBillsInput!) {
  fetchPublicOutstandingBills(
    fetchOutstandingBillsInput: $fetchOutstandingBillsInput
  ) {
    outstandingBills {
      billId
      dueDate
      clientId
      totalPayable
      principalBalance
      totalPaid
      interestDue
      totalDue
      totalWrittenOff
    }
    previousBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPublicOutstandingBillsQuery__
 *
 * To run a query within a React component, call `useFetchPublicOutstandingBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPublicOutstandingBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPublicOutstandingBillsQuery({
 *   variables: {
 *      fetchOutstandingBillsInput: // value for 'fetchOutstandingBillsInput'
 *   },
 * });
 */
export function useFetchPublicOutstandingBillsQuery(baseOptions: Apollo.QueryHookOptions<FetchPublicOutstandingBillsQuery, FetchPublicOutstandingBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPublicOutstandingBillsQuery, FetchPublicOutstandingBillsQueryVariables>(FetchPublicOutstandingBillsDocument, options);
      }
export function useFetchPublicOutstandingBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPublicOutstandingBillsQuery, FetchPublicOutstandingBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPublicOutstandingBillsQuery, FetchPublicOutstandingBillsQueryVariables>(FetchPublicOutstandingBillsDocument, options);
        }
export type FetchPublicOutstandingBillsQueryHookResult = ReturnType<typeof useFetchPublicOutstandingBillsQuery>;
export type FetchPublicOutstandingBillsLazyQueryHookResult = ReturnType<typeof useFetchPublicOutstandingBillsLazyQuery>;
export type FetchPublicOutstandingBillsQueryResult = Apollo.QueryResult<FetchPublicOutstandingBillsQuery, FetchPublicOutstandingBillsQueryVariables>;
export const SendBillToAttorneyDocument = gql`
    mutation SendBillToAttorney($sendBillToAttorneyInput: SendBillToAttorneyInput!) {
  sendBillToAttorney(sendBillToAttorneyInput: $sendBillToAttorneyInput) {
    response {
      status
      message
    }
    bill {
      id
      status
    }
  }
}
    `;
export type SendBillToAttorneyMutationFn = Apollo.MutationFunction<SendBillToAttorneyMutation, SendBillToAttorneyMutationVariables>;

/**
 * __useSendBillToAttorneyMutation__
 *
 * To run a mutation, you first call `useSendBillToAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBillToAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBillToAttorneyMutation, { data, loading, error }] = useSendBillToAttorneyMutation({
 *   variables: {
 *      sendBillToAttorneyInput: // value for 'sendBillToAttorneyInput'
 *   },
 * });
 */
export function useSendBillToAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<SendBillToAttorneyMutation, SendBillToAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBillToAttorneyMutation, SendBillToAttorneyMutationVariables>(SendBillToAttorneyDocument, options);
      }
export type SendBillToAttorneyMutationHookResult = ReturnType<typeof useSendBillToAttorneyMutation>;
export type SendBillToAttorneyMutationResult = Apollo.MutationResult<SendBillToAttorneyMutation>;
export type SendBillToAttorneyMutationOptions = Apollo.BaseMutationOptions<SendBillToAttorneyMutation, SendBillToAttorneyMutationVariables>;
export const VoidBillDocument = gql`
    mutation VoidBill($voidBillInput: VoidBillInput!) {
  voidBill(voidBillInput: $voidBillInput) {
    response {
      status
      message
    }
  }
}
    `;
export type VoidBillMutationFn = Apollo.MutationFunction<VoidBillMutation, VoidBillMutationVariables>;

/**
 * __useVoidBillMutation__
 *
 * To run a mutation, you first call `useVoidBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidBillMutation, { data, loading, error }] = useVoidBillMutation({
 *   variables: {
 *      voidBillInput: // value for 'voidBillInput'
 *   },
 * });
 */
export function useVoidBillMutation(baseOptions?: Apollo.MutationHookOptions<VoidBillMutation, VoidBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidBillMutation, VoidBillMutationVariables>(VoidBillDocument, options);
      }
export type VoidBillMutationHookResult = ReturnType<typeof useVoidBillMutation>;
export type VoidBillMutationResult = Apollo.MutationResult<VoidBillMutation>;
export type VoidBillMutationOptions = Apollo.BaseMutationOptions<VoidBillMutation, VoidBillMutationVariables>;
export const GeneratePreBillsDocument = gql`
    mutation GeneratePreBills($generatePreBillsInput: [GeneratePreBillInput!]!, $alsoSendForAttorneyApproval: Boolean) {
  generatePreBills(
    generatePreBillsInput: $generatePreBillsInput
    alsoSendForAttorneyApproval: $alsoSendForAttorneyApproval
  ) {
    response {
      status
      message
    }
    billIds
  }
}
    `;
export type GeneratePreBillsMutationFn = Apollo.MutationFunction<GeneratePreBillsMutation, GeneratePreBillsMutationVariables>;

/**
 * __useGeneratePreBillsMutation__
 *
 * To run a mutation, you first call `useGeneratePreBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePreBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePreBillsMutation, { data, loading, error }] = useGeneratePreBillsMutation({
 *   variables: {
 *      generatePreBillsInput: // value for 'generatePreBillsInput'
 *      alsoSendForAttorneyApproval: // value for 'alsoSendForAttorneyApproval'
 *   },
 * });
 */
export function useGeneratePreBillsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePreBillsMutation, GeneratePreBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePreBillsMutation, GeneratePreBillsMutationVariables>(GeneratePreBillsDocument, options);
      }
export type GeneratePreBillsMutationHookResult = ReturnType<typeof useGeneratePreBillsMutation>;
export type GeneratePreBillsMutationResult = Apollo.MutationResult<GeneratePreBillsMutation>;
export type GeneratePreBillsMutationOptions = Apollo.BaseMutationOptions<GeneratePreBillsMutation, GeneratePreBillsMutationVariables>;
export const GenerateInitialPaymentBillDocument = gql`
    mutation GenerateInitialPaymentBill($caseId: String!) {
  generateInitialPaymentBill(caseId: $caseId) {
    response {
      status
      message
    }
    billIds
  }
}
    `;
export type GenerateInitialPaymentBillMutationFn = Apollo.MutationFunction<GenerateInitialPaymentBillMutation, GenerateInitialPaymentBillMutationVariables>;

/**
 * __useGenerateInitialPaymentBillMutation__
 *
 * To run a mutation, you first call `useGenerateInitialPaymentBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInitialPaymentBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInitialPaymentBillMutation, { data, loading, error }] = useGenerateInitialPaymentBillMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGenerateInitialPaymentBillMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInitialPaymentBillMutation, GenerateInitialPaymentBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInitialPaymentBillMutation, GenerateInitialPaymentBillMutationVariables>(GenerateInitialPaymentBillDocument, options);
      }
export type GenerateInitialPaymentBillMutationHookResult = ReturnType<typeof useGenerateInitialPaymentBillMutation>;
export type GenerateInitialPaymentBillMutationResult = Apollo.MutationResult<GenerateInitialPaymentBillMutation>;
export type GenerateInitialPaymentBillMutationOptions = Apollo.BaseMutationOptions<GenerateInitialPaymentBillMutation, GenerateInitialPaymentBillMutationVariables>;
export const UpdateBillDocument = gql`
    mutation UpdateBill($updateBillRequestInput: UpdateBillRequestInput!) {
  updateBill(updateBillRequestInput: $updateBillRequestInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBillMutationFn = Apollo.MutationFunction<UpdateBillMutation, UpdateBillMutationVariables>;

/**
 * __useUpdateBillMutation__
 *
 * To run a mutation, you first call `useUpdateBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillMutation, { data, loading, error }] = useUpdateBillMutation({
 *   variables: {
 *      updateBillRequestInput: // value for 'updateBillRequestInput'
 *   },
 * });
 */
export function useUpdateBillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillMutation, UpdateBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillMutation, UpdateBillMutationVariables>(UpdateBillDocument, options);
      }
export type UpdateBillMutationHookResult = ReturnType<typeof useUpdateBillMutation>;
export type UpdateBillMutationResult = Apollo.MutationResult<UpdateBillMutation>;
export type UpdateBillMutationOptions = Apollo.BaseMutationOptions<UpdateBillMutation, UpdateBillMutationVariables>;
export const ApproveBillByAttorneyDocument = gql`
    mutation approveBillByAttorney($approveBillByAttorneyInput: ApproveBillByAttorneyInput!) {
  approveBillByAttorney(approveBillByAttorneyInput: $approveBillByAttorneyInput) {
    response {
      status
      message
    }
    bill {
      id
      status
    }
  }
}
    `;
export type ApproveBillByAttorneyMutationFn = Apollo.MutationFunction<ApproveBillByAttorneyMutation, ApproveBillByAttorneyMutationVariables>;

/**
 * __useApproveBillByAttorneyMutation__
 *
 * To run a mutation, you first call `useApproveBillByAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBillByAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBillByAttorneyMutation, { data, loading, error }] = useApproveBillByAttorneyMutation({
 *   variables: {
 *      approveBillByAttorneyInput: // value for 'approveBillByAttorneyInput'
 *   },
 * });
 */
export function useApproveBillByAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBillByAttorneyMutation, ApproveBillByAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBillByAttorneyMutation, ApproveBillByAttorneyMutationVariables>(ApproveBillByAttorneyDocument, options);
      }
export type ApproveBillByAttorneyMutationHookResult = ReturnType<typeof useApproveBillByAttorneyMutation>;
export type ApproveBillByAttorneyMutationResult = Apollo.MutationResult<ApproveBillByAttorneyMutation>;
export type ApproveBillByAttorneyMutationOptions = Apollo.BaseMutationOptions<ApproveBillByAttorneyMutation, ApproveBillByAttorneyMutationVariables>;
export const ApproveBillByDepartmentHeadDocument = gql`
    mutation approveBillByDepartmentHead($approveBillByDepartmentHeadInput: ApproveBillByDepartmentHeadInput!) {
  approveBillByDepartmentHead(
    approveBillByDepartmentHeadInput: $approveBillByDepartmentHeadInput
  ) {
    response {
      status
      message
    }
    bill {
      id
      status
    }
  }
}
    `;
export type ApproveBillByDepartmentHeadMutationFn = Apollo.MutationFunction<ApproveBillByDepartmentHeadMutation, ApproveBillByDepartmentHeadMutationVariables>;

/**
 * __useApproveBillByDepartmentHeadMutation__
 *
 * To run a mutation, you first call `useApproveBillByDepartmentHeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBillByDepartmentHeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBillByDepartmentHeadMutation, { data, loading, error }] = useApproveBillByDepartmentHeadMutation({
 *   variables: {
 *      approveBillByDepartmentHeadInput: // value for 'approveBillByDepartmentHeadInput'
 *   },
 * });
 */
export function useApproveBillByDepartmentHeadMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBillByDepartmentHeadMutation, ApproveBillByDepartmentHeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBillByDepartmentHeadMutation, ApproveBillByDepartmentHeadMutationVariables>(ApproveBillByDepartmentHeadDocument, options);
      }
export type ApproveBillByDepartmentHeadMutationHookResult = ReturnType<typeof useApproveBillByDepartmentHeadMutation>;
export type ApproveBillByDepartmentHeadMutationResult = Apollo.MutationResult<ApproveBillByDepartmentHeadMutation>;
export type ApproveBillByDepartmentHeadMutationOptions = Apollo.BaseMutationOptions<ApproveBillByDepartmentHeadMutation, ApproveBillByDepartmentHeadMutationVariables>;
export const ArchiveBillDocument = gql`
    mutation ArchiveBill($archiveBillInput: ArchiveBillInput!) {
  archiveBill(archiveBillInput: $archiveBillInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ArchiveBillMutationFn = Apollo.MutationFunction<ArchiveBillMutation, ArchiveBillMutationVariables>;

/**
 * __useArchiveBillMutation__
 *
 * To run a mutation, you first call `useArchiveBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBillMutation, { data, loading, error }] = useArchiveBillMutation({
 *   variables: {
 *      archiveBillInput: // value for 'archiveBillInput'
 *   },
 * });
 */
export function useArchiveBillMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBillMutation, ArchiveBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBillMutation, ArchiveBillMutationVariables>(ArchiveBillDocument, options);
      }
export type ArchiveBillMutationHookResult = ReturnType<typeof useArchiveBillMutation>;
export type ArchiveBillMutationResult = Apollo.MutationResult<ArchiveBillMutation>;
export type ArchiveBillMutationOptions = Apollo.BaseMutationOptions<ArchiveBillMutation, ArchiveBillMutationVariables>;
export const SendBillToClientDocument = gql`
    mutation SendBillToClient($sendBillToClientInput: SendBillToClientInput!) {
  sendBillToClient(sendBillToClientInput: $sendBillToClientInput) {
    response {
      status
      message
    }
    bill {
      id
      status
      dueDate
      lastSentAt
    }
  }
}
    `;
export type SendBillToClientMutationFn = Apollo.MutationFunction<SendBillToClientMutation, SendBillToClientMutationVariables>;

/**
 * __useSendBillToClientMutation__
 *
 * To run a mutation, you first call `useSendBillToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBillToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBillToClientMutation, { data, loading, error }] = useSendBillToClientMutation({
 *   variables: {
 *      sendBillToClientInput: // value for 'sendBillToClientInput'
 *   },
 * });
 */
export function useSendBillToClientMutation(baseOptions?: Apollo.MutationHookOptions<SendBillToClientMutation, SendBillToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBillToClientMutation, SendBillToClientMutationVariables>(SendBillToClientDocument, options);
      }
export type SendBillToClientMutationHookResult = ReturnType<typeof useSendBillToClientMutation>;
export type SendBillToClientMutationResult = Apollo.MutationResult<SendBillToClientMutation>;
export type SendBillToClientMutationOptions = Apollo.BaseMutationOptions<SendBillToClientMutation, SendBillToClientMutationVariables>;
export const RecordPaymentDocument = gql`
    mutation RecordPayment($recordPaymentInput: RecordPaymentInput!) {
  recordPayment(recordPaymentInput: $recordPaymentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type RecordPaymentMutationFn = Apollo.MutationFunction<RecordPaymentMutation, RecordPaymentMutationVariables>;

/**
 * __useRecordPaymentMutation__
 *
 * To run a mutation, you first call `useRecordPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPaymentMutation, { data, loading, error }] = useRecordPaymentMutation({
 *   variables: {
 *      recordPaymentInput: // value for 'recordPaymentInput'
 *   },
 * });
 */
export function useRecordPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordPaymentMutation, RecordPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPaymentMutation, RecordPaymentMutationVariables>(RecordPaymentDocument, options);
      }
export type RecordPaymentMutationHookResult = ReturnType<typeof useRecordPaymentMutation>;
export type RecordPaymentMutationResult = Apollo.MutationResult<RecordPaymentMutation>;
export type RecordPaymentMutationOptions = Apollo.BaseMutationOptions<RecordPaymentMutation, RecordPaymentMutationVariables>;
export const RecordManualPaymentDocument = gql`
    mutation RecordManualPayment($recordManualPaymentInput: RecordManualPaymentInput!) {
  recordManualPayment(recordManualPaymentInput: $recordManualPaymentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type RecordManualPaymentMutationFn = Apollo.MutationFunction<RecordManualPaymentMutation, RecordManualPaymentMutationVariables>;

/**
 * __useRecordManualPaymentMutation__
 *
 * To run a mutation, you first call `useRecordManualPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordManualPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordManualPaymentMutation, { data, loading, error }] = useRecordManualPaymentMutation({
 *   variables: {
 *      recordManualPaymentInput: // value for 'recordManualPaymentInput'
 *   },
 * });
 */
export function useRecordManualPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordManualPaymentMutation, RecordManualPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordManualPaymentMutation, RecordManualPaymentMutationVariables>(RecordManualPaymentDocument, options);
      }
export type RecordManualPaymentMutationHookResult = ReturnType<typeof useRecordManualPaymentMutation>;
export type RecordManualPaymentMutationResult = Apollo.MutationResult<RecordManualPaymentMutation>;
export type RecordManualPaymentMutationOptions = Apollo.BaseMutationOptions<RecordManualPaymentMutation, RecordManualPaymentMutationVariables>;
export const RecordClientCreditsDocument = gql`
    mutation RecordClientCredits($recordClientCreditsInput: RecordClientCreditsInput!) {
  recordClientCredits(recordClientCreditsInput: $recordClientCreditsInput) {
    paymentId
    response {
      status
      message
    }
  }
}
    `;
export type RecordClientCreditsMutationFn = Apollo.MutationFunction<RecordClientCreditsMutation, RecordClientCreditsMutationVariables>;

/**
 * __useRecordClientCreditsMutation__
 *
 * To run a mutation, you first call `useRecordClientCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordClientCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordClientCreditsMutation, { data, loading, error }] = useRecordClientCreditsMutation({
 *   variables: {
 *      recordClientCreditsInput: // value for 'recordClientCreditsInput'
 *   },
 * });
 */
export function useRecordClientCreditsMutation(baseOptions?: Apollo.MutationHookOptions<RecordClientCreditsMutation, RecordClientCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordClientCreditsMutation, RecordClientCreditsMutationVariables>(RecordClientCreditsDocument, options);
      }
export type RecordClientCreditsMutationHookResult = ReturnType<typeof useRecordClientCreditsMutation>;
export type RecordClientCreditsMutationResult = Apollo.MutationResult<RecordClientCreditsMutation>;
export type RecordClientCreditsMutationOptions = Apollo.BaseMutationOptions<RecordClientCreditsMutation, RecordClientCreditsMutationVariables>;
export const ApplyCreditsDocument = gql`
    mutation ApplyCredits($applyCreditsInput: ApplyCreditsInput!) {
  applyCredits(applyCreditsInput: $applyCreditsInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ApplyCreditsMutationFn = Apollo.MutationFunction<ApplyCreditsMutation, ApplyCreditsMutationVariables>;

/**
 * __useApplyCreditsMutation__
 *
 * To run a mutation, you first call `useApplyCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCreditsMutation, { data, loading, error }] = useApplyCreditsMutation({
 *   variables: {
 *      applyCreditsInput: // value for 'applyCreditsInput'
 *   },
 * });
 */
export function useApplyCreditsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCreditsMutation, ApplyCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCreditsMutation, ApplyCreditsMutationVariables>(ApplyCreditsDocument, options);
      }
export type ApplyCreditsMutationHookResult = ReturnType<typeof useApplyCreditsMutation>;
export type ApplyCreditsMutationResult = Apollo.MutationResult<ApplyCreditsMutation>;
export type ApplyCreditsMutationOptions = Apollo.BaseMutationOptions<ApplyCreditsMutation, ApplyCreditsMutationVariables>;
export const BillBulkActionsDocument = gql`
    mutation BillBulkActions($bulkInput: BillBulkInput!) {
  billBulkActions(bulkInput: $bulkInput) {
    results {
      success
      error
      billId
    }
    response {
      status
      message
    }
  }
}
    `;
export type BillBulkActionsMutationFn = Apollo.MutationFunction<BillBulkActionsMutation, BillBulkActionsMutationVariables>;

/**
 * __useBillBulkActionsMutation__
 *
 * To run a mutation, you first call `useBillBulkActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillBulkActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billBulkActionsMutation, { data, loading, error }] = useBillBulkActionsMutation({
 *   variables: {
 *      bulkInput: // value for 'bulkInput'
 *   },
 * });
 */
export function useBillBulkActionsMutation(baseOptions?: Apollo.MutationHookOptions<BillBulkActionsMutation, BillBulkActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillBulkActionsMutation, BillBulkActionsMutationVariables>(BillBulkActionsDocument, options);
      }
export type BillBulkActionsMutationHookResult = ReturnType<typeof useBillBulkActionsMutation>;
export type BillBulkActionsMutationResult = Apollo.MutationResult<BillBulkActionsMutation>;
export type BillBulkActionsMutationOptions = Apollo.BaseMutationOptions<BillBulkActionsMutation, BillBulkActionsMutationVariables>;
export const UpdateBillDueDateDocument = gql`
    mutation UpdateBillDueDate($updateBillDueDateInput: UpdateBillDueDateInput!) {
  updateBillDueDate(updateBillDueDateInput: $updateBillDueDateInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateBillDueDateMutationFn = Apollo.MutationFunction<UpdateBillDueDateMutation, UpdateBillDueDateMutationVariables>;

/**
 * __useUpdateBillDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateBillDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillDueDateMutation, { data, loading, error }] = useUpdateBillDueDateMutation({
 *   variables: {
 *      updateBillDueDateInput: // value for 'updateBillDueDateInput'
 *   },
 * });
 */
export function useUpdateBillDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillDueDateMutation, UpdateBillDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillDueDateMutation, UpdateBillDueDateMutationVariables>(UpdateBillDueDateDocument, options);
      }
export type UpdateBillDueDateMutationHookResult = ReturnType<typeof useUpdateBillDueDateMutation>;
export type UpdateBillDueDateMutationResult = Apollo.MutationResult<UpdateBillDueDateMutation>;
export type UpdateBillDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateBillDueDateMutation, UpdateBillDueDateMutationVariables>;
export const MarkBillsAsDeliveredDocument = gql`
    mutation MarkBillsAsDelivered($billIds: [Int!]!) {
  markBillsAsDelivered(billIds: $billIds) {
    markedBillIds
    skippedBillIds
    response {
      status
      message
    }
  }
}
    `;
export type MarkBillsAsDeliveredMutationFn = Apollo.MutationFunction<MarkBillsAsDeliveredMutation, MarkBillsAsDeliveredMutationVariables>;

/**
 * __useMarkBillsAsDeliveredMutation__
 *
 * To run a mutation, you first call `useMarkBillsAsDeliveredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkBillsAsDeliveredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markBillsAsDeliveredMutation, { data, loading, error }] = useMarkBillsAsDeliveredMutation({
 *   variables: {
 *      billIds: // value for 'billIds'
 *   },
 * });
 */
export function useMarkBillsAsDeliveredMutation(baseOptions?: Apollo.MutationHookOptions<MarkBillsAsDeliveredMutation, MarkBillsAsDeliveredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkBillsAsDeliveredMutation, MarkBillsAsDeliveredMutationVariables>(MarkBillsAsDeliveredDocument, options);
      }
export type MarkBillsAsDeliveredMutationHookResult = ReturnType<typeof useMarkBillsAsDeliveredMutation>;
export type MarkBillsAsDeliveredMutationResult = Apollo.MutationResult<MarkBillsAsDeliveredMutation>;
export type MarkBillsAsDeliveredMutationOptions = Apollo.BaseMutationOptions<MarkBillsAsDeliveredMutation, MarkBillsAsDeliveredMutationVariables>;
export const GeneratePreBillsForAllAttorneysDocument = gql`
    mutation GeneratePreBillsForAllAttorneys($generateAllPreBillsInput: GenerateAllPreBillsInput!) {
  generatePreBillsForAllAttorneys(
    generateAllPreBillsInput: $generateAllPreBillsInput
  ) {
    billIds
    response {
      status
      message
    }
  }
}
    `;
export type GeneratePreBillsForAllAttorneysMutationFn = Apollo.MutationFunction<GeneratePreBillsForAllAttorneysMutation, GeneratePreBillsForAllAttorneysMutationVariables>;

/**
 * __useGeneratePreBillsForAllAttorneysMutation__
 *
 * To run a mutation, you first call `useGeneratePreBillsForAllAttorneysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePreBillsForAllAttorneysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePreBillsForAllAttorneysMutation, { data, loading, error }] = useGeneratePreBillsForAllAttorneysMutation({
 *   variables: {
 *      generateAllPreBillsInput: // value for 'generateAllPreBillsInput'
 *   },
 * });
 */
export function useGeneratePreBillsForAllAttorneysMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePreBillsForAllAttorneysMutation, GeneratePreBillsForAllAttorneysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePreBillsForAllAttorneysMutation, GeneratePreBillsForAllAttorneysMutationVariables>(GeneratePreBillsForAllAttorneysDocument, options);
      }
export type GeneratePreBillsForAllAttorneysMutationHookResult = ReturnType<typeof useGeneratePreBillsForAllAttorneysMutation>;
export type GeneratePreBillsForAllAttorneysMutationResult = Apollo.MutationResult<GeneratePreBillsForAllAttorneysMutation>;
export type GeneratePreBillsForAllAttorneysMutationOptions = Apollo.BaseMutationOptions<GeneratePreBillsForAllAttorneysMutation, GeneratePreBillsForAllAttorneysMutationVariables>;
export const GenerateBillsForAttorneysDocument = gql`
    mutation GenerateBillsForAttorneys($generateBillsForAttorneysInput: GenerateBillsForAttorneysInput!) {
  generateBillsForAttorneys(
    generateBillsForAttorneysInput: $generateBillsForAttorneysInput
  ) {
    billIds
    response {
      status
      message
    }
  }
}
    `;
export type GenerateBillsForAttorneysMutationFn = Apollo.MutationFunction<GenerateBillsForAttorneysMutation, GenerateBillsForAttorneysMutationVariables>;

/**
 * __useGenerateBillsForAttorneysMutation__
 *
 * To run a mutation, you first call `useGenerateBillsForAttorneysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBillsForAttorneysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBillsForAttorneysMutation, { data, loading, error }] = useGenerateBillsForAttorneysMutation({
 *   variables: {
 *      generateBillsForAttorneysInput: // value for 'generateBillsForAttorneysInput'
 *   },
 * });
 */
export function useGenerateBillsForAttorneysMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBillsForAttorneysMutation, GenerateBillsForAttorneysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBillsForAttorneysMutation, GenerateBillsForAttorneysMutationVariables>(GenerateBillsForAttorneysDocument, options);
      }
export type GenerateBillsForAttorneysMutationHookResult = ReturnType<typeof useGenerateBillsForAttorneysMutation>;
export type GenerateBillsForAttorneysMutationResult = Apollo.MutationResult<GenerateBillsForAttorneysMutation>;
export type GenerateBillsForAttorneysMutationOptions = Apollo.BaseMutationOptions<GenerateBillsForAttorneysMutation, GenerateBillsForAttorneysMutationVariables>;
export const RefundPaymentDocument = gql`
    mutation RefundPayment($refundPaymentInput: RefundPaymentInput!) {
  refundPayment(refundPaymentInput: $refundPaymentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type RefundPaymentMutationFn = Apollo.MutationFunction<RefundPaymentMutation, RefundPaymentMutationVariables>;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      refundPaymentInput: // value for 'refundPaymentInput'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RefundPaymentMutation, RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<RefundPaymentMutation, RefundPaymentMutationVariables>;
export const ReversePaymentDocument = gql`
    mutation ReversePayment($reversePaymentInput: ReversePaymentInput!) {
  reversePayment(reversePaymentInput: $reversePaymentInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ReversePaymentMutationFn = Apollo.MutationFunction<ReversePaymentMutation, ReversePaymentMutationVariables>;

/**
 * __useReversePaymentMutation__
 *
 * To run a mutation, you first call `useReversePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReversePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reversePaymentMutation, { data, loading, error }] = useReversePaymentMutation({
 *   variables: {
 *      reversePaymentInput: // value for 'reversePaymentInput'
 *   },
 * });
 */
export function useReversePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReversePaymentMutation, ReversePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReversePaymentMutation, ReversePaymentMutationVariables>(ReversePaymentDocument, options);
      }
export type ReversePaymentMutationHookResult = ReturnType<typeof useReversePaymentMutation>;
export type ReversePaymentMutationResult = Apollo.MutationResult<ReversePaymentMutation>;
export type ReversePaymentMutationOptions = Apollo.BaseMutationOptions<ReversePaymentMutation, ReversePaymentMutationVariables>;
export const ReturnCheckPaymentDocument = gql`
    mutation ReturnCheckPayment($returnCheckInput: ReturnCheckInput!) {
  returnCheckPayment(returnCheckInput: $returnCheckInput) {
    response {
      status
      message
    }
  }
}
    `;
export type ReturnCheckPaymentMutationFn = Apollo.MutationFunction<ReturnCheckPaymentMutation, ReturnCheckPaymentMutationVariables>;

/**
 * __useReturnCheckPaymentMutation__
 *
 * To run a mutation, you first call `useReturnCheckPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnCheckPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnCheckPaymentMutation, { data, loading, error }] = useReturnCheckPaymentMutation({
 *   variables: {
 *      returnCheckInput: // value for 'returnCheckInput'
 *   },
 * });
 */
export function useReturnCheckPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReturnCheckPaymentMutation, ReturnCheckPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnCheckPaymentMutation, ReturnCheckPaymentMutationVariables>(ReturnCheckPaymentDocument, options);
      }
export type ReturnCheckPaymentMutationHookResult = ReturnType<typeof useReturnCheckPaymentMutation>;
export type ReturnCheckPaymentMutationResult = Apollo.MutationResult<ReturnCheckPaymentMutation>;
export type ReturnCheckPaymentMutationOptions = Apollo.BaseMutationOptions<ReturnCheckPaymentMutation, ReturnCheckPaymentMutationVariables>;
export const SendReminderToClientDocument = gql`
    mutation SendReminderToClient($sendReminderToClientInput: SendBillToClientInput!) {
  sendReminderToClient(sendReminderToClientInput: $sendReminderToClientInput) {
    response {
      message
      status
    }
  }
}
    `;
export type SendReminderToClientMutationFn = Apollo.MutationFunction<SendReminderToClientMutation, SendReminderToClientMutationVariables>;

/**
 * __useSendReminderToClientMutation__
 *
 * To run a mutation, you first call `useSendReminderToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReminderToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReminderToClientMutation, { data, loading, error }] = useSendReminderToClientMutation({
 *   variables: {
 *      sendReminderToClientInput: // value for 'sendReminderToClientInput'
 *   },
 * });
 */
export function useSendReminderToClientMutation(baseOptions?: Apollo.MutationHookOptions<SendReminderToClientMutation, SendReminderToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReminderToClientMutation, SendReminderToClientMutationVariables>(SendReminderToClientDocument, options);
      }
export type SendReminderToClientMutationHookResult = ReturnType<typeof useSendReminderToClientMutation>;
export type SendReminderToClientMutationResult = Apollo.MutationResult<SendReminderToClientMutation>;
export type SendReminderToClientMutationOptions = Apollo.BaseMutationOptions<SendReminderToClientMutation, SendReminderToClientMutationVariables>;
export const ResendBillToClientDocument = gql`
    mutation ResendBillToClient($resendBillToClient: ResendBillToClient!) {
  resendBillToClient(resendBillToClient: $resendBillToClient) {
    response {
      status
      message
    }
  }
}
    `;
export type ResendBillToClientMutationFn = Apollo.MutationFunction<ResendBillToClientMutation, ResendBillToClientMutationVariables>;

/**
 * __useResendBillToClientMutation__
 *
 * To run a mutation, you first call `useResendBillToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBillToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBillToClientMutation, { data, loading, error }] = useResendBillToClientMutation({
 *   variables: {
 *      resendBillToClient: // value for 'resendBillToClient'
 *   },
 * });
 */
export function useResendBillToClientMutation(baseOptions?: Apollo.MutationHookOptions<ResendBillToClientMutation, ResendBillToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBillToClientMutation, ResendBillToClientMutationVariables>(ResendBillToClientDocument, options);
      }
export type ResendBillToClientMutationHookResult = ReturnType<typeof useResendBillToClientMutation>;
export type ResendBillToClientMutationResult = Apollo.MutationResult<ResendBillToClientMutation>;
export type ResendBillToClientMutationOptions = Apollo.BaseMutationOptions<ResendBillToClientMutation, ResendBillToClientMutationVariables>;
export const GenerateQuickBillDocument = gql`
    mutation GenerateQuickBill($generateQuickBillInput: GenerateQuickBillInput!) {
  generateQuickBill(generateQuickBillInput: $generateQuickBillInput) {
    billId
    response {
      status
      message
    }
  }
}
    `;
export type GenerateQuickBillMutationFn = Apollo.MutationFunction<GenerateQuickBillMutation, GenerateQuickBillMutationVariables>;

/**
 * __useGenerateQuickBillMutation__
 *
 * To run a mutation, you first call `useGenerateQuickBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuickBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuickBillMutation, { data, loading, error }] = useGenerateQuickBillMutation({
 *   variables: {
 *      generateQuickBillInput: // value for 'generateQuickBillInput'
 *   },
 * });
 */
export function useGenerateQuickBillMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQuickBillMutation, GenerateQuickBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQuickBillMutation, GenerateQuickBillMutationVariables>(GenerateQuickBillDocument, options);
      }
export type GenerateQuickBillMutationHookResult = ReturnType<typeof useGenerateQuickBillMutation>;
export type GenerateQuickBillMutationResult = Apollo.MutationResult<GenerateQuickBillMutation>;
export type GenerateQuickBillMutationOptions = Apollo.BaseMutationOptions<GenerateQuickBillMutation, GenerateQuickBillMutationVariables>;
export const GenerateContingencyFinalBillDocument = gql`
    mutation GenerateContingencyFinalBill($generateContingencyFinalBillInput: ContingencyFinalBillInput!) {
  generateContingencyFinalBill(
    generateContingencyFinalBillInput: $generateContingencyFinalBillInput
  ) {
    billId
    response {
      status
      message
    }
  }
}
    `;
export type GenerateContingencyFinalBillMutationFn = Apollo.MutationFunction<GenerateContingencyFinalBillMutation, GenerateContingencyFinalBillMutationVariables>;

/**
 * __useGenerateContingencyFinalBillMutation__
 *
 * To run a mutation, you first call `useGenerateContingencyFinalBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateContingencyFinalBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateContingencyFinalBillMutation, { data, loading, error }] = useGenerateContingencyFinalBillMutation({
 *   variables: {
 *      generateContingencyFinalBillInput: // value for 'generateContingencyFinalBillInput'
 *   },
 * });
 */
export function useGenerateContingencyFinalBillMutation(baseOptions?: Apollo.MutationHookOptions<GenerateContingencyFinalBillMutation, GenerateContingencyFinalBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateContingencyFinalBillMutation, GenerateContingencyFinalBillMutationVariables>(GenerateContingencyFinalBillDocument, options);
      }
export type GenerateContingencyFinalBillMutationHookResult = ReturnType<typeof useGenerateContingencyFinalBillMutation>;
export type GenerateContingencyFinalBillMutationResult = Apollo.MutationResult<GenerateContingencyFinalBillMutation>;
export type GenerateContingencyFinalBillMutationOptions = Apollo.BaseMutationOptions<GenerateContingencyFinalBillMutation, GenerateContingencyFinalBillMutationVariables>;
export const GenerateConsultCaseBillDocument = gql`
    mutation GenerateConsultCaseBill($generateConsultCaseBillInput: ConsultCaseBillInput!) {
  generateConsultCaseBill(
    generateConsultCaseBillInput: $generateConsultCaseBillInput
  ) {
    billId
    response {
      status
      message
    }
  }
}
    `;
export type GenerateConsultCaseBillMutationFn = Apollo.MutationFunction<GenerateConsultCaseBillMutation, GenerateConsultCaseBillMutationVariables>;

/**
 * __useGenerateConsultCaseBillMutation__
 *
 * To run a mutation, you first call `useGenerateConsultCaseBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateConsultCaseBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateConsultCaseBillMutation, { data, loading, error }] = useGenerateConsultCaseBillMutation({
 *   variables: {
 *      generateConsultCaseBillInput: // value for 'generateConsultCaseBillInput'
 *   },
 * });
 */
export function useGenerateConsultCaseBillMutation(baseOptions?: Apollo.MutationHookOptions<GenerateConsultCaseBillMutation, GenerateConsultCaseBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateConsultCaseBillMutation, GenerateConsultCaseBillMutationVariables>(GenerateConsultCaseBillDocument, options);
      }
export type GenerateConsultCaseBillMutationHookResult = ReturnType<typeof useGenerateConsultCaseBillMutation>;
export type GenerateConsultCaseBillMutationResult = Apollo.MutationResult<GenerateConsultCaseBillMutation>;
export type GenerateConsultCaseBillMutationOptions = Apollo.BaseMutationOptions<GenerateConsultCaseBillMutation, GenerateConsultCaseBillMutationVariables>;
export const WriteOffBillsDocument = gql`
    mutation WriteOffBills($writeOffBillsInput: WriteOffBillsInput!) {
  writeOffBills(writeOffBillsInput: $writeOffBillsInput) {
    response {
      status
      message
    }
  }
}
    `;
export type WriteOffBillsMutationFn = Apollo.MutationFunction<WriteOffBillsMutation, WriteOffBillsMutationVariables>;

/**
 * __useWriteOffBillsMutation__
 *
 * To run a mutation, you first call `useWriteOffBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffBillsMutation, { data, loading, error }] = useWriteOffBillsMutation({
 *   variables: {
 *      writeOffBillsInput: // value for 'writeOffBillsInput'
 *   },
 * });
 */
export function useWriteOffBillsMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffBillsMutation, WriteOffBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffBillsMutation, WriteOffBillsMutationVariables>(WriteOffBillsDocument, options);
      }
export type WriteOffBillsMutationHookResult = ReturnType<typeof useWriteOffBillsMutation>;
export type WriteOffBillsMutationResult = Apollo.MutationResult<WriteOffBillsMutation>;
export type WriteOffBillsMutationOptions = Apollo.BaseMutationOptions<WriteOffBillsMutation, WriteOffBillsMutationVariables>;
export const DownloadBillSnapshotDocument = gql`
    query DownloadBillSnapshot($billId: Int!, $copyIndex: Int) {
  downloadBillSnapshot(billId: $billId, copyIndex: $copyIndex) {
    preSignedUrl
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useDownloadBillSnapshotQuery__
 *
 * To run a query within a React component, call `useDownloadBillSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBillSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadBillSnapshotQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *      copyIndex: // value for 'copyIndex'
 *   },
 * });
 */
export function useDownloadBillSnapshotQuery(baseOptions: Apollo.QueryHookOptions<DownloadBillSnapshotQuery, DownloadBillSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadBillSnapshotQuery, DownloadBillSnapshotQueryVariables>(DownloadBillSnapshotDocument, options);
      }
export function useDownloadBillSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadBillSnapshotQuery, DownloadBillSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadBillSnapshotQuery, DownloadBillSnapshotQueryVariables>(DownloadBillSnapshotDocument, options);
        }
export type DownloadBillSnapshotQueryHookResult = ReturnType<typeof useDownloadBillSnapshotQuery>;
export type DownloadBillSnapshotLazyQueryHookResult = ReturnType<typeof useDownloadBillSnapshotLazyQuery>;
export type DownloadBillSnapshotQueryResult = Apollo.QueryResult<DownloadBillSnapshotQuery, DownloadBillSnapshotQueryVariables>;
export const RegenerateBillClientCopyDocument = gql`
    mutation RegenerateBillClientCopy($billId: Int!) {
  regenerateBillClientCopy(billId: $billId) {
    preSignedUrl
    response {
      status
      message
    }
  }
}
    `;
export type RegenerateBillClientCopyMutationFn = Apollo.MutationFunction<RegenerateBillClientCopyMutation, RegenerateBillClientCopyMutationVariables>;

/**
 * __useRegenerateBillClientCopyMutation__
 *
 * To run a mutation, you first call `useRegenerateBillClientCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateBillClientCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateBillClientCopyMutation, { data, loading, error }] = useRegenerateBillClientCopyMutation({
 *   variables: {
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useRegenerateBillClientCopyMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateBillClientCopyMutation, RegenerateBillClientCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateBillClientCopyMutation, RegenerateBillClientCopyMutationVariables>(RegenerateBillClientCopyDocument, options);
      }
export type RegenerateBillClientCopyMutationHookResult = ReturnType<typeof useRegenerateBillClientCopyMutation>;
export type RegenerateBillClientCopyMutationResult = Apollo.MutationResult<RegenerateBillClientCopyMutation>;
export type RegenerateBillClientCopyMutationOptions = Apollo.BaseMutationOptions<RegenerateBillClientCopyMutation, RegenerateBillClientCopyMutationVariables>;
export const CreateCaseDocument = gql`
    mutation createCase($createCaseInput: CreateCaseInput!) {
  createCase(createCaseInput: $createCaseInput) {
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      createdAt
      updatedAt
      deletedAt
      caseTypeId
      courtId
    }
    response {
      status
      message
    }
  }
}
    `;
export type CreateCaseMutationFn = Apollo.MutationFunction<CreateCaseMutation, CreateCaseMutationVariables>;

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      createCaseInput: // value for 'createCaseInput'
 *   },
 * });
 */
export function useCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseMutation, CreateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseMutation, CreateCaseMutationVariables>(CreateCaseDocument, options);
      }
export type CreateCaseMutationHookResult = ReturnType<typeof useCreateCaseMutation>;
export type CreateCaseMutationResult = Apollo.MutationResult<CreateCaseMutation>;
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<CreateCaseMutation, CreateCaseMutationVariables>;
export const CreateCaseEventDocument = gql`
    mutation CreateCaseEvent($createCaseEventInput: CreateCaseEventInput!) {
  createCaseEvent(createCaseEventInput: $createCaseEventInput) {
    caseEvent {
      id
      eventType
      title
      hearingAt
      hearingEndsAt
      createdAt
      updatedAt
      outlookEventId
    }
    response {
      status
      message
    }
  }
}
    `;
export type CreateCaseEventMutationFn = Apollo.MutationFunction<CreateCaseEventMutation, CreateCaseEventMutationVariables>;

/**
 * __useCreateCaseEventMutation__
 *
 * To run a mutation, you first call `useCreateCaseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseEventMutation, { data, loading, error }] = useCreateCaseEventMutation({
 *   variables: {
 *      createCaseEventInput: // value for 'createCaseEventInput'
 *   },
 * });
 */
export function useCreateCaseEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseEventMutation, CreateCaseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseEventMutation, CreateCaseEventMutationVariables>(CreateCaseEventDocument, options);
      }
export type CreateCaseEventMutationHookResult = ReturnType<typeof useCreateCaseEventMutation>;
export type CreateCaseEventMutationResult = Apollo.MutationResult<CreateCaseEventMutation>;
export type CreateCaseEventMutationOptions = Apollo.BaseMutationOptions<CreateCaseEventMutation, CreateCaseEventMutationVariables>;
export const UpdateCaseDocument = gql`
    mutation UpdateCase($updateCaseInput: UpdateCaseInput!) {
  updateCase(updateCaseInput: $updateCaseInput) {
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      dueDate
      accidentDate
      createdAt
      caseTypeId
      updatedAt
      deletedAt
      caseTypeId
      docketNo
      courtId
      openDate
      closeDate
      completedDate
      isInternalMatter
      billing {
        id
        billingType
        flatFee
        retainerAmount
        billingCycle
        billingCycleCustomDate
        upfrontFlatFee
        monthlyFlatFee
        billEntireFlatFeeUpfront
        pauseBillingUntil
        contingencyShare
        contingencySettlementAmount
        billGenerationLimitEnabled
        billGenerationType
        billGenerationAmount
        billGenerationHours
        writeOffInterest
        increaseInterestRateOnFirstLatePayment
        splitBillEnabled
        discountAmount
        discountPercentage
        discountType
        consultationFee
        minimumFundsThreshold
        specialPayments {
          amount
          date
        }
        paymentPlanStartDate
        retainerAccount {
          id
          name
          active
          category
          sortCode
          isBankAccount
          creator {
            id
            firstName
            lastName
            email
            emailVerified
            status
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        billApprover {
          id
          firstName
          lastName
          status
          email
          emailVerified
          hourlyRate
          createdAt
          updatedAt
        }
        interestRates {
          rate
          applicableDays
        }
        createdAt
        updatedAt
      }
      setting {
        id
        flatFeeHoursNotificationThreshold
        sendFlatFeeHoursExhaustedNotification
      }
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      caseEvents {
        id
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        createdAt
        updatedAt
        splitBillShare
        billingAddress
        billingPhoneNumber
        billingEmail
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          createdAt
          updatedAt
          externalUser {
            id
            firstName
            lastName
            displayName
            ssn
            phoneNumber
            clientNumber
            createdAt
            updatedAt
            phoneNumberExtension
            addresses {
              address1
              address2
              city
              state
              country
              county
              zipCode
              id
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      }
      caseToUsers {
        id
        userId
        hourlyRate
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdateCaseMutationFn = Apollo.MutationFunction<UpdateCaseMutation, UpdateCaseMutationVariables>;

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      updateCaseInput: // value for 'updateCaseInput'
 *   },
 * });
 */
export function useUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMutation, UpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseMutation, UpdateCaseMutationVariables>(UpdateCaseDocument, options);
      }
export type UpdateCaseMutationHookResult = ReturnType<typeof useUpdateCaseMutation>;
export type UpdateCaseMutationResult = Apollo.MutationResult<UpdateCaseMutation>;
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMutation, UpdateCaseMutationVariables>;
export const FetchAllCaseTypesByLawIdDocument = gql`
    query FetchAllCaseTypesByLawId($caseTypesInput: CaseTypesInput!) {
  fetchAllCaseTypesByLawId(caseTypesInput: $caseTypesInput) {
    response {
      status
      message
    }
    caseTypes {
      id
      name
      lawTypeId
      createdAt
      updatedAt
      lawType {
        id
        name
        syncWithOutlook
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFetchAllCaseTypesByLawIdQuery__
 *
 * To run a query within a React component, call `useFetchAllCaseTypesByLawIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCaseTypesByLawIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCaseTypesByLawIdQuery({
 *   variables: {
 *      caseTypesInput: // value for 'caseTypesInput'
 *   },
 * });
 */
export function useFetchAllCaseTypesByLawIdQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCaseTypesByLawIdQuery, FetchAllCaseTypesByLawIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCaseTypesByLawIdQuery, FetchAllCaseTypesByLawIdQueryVariables>(FetchAllCaseTypesByLawIdDocument, options);
      }
export function useFetchAllCaseTypesByLawIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCaseTypesByLawIdQuery, FetchAllCaseTypesByLawIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCaseTypesByLawIdQuery, FetchAllCaseTypesByLawIdQueryVariables>(FetchAllCaseTypesByLawIdDocument, options);
        }
export type FetchAllCaseTypesByLawIdQueryHookResult = ReturnType<typeof useFetchAllCaseTypesByLawIdQuery>;
export type FetchAllCaseTypesByLawIdLazyQueryHookResult = ReturnType<typeof useFetchAllCaseTypesByLawIdLazyQuery>;
export type FetchAllCaseTypesByLawIdQueryResult = Apollo.QueryResult<FetchAllCaseTypesByLawIdQuery, FetchAllCaseTypesByLawIdQueryVariables>;
export const CreateExternalUserDocument = gql`
    mutation createExternalUser($createExternalUserInput: CreateExternalUser!) {
  createExternalUser(createExternalUserInput: $createExternalUserInput) {
    response {
      status
      message
    }
    externalUser {
      id
      firstName
      lastName
      displayName
      createdAt
      updatedAt
      clientNumber
      email
    }
  }
}
    `;
export type CreateExternalUserMutationFn = Apollo.MutationFunction<CreateExternalUserMutation, CreateExternalUserMutationVariables>;

/**
 * __useCreateExternalUserMutation__
 *
 * To run a mutation, you first call `useCreateExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalUserMutation, { data, loading, error }] = useCreateExternalUserMutation({
 *   variables: {
 *      createExternalUserInput: // value for 'createExternalUserInput'
 *   },
 * });
 */
export function useCreateExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalUserMutation, CreateExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalUserMutation, CreateExternalUserMutationVariables>(CreateExternalUserDocument, options);
      }
export type CreateExternalUserMutationHookResult = ReturnType<typeof useCreateExternalUserMutation>;
export type CreateExternalUserMutationResult = Apollo.MutationResult<CreateExternalUserMutation>;
export type CreateExternalUserMutationOptions = Apollo.BaseMutationOptions<CreateExternalUserMutation, CreateExternalUserMutationVariables>;
export const FetchAllExternalUserRolesDocument = gql`
    query fetchAllExternalUserRoles {
  fetchAllExternalUserRoles {
    externalUserRoles {
      id
      role
      createdAt
      updatedAt
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllExternalUserRolesQuery__
 *
 * To run a query within a React component, call `useFetchAllExternalUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllExternalUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllExternalUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllExternalUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllExternalUserRolesQuery, FetchAllExternalUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllExternalUserRolesQuery, FetchAllExternalUserRolesQueryVariables>(FetchAllExternalUserRolesDocument, options);
      }
export function useFetchAllExternalUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllExternalUserRolesQuery, FetchAllExternalUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllExternalUserRolesQuery, FetchAllExternalUserRolesQueryVariables>(FetchAllExternalUserRolesDocument, options);
        }
export type FetchAllExternalUserRolesQueryHookResult = ReturnType<typeof useFetchAllExternalUserRolesQuery>;
export type FetchAllExternalUserRolesLazyQueryHookResult = ReturnType<typeof useFetchAllExternalUserRolesLazyQuery>;
export type FetchAllExternalUserRolesQueryResult = Apollo.QueryResult<FetchAllExternalUserRolesQuery, FetchAllExternalUserRolesQueryVariables>;
export const FetchAllExternalUsersDocument = gql`
    query FetchAllExternalUsers($externalUsersInput: ExternalUsersInput!) {
  fetchAllExternalUsers(externalUsersInput: $externalUsersInput) {
    externalUsers {
      id
      firstName
      lastName
      displayName
      businessName
      createdAt
      updatedAt
      email
      phoneNumber
      phoneNumberExtension
      clientNumber
      phoneNumber
      contractBalance
      arrearsBalance
      residualBalance
      trustBalance
      lastPayDate
      lastPayAmount
      socialSecurityNumber
      driverLicenseNumber
      isInternational
      language
      courtToExternalUserToExternalUserRole {
        id
        courtId
        externalUserId
        isArchived
        createdAt
        updatedAt
        court {
          id
          name
          createdAt
          updatedAt
        }
      }
      addresses {
        id
        address1
        address2
        city
        state
        country
        county
        zipCode
        createdAt
        updatedAt
      }
      externalUserRoles {
        id
        externalUserId
        externalUserRoleId
        createdAt
        updatedAt
        externalUserRole {
          id
          role
          createdAt
          updatedAt
        }
        caseToExternalUserToExternalUserRole {
          id
          caseRole
          createdAt
          updatedAt
          isArchived
          isArchivedAt
          externalUserToExternalUserRoleId
          litigation {
            id
            advantageCode
            title
            description
            caseNumber
            consultMatterNumber
            status
            dueDate
            accidentDate
            caseTypeId
            courtId
            deletedAt
            createdAt
            updatedAt
            caseTypeId
            courtId
            isConsultMatter
          }
          litigationId
          externalUserToExternalUserRole {
            id
            createdAt
            externalUserId
            externalUserRoleId
            updatedAt
          }
        }
      }
      dateOfBirth
      initials
      middleName
      personalPhone
      suffix
      homePhone
    }
    response {
      status
      message
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchAllExternalUsersQuery__
 *
 * To run a query within a React component, call `useFetchAllExternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllExternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllExternalUsersQuery({
 *   variables: {
 *      externalUsersInput: // value for 'externalUsersInput'
 *   },
 * });
 */
export function useFetchAllExternalUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchAllExternalUsersQuery, FetchAllExternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllExternalUsersQuery, FetchAllExternalUsersQueryVariables>(FetchAllExternalUsersDocument, options);
      }
export function useFetchAllExternalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllExternalUsersQuery, FetchAllExternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllExternalUsersQuery, FetchAllExternalUsersQueryVariables>(FetchAllExternalUsersDocument, options);
        }
export type FetchAllExternalUsersQueryHookResult = ReturnType<typeof useFetchAllExternalUsersQuery>;
export type FetchAllExternalUsersLazyQueryHookResult = ReturnType<typeof useFetchAllExternalUsersLazyQuery>;
export type FetchAllExternalUsersQueryResult = Apollo.QueryResult<FetchAllExternalUsersQuery, FetchAllExternalUsersQueryVariables>;
export const DeleteExternalUserDocument = gql`
    mutation DeleteExternalUser($deleteExternalUser: DeleteExternalUser!) {
  deleteExternalUser(deleteExternalUser: $deleteExternalUser) {
    response {
      status
      message
    }
  }
}
    `;
export type DeleteExternalUserMutationFn = Apollo.MutationFunction<DeleteExternalUserMutation, DeleteExternalUserMutationVariables>;

/**
 * __useDeleteExternalUserMutation__
 *
 * To run a mutation, you first call `useDeleteExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalUserMutation, { data, loading, error }] = useDeleteExternalUserMutation({
 *   variables: {
 *      deleteExternalUser: // value for 'deleteExternalUser'
 *   },
 * });
 */
export function useDeleteExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalUserMutation, DeleteExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalUserMutation, DeleteExternalUserMutationVariables>(DeleteExternalUserDocument, options);
      }
export type DeleteExternalUserMutationHookResult = ReturnType<typeof useDeleteExternalUserMutation>;
export type DeleteExternalUserMutationResult = Apollo.MutationResult<DeleteExternalUserMutation>;
export type DeleteExternalUserMutationOptions = Apollo.BaseMutationOptions<DeleteExternalUserMutation, DeleteExternalUserMutationVariables>;
export const UpdateExternalUserAddressDocument = gql`
    mutation UpdateExternalUserAddress($updateExternalUserAddress: UpdateExternalUserAddress!) {
  updateExternalUserAddress(updateExternalUserAddress: $updateExternalUserAddress) {
    response {
      name
      error
    }
    externalUser {
      lastName
      firstName
      displayName
      isInternational
      addresses {
        address1
        address2
        city
        state
        country
        zipCode
        id
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type UpdateExternalUserAddressMutationFn = Apollo.MutationFunction<UpdateExternalUserAddressMutation, UpdateExternalUserAddressMutationVariables>;

/**
 * __useUpdateExternalUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateExternalUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalUserAddressMutation, { data, loading, error }] = useUpdateExternalUserAddressMutation({
 *   variables: {
 *      updateExternalUserAddress: // value for 'updateExternalUserAddress'
 *   },
 * });
 */
export function useUpdateExternalUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalUserAddressMutation, UpdateExternalUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalUserAddressMutation, UpdateExternalUserAddressMutationVariables>(UpdateExternalUserAddressDocument, options);
      }
export type UpdateExternalUserAddressMutationHookResult = ReturnType<typeof useUpdateExternalUserAddressMutation>;
export type UpdateExternalUserAddressMutationResult = Apollo.MutationResult<UpdateExternalUserAddressMutation>;
export type UpdateExternalUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateExternalUserAddressMutation, UpdateExternalUserAddressMutationVariables>;
export const CreateAddressDocument = gql`
    mutation createAddress($createAddressInput: CreateAddressForExtUserInput!) {
  createAddress(createAddressInput: $createAddressInput) {
    address {
      id
      address1
      address2
      city
      state
      country
      zipCode
      id
      createdAt
      updatedAt
      externalUser {
        id
        firstName
        lastName
        displayName
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type CreateAddressMutationFn = Apollo.MutationFunction<CreateAddressMutation, CreateAddressMutationVariables>;

/**
 * __useCreateAddressMutation__
 *
 * To run a mutation, you first call `useCreateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressMutation, { data, loading, error }] = useCreateAddressMutation({
 *   variables: {
 *      createAddressInput: // value for 'createAddressInput'
 *   },
 * });
 */
export function useCreateAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressMutation, CreateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressMutation, CreateAddressMutationVariables>(CreateAddressDocument, options);
      }
export type CreateAddressMutationHookResult = ReturnType<typeof useCreateAddressMutation>;
export type CreateAddressMutationResult = Apollo.MutationResult<CreateAddressMutation>;
export type CreateAddressMutationOptions = Apollo.BaseMutationOptions<CreateAddressMutation, CreateAddressMutationVariables>;
export const FetchCaseDocument = gql`
    query FetchCase($caseInput: CaseInput!) {
  fetchCase(caseInput: $caseInput) {
    case {
      id
      advantageCode
      title
      description
      caseNumber
      consultMatterNumber
      convertedToNormalMatter
      convertedToNormalMatterBy {
        id
        firstName
        lastName
        email
      }
      status
      dueDate
      courtId
      accidentDate
      caseTypeId
      createdAt
      updatedAt
      caseTypeId
      courtId
      docketNo
      openDate
      closeDate
      completedDate
      isConsultMatter
      isInternalMatter
      isDelinquent
      ccEmailBillsTo
      profitCenter {
        id
        name
      }
      location {
        id
        name
      }
      billing {
        id
        billingType
        flatFee
        retainerAmount
        billingCycle
        billingCycleCustomDate
        upfrontFlatFee
        monthlyFlatFee
        pauseBillingUntil
        billEntireFlatFeeUpfront
        contingencyShare
        contingencySettlementAmount
        billGenerationLimitEnabled
        billGenerationType
        billGenerationAmount
        billGenerationHours
        writeOffInterest
        increaseInterestRateOnFirstLatePayment
        splitBillEnabled
        discountAmount
        discountPercentage
        discountType
        consultationFee
        isFlatFeeHoursExhausted
        minimumFundsThreshold
        specialPayments {
          amount
          date
        }
        paymentPlanStartDate
        retainerAccount {
          id
          name
          active
          category
          sortCode
          isBankAccount
          creator {
            id
            firstName
            lastName
            email
            emailVerified
            status
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        billApprover {
          id
          firstName
          lastName
          status
          email
          emailVerified
          hourlyRate
          createdAt
          updatedAt
        }
        interestRates {
          rate
          applicableDays
        }
        createdAt
        updatedAt
        skipDeptHeadApproval
      }
      setting {
        id
        flatFeeHoursNotificationThreshold
        sendFlatFeeHoursExhaustedNotification
      }
      caseToUsers {
        id
        userId
        caseId
        userType
        createdAt
        updatedAt
      }
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          createdAt
          updatedAt
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
      }
      attachments {
        id
        title
        isLocked
        type
        typeId
        url
        createdAt
        updatedAt
      }
      caseEvents {
        id
        title
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        createdAt
        updatedAt
        caseRole
        splitBillShare
        trustBalance
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          createdAt
          updatedAt
          externalUser {
            id
            firstName
            middleName
            lastName
            displayName
            suffix
            email
            phoneNumber
            clientNumber
            phoneNumber
            contractBalance
            arrearsBalance
            residualBalance
            trustBalance
            lastPayDate
            lastPayAmount
            createdAt
            updatedAt
            addresses {
              id
              address1
              address2
              city
              state
              country
              county
              zipCode
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              createdAt
              updatedAt
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
            }
          }
        }
        billDeliveryMethods
        billingAddress
        billingPhoneNumber
        billingEmail
      }
      caseToUsers {
        id
        userId
        hourlyRate
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
        courtToExternalUserToExternalUserRole {
          id
          courtId
          externalUserId
          isArchived
          createdAt
          updatedAt
          externalUser {
            id
            firstName
            lastName
            displayName
            phoneNumber
            email
            createdAt
            updatedAt
          }
        }
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
      caseReferences {
        id
        percentage
        reference {
          id
          referral
          referralSourceId
          referralSource {
            id
            sourceType
          }
        }
      }
      bills {
        billTimelines {
          action
          metadata {
            client
            clientRole
            email
          }
          description
          createdAt
          deliveryMetadata {
            status
            mode
            details
            content
          }
        }
        id
        status
        issueDate
        amount
        amountPaid
        writtenOffPrincipal
        type
      }
      openedBy {
        id
        firstName
        lastName
        status
        emailVerified
        email
        createdAt
        updatedAt
        initials
        hourlyRate
      }
      consultAttorney {
        id
        firstName
        lastName
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCaseQuery__
 *
 * To run a query within a React component, call `useFetchCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseQuery({
 *   variables: {
 *      caseInput: // value for 'caseInput'
 *   },
 * });
 */
export function useFetchCaseQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseQuery, FetchCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseQuery, FetchCaseQueryVariables>(FetchCaseDocument, options);
      }
export function useFetchCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseQuery, FetchCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseQuery, FetchCaseQueryVariables>(FetchCaseDocument, options);
        }
export type FetchCaseQueryHookResult = ReturnType<typeof useFetchCaseQuery>;
export type FetchCaseLazyQueryHookResult = ReturnType<typeof useFetchCaseLazyQuery>;
export type FetchCaseQueryResult = Apollo.QueryResult<FetchCaseQuery, FetchCaseQueryVariables>;
export const FetchCaseBillingDocument = gql`
    query FetchCaseBilling($caseInput: CaseInput!) {
  fetchCase(caseInput: $caseInput) {
    case {
      id
      billing {
        id
        billingType
        isFlatFeeHoursExhausted
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCaseBillingQuery__
 *
 * To run a query within a React component, call `useFetchCaseBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseBillingQuery({
 *   variables: {
 *      caseInput: // value for 'caseInput'
 *   },
 * });
 */
export function useFetchCaseBillingQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseBillingQuery, FetchCaseBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseBillingQuery, FetchCaseBillingQueryVariables>(FetchCaseBillingDocument, options);
      }
export function useFetchCaseBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseBillingQuery, FetchCaseBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseBillingQuery, FetchCaseBillingQueryVariables>(FetchCaseBillingDocument, options);
        }
export type FetchCaseBillingQueryHookResult = ReturnType<typeof useFetchCaseBillingQuery>;
export type FetchCaseBillingLazyQueryHookResult = ReturnType<typeof useFetchCaseBillingLazyQuery>;
export type FetchCaseBillingQueryResult = Apollo.QueryResult<FetchCaseBillingQuery, FetchCaseBillingQueryVariables>;
export const AddUsersToCaseDocument = gql`
    mutation addUsersToCase($addUsersToCaseInput: AddUsersToCaseInput!) {
  addUsersToCase(addUsersToCaseInput: $addUsersToCaseInput) {
    response {
      status
      message
    }
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      dueDate
      accidentDate
      createdAt
      updatedAt
      caseTypeId
      courtId
      docketNo
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      caseEvents {
        id
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          externalUser {
            id
            firstName
            lastName
            displayName
            ssn
            phoneNumber
            ssn
            clientNumber
            addresses {
              address1
              address2
              city
              state
              country
              county
              zipCode
              id
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
    }
  }
}
    `;
export type AddUsersToCaseMutationFn = Apollo.MutationFunction<AddUsersToCaseMutation, AddUsersToCaseMutationVariables>;

/**
 * __useAddUsersToCaseMutation__
 *
 * To run a mutation, you first call `useAddUsersToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToCaseMutation, { data, loading, error }] = useAddUsersToCaseMutation({
 *   variables: {
 *      addUsersToCaseInput: // value for 'addUsersToCaseInput'
 *   },
 * });
 */
export function useAddUsersToCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToCaseMutation, AddUsersToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToCaseMutation, AddUsersToCaseMutationVariables>(AddUsersToCaseDocument, options);
      }
export type AddUsersToCaseMutationHookResult = ReturnType<typeof useAddUsersToCaseMutation>;
export type AddUsersToCaseMutationResult = Apollo.MutationResult<AddUsersToCaseMutation>;
export type AddUsersToCaseMutationOptions = Apollo.BaseMutationOptions<AddUsersToCaseMutation, AddUsersToCaseMutationVariables>;
export const UpdateCaseCaseTypeDocument = gql`
    mutation updateCaseCaseType($updateCaseCaseTypeInput: UpdateCaseCaseTypeInput!) {
  updateCaseCaseType(updateCaseCaseInput: $updateCaseCaseTypeInput) {
    response {
      status
      message
    }
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      dueDate
      accidentDate
      createdAt
      updatedAt
      caseTypeId
      courtId
      docketNo
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      caseEvents {
        id
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          externalUser {
            id
            firstName
            lastName
            displayName
            ssn
            phoneNumber
            ssn
            clientNumber
            addresses {
              address1
              address2
              city
              state
              country
              county
              zipCode
              id
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
    }
  }
}
    `;
export type UpdateCaseCaseTypeMutationFn = Apollo.MutationFunction<UpdateCaseCaseTypeMutation, UpdateCaseCaseTypeMutationVariables>;

/**
 * __useUpdateCaseCaseTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCaseCaseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseCaseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseCaseTypeMutation, { data, loading, error }] = useUpdateCaseCaseTypeMutation({
 *   variables: {
 *      updateCaseCaseTypeInput: // value for 'updateCaseCaseTypeInput'
 *   },
 * });
 */
export function useUpdateCaseCaseTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseCaseTypeMutation, UpdateCaseCaseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseCaseTypeMutation, UpdateCaseCaseTypeMutationVariables>(UpdateCaseCaseTypeDocument, options);
      }
export type UpdateCaseCaseTypeMutationHookResult = ReturnType<typeof useUpdateCaseCaseTypeMutation>;
export type UpdateCaseCaseTypeMutationResult = Apollo.MutationResult<UpdateCaseCaseTypeMutation>;
export type UpdateCaseCaseTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCaseCaseTypeMutation, UpdateCaseCaseTypeMutationVariables>;
export const RemoveAssigneeFromCaseDocument = gql`
    mutation removeAssigneeFromCase($removeAssigneeFromCaseInput: RemoveUsersFromCaseInput!) {
  removeAssigneeFromCase(
    removeAssigneeFromCaseInput: $removeAssigneeFromCaseInput
  ) {
    response {
      status
      message
    }
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      dueDate
      courtId
      accidentDate
      caseTypeId
      createdAt
      updatedAt
      caseTypeId
      courtId
      docketNo
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      caseEvents {
        id
        eventType
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          externalUser {
            id
            firstName
            lastName
            displayName
            ssn
            phoneNumber
            ssn
            clientNumber
            addresses {
              address1
              address2
              city
              state
              country
              county
              zipCode
              id
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
    }
  }
}
    `;
export type RemoveAssigneeFromCaseMutationFn = Apollo.MutationFunction<RemoveAssigneeFromCaseMutation, RemoveAssigneeFromCaseMutationVariables>;

/**
 * __useRemoveAssigneeFromCaseMutation__
 *
 * To run a mutation, you first call `useRemoveAssigneeFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssigneeFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssigneeFromCaseMutation, { data, loading, error }] = useRemoveAssigneeFromCaseMutation({
 *   variables: {
 *      removeAssigneeFromCaseInput: // value for 'removeAssigneeFromCaseInput'
 *   },
 * });
 */
export function useRemoveAssigneeFromCaseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssigneeFromCaseMutation, RemoveAssigneeFromCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssigneeFromCaseMutation, RemoveAssigneeFromCaseMutationVariables>(RemoveAssigneeFromCaseDocument, options);
      }
export type RemoveAssigneeFromCaseMutationHookResult = ReturnType<typeof useRemoveAssigneeFromCaseMutation>;
export type RemoveAssigneeFromCaseMutationResult = Apollo.MutationResult<RemoveAssigneeFromCaseMutation>;
export type RemoveAssigneeFromCaseMutationOptions = Apollo.BaseMutationOptions<RemoveAssigneeFromCaseMutation, RemoveAssigneeFromCaseMutationVariables>;
export const RemoveAttachmentDataDocument = gql`
    mutation removeAttachmentData($removeAttachment: RemoveAttachment!) {
  removeAttachmentData(removeAttachment: $removeAttachment) {
    response {
      status
      message
    }
    attachment {
      id
      isLocked
      type
      typeId
      createdAt
      updatedAt
    }
  }
}
    `;
export type RemoveAttachmentDataMutationFn = Apollo.MutationFunction<RemoveAttachmentDataMutation, RemoveAttachmentDataMutationVariables>;

/**
 * __useRemoveAttachmentDataMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentDataMutation, { data, loading, error }] = useRemoveAttachmentDataMutation({
 *   variables: {
 *      removeAttachment: // value for 'removeAttachment'
 *   },
 * });
 */
export function useRemoveAttachmentDataMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentDataMutation, RemoveAttachmentDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentDataMutation, RemoveAttachmentDataMutationVariables>(RemoveAttachmentDataDocument, options);
      }
export type RemoveAttachmentDataMutationHookResult = ReturnType<typeof useRemoveAttachmentDataMutation>;
export type RemoveAttachmentDataMutationResult = Apollo.MutationResult<RemoveAttachmentDataMutation>;
export type RemoveAttachmentDataMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentDataMutation, RemoveAttachmentDataMutationVariables>;
export const RemoveCasesMediaDocument = gql`
    mutation RemoveCasesMedia($removeAttachment: RemoveCasesMediaInput!) {
  removeCasesMedia(removeAttachment: $removeAttachment)
}
    `;
export type RemoveCasesMediaMutationFn = Apollo.MutationFunction<RemoveCasesMediaMutation, RemoveCasesMediaMutationVariables>;

/**
 * __useRemoveCasesMediaMutation__
 *
 * To run a mutation, you first call `useRemoveCasesMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCasesMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCasesMediaMutation, { data, loading, error }] = useRemoveCasesMediaMutation({
 *   variables: {
 *      removeAttachment: // value for 'removeAttachment'
 *   },
 * });
 */
export function useRemoveCasesMediaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCasesMediaMutation, RemoveCasesMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCasesMediaMutation, RemoveCasesMediaMutationVariables>(RemoveCasesMediaDocument, options);
      }
export type RemoveCasesMediaMutationHookResult = ReturnType<typeof useRemoveCasesMediaMutation>;
export type RemoveCasesMediaMutationResult = Apollo.MutationResult<RemoveCasesMediaMutation>;
export type RemoveCasesMediaMutationOptions = Apollo.BaseMutationOptions<RemoveCasesMediaMutation, RemoveCasesMediaMutationVariables>;
export const FetchAllTasksDocument = gql`
    query fetchAllTasks($tasksInput: tasksInput!) {
  fetchAllTasks(tasksInput: $tasksInput) {
    response {
      status
      message
    }
    tasks {
      id
      title
      type
      createdAt
      updatedAt
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchAllTasksQuery__
 *
 * To run a query within a React component, call `useFetchAllTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllTasksQuery({
 *   variables: {
 *      tasksInput: // value for 'tasksInput'
 *   },
 * });
 */
export function useFetchAllTasksQuery(baseOptions: Apollo.QueryHookOptions<FetchAllTasksQuery, FetchAllTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllTasksQuery, FetchAllTasksQueryVariables>(FetchAllTasksDocument, options);
      }
export function useFetchAllTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllTasksQuery, FetchAllTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllTasksQuery, FetchAllTasksQueryVariables>(FetchAllTasksDocument, options);
        }
export type FetchAllTasksQueryHookResult = ReturnType<typeof useFetchAllTasksQuery>;
export type FetchAllTasksLazyQueryHookResult = ReturnType<typeof useFetchAllTasksLazyQuery>;
export type FetchAllTasksQueryResult = Apollo.QueryResult<FetchAllTasksQuery, FetchAllTasksQueryVariables>;
export const AddUserCaseTaskDocument = gql`
    mutation addUserCaseTask($userCaseTaskInput: UserCaseTaskInput!) {
  addUserCaseTask(userCaseTaskInput: $userCaseTaskInput) {
    response {
      status
      message
    }
    userCaseTask {
      id
      status
      taskId
      createdAt
      updatedAt
      followUpDate
      task {
        id
        title
        type
        createdAt
        updatedAt
      }
      assignee {
        id
        firstName
        lastName
        status
        emailVerified
        email
        createdAt
        updatedAt
        initials
        hourlyRate
        roles {
          id
          role
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;
export type AddUserCaseTaskMutationFn = Apollo.MutationFunction<AddUserCaseTaskMutation, AddUserCaseTaskMutationVariables>;

/**
 * __useAddUserCaseTaskMutation__
 *
 * To run a mutation, you first call `useAddUserCaseTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserCaseTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserCaseTaskMutation, { data, loading, error }] = useAddUserCaseTaskMutation({
 *   variables: {
 *      userCaseTaskInput: // value for 'userCaseTaskInput'
 *   },
 * });
 */
export function useAddUserCaseTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddUserCaseTaskMutation, AddUserCaseTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserCaseTaskMutation, AddUserCaseTaskMutationVariables>(AddUserCaseTaskDocument, options);
      }
export type AddUserCaseTaskMutationHookResult = ReturnType<typeof useAddUserCaseTaskMutation>;
export type AddUserCaseTaskMutationResult = Apollo.MutationResult<AddUserCaseTaskMutation>;
export type AddUserCaseTaskMutationOptions = Apollo.BaseMutationOptions<AddUserCaseTaskMutation, AddUserCaseTaskMutationVariables>;
export const CreateTaskDocument = gql`
    mutation createTask($createTaskInput: CreateTaskInput!) {
  createTask(createTaskInput: $createTaskInput) {
    response {
      status
      message
    }
    task {
      id
      title
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      createTaskInput: // value for 'createTaskInput'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($updateTaskInput: UpdateTaskInput!) {
  updateTask(updateTaskInput: $updateTaskInput) {
    response {
      status
      error
    }
    task {
      id
      title
      createdAt
      updatedAt
      description
      type
    }
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      updateTaskInput: // value for 'updateTaskInput'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($deleteTaskInput: DeleteTask!) {
  deleteTask(deleteTaskInput: $deleteTaskInput) {
    response {
      status
      error
      name
      message
    }
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      deleteTaskInput: // value for 'deleteTaskInput'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const FetchAllCaseTaskDocument = gql`
    query FetchAllCaseTask($tasksByCaseInput: TasksByCaseInput!) {
  fetchAllCaseTasks(tasksInput: $tasksByCaseInput) {
    response {
      status
      message
    }
    userCaseTasks {
      id
      status
      taskId
      createdAt
      updatedAt
      followUpDate
      task {
        id
        title
        type
        createdAt
        updatedAt
      }
      assignee {
        id
        firstName
        lastName
        status
        emailVerified
        email
        createdAt
        updatedAt
        initials
        hourlyRate
        roles {
          id
          role
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAllCaseTaskQuery__
 *
 * To run a query within a React component, call `useFetchAllCaseTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCaseTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCaseTaskQuery({
 *   variables: {
 *      tasksByCaseInput: // value for 'tasksByCaseInput'
 *   },
 * });
 */
export function useFetchAllCaseTaskQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCaseTaskQuery, FetchAllCaseTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCaseTaskQuery, FetchAllCaseTaskQueryVariables>(FetchAllCaseTaskDocument, options);
      }
export function useFetchAllCaseTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCaseTaskQuery, FetchAllCaseTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCaseTaskQuery, FetchAllCaseTaskQueryVariables>(FetchAllCaseTaskDocument, options);
        }
export type FetchAllCaseTaskQueryHookResult = ReturnType<typeof useFetchAllCaseTaskQuery>;
export type FetchAllCaseTaskLazyQueryHookResult = ReturnType<typeof useFetchAllCaseTaskLazyQuery>;
export type FetchAllCaseTaskQueryResult = Apollo.QueryResult<FetchAllCaseTaskQuery, FetchAllCaseTaskQueryVariables>;
export const UpdateUserCasesTaskDocument = gql`
    mutation updateUserCasesTask($updateUserCasesTaskInput: UpdateUserCaseTaskInput!) {
  updateUserCasesTask(updateUserCasesTaskInput: $updateUserCasesTaskInput) {
    response {
      status
      message
      name
      error
    }
    task {
      id
      title
      description
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;
export type UpdateUserCasesTaskMutationFn = Apollo.MutationFunction<UpdateUserCasesTaskMutation, UpdateUserCasesTaskMutationVariables>;

/**
 * __useUpdateUserCasesTaskMutation__
 *
 * To run a mutation, you first call `useUpdateUserCasesTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCasesTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCasesTaskMutation, { data, loading, error }] = useUpdateUserCasesTaskMutation({
 *   variables: {
 *      updateUserCasesTaskInput: // value for 'updateUserCasesTaskInput'
 *   },
 * });
 */
export function useUpdateUserCasesTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCasesTaskMutation, UpdateUserCasesTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCasesTaskMutation, UpdateUserCasesTaskMutationVariables>(UpdateUserCasesTaskDocument, options);
      }
export type UpdateUserCasesTaskMutationHookResult = ReturnType<typeof useUpdateUserCasesTaskMutation>;
export type UpdateUserCasesTaskMutationResult = Apollo.MutationResult<UpdateUserCasesTaskMutation>;
export type UpdateUserCasesTaskMutationOptions = Apollo.BaseMutationOptions<UpdateUserCasesTaskMutation, UpdateUserCasesTaskMutationVariables>;
export const UpdateCaseEventDocument = gql`
    mutation updateCaseEvent($updateCaseEventInput: UpdateCaseEventInput!) {
  updateCaseEvent(updateCaseEventInput: $updateCaseEventInput) {
    response {
      status
      message
    }
    caseEvent {
      id
      title
      hearingAt
      eventType
      hearingEndsAt
      nextHearingAt
      outlookEventId
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateCaseEventMutationFn = Apollo.MutationFunction<UpdateCaseEventMutation, UpdateCaseEventMutationVariables>;

/**
 * __useUpdateCaseEventMutation__
 *
 * To run a mutation, you first call `useUpdateCaseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseEventMutation, { data, loading, error }] = useUpdateCaseEventMutation({
 *   variables: {
 *      updateCaseEventInput: // value for 'updateCaseEventInput'
 *   },
 * });
 */
export function useUpdateCaseEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseEventMutation, UpdateCaseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseEventMutation, UpdateCaseEventMutationVariables>(UpdateCaseEventDocument, options);
      }
export type UpdateCaseEventMutationHookResult = ReturnType<typeof useUpdateCaseEventMutation>;
export type UpdateCaseEventMutationResult = Apollo.MutationResult<UpdateCaseEventMutation>;
export type UpdateCaseEventMutationOptions = Apollo.BaseMutationOptions<UpdateCaseEventMutation, UpdateCaseEventMutationVariables>;
export const DeleteCaseEventDocument = gql`
    mutation deleteCaseEvent($deleteCaseEvent: DeleteCaseEvent!) {
  deleteCaseEvent(deleteCaseEventInput: $deleteCaseEvent) {
    response {
      status
      message
    }
  }
}
    `;
export type DeleteCaseEventMutationFn = Apollo.MutationFunction<DeleteCaseEventMutation, DeleteCaseEventMutationVariables>;

/**
 * __useDeleteCaseEventMutation__
 *
 * To run a mutation, you first call `useDeleteCaseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseEventMutation, { data, loading, error }] = useDeleteCaseEventMutation({
 *   variables: {
 *      deleteCaseEvent: // value for 'deleteCaseEvent'
 *   },
 * });
 */
export function useDeleteCaseEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseEventMutation, DeleteCaseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseEventMutation, DeleteCaseEventMutationVariables>(DeleteCaseEventDocument, options);
      }
export type DeleteCaseEventMutationHookResult = ReturnType<typeof useDeleteCaseEventMutation>;
export type DeleteCaseEventMutationResult = Apollo.MutationResult<DeleteCaseEventMutation>;
export type DeleteCaseEventMutationOptions = Apollo.BaseMutationOptions<DeleteCaseEventMutation, DeleteCaseEventMutationVariables>;
export const FetchAllCaseEventsDocument = gql`
    query fetchAllCaseEvents($caseEventsByCaseInput: CaseEventsByCaseInput!) {
  fetchAllCaseEvents(caseEventsInput: $caseEventsByCaseInput) {
    response {
      status
      message
    }
    caseEvents {
      id
      eventType
      title
      outlookEventId
      hearingEndsAt
      hearingAt
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useFetchAllCaseEventsQuery__
 *
 * To run a query within a React component, call `useFetchAllCaseEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCaseEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCaseEventsQuery({
 *   variables: {
 *      caseEventsByCaseInput: // value for 'caseEventsByCaseInput'
 *   },
 * });
 */
export function useFetchAllCaseEventsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCaseEventsQuery, FetchAllCaseEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCaseEventsQuery, FetchAllCaseEventsQueryVariables>(FetchAllCaseEventsDocument, options);
      }
export function useFetchAllCaseEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCaseEventsQuery, FetchAllCaseEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCaseEventsQuery, FetchAllCaseEventsQueryVariables>(FetchAllCaseEventsDocument, options);
        }
export type FetchAllCaseEventsQueryHookResult = ReturnType<typeof useFetchAllCaseEventsQuery>;
export type FetchAllCaseEventsLazyQueryHookResult = ReturnType<typeof useFetchAllCaseEventsLazyQuery>;
export type FetchAllCaseEventsQueryResult = Apollo.QueryResult<FetchAllCaseEventsQuery, FetchAllCaseEventsQueryVariables>;
export const FetchCourtDatesDocument = gql`
    query fetchCourtDates($courtDatesInput: CourtDatesInput!) {
  fetchCourtDates(courtDatesInput: $courtDatesInput) {
    response {
      status
      message
    }
    courtDates {
      id
      title
      hearingAt
      hearingEndsAt
      caseId
      caseNumber
      consultMatterNumber
      isConsultMatter
      caseTitle
      caseStatus
      clientName
      courtName
      responsibleAttorneyId
      responsibleAttorneyName
    }
  }
}
    `;

/**
 * __useFetchCourtDatesQuery__
 *
 * To run a query within a React component, call `useFetchCourtDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCourtDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCourtDatesQuery({
 *   variables: {
 *      courtDatesInput: // value for 'courtDatesInput'
 *   },
 * });
 */
export function useFetchCourtDatesQuery(baseOptions: Apollo.QueryHookOptions<FetchCourtDatesQuery, FetchCourtDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCourtDatesQuery, FetchCourtDatesQueryVariables>(FetchCourtDatesDocument, options);
      }
export function useFetchCourtDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCourtDatesQuery, FetchCourtDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCourtDatesQuery, FetchCourtDatesQueryVariables>(FetchCourtDatesDocument, options);
        }
export type FetchCourtDatesQueryHookResult = ReturnType<typeof useFetchCourtDatesQuery>;
export type FetchCourtDatesLazyQueryHookResult = ReturnType<typeof useFetchCourtDatesLazyQuery>;
export type FetchCourtDatesQueryResult = Apollo.QueryResult<FetchCourtDatesQuery, FetchCourtDatesQueryVariables>;
export const GetAttachmentDocument = gql`
    query getAttachment($getMedia: GetMedia!) {
  getAttachment(getMedia: $getMedia) {
    response {
      status
      message
    }
    preSignedUrl
  }
}
    `;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      getMedia: // value for 'getMedia'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const AssignCaseToExternalUserDocument = gql`
    mutation assignCaseToExternalUser($assignExternalUserToCase: AssignExternalUserToCase!) {
  assignCaseToExternalUser(assignCaseInput: $assignExternalUserToCase) {
    response {
      status
      message
    }
    case {
      id
      advantageCode
      title
      description
      caseNumber
      status
      dueDate
      courtId
      accidentDate
      caseTypeId
      createdAt
      updatedAt
      caseTypeId
      courtId
      userCasesTasks {
        id
        status
        taskId
        followUpDate
        createdAt
        updatedAt
        task {
          id
          title
          createdAt
          updatedAt
          type
        }
        assignee {
          id
          firstName
          lastName
          status
          emailVerified
          email
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      attachments {
        id
        title
        isLocked
        type
        typeId
        url
        createdAt
        updatedAt
      }
      caseEvents {
        id
        title
        eventType
        hearingAt
        outlookEventId
        hearingEndsAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          externalUser {
            id
            email
            firstName
            lastName
            displayName
            ssn
            phoneNumber
            ssn
            clientNumber
            addresses {
              address1
              address2
              city
              state
              country
              county
              zipCode
              id
              createdAt
              updatedAt
            }
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        caseId
        userType
        createdAt
        updatedAt
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
      deletedAt
    }
  }
}
    `;
export type AssignCaseToExternalUserMutationFn = Apollo.MutationFunction<AssignCaseToExternalUserMutation, AssignCaseToExternalUserMutationVariables>;

/**
 * __useAssignCaseToExternalUserMutation__
 *
 * To run a mutation, you first call `useAssignCaseToExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCaseToExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCaseToExternalUserMutation, { data, loading, error }] = useAssignCaseToExternalUserMutation({
 *   variables: {
 *      assignExternalUserToCase: // value for 'assignExternalUserToCase'
 *   },
 * });
 */
export function useAssignCaseToExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignCaseToExternalUserMutation, AssignCaseToExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCaseToExternalUserMutation, AssignCaseToExternalUserMutationVariables>(AssignCaseToExternalUserDocument, options);
      }
export type AssignCaseToExternalUserMutationHookResult = ReturnType<typeof useAssignCaseToExternalUserMutation>;
export type AssignCaseToExternalUserMutationResult = Apollo.MutationResult<AssignCaseToExternalUserMutation>;
export type AssignCaseToExternalUserMutationOptions = Apollo.BaseMutationOptions<AssignCaseToExternalUserMutation, AssignCaseToExternalUserMutationVariables>;
export const UpdateExternalUserDocument = gql`
    mutation updateExternalUser($updateExternalUserInput: UpdateExternalUserInput!) {
  updateExternalUser(updateExternalUserInput: $updateExternalUserInput) {
    response {
      status
      message
    }
    externalUser {
      id
      firstName
      lastName
      displayName
      businessName
      createdAt
      updatedAt
      email
      phoneNumber
      phoneNumberExtension
      clientNumber
      phoneNumber
      contractBalance
      arrearsBalance
      residualBalance
      trustBalance
      lastPayDate
      lastPayAmount
      isInternational
      language
      addresses {
        id
        address1
        address2
        city
        state
        country
        county
        zipCode
        createdAt
        updatedAt
      }
      dateOfBirth
      initials
      middleName
      personalPhone
      suffix
      homePhone
    }
  }
}
    `;
export type UpdateExternalUserMutationFn = Apollo.MutationFunction<UpdateExternalUserMutation, UpdateExternalUserMutationVariables>;

/**
 * __useUpdateExternalUserMutation__
 *
 * To run a mutation, you first call `useUpdateExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalUserMutation, { data, loading, error }] = useUpdateExternalUserMutation({
 *   variables: {
 *      updateExternalUserInput: // value for 'updateExternalUserInput'
 *   },
 * });
 */
export function useUpdateExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalUserMutation, UpdateExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalUserMutation, UpdateExternalUserMutationVariables>(UpdateExternalUserDocument, options);
      }
export type UpdateExternalUserMutationHookResult = ReturnType<typeof useUpdateExternalUserMutation>;
export type UpdateExternalUserMutationResult = Apollo.MutationResult<UpdateExternalUserMutation>;
export type UpdateExternalUserMutationOptions = Apollo.BaseMutationOptions<UpdateExternalUserMutation, UpdateExternalUserMutationVariables>;
export const ArchiveCaseDocument = gql`
    mutation archiveCase($archiveCase: ArchiveCase!) {
  archiveCase(archiveCase: $archiveCase) {
    response {
      status
      message
    }
  }
}
    `;
export type ArchiveCaseMutationFn = Apollo.MutationFunction<ArchiveCaseMutation, ArchiveCaseMutationVariables>;

/**
 * __useArchiveCaseMutation__
 *
 * To run a mutation, you first call `useArchiveCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCaseMutation, { data, loading, error }] = useArchiveCaseMutation({
 *   variables: {
 *      archiveCase: // value for 'archiveCase'
 *   },
 * });
 */
export function useArchiveCaseMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCaseMutation, ArchiveCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCaseMutation, ArchiveCaseMutationVariables>(ArchiveCaseDocument, options);
      }
export type ArchiveCaseMutationHookResult = ReturnType<typeof useArchiveCaseMutation>;
export type ArchiveCaseMutationResult = Apollo.MutationResult<ArchiveCaseMutation>;
export type ArchiveCaseMutationOptions = Apollo.BaseMutationOptions<ArchiveCaseMutation, ArchiveCaseMutationVariables>;
export const DeleteCaseDocument = gql`
    mutation deleteCase($deleteCaseInput: DeleteCase!) {
  deleteCase(deleteCaseInput: $deleteCaseInput) {
    response {
      message
      error
      status
    }
  }
}
    `;
export type DeleteCaseMutationFn = Apollo.MutationFunction<DeleteCaseMutation, DeleteCaseMutationVariables>;

/**
 * __useDeleteCaseMutation__
 *
 * To run a mutation, you first call `useDeleteCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseMutation, { data, loading, error }] = useDeleteCaseMutation({
 *   variables: {
 *      deleteCaseInput: // value for 'deleteCaseInput'
 *   },
 * });
 */
export function useDeleteCaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseMutation, DeleteCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseMutation, DeleteCaseMutationVariables>(DeleteCaseDocument, options);
      }
export type DeleteCaseMutationHookResult = ReturnType<typeof useDeleteCaseMutation>;
export type DeleteCaseMutationResult = Apollo.MutationResult<DeleteCaseMutation>;
export type DeleteCaseMutationOptions = Apollo.BaseMutationOptions<DeleteCaseMutation, DeleteCaseMutationVariables>;
export const ResendMessageDocument = gql`
    mutation ResendMessage($externalUserId: String!, $caseId: String!) {
  resendMessage(externalUserId: $externalUserId, caseId: $caseId)
}
    `;
export type ResendMessageMutationFn = Apollo.MutationFunction<ResendMessageMutation, ResendMessageMutationVariables>;

/**
 * __useResendMessageMutation__
 *
 * To run a mutation, you first call `useResendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMessageMutation, { data, loading, error }] = useResendMessageMutation({
 *   variables: {
 *      externalUserId: // value for 'externalUserId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useResendMessageMutation(baseOptions?: Apollo.MutationHookOptions<ResendMessageMutation, ResendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMessageMutation, ResendMessageMutationVariables>(ResendMessageDocument, options);
      }
export type ResendMessageMutationHookResult = ReturnType<typeof useResendMessageMutation>;
export type ResendMessageMutationResult = Apollo.MutationResult<ResendMessageMutation>;
export type ResendMessageMutationOptions = Apollo.BaseMutationOptions<ResendMessageMutation, ResendMessageMutationVariables>;
export const FetchAllReferralSourcesDocument = gql`
    query FetchAllReferralSources($fetchAllSources: FetchAllReferralSourceInput!) {
  fetchAllReferralSources(fetchAllSources: $fetchAllSources) {
    response {
      message
      status
    }
    referralSources {
      id
      sourceType
    }
    pagination {
      totalPages
      totalCount
      page
    }
  }
}
    `;

/**
 * __useFetchAllReferralSourcesQuery__
 *
 * To run a query within a React component, call `useFetchAllReferralSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllReferralSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllReferralSourcesQuery({
 *   variables: {
 *      fetchAllSources: // value for 'fetchAllSources'
 *   },
 * });
 */
export function useFetchAllReferralSourcesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllReferralSourcesQuery, FetchAllReferralSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllReferralSourcesQuery, FetchAllReferralSourcesQueryVariables>(FetchAllReferralSourcesDocument, options);
      }
export function useFetchAllReferralSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllReferralSourcesQuery, FetchAllReferralSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllReferralSourcesQuery, FetchAllReferralSourcesQueryVariables>(FetchAllReferralSourcesDocument, options);
        }
export type FetchAllReferralSourcesQueryHookResult = ReturnType<typeof useFetchAllReferralSourcesQuery>;
export type FetchAllReferralSourcesLazyQueryHookResult = ReturnType<typeof useFetchAllReferralSourcesLazyQuery>;
export type FetchAllReferralSourcesQueryResult = Apollo.QueryResult<FetchAllReferralSourcesQuery, FetchAllReferralSourcesQueryVariables>;
export const CreateReferralSourceDocument = gql`
    mutation CreateReferralSource($sourceType: String!) {
  createReferralSource(sourceType: $sourceType) {
    id
    sourceType
  }
}
    `;
export type CreateReferralSourceMutationFn = Apollo.MutationFunction<CreateReferralSourceMutation, CreateReferralSourceMutationVariables>;

/**
 * __useCreateReferralSourceMutation__
 *
 * To run a mutation, you first call `useCreateReferralSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferralSourceMutation, { data, loading, error }] = useCreateReferralSourceMutation({
 *   variables: {
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useCreateReferralSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferralSourceMutation, CreateReferralSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferralSourceMutation, CreateReferralSourceMutationVariables>(CreateReferralSourceDocument, options);
      }
export type CreateReferralSourceMutationHookResult = ReturnType<typeof useCreateReferralSourceMutation>;
export type CreateReferralSourceMutationResult = Apollo.MutationResult<CreateReferralSourceMutation>;
export type CreateReferralSourceMutationOptions = Apollo.BaseMutationOptions<CreateReferralSourceMutation, CreateReferralSourceMutationVariables>;
export const CheckConflictsDocument = gql`
    query CheckConflicts($checkConflictsInput: CheckConflictsInput!) {
  checkConflicts(checkConflictsInput: $checkConflictsInput) {
    conflicts {
      role
      caseRole
      case {
        title
        id
        caseNumber
        caseToUsers {
          id
          user {
            lastName
            firstName
            roles {
              role
            }
          }
          userType
        }
      }
      contact {
        lastName
        firstName
        addresses {
          state
          address1
          city
          country
          zipCode
        }
        middleName
        suffix
        phoneNumber
        email
      }
    }
    pagination {
      totalCount
      totalPages
      page
    }
  }
}
    `;

/**
 * __useCheckConflictsQuery__
 *
 * To run a query within a React component, call `useCheckConflictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckConflictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckConflictsQuery({
 *   variables: {
 *      checkConflictsInput: // value for 'checkConflictsInput'
 *   },
 * });
 */
export function useCheckConflictsQuery(baseOptions: Apollo.QueryHookOptions<CheckConflictsQuery, CheckConflictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckConflictsQuery, CheckConflictsQueryVariables>(CheckConflictsDocument, options);
      }
export function useCheckConflictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckConflictsQuery, CheckConflictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckConflictsQuery, CheckConflictsQueryVariables>(CheckConflictsDocument, options);
        }
export type CheckConflictsQueryHookResult = ReturnType<typeof useCheckConflictsQuery>;
export type CheckConflictsLazyQueryHookResult = ReturnType<typeof useCheckConflictsLazyQuery>;
export type CheckConflictsQueryResult = Apollo.QueryResult<CheckConflictsQuery, CheckConflictsQueryVariables>;
export const FetchRecentCaseDocument = gql`
    query FetchRecentCase($isConsultMatter: Boolean!) {
  fetchRecentCase(isConsultMatter: $isConsultMatter) {
    matterNo
  }
}
    `;

/**
 * __useFetchRecentCaseQuery__
 *
 * To run a query within a React component, call `useFetchRecentCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentCaseQuery({
 *   variables: {
 *      isConsultMatter: // value for 'isConsultMatter'
 *   },
 * });
 */
export function useFetchRecentCaseQuery(baseOptions: Apollo.QueryHookOptions<FetchRecentCaseQuery, FetchRecentCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRecentCaseQuery, FetchRecentCaseQueryVariables>(FetchRecentCaseDocument, options);
      }
export function useFetchRecentCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRecentCaseQuery, FetchRecentCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRecentCaseQuery, FetchRecentCaseQueryVariables>(FetchRecentCaseDocument, options);
        }
export type FetchRecentCaseQueryHookResult = ReturnType<typeof useFetchRecentCaseQuery>;
export type FetchRecentCaseLazyQueryHookResult = ReturnType<typeof useFetchRecentCaseLazyQuery>;
export type FetchRecentCaseQueryResult = Apollo.QueryResult<FetchRecentCaseQuery, FetchRecentCaseQueryVariables>;
export const FetchAllHourlyCasesDocument = gql`
    query FetchAllHourlyCases($fetchHourlyCasesInput: FetchHourlyCasesInput!) {
  fetchAllHourlyCases(fetchHourlyCasesInput: $fetchHourlyCasesInput) {
    cases {
      id
      title
    }
    pagination {
      totalCount
      totalPages
      page
    }
  }
}
    `;

/**
 * __useFetchAllHourlyCasesQuery__
 *
 * To run a query within a React component, call `useFetchAllHourlyCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllHourlyCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllHourlyCasesQuery({
 *   variables: {
 *      fetchHourlyCasesInput: // value for 'fetchHourlyCasesInput'
 *   },
 * });
 */
export function useFetchAllHourlyCasesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllHourlyCasesQuery, FetchAllHourlyCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllHourlyCasesQuery, FetchAllHourlyCasesQueryVariables>(FetchAllHourlyCasesDocument, options);
      }
export function useFetchAllHourlyCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllHourlyCasesQuery, FetchAllHourlyCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllHourlyCasesQuery, FetchAllHourlyCasesQueryVariables>(FetchAllHourlyCasesDocument, options);
        }
export type FetchAllHourlyCasesQueryHookResult = ReturnType<typeof useFetchAllHourlyCasesQuery>;
export type FetchAllHourlyCasesLazyQueryHookResult = ReturnType<typeof useFetchAllHourlyCasesLazyQuery>;
export type FetchAllHourlyCasesQueryResult = Apollo.QueryResult<FetchAllHourlyCasesQuery, FetchAllHourlyCasesQueryVariables>;
export const FetchCaseFinancialTimelineDocument = gql`
    query FetchCaseFinancialTimeline($caseId: String!) {
  fetchCaseFinancialTimeline(caseId: $caseId) {
    startDate
    events {
      id
      date
      category
      label
      description
      amount
      billId
      actorName
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCaseFinancialTimelineQuery__
 *
 * To run a query within a React component, call `useFetchCaseFinancialTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseFinancialTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseFinancialTimelineQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useFetchCaseFinancialTimelineQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseFinancialTimelineQuery, FetchCaseFinancialTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseFinancialTimelineQuery, FetchCaseFinancialTimelineQueryVariables>(FetchCaseFinancialTimelineDocument, options);
      }
export function useFetchCaseFinancialTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseFinancialTimelineQuery, FetchCaseFinancialTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseFinancialTimelineQuery, FetchCaseFinancialTimelineQueryVariables>(FetchCaseFinancialTimelineDocument, options);
        }
export type FetchCaseFinancialTimelineQueryHookResult = ReturnType<typeof useFetchCaseFinancialTimelineQuery>;
export type FetchCaseFinancialTimelineLazyQueryHookResult = ReturnType<typeof useFetchCaseFinancialTimelineLazyQuery>;
export type FetchCaseFinancialTimelineQueryResult = Apollo.QueryResult<FetchCaseFinancialTimelineQuery, FetchCaseFinancialTimelineQueryVariables>;
export const FetchCaseChartsSummaryDocument = gql`
    query FetchCaseChartsSummary($caseId: String!) {
  fetchCaseChartsSummary(caseId: $caseId) {
    financialSummary {
      paidToDate
      writtenOff
      expenses
      investigatorTime
      interestIncome
      moneyInTrust
    }
    flatFeeSummary {
      contractFee
      discount
      paidAmount
      unpaidAmount
      residualBalance
      hybridFlatFeeUsed
    }
    arBalance
    hoursSummary {
      billed
      unbilled
      onPreBill
      wip
      accommodated
      total
      byPerson {
        userId
        name
        role
        legalTeamPosition
        billed
        unbilled
        onPreBill
        wip
        accommodated
        total
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCaseChartsSummaryQuery__
 *
 * To run a query within a React component, call `useFetchCaseChartsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseChartsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseChartsSummaryQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useFetchCaseChartsSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseChartsSummaryQuery, FetchCaseChartsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseChartsSummaryQuery, FetchCaseChartsSummaryQueryVariables>(FetchCaseChartsSummaryDocument, options);
      }
export function useFetchCaseChartsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseChartsSummaryQuery, FetchCaseChartsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseChartsSummaryQuery, FetchCaseChartsSummaryQueryVariables>(FetchCaseChartsSummaryDocument, options);
        }
export type FetchCaseChartsSummaryQueryHookResult = ReturnType<typeof useFetchCaseChartsSummaryQuery>;
export type FetchCaseChartsSummaryLazyQueryHookResult = ReturnType<typeof useFetchCaseChartsSummaryLazyQuery>;
export type FetchCaseChartsSummaryQueryResult = Apollo.QueryResult<FetchCaseChartsSummaryQuery, FetchCaseChartsSummaryQueryVariables>;
export const FetchCaseFinancialsDocument = gql`
    query FetchCaseFinancials($caseId: String!) {
  fetchCaseFinancials(caseId: $caseId) {
    timeEntriesSummary {
      time
      amount
    }
    costEntriesSummary {
      time
      amount
    }
    expensesSummary {
      time
      amount
    }
    legalFeeSummary {
      time
      amount
    }
    flatFeeSummary {
      contractFee
      discount
      paidAmount
      unpaidAmount
      residualBalance
      hybridFlatFeeUsed
      payoffAmount
    }
    billingSummary {
      lastPaymentDate
      lastPaymentAmount
      paidToDate
      totalRefunds
      lastBillDate
      advArBalance
      arBalance
    }
    costSummary {
      costBilled
      costPaidToDate
      costUnpaid
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCaseFinancialsQuery__
 *
 * To run a query within a React component, call `useFetchCaseFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseFinancialsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useFetchCaseFinancialsQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseFinancialsQuery, FetchCaseFinancialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseFinancialsQuery, FetchCaseFinancialsQueryVariables>(FetchCaseFinancialsDocument, options);
      }
export function useFetchCaseFinancialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseFinancialsQuery, FetchCaseFinancialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseFinancialsQuery, FetchCaseFinancialsQueryVariables>(FetchCaseFinancialsDocument, options);
        }
export type FetchCaseFinancialsQueryHookResult = ReturnType<typeof useFetchCaseFinancialsQuery>;
export type FetchCaseFinancialsLazyQueryHookResult = ReturnType<typeof useFetchCaseFinancialsLazyQuery>;
export type FetchCaseFinancialsQueryResult = Apollo.QueryResult<FetchCaseFinancialsQuery, FetchCaseFinancialsQueryVariables>;
export const UpdateReferralSourceDocument = gql`
    mutation UpdateReferralSource($updateReferralSourceId: String!, $sourceType: String!) {
  updateReferralSource(id: $updateReferralSourceId, sourceType: $sourceType) {
    id
    sourceType
    createdAt
    updatedAt
  }
}
    `;
export type UpdateReferralSourceMutationFn = Apollo.MutationFunction<UpdateReferralSourceMutation, UpdateReferralSourceMutationVariables>;

/**
 * __useUpdateReferralSourceMutation__
 *
 * To run a mutation, you first call `useUpdateReferralSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferralSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferralSourceMutation, { data, loading, error }] = useUpdateReferralSourceMutation({
 *   variables: {
 *      updateReferralSourceId: // value for 'updateReferralSourceId'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useUpdateReferralSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferralSourceMutation, UpdateReferralSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferralSourceMutation, UpdateReferralSourceMutationVariables>(UpdateReferralSourceDocument, options);
      }
export type UpdateReferralSourceMutationHookResult = ReturnType<typeof useUpdateReferralSourceMutation>;
export type UpdateReferralSourceMutationResult = Apollo.MutationResult<UpdateReferralSourceMutation>;
export type UpdateReferralSourceMutationOptions = Apollo.BaseMutationOptions<UpdateReferralSourceMutation, UpdateReferralSourceMutationVariables>;
export const DeleteReferralSourceDocument = gql`
    mutation DeleteReferralSource($deleteReferralSourceId: String!) {
  deleteReferralSource(id: $deleteReferralSourceId)
}
    `;
export type DeleteReferralSourceMutationFn = Apollo.MutationFunction<DeleteReferralSourceMutation, DeleteReferralSourceMutationVariables>;

/**
 * __useDeleteReferralSourceMutation__
 *
 * To run a mutation, you first call `useDeleteReferralSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReferralSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReferralSourceMutation, { data, loading, error }] = useDeleteReferralSourceMutation({
 *   variables: {
 *      deleteReferralSourceId: // value for 'deleteReferralSourceId'
 *   },
 * });
 */
export function useDeleteReferralSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReferralSourceMutation, DeleteReferralSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReferralSourceMutation, DeleteReferralSourceMutationVariables>(DeleteReferralSourceDocument, options);
      }
export type DeleteReferralSourceMutationHookResult = ReturnType<typeof useDeleteReferralSourceMutation>;
export type DeleteReferralSourceMutationResult = Apollo.MutationResult<DeleteReferralSourceMutation>;
export type DeleteReferralSourceMutationOptions = Apollo.BaseMutationOptions<DeleteReferralSourceMutation, DeleteReferralSourceMutationVariables>;
export const ConvertFlatFeeCaseToHourlyDocument = gql`
    mutation ConvertFlatFeeCaseToHourly($caseId: String!) {
  convertFlatFeeCaseToHourly(caseId: $caseId) {
    response {
      status
      message
    }
  }
}
    `;
export type ConvertFlatFeeCaseToHourlyMutationFn = Apollo.MutationFunction<ConvertFlatFeeCaseToHourlyMutation, ConvertFlatFeeCaseToHourlyMutationVariables>;

/**
 * __useConvertFlatFeeCaseToHourlyMutation__
 *
 * To run a mutation, you first call `useConvertFlatFeeCaseToHourlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertFlatFeeCaseToHourlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertFlatFeeCaseToHourlyMutation, { data, loading, error }] = useConvertFlatFeeCaseToHourlyMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useConvertFlatFeeCaseToHourlyMutation(baseOptions?: Apollo.MutationHookOptions<ConvertFlatFeeCaseToHourlyMutation, ConvertFlatFeeCaseToHourlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertFlatFeeCaseToHourlyMutation, ConvertFlatFeeCaseToHourlyMutationVariables>(ConvertFlatFeeCaseToHourlyDocument, options);
      }
export type ConvertFlatFeeCaseToHourlyMutationHookResult = ReturnType<typeof useConvertFlatFeeCaseToHourlyMutation>;
export type ConvertFlatFeeCaseToHourlyMutationResult = Apollo.MutationResult<ConvertFlatFeeCaseToHourlyMutation>;
export type ConvertFlatFeeCaseToHourlyMutationOptions = Apollo.BaseMutationOptions<ConvertFlatFeeCaseToHourlyMutation, ConvertFlatFeeCaseToHourlyMutationVariables>;
export const UpdateCaseBillingTypeDocument = gql`
    mutation UpdateCaseBillingType($updateCaseBillingTypeInput: UpdateCaseBillingTypeInput!) {
  updateCaseBillingType(updateCaseBillingTypeInput: $updateCaseBillingTypeInput) {
    case {
      id
      billing {
        id
        billingType
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdateCaseBillingTypeMutationFn = Apollo.MutationFunction<UpdateCaseBillingTypeMutation, UpdateCaseBillingTypeMutationVariables>;

/**
 * __useUpdateCaseBillingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCaseBillingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseBillingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseBillingTypeMutation, { data, loading, error }] = useUpdateCaseBillingTypeMutation({
 *   variables: {
 *      updateCaseBillingTypeInput: // value for 'updateCaseBillingTypeInput'
 *   },
 * });
 */
export function useUpdateCaseBillingTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseBillingTypeMutation, UpdateCaseBillingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseBillingTypeMutation, UpdateCaseBillingTypeMutationVariables>(UpdateCaseBillingTypeDocument, options);
      }
export type UpdateCaseBillingTypeMutationHookResult = ReturnType<typeof useUpdateCaseBillingTypeMutation>;
export type UpdateCaseBillingTypeMutationResult = Apollo.MutationResult<UpdateCaseBillingTypeMutation>;
export type UpdateCaseBillingTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCaseBillingTypeMutation, UpdateCaseBillingTypeMutationVariables>;
export const FetchAllMattersWithoutJoinDocument = gql`
    query FetchAllMattersWithoutJoin($casesInput: CasesInput!) {
  fetchAllMattersWithoutJoin(casesInput: $casesInput) {
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    response {
      status
      message
    }
    cases {
      id
      advantageCode
      title
      description
      caseNumber
      consultMatterNumber
      status
      dueDate
      deletedAt
      createdAt
      updatedAt
      isConsultMatter
      advCaseNumber
      caseToUsers {
        id
        userId
        caseId
        userType
        createdAt
        updatedAt
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        hourlyRate
      }
      caseTypeId
    }
  }
}
    `;

/**
 * __useFetchAllMattersWithoutJoinQuery__
 *
 * To run a query within a React component, call `useFetchAllMattersWithoutJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllMattersWithoutJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllMattersWithoutJoinQuery({
 *   variables: {
 *      casesInput: // value for 'casesInput'
 *   },
 * });
 */
export function useFetchAllMattersWithoutJoinQuery(baseOptions: Apollo.QueryHookOptions<FetchAllMattersWithoutJoinQuery, FetchAllMattersWithoutJoinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllMattersWithoutJoinQuery, FetchAllMattersWithoutJoinQueryVariables>(FetchAllMattersWithoutJoinDocument, options);
      }
export function useFetchAllMattersWithoutJoinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllMattersWithoutJoinQuery, FetchAllMattersWithoutJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllMattersWithoutJoinQuery, FetchAllMattersWithoutJoinQueryVariables>(FetchAllMattersWithoutJoinDocument, options);
        }
export type FetchAllMattersWithoutJoinQueryHookResult = ReturnType<typeof useFetchAllMattersWithoutJoinQuery>;
export type FetchAllMattersWithoutJoinLazyQueryHookResult = ReturnType<typeof useFetchAllMattersWithoutJoinLazyQuery>;
export type FetchAllMattersWithoutJoinQueryResult = Apollo.QueryResult<FetchAllMattersWithoutJoinQuery, FetchAllMattersWithoutJoinQueryVariables>;
export const SearchMattersDocument = gql`
    query SearchMatters($searchMattersInput: SearchMattersInput!) {
  searchMatters(searchMattersInput: $searchMattersInput) {
    cases {
      id
      caseNumber
      consultMatterNumber
      advCaseNumber
      title
      status
      openDate
      completedDate
      closeDate
      createdAt
      updatedAt
      isConsultMatter
      billing {
        pauseBillingUntil
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          createdAt
          syncWithOutlook
          updatedAt
        }
      }
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useSearchMattersQuery__
 *
 * To run a query within a React component, call `useSearchMattersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMattersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMattersQuery({
 *   variables: {
 *      searchMattersInput: // value for 'searchMattersInput'
 *   },
 * });
 */
export function useSearchMattersQuery(baseOptions: Apollo.QueryHookOptions<SearchMattersQuery, SearchMattersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMattersQuery, SearchMattersQueryVariables>(SearchMattersDocument, options);
      }
export function useSearchMattersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMattersQuery, SearchMattersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMattersQuery, SearchMattersQueryVariables>(SearchMattersDocument, options);
        }
export type SearchMattersQueryHookResult = ReturnType<typeof useSearchMattersQuery>;
export type SearchMattersLazyQueryHookResult = ReturnType<typeof useSearchMattersLazyQuery>;
export type SearchMattersQueryResult = Apollo.QueryResult<SearchMattersQuery, SearchMattersQueryVariables>;
export const FetchDataForRecordPaymentsDocument = gql`
    query FetchDataForRecordPayments($fetchDataForRecordPaymentsInput: FetchDataForRecordPaymentsInput!) {
  fetchDataForRecordPayments(
    fetchDataForRecordPaymentsInput: $fetchDataForRecordPaymentsInput
  ) {
    response {
      status
      message
    }
    cases {
      id
      caseNumber
      consultMatterNumber
      advCaseNumber
      title
      status
      caseTypeId
      openDate
      completedDate
      closeDate
      createdAt
      updatedAt
      isConsultMatter
      billing {
        billingType
      }
      caseType {
        id
        name
      }
      caseToUsers {
        userType
        user {
          id
          firstName
          lastName
        }
      }
      caseToExternalUserToExternalUserRole {
        caseRole
        externalUserToExternalUserRole {
          externalUser {
            id
            firstName
            lastName
            displayName
            clientNumber
          }
        }
      }
      bills {
        id
        type
        status
        amount
        dueDate
        issueDate
        amountPaid
        description
        payOffAmount
        writtenOffPrincipal
        writtenOffInterest
        lastSentAt
        sendToClient
        createdAt
        updatedAt
      }
    }
    client {
      id
      firstName
      lastName
      displayName
      clientNumber
      email
      phoneNumber
      createdAt
      updatedAt
      addresses {
        id
        address1
        address2
        city
        state
        zipCode
      }
    }
  }
}
    `;

/**
 * __useFetchDataForRecordPaymentsQuery__
 *
 * To run a query within a React component, call `useFetchDataForRecordPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDataForRecordPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDataForRecordPaymentsQuery({
 *   variables: {
 *      fetchDataForRecordPaymentsInput: // value for 'fetchDataForRecordPaymentsInput'
 *   },
 * });
 */
export function useFetchDataForRecordPaymentsQuery(baseOptions: Apollo.QueryHookOptions<FetchDataForRecordPaymentsQuery, FetchDataForRecordPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDataForRecordPaymentsQuery, FetchDataForRecordPaymentsQueryVariables>(FetchDataForRecordPaymentsDocument, options);
      }
export function useFetchDataForRecordPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDataForRecordPaymentsQuery, FetchDataForRecordPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDataForRecordPaymentsQuery, FetchDataForRecordPaymentsQueryVariables>(FetchDataForRecordPaymentsDocument, options);
        }
export type FetchDataForRecordPaymentsQueryHookResult = ReturnType<typeof useFetchDataForRecordPaymentsQuery>;
export type FetchDataForRecordPaymentsLazyQueryHookResult = ReturnType<typeof useFetchDataForRecordPaymentsLazyQuery>;
export type FetchDataForRecordPaymentsQueryResult = Apollo.QueryResult<FetchDataForRecordPaymentsQuery, FetchDataForRecordPaymentsQueryVariables>;
export const GetCaseBillingPauseDateDocument = gql`
    query getCaseBillingPauseDate($caseId: String!, $advancePayment: Float!) {
  getCaseBillingPauseDate(caseId: $caseId, advancePayment: $advancePayment) {
    date
    response {
      status
    }
  }
}
    `;

/**
 * __useGetCaseBillingPauseDateQuery__
 *
 * To run a query within a React component, call `useGetCaseBillingPauseDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseBillingPauseDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseBillingPauseDateQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      advancePayment: // value for 'advancePayment'
 *   },
 * });
 */
export function useGetCaseBillingPauseDateQuery(baseOptions: Apollo.QueryHookOptions<GetCaseBillingPauseDateQuery, GetCaseBillingPauseDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseBillingPauseDateQuery, GetCaseBillingPauseDateQueryVariables>(GetCaseBillingPauseDateDocument, options);
      }
export function useGetCaseBillingPauseDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseBillingPauseDateQuery, GetCaseBillingPauseDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseBillingPauseDateQuery, GetCaseBillingPauseDateQueryVariables>(GetCaseBillingPauseDateDocument, options);
        }
export type GetCaseBillingPauseDateQueryHookResult = ReturnType<typeof useGetCaseBillingPauseDateQuery>;
export type GetCaseBillingPauseDateLazyQueryHookResult = ReturnType<typeof useGetCaseBillingPauseDateLazyQuery>;
export type GetCaseBillingPauseDateQueryResult = Apollo.QueryResult<GetCaseBillingPauseDateQuery, GetCaseBillingPauseDateQueryVariables>;
export const GetInitialPaymentLockDocument = gql`
    query getInitialPaymentLock($caseId: String!) {
  getInitialPaymentLock(caseId: $caseId) {
    state
    canEdit
    message
    billId
    billStatus
    canGenerateBill
    response {
      status
    }
  }
}
    `;

/**
 * __useGetInitialPaymentLockQuery__
 *
 * To run a query within a React component, call `useGetInitialPaymentLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialPaymentLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialPaymentLockQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetInitialPaymentLockQuery(baseOptions: Apollo.QueryHookOptions<GetInitialPaymentLockQuery, GetInitialPaymentLockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialPaymentLockQuery, GetInitialPaymentLockQueryVariables>(GetInitialPaymentLockDocument, options);
      }
export function useGetInitialPaymentLockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialPaymentLockQuery, GetInitialPaymentLockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialPaymentLockQuery, GetInitialPaymentLockQueryVariables>(GetInitialPaymentLockDocument, options);
        }
export type GetInitialPaymentLockQueryHookResult = ReturnType<typeof useGetInitialPaymentLockQuery>;
export type GetInitialPaymentLockLazyQueryHookResult = ReturnType<typeof useGetInitialPaymentLockLazyQuery>;
export type GetInitialPaymentLockQueryResult = Apollo.QueryResult<GetInitialPaymentLockQuery, GetInitialPaymentLockQueryVariables>;
export const GetClientTrustBalanceDocument = gql`
    query GetClientTrustBalance($getClientTrustBalanceInput: GetClientTrustBalanceInput!) {
  getClientTrustBalance(getClientTrustBalanceInput: $getClientTrustBalanceInput) {
    trustBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetClientTrustBalanceQuery__
 *
 * To run a query within a React component, call `useGetClientTrustBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTrustBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTrustBalanceQuery({
 *   variables: {
 *      getClientTrustBalanceInput: // value for 'getClientTrustBalanceInput'
 *   },
 * });
 */
export function useGetClientTrustBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetClientTrustBalanceQuery, GetClientTrustBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientTrustBalanceQuery, GetClientTrustBalanceQueryVariables>(GetClientTrustBalanceDocument, options);
      }
export function useGetClientTrustBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientTrustBalanceQuery, GetClientTrustBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientTrustBalanceQuery, GetClientTrustBalanceQueryVariables>(GetClientTrustBalanceDocument, options);
        }
export type GetClientTrustBalanceQueryHookResult = ReturnType<typeof useGetClientTrustBalanceQuery>;
export type GetClientTrustBalanceLazyQueryHookResult = ReturnType<typeof useGetClientTrustBalanceLazyQuery>;
export type GetClientTrustBalanceQueryResult = Apollo.QueryResult<GetClientTrustBalanceQuery, GetClientTrustBalanceQueryVariables>;
export const GetPublicClientTrustBalanceDocument = gql`
    query GetPublicClientTrustBalance($getClientTrustBalanceInput: GetClientTrustBalanceInput!) {
  getPublicClientTrustBalance(
    getClientTrustBalanceInput: $getClientTrustBalanceInput
  ) {
    trustBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetPublicClientTrustBalanceQuery__
 *
 * To run a query within a React component, call `useGetPublicClientTrustBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicClientTrustBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicClientTrustBalanceQuery({
 *   variables: {
 *      getClientTrustBalanceInput: // value for 'getClientTrustBalanceInput'
 *   },
 * });
 */
export function useGetPublicClientTrustBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetPublicClientTrustBalanceQuery, GetPublicClientTrustBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicClientTrustBalanceQuery, GetPublicClientTrustBalanceQueryVariables>(GetPublicClientTrustBalanceDocument, options);
      }
export function useGetPublicClientTrustBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicClientTrustBalanceQuery, GetPublicClientTrustBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicClientTrustBalanceQuery, GetPublicClientTrustBalanceQueryVariables>(GetPublicClientTrustBalanceDocument, options);
        }
export type GetPublicClientTrustBalanceQueryHookResult = ReturnType<typeof useGetPublicClientTrustBalanceQuery>;
export type GetPublicClientTrustBalanceLazyQueryHookResult = ReturnType<typeof useGetPublicClientTrustBalanceLazyQuery>;
export type GetPublicClientTrustBalanceQueryResult = Apollo.QueryResult<GetPublicClientTrustBalanceQuery, GetPublicClientTrustBalanceQueryVariables>;
export const GetTrustBalanceSummaryDocument = gql`
    query GetTrustBalanceSummary($getTrustBalanceSummaryInput: GetTrustBalanceSummaryInput!) {
  getTrustBalanceSummary(
    getTrustBalanceSummaryInput: $getTrustBalanceSummaryInput
  ) {
    ioltaBalanceSummary {
      balance
      retainerAccount {
        id
        name
        accountNo
      }
      clients {
        clientId
        name
        trustBalance
        settlementCheck {
          checkNo
          date
          memo
          amount
        }
      }
    }
    escrowBalanceSummary {
      balance
      clients {
        clientId
        name
        trustBalance
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetTrustBalanceSummaryQuery__
 *
 * To run a query within a React component, call `useGetTrustBalanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrustBalanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrustBalanceSummaryQuery({
 *   variables: {
 *      getTrustBalanceSummaryInput: // value for 'getTrustBalanceSummaryInput'
 *   },
 * });
 */
export function useGetTrustBalanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetTrustBalanceSummaryQuery, GetTrustBalanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrustBalanceSummaryQuery, GetTrustBalanceSummaryQueryVariables>(GetTrustBalanceSummaryDocument, options);
      }
export function useGetTrustBalanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrustBalanceSummaryQuery, GetTrustBalanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrustBalanceSummaryQuery, GetTrustBalanceSummaryQueryVariables>(GetTrustBalanceSummaryDocument, options);
        }
export type GetTrustBalanceSummaryQueryHookResult = ReturnType<typeof useGetTrustBalanceSummaryQuery>;
export type GetTrustBalanceSummaryLazyQueryHookResult = ReturnType<typeof useGetTrustBalanceSummaryLazyQuery>;
export type GetTrustBalanceSummaryQueryResult = Apollo.QueryResult<GetTrustBalanceSummaryQuery, GetTrustBalanceSummaryQueryVariables>;
export const GetCasesWithLowTrustBalanceDocument = gql`
    query GetCasesWithLowTrustBalance($casesWithLowTrustBalanceInput: CasesWithLowTrustBalanceInput) {
  getCasesWithLowTrustBalance(
    casesWithLowTrustBalanceInput: $casesWithLowTrustBalanceInput
  ) {
    cases {
      id
      caseNumber
      title
      minimumFundsThreshold
      totalTrustBalance
      retainerAmount
      amountToBill
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetCasesWithLowTrustBalanceQuery__
 *
 * To run a query within a React component, call `useGetCasesWithLowTrustBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesWithLowTrustBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesWithLowTrustBalanceQuery({
 *   variables: {
 *      casesWithLowTrustBalanceInput: // value for 'casesWithLowTrustBalanceInput'
 *   },
 * });
 */
export function useGetCasesWithLowTrustBalanceQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesWithLowTrustBalanceQuery, GetCasesWithLowTrustBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesWithLowTrustBalanceQuery, GetCasesWithLowTrustBalanceQueryVariables>(GetCasesWithLowTrustBalanceDocument, options);
      }
export function useGetCasesWithLowTrustBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesWithLowTrustBalanceQuery, GetCasesWithLowTrustBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesWithLowTrustBalanceQuery, GetCasesWithLowTrustBalanceQueryVariables>(GetCasesWithLowTrustBalanceDocument, options);
        }
export type GetCasesWithLowTrustBalanceQueryHookResult = ReturnType<typeof useGetCasesWithLowTrustBalanceQuery>;
export type GetCasesWithLowTrustBalanceLazyQueryHookResult = ReturnType<typeof useGetCasesWithLowTrustBalanceLazyQuery>;
export type GetCasesWithLowTrustBalanceQueryResult = Apollo.QueryResult<GetCasesWithLowTrustBalanceQuery, GetCasesWithLowTrustBalanceQueryVariables>;
export const GetClientBalanceInAccountDocument = gql`
    query GetClientBalanceInAccount($getClientBalanceInAccountInput: GetClientBalanceInAccountInput!) {
  getClientBalanceInAccount(
    getClientBalanceInAccountInput: $getClientBalanceInAccountInput
  ) {
    balance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetClientBalanceInAccountQuery__
 *
 * To run a query within a React component, call `useGetClientBalanceInAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientBalanceInAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientBalanceInAccountQuery({
 *   variables: {
 *      getClientBalanceInAccountInput: // value for 'getClientBalanceInAccountInput'
 *   },
 * });
 */
export function useGetClientBalanceInAccountQuery(baseOptions: Apollo.QueryHookOptions<GetClientBalanceInAccountQuery, GetClientBalanceInAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientBalanceInAccountQuery, GetClientBalanceInAccountQueryVariables>(GetClientBalanceInAccountDocument, options);
      }
export function useGetClientBalanceInAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientBalanceInAccountQuery, GetClientBalanceInAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientBalanceInAccountQuery, GetClientBalanceInAccountQueryVariables>(GetClientBalanceInAccountDocument, options);
        }
export type GetClientBalanceInAccountQueryHookResult = ReturnType<typeof useGetClientBalanceInAccountQuery>;
export type GetClientBalanceInAccountLazyQueryHookResult = ReturnType<typeof useGetClientBalanceInAccountLazyQuery>;
export type GetClientBalanceInAccountQueryResult = Apollo.QueryResult<GetClientBalanceInAccountQuery, GetClientBalanceInAccountQueryVariables>;
export const GetCaseClientsDocument = gql`
    query GetCaseClients($getCaseClientsInput: GetCaseClientsInput!) {
  getCaseClients(getCaseClientsInput: $getCaseClientsInput) {
    clients {
      id
      caseRole
      splitBillShare
      externalUserToExternalUserRole {
        externalUser {
          id
          firstName
          lastName
          displayName
          clientNumber
        }
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetCaseClientsQuery__
 *
 * To run a query within a React component, call `useGetCaseClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseClientsQuery({
 *   variables: {
 *      getCaseClientsInput: // value for 'getCaseClientsInput'
 *   },
 * });
 */
export function useGetCaseClientsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseClientsQuery, GetCaseClientsQueryVariables>(GetCaseClientsDocument, options);
      }
export function useGetCaseClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseClientsQuery, GetCaseClientsQueryVariables>(GetCaseClientsDocument, options);
        }
export type GetCaseClientsQueryHookResult = ReturnType<typeof useGetCaseClientsQuery>;
export type GetCaseClientsLazyQueryHookResult = ReturnType<typeof useGetCaseClientsLazyQuery>;
export type GetCaseClientsQueryResult = Apollo.QueryResult<GetCaseClientsQuery, GetCaseClientsQueryVariables>;
export const FetchExternalUserDocument = gql`
    query FetchExternalUser($externalUserInput: ExternalUserInput!) {
  fetchExternalUser(externalUserInput: $externalUserInput) {
    response {
      status
      message
    }
    externalUser {
      id
      firstName
      lastName
      displayName
      createdAt
      updatedAt
      email
      phoneNumber
      phoneNumberExtension
      clientNumber
      phoneNumber
      contractBalance
      arrearsBalance
      residualBalance
      trustBalance
      lastPayDate
      lastPayAmount
      socialSecurityNumber
      driverLicenseNumber
      isInternational
      language
      addresses {
        id
        address1
        address2
        city
        state
        country
        county
        zipCode
        createdAt
        updatedAt
      }
      externalUserRoles {
        id
        externalUserId
        externalUserRoleId
        createdAt
        updatedAt
        externalUserRole {
          id
          role
          createdAt
          updatedAt
        }
        caseToExternalUserToExternalUserRole {
          id
          caseRole
          createdAt
          updatedAt
          isArchived
          externalUserToExternalUserRoleId
          litigation {
            id
            advantageCode
            title
            description
            caseNumber
            consultMatterNumber
            status
            caseTypeId
            caseTypeId
            isConsultMatter
            createdAt
            updatedAt
          }
          litigationId
          externalUserToExternalUserRole {
            id
            createdAt
            externalUserId
            externalUserRoleId
            updatedAt
          }
        }
      }
      dateOfBirth
      initials
      middleName
      personalPhone
      suffix
      homePhone
      businessName
    }
  }
}
    `;

/**
 * __useFetchExternalUserQuery__
 *
 * To run a query within a React component, call `useFetchExternalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchExternalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchExternalUserQuery({
 *   variables: {
 *      externalUserInput: // value for 'externalUserInput'
 *   },
 * });
 */
export function useFetchExternalUserQuery(baseOptions: Apollo.QueryHookOptions<FetchExternalUserQuery, FetchExternalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchExternalUserQuery, FetchExternalUserQueryVariables>(FetchExternalUserDocument, options);
      }
export function useFetchExternalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchExternalUserQuery, FetchExternalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchExternalUserQuery, FetchExternalUserQueryVariables>(FetchExternalUserDocument, options);
        }
export type FetchExternalUserQueryHookResult = ReturnType<typeof useFetchExternalUserQuery>;
export type FetchExternalUserLazyQueryHookResult = ReturnType<typeof useFetchExternalUserLazyQuery>;
export type FetchExternalUserQueryResult = Apollo.QueryResult<FetchExternalUserQuery, FetchExternalUserQueryVariables>;
export const GetClientCreditBalanceDocument = gql`
    query GetClientCreditBalance($getClientCreditBalanceInput: GetClientCreditBalanceInput!) {
  getClientCreditBalance(
    getClientCreditBalanceInput: $getClientCreditBalanceInput
  ) {
    creditBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetClientCreditBalanceQuery__
 *
 * To run a query within a React component, call `useGetClientCreditBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCreditBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCreditBalanceQuery({
 *   variables: {
 *      getClientCreditBalanceInput: // value for 'getClientCreditBalanceInput'
 *   },
 * });
 */
export function useGetClientCreditBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetClientCreditBalanceQuery, GetClientCreditBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCreditBalanceQuery, GetClientCreditBalanceQueryVariables>(GetClientCreditBalanceDocument, options);
      }
export function useGetClientCreditBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCreditBalanceQuery, GetClientCreditBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCreditBalanceQuery, GetClientCreditBalanceQueryVariables>(GetClientCreditBalanceDocument, options);
        }
export type GetClientCreditBalanceQueryHookResult = ReturnType<typeof useGetClientCreditBalanceQuery>;
export type GetClientCreditBalanceLazyQueryHookResult = ReturnType<typeof useGetClientCreditBalanceLazyQuery>;
export type GetClientCreditBalanceQueryResult = Apollo.QueryResult<GetClientCreditBalanceQuery, GetClientCreditBalanceQueryVariables>;
export const GetCreditBalanceSummaryDocument = gql`
    query GetCreditBalanceSummary($getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput!) {
  getCreditBalanceSummary(
    getCreditBalanceSummaryInput: $getCreditBalanceSummaryInput
  ) {
    clients {
      clientId
      name
      creditBalance
    }
    totalCreditBalance
    voidedPayableCredit
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetCreditBalanceSummaryQuery__
 *
 * To run a query within a React component, call `useGetCreditBalanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditBalanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditBalanceSummaryQuery({
 *   variables: {
 *      getCreditBalanceSummaryInput: // value for 'getCreditBalanceSummaryInput'
 *   },
 * });
 */
export function useGetCreditBalanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCreditBalanceSummaryQuery, GetCreditBalanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditBalanceSummaryQuery, GetCreditBalanceSummaryQueryVariables>(GetCreditBalanceSummaryDocument, options);
      }
export function useGetCreditBalanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditBalanceSummaryQuery, GetCreditBalanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditBalanceSummaryQuery, GetCreditBalanceSummaryQueryVariables>(GetCreditBalanceSummaryDocument, options);
        }
export type GetCreditBalanceSummaryQueryHookResult = ReturnType<typeof useGetCreditBalanceSummaryQuery>;
export type GetCreditBalanceSummaryLazyQueryHookResult = ReturnType<typeof useGetCreditBalanceSummaryLazyQuery>;
export type GetCreditBalanceSummaryQueryResult = Apollo.QueryResult<GetCreditBalanceSummaryQuery, GetCreditBalanceSummaryQueryVariables>;
export const GetPublicCreditBalanceSummaryDocument = gql`
    query GetPublicCreditBalanceSummary($getCreditBalanceSummaryInput: GetCreditBalanceSummaryInput!) {
  getPublicCreditBalanceSummary(
    getCreditBalanceSummaryInput: $getCreditBalanceSummaryInput
  ) {
    clients {
      clientId
      name
      creditBalance
    }
    totalCreditBalance
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetPublicCreditBalanceSummaryQuery__
 *
 * To run a query within a React component, call `useGetPublicCreditBalanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCreditBalanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCreditBalanceSummaryQuery({
 *   variables: {
 *      getCreditBalanceSummaryInput: // value for 'getCreditBalanceSummaryInput'
 *   },
 * });
 */
export function useGetPublicCreditBalanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCreditBalanceSummaryQuery, GetPublicCreditBalanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCreditBalanceSummaryQuery, GetPublicCreditBalanceSummaryQueryVariables>(GetPublicCreditBalanceSummaryDocument, options);
      }
export function useGetPublicCreditBalanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCreditBalanceSummaryQuery, GetPublicCreditBalanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCreditBalanceSummaryQuery, GetPublicCreditBalanceSummaryQueryVariables>(GetPublicCreditBalanceSummaryDocument, options);
        }
export type GetPublicCreditBalanceSummaryQueryHookResult = ReturnType<typeof useGetPublicCreditBalanceSummaryQuery>;
export type GetPublicCreditBalanceSummaryLazyQueryHookResult = ReturnType<typeof useGetPublicCreditBalanceSummaryLazyQuery>;
export type GetPublicCreditBalanceSummaryQueryResult = Apollo.QueryResult<GetPublicCreditBalanceSummaryQuery, GetPublicCreditBalanceSummaryQueryVariables>;
export const FetchCategoriesBalancesDocument = gql`
    query fetchCategoriesBalances {
  fetchCategoriesBalances {
    asset
    liability
    equity
    revenue
    expense
  }
}
    `;

/**
 * __useFetchCategoriesBalancesQuery__
 *
 * To run a query within a React component, call `useFetchCategoriesBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCategoriesBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCategoriesBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCategoriesBalancesQuery(baseOptions?: Apollo.QueryHookOptions<FetchCategoriesBalancesQuery, FetchCategoriesBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCategoriesBalancesQuery, FetchCategoriesBalancesQueryVariables>(FetchCategoriesBalancesDocument, options);
      }
export function useFetchCategoriesBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCategoriesBalancesQuery, FetchCategoriesBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCategoriesBalancesQuery, FetchCategoriesBalancesQueryVariables>(FetchCategoriesBalancesDocument, options);
        }
export type FetchCategoriesBalancesQueryHookResult = ReturnType<typeof useFetchCategoriesBalancesQuery>;
export type FetchCategoriesBalancesLazyQueryHookResult = ReturnType<typeof useFetchCategoriesBalancesLazyQuery>;
export type FetchCategoriesBalancesQueryResult = Apollo.QueryResult<FetchCategoriesBalancesQuery, FetchCategoriesBalancesQueryVariables>;
export const FetchZescrowAccountDocument = gql`
    query fetchZescrowAccount {
  fetchZescrowAccount {
    id
    name
    sortCode
    currentBalance
  }
}
    `;

/**
 * __useFetchZescrowAccountQuery__
 *
 * To run a query within a React component, call `useFetchZescrowAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchZescrowAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchZescrowAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchZescrowAccountQuery(baseOptions?: Apollo.QueryHookOptions<FetchZescrowAccountQuery, FetchZescrowAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchZescrowAccountQuery, FetchZescrowAccountQueryVariables>(FetchZescrowAccountDocument, options);
      }
export function useFetchZescrowAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchZescrowAccountQuery, FetchZescrowAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchZescrowAccountQuery, FetchZescrowAccountQueryVariables>(FetchZescrowAccountDocument, options);
        }
export type FetchZescrowAccountQueryHookResult = ReturnType<typeof useFetchZescrowAccountQuery>;
export type FetchZescrowAccountLazyQueryHookResult = ReturnType<typeof useFetchZescrowAccountLazyQuery>;
export type FetchZescrowAccountQueryResult = Apollo.QueryResult<FetchZescrowAccountQuery, FetchZescrowAccountQueryVariables>;
export const FetchRetainerAccountDocument = gql`
    query fetchRetainerAccount {
  fetchRetainerAccount {
    id
    name
    sortCode
    currentBalance
  }
}
    `;

/**
 * __useFetchRetainerAccountQuery__
 *
 * To run a query within a React component, call `useFetchRetainerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRetainerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRetainerAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRetainerAccountQuery(baseOptions?: Apollo.QueryHookOptions<FetchRetainerAccountQuery, FetchRetainerAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRetainerAccountQuery, FetchRetainerAccountQueryVariables>(FetchRetainerAccountDocument, options);
      }
export function useFetchRetainerAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRetainerAccountQuery, FetchRetainerAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRetainerAccountQuery, FetchRetainerAccountQueryVariables>(FetchRetainerAccountDocument, options);
        }
export type FetchRetainerAccountQueryHookResult = ReturnType<typeof useFetchRetainerAccountQuery>;
export type FetchRetainerAccountLazyQueryHookResult = ReturnType<typeof useFetchRetainerAccountLazyQuery>;
export type FetchRetainerAccountQueryResult = Apollo.QueryResult<FetchRetainerAccountQuery, FetchRetainerAccountQueryVariables>;
export const FetchOperatingAccountDocument = gql`
    query fetchOperatingAccount {
  fetchOperatingAccount {
    id
    name
    sortCode
    currentBalance
  }
}
    `;

/**
 * __useFetchOperatingAccountQuery__
 *
 * To run a query within a React component, call `useFetchOperatingAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOperatingAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOperatingAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchOperatingAccountQuery(baseOptions?: Apollo.QueryHookOptions<FetchOperatingAccountQuery, FetchOperatingAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOperatingAccountQuery, FetchOperatingAccountQueryVariables>(FetchOperatingAccountDocument, options);
      }
export function useFetchOperatingAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOperatingAccountQuery, FetchOperatingAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOperatingAccountQuery, FetchOperatingAccountQueryVariables>(FetchOperatingAccountDocument, options);
        }
export type FetchOperatingAccountQueryHookResult = ReturnType<typeof useFetchOperatingAccountQuery>;
export type FetchOperatingAccountLazyQueryHookResult = ReturnType<typeof useFetchOperatingAccountLazyQuery>;
export type FetchOperatingAccountQueryResult = Apollo.QueryResult<FetchOperatingAccountQuery, FetchOperatingAccountQueryVariables>;
export const FetchClientLedgerDocument = gql`
    query FetchClientLedger($input: FetchClientLedgerInput!) {
  fetchClientLedger(input: $input) {
    response {
      status
      message
    }
    headers
    rows
    matter {
      id
      matterNumber
      matterTitle
      clientNumber
      clientName
      responsibleAttorney
    }
  }
}
    `;

/**
 * __useFetchClientLedgerQuery__
 *
 * To run a query within a React component, call `useFetchClientLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchClientLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchClientLedgerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchClientLedgerQuery(baseOptions: Apollo.QueryHookOptions<FetchClientLedgerQuery, FetchClientLedgerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchClientLedgerQuery, FetchClientLedgerQueryVariables>(FetchClientLedgerDocument, options);
      }
export function useFetchClientLedgerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchClientLedgerQuery, FetchClientLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchClientLedgerQuery, FetchClientLedgerQueryVariables>(FetchClientLedgerDocument, options);
        }
export type FetchClientLedgerQueryHookResult = ReturnType<typeof useFetchClientLedgerQuery>;
export type FetchClientLedgerLazyQueryHookResult = ReturnType<typeof useFetchClientLedgerLazyQuery>;
export type FetchClientLedgerQueryResult = Apollo.QueryResult<FetchClientLedgerQuery, FetchClientLedgerQueryVariables>;
export const FetchAllCourtsDocument = gql`
    query fetchAllCourts($courtsInput: CourtsInput!) {
  fetchAllCourts(courtsInput: $courtsInput) {
    courts {
      id
      name
      county
      totalCaseCount
      createdAt
      updatedAt
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllCourtsQuery__
 *
 * To run a query within a React component, call `useFetchAllCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCourtsQuery({
 *   variables: {
 *      courtsInput: // value for 'courtsInput'
 *   },
 * });
 */
export function useFetchAllCourtsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCourtsQuery, FetchAllCourtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCourtsQuery, FetchAllCourtsQueryVariables>(FetchAllCourtsDocument, options);
      }
export function useFetchAllCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCourtsQuery, FetchAllCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCourtsQuery, FetchAllCourtsQueryVariables>(FetchAllCourtsDocument, options);
        }
export type FetchAllCourtsQueryHookResult = ReturnType<typeof useFetchAllCourtsQuery>;
export type FetchAllCourtsLazyQueryHookResult = ReturnType<typeof useFetchAllCourtsLazyQuery>;
export type FetchAllCourtsQueryResult = Apollo.QueryResult<FetchAllCourtsQuery, FetchAllCourtsQueryVariables>;
export const FetchAllAssigneeCourtsDocument = gql`
    query FetchAllAssigneeCourts($courtsInput: CourtsInput!) {
  fetchAssigneeCourts(courtsInput: $courtsInput) {
    courts {
      id
      name
      startDay
      endDay
      county
      totalCaseCount
      createdAt
      updatedAt
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllAssigneeCourtsQuery__
 *
 * To run a query within a React component, call `useFetchAllAssigneeCourtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAssigneeCourtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAssigneeCourtsQuery({
 *   variables: {
 *      courtsInput: // value for 'courtsInput'
 *   },
 * });
 */
export function useFetchAllAssigneeCourtsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllAssigneeCourtsQuery, FetchAllAssigneeCourtsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAssigneeCourtsQuery, FetchAllAssigneeCourtsQueryVariables>(FetchAllAssigneeCourtsDocument, options);
      }
export function useFetchAllAssigneeCourtsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAssigneeCourtsQuery, FetchAllAssigneeCourtsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAssigneeCourtsQuery, FetchAllAssigneeCourtsQueryVariables>(FetchAllAssigneeCourtsDocument, options);
        }
export type FetchAllAssigneeCourtsQueryHookResult = ReturnType<typeof useFetchAllAssigneeCourtsQuery>;
export type FetchAllAssigneeCourtsLazyQueryHookResult = ReturnType<typeof useFetchAllAssigneeCourtsLazyQuery>;
export type FetchAllAssigneeCourtsQueryResult = Apollo.QueryResult<FetchAllAssigneeCourtsQuery, FetchAllAssigneeCourtsQueryVariables>;
export const FetchCourtDocument = gql`
    query fetchCourt($courtInput: GetCourt!) {
  fetchCourt(courtInput: $courtInput) {
    response {
      status
      message
    }
    court {
      id
      name
      county
      createdAt
      updatedAt
      litigations {
        id
        advantageCode
        title
        description
        caseNumber
        status
        createdAt
        updatedAt
        caseTypeId
        courtId
        caseToUsers {
          id
          userId
          caseId
          userType
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            status
            emailVerified
            email
            createdAt
            updatedAt
            initials
            hourlyRate
            roles {
              id
              role
              createdAt
              updatedAt
            }
          }
        }
        caseType {
          id
          name
          lawTypeId
          createdAt
          updatedAt
        }
        caseEvents {
          id
          eventType
          hearingAt
          nextHearingAt
          createdAt
          updatedAt
        }
        caseToExternalUserToExternalUserRole {
          id
          litigationId
          externalUserToExternalUserRoleId
          isArchived
          createdAt
          updatedAt
          externalUserToExternalUserRole {
            id
            externalUserId
            externalUserRoleId
            createdAt
            updatedAt
            externalUser {
              id
              firstName
              lastName
              displayName
              createdAt
              updatedAt
              clientNumber
            }
            externalUserRole {
              id
              role
              createdAt
              updatedAt
            }
          }
        }
      }
      courtToExternalUserToExternalUserRole {
        id
        courtId
        externalUserId
        externalUserToExternalUserRoleId
        isArchived
        externalUser {
          id
          firstName
          lastName
          displayName
          email
          createdAt
          updatedAt
          phoneNumber
          addresses {
            id
            address1
            address2
            city
            state
            country
            county
            zipCode
            createdAt
            updatedAt
          }
        }
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFetchCourtQuery__
 *
 * To run a query within a React component, call `useFetchCourtQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCourtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCourtQuery({
 *   variables: {
 *      courtInput: // value for 'courtInput'
 *   },
 * });
 */
export function useFetchCourtQuery(baseOptions: Apollo.QueryHookOptions<FetchCourtQuery, FetchCourtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCourtQuery, FetchCourtQueryVariables>(FetchCourtDocument, options);
      }
export function useFetchCourtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCourtQuery, FetchCourtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCourtQuery, FetchCourtQueryVariables>(FetchCourtDocument, options);
        }
export type FetchCourtQueryHookResult = ReturnType<typeof useFetchCourtQuery>;
export type FetchCourtLazyQueryHookResult = ReturnType<typeof useFetchCourtLazyQuery>;
export type FetchCourtQueryResult = Apollo.QueryResult<FetchCourtQuery, FetchCourtQueryVariables>;
export const AssignCourtToExternalUserDocument = gql`
    mutation assignCourtToExternalUser($assignExternalUserToCourt: AssignExternalUserToCourt!) {
  assignCourtToExternalUser(assignCourtInput: $assignExternalUserToCourt) {
    response {
      status
      message
    }
    court {
      id
      name
      createdAt
      updatedAt
    }
  }
}
    `;
export type AssignCourtToExternalUserMutationFn = Apollo.MutationFunction<AssignCourtToExternalUserMutation, AssignCourtToExternalUserMutationVariables>;

/**
 * __useAssignCourtToExternalUserMutation__
 *
 * To run a mutation, you first call `useAssignCourtToExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourtToExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourtToExternalUserMutation, { data, loading, error }] = useAssignCourtToExternalUserMutation({
 *   variables: {
 *      assignExternalUserToCourt: // value for 'assignExternalUserToCourt'
 *   },
 * });
 */
export function useAssignCourtToExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignCourtToExternalUserMutation, AssignCourtToExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCourtToExternalUserMutation, AssignCourtToExternalUserMutationVariables>(AssignCourtToExternalUserDocument, options);
      }
export type AssignCourtToExternalUserMutationHookResult = ReturnType<typeof useAssignCourtToExternalUserMutation>;
export type AssignCourtToExternalUserMutationResult = Apollo.MutationResult<AssignCourtToExternalUserMutation>;
export type AssignCourtToExternalUserMutationOptions = Apollo.BaseMutationOptions<AssignCourtToExternalUserMutation, AssignCourtToExternalUserMutationVariables>;
export const RemoveExternalUserFromCourtDocument = gql`
    mutation removeExternalUserFromCourt($removeExternalUserFromCourt: RemoveExternalUserFromCourt!) {
  removeExternalUserFromCourt(
    removeExternalUserFromCourtInput: $removeExternalUserFromCourt
  ) {
    response {
      status
      message
    }
  }
}
    `;
export type RemoveExternalUserFromCourtMutationFn = Apollo.MutationFunction<RemoveExternalUserFromCourtMutation, RemoveExternalUserFromCourtMutationVariables>;

/**
 * __useRemoveExternalUserFromCourtMutation__
 *
 * To run a mutation, you first call `useRemoveExternalUserFromCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalUserFromCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExternalUserFromCourtMutation, { data, loading, error }] = useRemoveExternalUserFromCourtMutation({
 *   variables: {
 *      removeExternalUserFromCourt: // value for 'removeExternalUserFromCourt'
 *   },
 * });
 */
export function useRemoveExternalUserFromCourtMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExternalUserFromCourtMutation, RemoveExternalUserFromCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExternalUserFromCourtMutation, RemoveExternalUserFromCourtMutationVariables>(RemoveExternalUserFromCourtDocument, options);
      }
export type RemoveExternalUserFromCourtMutationHookResult = ReturnType<typeof useRemoveExternalUserFromCourtMutation>;
export type RemoveExternalUserFromCourtMutationResult = Apollo.MutationResult<RemoveExternalUserFromCourtMutation>;
export type RemoveExternalUserFromCourtMutationOptions = Apollo.BaseMutationOptions<RemoveExternalUserFromCourtMutation, RemoveExternalUserFromCourtMutationVariables>;
export const CreateCourtDocument = gql`
    mutation createCourt($createCourtInput: CreateCourtInput!) {
  createCourt(createCourtInput: $createCourtInput) {
    response {
      status
      message
    }
    court {
      id
      name
      county
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateCourtMutationFn = Apollo.MutationFunction<CreateCourtMutation, CreateCourtMutationVariables>;

/**
 * __useCreateCourtMutation__
 *
 * To run a mutation, you first call `useCreateCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourtMutation, { data, loading, error }] = useCreateCourtMutation({
 *   variables: {
 *      createCourtInput: // value for 'createCourtInput'
 *   },
 * });
 */
export function useCreateCourtMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourtMutation, CreateCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourtMutation, CreateCourtMutationVariables>(CreateCourtDocument, options);
      }
export type CreateCourtMutationHookResult = ReturnType<typeof useCreateCourtMutation>;
export type CreateCourtMutationResult = Apollo.MutationResult<CreateCourtMutation>;
export type CreateCourtMutationOptions = Apollo.BaseMutationOptions<CreateCourtMutation, CreateCourtMutationVariables>;
export const UpdateCourtDocument = gql`
    mutation updateCourt($updateCourtInput: UpdateCourtInput!) {
  updateCourt(updateCourtInput: $updateCourtInput) {
    response {
      status
      message
    }
    court {
      id
      name
      county
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateCourtMutationFn = Apollo.MutationFunction<UpdateCourtMutation, UpdateCourtMutationVariables>;

/**
 * __useUpdateCourtMutation__
 *
 * To run a mutation, you first call `useUpdateCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourtMutation, { data, loading, error }] = useUpdateCourtMutation({
 *   variables: {
 *      updateCourtInput: // value for 'updateCourtInput'
 *   },
 * });
 */
export function useUpdateCourtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourtMutation, UpdateCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourtMutation, UpdateCourtMutationVariables>(UpdateCourtDocument, options);
      }
export type UpdateCourtMutationHookResult = ReturnType<typeof useUpdateCourtMutation>;
export type UpdateCourtMutationResult = Apollo.MutationResult<UpdateCourtMutation>;
export type UpdateCourtMutationOptions = Apollo.BaseMutationOptions<UpdateCourtMutation, UpdateCourtMutationVariables>;
export const RemoveCourtDocument = gql`
    mutation removeCourt($removeCourt: RemoveCourt!) {
  removeCourt(removeCourtInput: $removeCourt) {
    response {
      status
      message
    }
    court {
      id
      name
      county
      createdAt
      updatedAt
    }
  }
}
    `;
export type RemoveCourtMutationFn = Apollo.MutationFunction<RemoveCourtMutation, RemoveCourtMutationVariables>;

/**
 * __useRemoveCourtMutation__
 *
 * To run a mutation, you first call `useRemoveCourtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourtMutation, { data, loading, error }] = useRemoveCourtMutation({
 *   variables: {
 *      removeCourt: // value for 'removeCourt'
 *   },
 * });
 */
export function useRemoveCourtMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCourtMutation, RemoveCourtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCourtMutation, RemoveCourtMutationVariables>(RemoveCourtDocument, options);
      }
export type RemoveCourtMutationHookResult = ReturnType<typeof useRemoveCourtMutation>;
export type RemoveCourtMutationResult = Apollo.MutationResult<RemoveCourtMutation>;
export type RemoveCourtMutationOptions = Apollo.BaseMutationOptions<RemoveCourtMutation, RemoveCourtMutationVariables>;
export const FetchAllAssignedTasksDocument = gql`
    query fetchAllAssignedTasks($tasksByAssigneeInput: TasksByAssigneeInput!) {
  fetchAllAssignedTasks(tasksInput: $tasksByAssigneeInput) {
    response {
      status
      message
    }
    userCaseTasks {
      id
      status
      createdAt
      updatedAt
      taskId
      followUpDate
      task {
        id
        title
        createdAt
        updatedAt
      }
      litigation {
        id
        advantageCode
        title
        description
        caseNumber
        status
        caseTypeId
        courtId
        createdAt
        updatedAt
        caseToExternalUserToExternalUserRole {
          id
          litigationId
          externalUserToExternalUserRoleId
          isArchived
          createdAt
          updatedAt
          externalUserToExternalUserRole {
            id
            externalUserId
            externalUserRoleId
            createdAt
            updatedAt
            externalUser {
              id
              firstName
              lastName
              displayName
              clientNumber
              createdAt
              updatedAt
              externalUserRoles {
                id
                createdAt
                updatedAt
                externalUserId
                externalUserRoleId
                externalUserRole {
                  id
                  role
                  createdAt
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAllAssignedTasksQuery__
 *
 * To run a query within a React component, call `useFetchAllAssignedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAssignedTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAssignedTasksQuery({
 *   variables: {
 *      tasksByAssigneeInput: // value for 'tasksByAssigneeInput'
 *   },
 * });
 */
export function useFetchAllAssignedTasksQuery(baseOptions: Apollo.QueryHookOptions<FetchAllAssignedTasksQuery, FetchAllAssignedTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAssignedTasksQuery, FetchAllAssignedTasksQueryVariables>(FetchAllAssignedTasksDocument, options);
      }
export function useFetchAllAssignedTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAssignedTasksQuery, FetchAllAssignedTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAssignedTasksQuery, FetchAllAssignedTasksQueryVariables>(FetchAllAssignedTasksDocument, options);
        }
export type FetchAllAssignedTasksQueryHookResult = ReturnType<typeof useFetchAllAssignedTasksQuery>;
export type FetchAllAssignedTasksLazyQueryHookResult = ReturnType<typeof useFetchAllAssignedTasksLazyQuery>;
export type FetchAllAssignedTasksQueryResult = Apollo.QueryResult<FetchAllAssignedTasksQuery, FetchAllAssignedTasksQueryVariables>;
export const FetchAllDepartmentsDocument = gql`
    query FetchAllDepartments($fetchDepartmentsInput: FetchDepartmentsInput!) {
  fetchAllDepartments(fetchDepartmentsInput: $fetchDepartmentsInput) {
    response {
      message
      status
    }
    departments {
      id
      name
      description
      departmentHeadId
      departmentHead {
        id
        email
        firstName
        lastName
      }
      departmentToLawTypes {
        lawType {
          id
          name
        }
      }
    }
    pagination {
      totalCount
      totalPages
      page
    }
  }
}
    `;

/**
 * __useFetchAllDepartmentsQuery__
 *
 * To run a query within a React component, call `useFetchAllDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllDepartmentsQuery({
 *   variables: {
 *      fetchDepartmentsInput: // value for 'fetchDepartmentsInput'
 *   },
 * });
 */
export function useFetchAllDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllDepartmentsQuery, FetchAllDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllDepartmentsQuery, FetchAllDepartmentsQueryVariables>(FetchAllDepartmentsDocument, options);
      }
export function useFetchAllDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllDepartmentsQuery, FetchAllDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllDepartmentsQuery, FetchAllDepartmentsQueryVariables>(FetchAllDepartmentsDocument, options);
        }
export type FetchAllDepartmentsQueryHookResult = ReturnType<typeof useFetchAllDepartmentsQuery>;
export type FetchAllDepartmentsLazyQueryHookResult = ReturnType<typeof useFetchAllDepartmentsLazyQuery>;
export type FetchAllDepartmentsQueryResult = Apollo.QueryResult<FetchAllDepartmentsQuery, FetchAllDepartmentsQueryVariables>;
export const IsDepartmentHeadForCaseDocument = gql`
    query isDepartmentHeadForCase($fetchDepartmentHeadInput: FetchDepartmentHeadInput!) {
  isDepartmentHeadForCase(fetchDepartmentHeadInput: $fetchDepartmentHeadInput) {
    response {
      message
      status
    }
    isDepartmentHead
  }
}
    `;

/**
 * __useIsDepartmentHeadForCaseQuery__
 *
 * To run a query within a React component, call `useIsDepartmentHeadForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDepartmentHeadForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDepartmentHeadForCaseQuery({
 *   variables: {
 *      fetchDepartmentHeadInput: // value for 'fetchDepartmentHeadInput'
 *   },
 * });
 */
export function useIsDepartmentHeadForCaseQuery(baseOptions: Apollo.QueryHookOptions<IsDepartmentHeadForCaseQuery, IsDepartmentHeadForCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDepartmentHeadForCaseQuery, IsDepartmentHeadForCaseQueryVariables>(IsDepartmentHeadForCaseDocument, options);
      }
export function useIsDepartmentHeadForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDepartmentHeadForCaseQuery, IsDepartmentHeadForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDepartmentHeadForCaseQuery, IsDepartmentHeadForCaseQueryVariables>(IsDepartmentHeadForCaseDocument, options);
        }
export type IsDepartmentHeadForCaseQueryHookResult = ReturnType<typeof useIsDepartmentHeadForCaseQuery>;
export type IsDepartmentHeadForCaseLazyQueryHookResult = ReturnType<typeof useIsDepartmentHeadForCaseLazyQuery>;
export type IsDepartmentHeadForCaseQueryResult = Apollo.QueryResult<IsDepartmentHeadForCaseQuery, IsDepartmentHeadForCaseQueryVariables>;
export const GetDepartmentHeadForCaseDocument = gql`
    query getDepartmentHeadForCase($caseId: String!) {
  getDepartmentHeadForCase(caseId: $caseId) {
    departmentHead {
      id
      firstName
      lastName
    }
    response {
      message
      status
    }
  }
}
    `;

/**
 * __useGetDepartmentHeadForCaseQuery__
 *
 * To run a query within a React component, call `useGetDepartmentHeadForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentHeadForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentHeadForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetDepartmentHeadForCaseQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentHeadForCaseQuery, GetDepartmentHeadForCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentHeadForCaseQuery, GetDepartmentHeadForCaseQueryVariables>(GetDepartmentHeadForCaseDocument, options);
      }
export function useGetDepartmentHeadForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentHeadForCaseQuery, GetDepartmentHeadForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentHeadForCaseQuery, GetDepartmentHeadForCaseQueryVariables>(GetDepartmentHeadForCaseDocument, options);
        }
export type GetDepartmentHeadForCaseQueryHookResult = ReturnType<typeof useGetDepartmentHeadForCaseQuery>;
export type GetDepartmentHeadForCaseLazyQueryHookResult = ReturnType<typeof useGetDepartmentHeadForCaseLazyQuery>;
export type GetDepartmentHeadForCaseQueryResult = Apollo.QueryResult<GetDepartmentHeadForCaseQuery, GetDepartmentHeadForCaseQueryVariables>;
export const FetchDepartmentUsersByLawTypeDocument = gql`
    query FetchDepartmentUsersByLawType($fetchDepartmentUsersByLawTypeInput: FetchDepartmentUsersByLawTypeInput!) {
  fetchDepartmentUsersByLawType(
    fetchDepartmentUsersByLawTypeInput: $fetchDepartmentUsersByLawTypeInput
  ) {
    response {
      status
      message
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    users {
      id
      firstName
      lastName
      email
      emailVerified
      status
      updatedAt
      createdAt
      departmentHead
    }
  }
}
    `;

/**
 * __useFetchDepartmentUsersByLawTypeQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentUsersByLawTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentUsersByLawTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentUsersByLawTypeQuery({
 *   variables: {
 *      fetchDepartmentUsersByLawTypeInput: // value for 'fetchDepartmentUsersByLawTypeInput'
 *   },
 * });
 */
export function useFetchDepartmentUsersByLawTypeQuery(baseOptions: Apollo.QueryHookOptions<FetchDepartmentUsersByLawTypeQuery, FetchDepartmentUsersByLawTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDepartmentUsersByLawTypeQuery, FetchDepartmentUsersByLawTypeQueryVariables>(FetchDepartmentUsersByLawTypeDocument, options);
      }
export function useFetchDepartmentUsersByLawTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDepartmentUsersByLawTypeQuery, FetchDepartmentUsersByLawTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDepartmentUsersByLawTypeQuery, FetchDepartmentUsersByLawTypeQueryVariables>(FetchDepartmentUsersByLawTypeDocument, options);
        }
export type FetchDepartmentUsersByLawTypeQueryHookResult = ReturnType<typeof useFetchDepartmentUsersByLawTypeQuery>;
export type FetchDepartmentUsersByLawTypeLazyQueryHookResult = ReturnType<typeof useFetchDepartmentUsersByLawTypeLazyQuery>;
export type FetchDepartmentUsersByLawTypeQueryResult = Apollo.QueryResult<FetchDepartmentUsersByLawTypeQuery, FetchDepartmentUsersByLawTypeQueryVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($createDepartmentInput: CreateDepartmentInput!) {
  createDepartment(createDepartmentInput: $createDepartmentInput) {
    response {
      message
      status
    }
    department {
      departmentHead {
        id
        lastName
        firstName
      }
      description
      id
      name
    }
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      createDepartmentInput: // value for 'createDepartmentInput'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($updateDepartmentInput: UpdateDepartmentInput!) {
  updateDepartment(updateDepartmentInput: $updateDepartmentInput) {
    response {
      status
      message
    }
    department {
      id
      name
    }
  }
}
    `;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      updateDepartmentInput: // value for 'updateDepartmentInput'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($deleteDepartmentId: String!) {
  deleteDepartment(id: $deleteDepartmentId) {
    message
    status
  }
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      deleteDepartmentId: // value for 'deleteDepartmentId'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
      }
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = Apollo.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;
export const DocPagesTreeDocument = gql`
    query DocPagesTree($scope: DocPageScope) {
  docPagesTree(scope: $scope) {
    docPages {
      ...DocPageSummary
    }
    response {
      status
      message
    }
  }
}
    ${DocPageSummaryFragmentDoc}`;

/**
 * __useDocPagesTreeQuery__
 *
 * To run a query within a React component, call `useDocPagesTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocPagesTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocPagesTreeQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDocPagesTreeQuery(baseOptions?: Apollo.QueryHookOptions<DocPagesTreeQuery, DocPagesTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocPagesTreeQuery, DocPagesTreeQueryVariables>(DocPagesTreeDocument, options);
      }
export function useDocPagesTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocPagesTreeQuery, DocPagesTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocPagesTreeQuery, DocPagesTreeQueryVariables>(DocPagesTreeDocument, options);
        }
export type DocPagesTreeQueryHookResult = ReturnType<typeof useDocPagesTreeQuery>;
export type DocPagesTreeLazyQueryHookResult = ReturnType<typeof useDocPagesTreeLazyQuery>;
export type DocPagesTreeQueryResult = Apollo.QueryResult<DocPagesTreeQuery, DocPagesTreeQueryVariables>;
export const SearchDocPagesDocument = gql`
    query SearchDocPages($searchDocPagesInput: SearchDocPagesInput!) {
  searchDocPages(searchDocPagesInput: $searchDocPagesInput) {
    results {
      page {
        ...DocPageSummary
      }
      titleMatch
      snippet
    }
    total
    page
    limit
    response {
      status
      message
    }
  }
}
    ${DocPageSummaryFragmentDoc}`;

/**
 * __useSearchDocPagesQuery__
 *
 * To run a query within a React component, call `useSearchDocPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDocPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDocPagesQuery({
 *   variables: {
 *      searchDocPagesInput: // value for 'searchDocPagesInput'
 *   },
 * });
 */
export function useSearchDocPagesQuery(baseOptions: Apollo.QueryHookOptions<SearchDocPagesQuery, SearchDocPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDocPagesQuery, SearchDocPagesQueryVariables>(SearchDocPagesDocument, options);
      }
export function useSearchDocPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDocPagesQuery, SearchDocPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDocPagesQuery, SearchDocPagesQueryVariables>(SearchDocPagesDocument, options);
        }
export type SearchDocPagesQueryHookResult = ReturnType<typeof useSearchDocPagesQuery>;
export type SearchDocPagesLazyQueryHookResult = ReturnType<typeof useSearchDocPagesLazyQuery>;
export type SearchDocPagesQueryResult = Apollo.QueryResult<SearchDocPagesQuery, SearchDocPagesQueryVariables>;
export const RecentDocPagesDocument = gql`
    query RecentDocPages($scope: DocPageScope, $limit: Int) {
  recentDocPages(scope: $scope, limit: $limit) {
    docPages {
      ...DocPageSummary
    }
    response {
      status
      message
    }
  }
}
    ${DocPageSummaryFragmentDoc}`;

/**
 * __useRecentDocPagesQuery__
 *
 * To run a query within a React component, call `useRecentDocPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentDocPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentDocPagesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentDocPagesQuery(baseOptions?: Apollo.QueryHookOptions<RecentDocPagesQuery, RecentDocPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentDocPagesQuery, RecentDocPagesQueryVariables>(RecentDocPagesDocument, options);
      }
export function useRecentDocPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentDocPagesQuery, RecentDocPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentDocPagesQuery, RecentDocPagesQueryVariables>(RecentDocPagesDocument, options);
        }
export type RecentDocPagesQueryHookResult = ReturnType<typeof useRecentDocPagesQuery>;
export type RecentDocPagesLazyQueryHookResult = ReturnType<typeof useRecentDocPagesLazyQuery>;
export type RecentDocPagesQueryResult = Apollo.QueryResult<RecentDocPagesQuery, RecentDocPagesQueryVariables>;
export const DocPageDocument = gql`
    query DocPage($fetchDocPageInput: FetchDocPageInput!) {
  docPage(fetchDocPageInput: $fetchDocPageInput) {
    docPage {
      ...DocPageDetail
    }
    response {
      status
      message
    }
  }
}
    ${DocPageDetailFragmentDoc}`;

/**
 * __useDocPageQuery__
 *
 * To run a query within a React component, call `useDocPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocPageQuery({
 *   variables: {
 *      fetchDocPageInput: // value for 'fetchDocPageInput'
 *   },
 * });
 */
export function useDocPageQuery(baseOptions: Apollo.QueryHookOptions<DocPageQuery, DocPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocPageQuery, DocPageQueryVariables>(DocPageDocument, options);
      }
export function useDocPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocPageQuery, DocPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocPageQuery, DocPageQueryVariables>(DocPageDocument, options);
        }
export type DocPageQueryHookResult = ReturnType<typeof useDocPageQuery>;
export type DocPageLazyQueryHookResult = ReturnType<typeof useDocPageLazyQuery>;
export type DocPageQueryResult = Apollo.QueryResult<DocPageQuery, DocPageQueryVariables>;
export const DocPageRevisionsDocument = gql`
    query DocPageRevisions($pageId: String!) {
  docPageRevisions(pageId: $pageId) {
    revisions {
      id
      title
      status
      changeSummary
      content
      createdAt
      editor {
        id
        firstName
        lastName
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useDocPageRevisionsQuery__
 *
 * To run a query within a React component, call `useDocPageRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocPageRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocPageRevisionsQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDocPageRevisionsQuery(baseOptions: Apollo.QueryHookOptions<DocPageRevisionsQuery, DocPageRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocPageRevisionsQuery, DocPageRevisionsQueryVariables>(DocPageRevisionsDocument, options);
      }
export function useDocPageRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocPageRevisionsQuery, DocPageRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocPageRevisionsQuery, DocPageRevisionsQueryVariables>(DocPageRevisionsDocument, options);
        }
export type DocPageRevisionsQueryHookResult = ReturnType<typeof useDocPageRevisionsQuery>;
export type DocPageRevisionsLazyQueryHookResult = ReturnType<typeof useDocPageRevisionsLazyQuery>;
export type DocPageRevisionsQueryResult = Apollo.QueryResult<DocPageRevisionsQuery, DocPageRevisionsQueryVariables>;
export const CreateDocPageDocument = gql`
    mutation CreateDocPage($createDocPageInput: CreateDocPageInput!) {
  createDocPage(createDocPageInput: $createDocPageInput) {
    docPage {
      ...DocPageDetail
    }
    response {
      status
      message
    }
  }
}
    ${DocPageDetailFragmentDoc}`;
export type CreateDocPageMutationFn = Apollo.MutationFunction<CreateDocPageMutation, CreateDocPageMutationVariables>;

/**
 * __useCreateDocPageMutation__
 *
 * To run a mutation, you first call `useCreateDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocPageMutation, { data, loading, error }] = useCreateDocPageMutation({
 *   variables: {
 *      createDocPageInput: // value for 'createDocPageInput'
 *   },
 * });
 */
export function useCreateDocPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocPageMutation, CreateDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocPageMutation, CreateDocPageMutationVariables>(CreateDocPageDocument, options);
      }
export type CreateDocPageMutationHookResult = ReturnType<typeof useCreateDocPageMutation>;
export type CreateDocPageMutationResult = Apollo.MutationResult<CreateDocPageMutation>;
export type CreateDocPageMutationOptions = Apollo.BaseMutationOptions<CreateDocPageMutation, CreateDocPageMutationVariables>;
export const UpdateDocPageDocument = gql`
    mutation UpdateDocPage($updateDocPageInput: UpdateDocPageInput!) {
  updateDocPage(updateDocPageInput: $updateDocPageInput) {
    docPage {
      ...DocPageDetail
    }
    response {
      status
      message
    }
  }
}
    ${DocPageDetailFragmentDoc}`;
export type UpdateDocPageMutationFn = Apollo.MutationFunction<UpdateDocPageMutation, UpdateDocPageMutationVariables>;

/**
 * __useUpdateDocPageMutation__
 *
 * To run a mutation, you first call `useUpdateDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocPageMutation, { data, loading, error }] = useUpdateDocPageMutation({
 *   variables: {
 *      updateDocPageInput: // value for 'updateDocPageInput'
 *   },
 * });
 */
export function useUpdateDocPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocPageMutation, UpdateDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocPageMutation, UpdateDocPageMutationVariables>(UpdateDocPageDocument, options);
      }
export type UpdateDocPageMutationHookResult = ReturnType<typeof useUpdateDocPageMutation>;
export type UpdateDocPageMutationResult = Apollo.MutationResult<UpdateDocPageMutation>;
export type UpdateDocPageMutationOptions = Apollo.BaseMutationOptions<UpdateDocPageMutation, UpdateDocPageMutationVariables>;
export const SaveDocPageDraftDocument = gql`
    mutation SaveDocPageDraft($saveDocPageDraftInput: SaveDocPageDraftInput!) {
  saveDocPageDraft(saveDocPageDraftInput: $saveDocPageDraftInput) {
    docPage {
      id
      title
      updatedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type SaveDocPageDraftMutationFn = Apollo.MutationFunction<SaveDocPageDraftMutation, SaveDocPageDraftMutationVariables>;

/**
 * __useSaveDocPageDraftMutation__
 *
 * To run a mutation, you first call `useSaveDocPageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocPageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocPageDraftMutation, { data, loading, error }] = useSaveDocPageDraftMutation({
 *   variables: {
 *      saveDocPageDraftInput: // value for 'saveDocPageDraftInput'
 *   },
 * });
 */
export function useSaveDocPageDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveDocPageDraftMutation, SaveDocPageDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDocPageDraftMutation, SaveDocPageDraftMutationVariables>(SaveDocPageDraftDocument, options);
      }
export type SaveDocPageDraftMutationHookResult = ReturnType<typeof useSaveDocPageDraftMutation>;
export type SaveDocPageDraftMutationResult = Apollo.MutationResult<SaveDocPageDraftMutation>;
export type SaveDocPageDraftMutationOptions = Apollo.BaseMutationOptions<SaveDocPageDraftMutation, SaveDocPageDraftMutationVariables>;
export const PublishDocPageDocument = gql`
    mutation PublishDocPage($publishDocPageInput: PublishDocPageInput!) {
  publishDocPage(publishDocPageInput: $publishDocPageInput) {
    docPage {
      ...DocPageDetail
    }
    response {
      status
      message
    }
  }
}
    ${DocPageDetailFragmentDoc}`;
export type PublishDocPageMutationFn = Apollo.MutationFunction<PublishDocPageMutation, PublishDocPageMutationVariables>;

/**
 * __usePublishDocPageMutation__
 *
 * To run a mutation, you first call `usePublishDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDocPageMutation, { data, loading, error }] = usePublishDocPageMutation({
 *   variables: {
 *      publishDocPageInput: // value for 'publishDocPageInput'
 *   },
 * });
 */
export function usePublishDocPageMutation(baseOptions?: Apollo.MutationHookOptions<PublishDocPageMutation, PublishDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDocPageMutation, PublishDocPageMutationVariables>(PublishDocPageDocument, options);
      }
export type PublishDocPageMutationHookResult = ReturnType<typeof usePublishDocPageMutation>;
export type PublishDocPageMutationResult = Apollo.MutationResult<PublishDocPageMutation>;
export type PublishDocPageMutationOptions = Apollo.BaseMutationOptions<PublishDocPageMutation, PublishDocPageMutationVariables>;
export const ArchiveDocPageDocument = gql`
    mutation ArchiveDocPage($id: String!) {
  archiveDocPage(id: $id) {
    docPage {
      id
      status
    }
    response {
      status
      message
    }
  }
}
    `;
export type ArchiveDocPageMutationFn = Apollo.MutationFunction<ArchiveDocPageMutation, ArchiveDocPageMutationVariables>;

/**
 * __useArchiveDocPageMutation__
 *
 * To run a mutation, you first call `useArchiveDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocPageMutation, { data, loading, error }] = useArchiveDocPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveDocPageMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDocPageMutation, ArchiveDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDocPageMutation, ArchiveDocPageMutationVariables>(ArchiveDocPageDocument, options);
      }
export type ArchiveDocPageMutationHookResult = ReturnType<typeof useArchiveDocPageMutation>;
export type ArchiveDocPageMutationResult = Apollo.MutationResult<ArchiveDocPageMutation>;
export type ArchiveDocPageMutationOptions = Apollo.BaseMutationOptions<ArchiveDocPageMutation, ArchiveDocPageMutationVariables>;
export const UnarchiveDocPageDocument = gql`
    mutation UnarchiveDocPage($id: String!) {
  unarchiveDocPage(id: $id) {
    docPage {
      id
      status
    }
    response {
      status
      message
    }
  }
}
    `;
export type UnarchiveDocPageMutationFn = Apollo.MutationFunction<UnarchiveDocPageMutation, UnarchiveDocPageMutationVariables>;

/**
 * __useUnarchiveDocPageMutation__
 *
 * To run a mutation, you first call `useUnarchiveDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveDocPageMutation, { data, loading, error }] = useUnarchiveDocPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveDocPageMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveDocPageMutation, UnarchiveDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveDocPageMutation, UnarchiveDocPageMutationVariables>(UnarchiveDocPageDocument, options);
      }
export type UnarchiveDocPageMutationHookResult = ReturnType<typeof useUnarchiveDocPageMutation>;
export type UnarchiveDocPageMutationResult = Apollo.MutationResult<UnarchiveDocPageMutation>;
export type UnarchiveDocPageMutationOptions = Apollo.BaseMutationOptions<UnarchiveDocPageMutation, UnarchiveDocPageMutationVariables>;
export const DeleteDocPageDocument = gql`
    mutation DeleteDocPage($id: String!) {
  deleteDocPage(id: $id) {
    response {
      status
      message
    }
  }
}
    `;
export type DeleteDocPageMutationFn = Apollo.MutationFunction<DeleteDocPageMutation, DeleteDocPageMutationVariables>;

/**
 * __useDeleteDocPageMutation__
 *
 * To run a mutation, you first call `useDeleteDocPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocPageMutation, { data, loading, error }] = useDeleteDocPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocPageMutation, DeleteDocPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocPageMutation, DeleteDocPageMutationVariables>(DeleteDocPageDocument, options);
      }
export type DeleteDocPageMutationHookResult = ReturnType<typeof useDeleteDocPageMutation>;
export type DeleteDocPageMutationResult = Apollo.MutationResult<DeleteDocPageMutation>;
export type DeleteDocPageMutationOptions = Apollo.BaseMutationOptions<DeleteDocPageMutation, DeleteDocPageMutationVariables>;
export const ReorderDocPagesDocument = gql`
    mutation ReorderDocPages($reorderDocPagesInput: ReorderDocPagesInput!) {
  reorderDocPages(reorderDocPagesInput: $reorderDocPagesInput) {
    docPages {
      ...DocPageSummary
    }
    response {
      status
      message
    }
  }
}
    ${DocPageSummaryFragmentDoc}`;
export type ReorderDocPagesMutationFn = Apollo.MutationFunction<ReorderDocPagesMutation, ReorderDocPagesMutationVariables>;

/**
 * __useReorderDocPagesMutation__
 *
 * To run a mutation, you first call `useReorderDocPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderDocPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderDocPagesMutation, { data, loading, error }] = useReorderDocPagesMutation({
 *   variables: {
 *      reorderDocPagesInput: // value for 'reorderDocPagesInput'
 *   },
 * });
 */
export function useReorderDocPagesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderDocPagesMutation, ReorderDocPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderDocPagesMutation, ReorderDocPagesMutationVariables>(ReorderDocPagesDocument, options);
      }
export type ReorderDocPagesMutationHookResult = ReturnType<typeof useReorderDocPagesMutation>;
export type ReorderDocPagesMutationResult = Apollo.MutationResult<ReorderDocPagesMutation>;
export type ReorderDocPagesMutationOptions = Apollo.BaseMutationOptions<ReorderDocPagesMutation, ReorderDocPagesMutationVariables>;
export const FetchAllEntriesDocument = gql`
    query FetchAllEntries($fetchTimeEntriesInput: FetchEntriesInput!) {
  fetchAllEntries(fetchEntriesInput: $fetchTimeEntriesInput) {
    response {
      status
    }
    entries {
      id
      billable
      amount
      qty
      unitPrice
      caseId
      case {
        id
        title
        caseNumber
        isConsultMatter
        consultMatterNumber
        caseToExternalUserToExternalUserRole {
          externalUserToExternalUserRole {
            externalUser {
              id
              lastName
              firstName
              displayName
            }
          }
        }
      }
      date
      description
      duration
      status
      user {
        id
        firstName
        lastName
      }
      userId
      creatorId
      creator {
        id
        firstName
        lastName
      }
      category {
        id
        name
      }
      rate
      rateType
      sendNotesToMatterNotes
      showOnBill
      userType
      entryType
      categoryId
      feeType {
        id
        feeType
      }
      feeTypeId
      isSystemGenerated
      startTime
      createdAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchAllEntriesQuery__
 *
 * To run a query within a React component, call `useFetchAllEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllEntriesQuery({
 *   variables: {
 *      fetchTimeEntriesInput: // value for 'fetchTimeEntriesInput'
 *   },
 * });
 */
export function useFetchAllEntriesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllEntriesQuery, FetchAllEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllEntriesQuery, FetchAllEntriesQueryVariables>(FetchAllEntriesDocument, options);
      }
export function useFetchAllEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllEntriesQuery, FetchAllEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllEntriesQuery, FetchAllEntriesQueryVariables>(FetchAllEntriesDocument, options);
        }
export type FetchAllEntriesQueryHookResult = ReturnType<typeof useFetchAllEntriesQuery>;
export type FetchAllEntriesLazyQueryHookResult = ReturnType<typeof useFetchAllEntriesLazyQuery>;
export type FetchAllEntriesQueryResult = Apollo.QueryResult<FetchAllEntriesQuery, FetchAllEntriesQueryVariables>;
export const CreateManualEntryDocument = gql`
    mutation CreateManualEntry($input: CreateManualEntryInput!) {
  createManualEntry(input: $input) {
    response {
      message
      status
    }
    entry {
      id
      duration
      description
    }
  }
}
    `;
export type CreateManualEntryMutationFn = Apollo.MutationFunction<CreateManualEntryMutation, CreateManualEntryMutationVariables>;

/**
 * __useCreateManualEntryMutation__
 *
 * To run a mutation, you first call `useCreateManualEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualEntryMutation, { data, loading, error }] = useCreateManualEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualEntryMutation, CreateManualEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualEntryMutation, CreateManualEntryMutationVariables>(CreateManualEntryDocument, options);
      }
export type CreateManualEntryMutationHookResult = ReturnType<typeof useCreateManualEntryMutation>;
export type CreateManualEntryMutationResult = Apollo.MutationResult<CreateManualEntryMutation>;
export type CreateManualEntryMutationOptions = Apollo.BaseMutationOptions<CreateManualEntryMutation, CreateManualEntryMutationVariables>;
export const UpdateEntryDocument = gql`
    mutation UpdateEntry($input: UpdateEntryInput!) {
  updateEntry(input: $input) {
    response {
      message
      status
    }
    entry {
      id
    }
  }
}
    `;
export type UpdateEntryMutationFn = Apollo.MutationFunction<UpdateEntryMutation, UpdateEntryMutationVariables>;

/**
 * __useUpdateEntryMutation__
 *
 * To run a mutation, you first call `useUpdateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntryMutation, { data, loading, error }] = useUpdateEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntryMutation, UpdateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntryMutation, UpdateEntryMutationVariables>(UpdateEntryDocument, options);
      }
export type UpdateEntryMutationHookResult = ReturnType<typeof useUpdateEntryMutation>;
export type UpdateEntryMutationResult = Apollo.MutationResult<UpdateEntryMutation>;
export type UpdateEntryMutationOptions = Apollo.BaseMutationOptions<UpdateEntryMutation, UpdateEntryMutationVariables>;
export const DeleteEntryDocument = gql`
    mutation DeleteEntry($entryId: String!) {
  deleteEntry(entryId: $entryId) {
    response {
      message
      status
    }
  }
}
    `;
export type DeleteEntryMutationFn = Apollo.MutationFunction<DeleteEntryMutation, DeleteEntryMutationVariables>;

/**
 * __useDeleteEntryMutation__
 *
 * To run a mutation, you first call `useDeleteEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntryMutation, { data, loading, error }] = useDeleteEntryMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useDeleteEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntryMutation, DeleteEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntryMutation, DeleteEntryMutationVariables>(DeleteEntryDocument, options);
      }
export type DeleteEntryMutationHookResult = ReturnType<typeof useDeleteEntryMutation>;
export type DeleteEntryMutationResult = Apollo.MutationResult<DeleteEntryMutation>;
export type DeleteEntryMutationOptions = Apollo.BaseMutationOptions<DeleteEntryMutation, DeleteEntryMutationVariables>;
export const StartTimerDocument = gql`
    mutation StartTimer($input: StartTimerInput!) {
  startTimer(input: $input) {
    response {
      message
      status
    }
    entry {
      id
      startTime
      userId
      entryType
      status
      user {
        lastName
        firstName
        id
      }
      pauseTime
      isTimerPaused
      totalPausedTime
      billable
      showOnBill
      caseId
      date
      case {
        id
        title
        caseNumber
        consultMatterNumber
        isConsultMatter
      }
      description
      rate
      rateType
      sendNotesToMatterNotes
      createdAt
      updatedAt
    }
  }
}
    `;
export type StartTimerMutationFn = Apollo.MutationFunction<StartTimerMutation, StartTimerMutationVariables>;

/**
 * __useStartTimerMutation__
 *
 * To run a mutation, you first call `useStartTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTimerMutation, { data, loading, error }] = useStartTimerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTimerMutation(baseOptions?: Apollo.MutationHookOptions<StartTimerMutation, StartTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTimerMutation, StartTimerMutationVariables>(StartTimerDocument, options);
      }
export type StartTimerMutationHookResult = ReturnType<typeof useStartTimerMutation>;
export type StartTimerMutationResult = Apollo.MutationResult<StartTimerMutation>;
export type StartTimerMutationOptions = Apollo.BaseMutationOptions<StartTimerMutation, StartTimerMutationVariables>;
export const StopTimerDocument = gql`
    mutation StopTimer($timeEntryId: String!) {
  stopTimer(timeEntryId: $timeEntryId) {
    response {
      message
      status
    }
    entry {
      id
      case {
        title
      }
    }
  }
}
    `;
export type StopTimerMutationFn = Apollo.MutationFunction<StopTimerMutation, StopTimerMutationVariables>;

/**
 * __useStopTimerMutation__
 *
 * To run a mutation, you first call `useStopTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTimerMutation, { data, loading, error }] = useStopTimerMutation({
 *   variables: {
 *      timeEntryId: // value for 'timeEntryId'
 *   },
 * });
 */
export function useStopTimerMutation(baseOptions?: Apollo.MutationHookOptions<StopTimerMutation, StopTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopTimerMutation, StopTimerMutationVariables>(StopTimerDocument, options);
      }
export type StopTimerMutationHookResult = ReturnType<typeof useStopTimerMutation>;
export type StopTimerMutationResult = Apollo.MutationResult<StopTimerMutation>;
export type StopTimerMutationOptions = Apollo.BaseMutationOptions<StopTimerMutation, StopTimerMutationVariables>;
export const PauseOrResumeTimerDocument = gql`
    mutation PauseOrResumeTimer($timeEntryId: String!) {
  pauseOrResumeTimer(timeEntryId: $timeEntryId) {
    response {
      message
      status
    }
    entry {
      id
      isTimerPaused
      pauseTime
      totalPausedTime
      startTime
    }
  }
}
    `;
export type PauseOrResumeTimerMutationFn = Apollo.MutationFunction<PauseOrResumeTimerMutation, PauseOrResumeTimerMutationVariables>;

/**
 * __usePauseOrResumeTimerMutation__
 *
 * To run a mutation, you first call `usePauseOrResumeTimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseOrResumeTimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseOrResumeTimerMutation, { data, loading, error }] = usePauseOrResumeTimerMutation({
 *   variables: {
 *      timeEntryId: // value for 'timeEntryId'
 *   },
 * });
 */
export function usePauseOrResumeTimerMutation(baseOptions?: Apollo.MutationHookOptions<PauseOrResumeTimerMutation, PauseOrResumeTimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseOrResumeTimerMutation, PauseOrResumeTimerMutationVariables>(PauseOrResumeTimerDocument, options);
      }
export type PauseOrResumeTimerMutationHookResult = ReturnType<typeof usePauseOrResumeTimerMutation>;
export type PauseOrResumeTimerMutationResult = Apollo.MutationResult<PauseOrResumeTimerMutation>;
export type PauseOrResumeTimerMutationOptions = Apollo.BaseMutationOptions<PauseOrResumeTimerMutation, PauseOrResumeTimerMutationVariables>;
export const GetRunningTimersDocument = gql`
    query GetRunningTimers {
  getRunningTimers {
    response {
      message
      status
    }
    entries {
      id
      startTime
      userId
      creatorId
      user {
        lastName
        firstName
        id
      }
      pauseTime
      isTimerPaused
      totalPausedTime
      billable
      showOnBill
      rate
      rateType
      sendNotesToMatterNotes
      caseId
      date
      entryType
      description
      case {
        id
        title
        caseNumber
        consultMatterNumber
        isConsultMatter
      }
    }
  }
}
    `;

/**
 * __useGetRunningTimersQuery__
 *
 * To run a query within a React component, call `useGetRunningTimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunningTimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunningTimersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRunningTimersQuery(baseOptions?: Apollo.QueryHookOptions<GetRunningTimersQuery, GetRunningTimersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRunningTimersQuery, GetRunningTimersQueryVariables>(GetRunningTimersDocument, options);
      }
export function useGetRunningTimersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRunningTimersQuery, GetRunningTimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRunningTimersQuery, GetRunningTimersQueryVariables>(GetRunningTimersDocument, options);
        }
export type GetRunningTimersQueryHookResult = ReturnType<typeof useGetRunningTimersQuery>;
export type GetRunningTimersLazyQueryHookResult = ReturnType<typeof useGetRunningTimersLazyQuery>;
export type GetRunningTimersQueryResult = Apollo.QueryResult<GetRunningTimersQuery, GetRunningTimersQueryVariables>;
export const FetchAllCategoriesDocument = gql`
    query FetchAllCategories($fetchCategoriesInput: FetchCategoriesInput!) {
  fetchAllCategories(fetchCategoriesInput: $fetchCategoriesInput) {
    categories {
      id
      name
      description
    }
    response {
      message
      status
    }
    pagination {
      totalCount
      page
      totalPages
    }
  }
}
    `;

/**
 * __useFetchAllCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCategoriesQuery({
 *   variables: {
 *      fetchCategoriesInput: // value for 'fetchCategoriesInput'
 *   },
 * });
 */
export function useFetchAllCategoriesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCategoriesQuery, FetchAllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCategoriesQuery, FetchAllCategoriesQueryVariables>(FetchAllCategoriesDocument, options);
      }
export function useFetchAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCategoriesQuery, FetchAllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCategoriesQuery, FetchAllCategoriesQueryVariables>(FetchAllCategoriesDocument, options);
        }
export type FetchAllCategoriesQueryHookResult = ReturnType<typeof useFetchAllCategoriesQuery>;
export type FetchAllCategoriesLazyQueryHookResult = ReturnType<typeof useFetchAllCategoriesLazyQuery>;
export type FetchAllCategoriesQueryResult = Apollo.QueryResult<FetchAllCategoriesQuery, FetchAllCategoriesQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($createCategoryInput: CreateCategoryInput!) {
  createCategory(createCategoryInput: $createCategoryInput) {
    category {
      id
      name
      description
    }
    response {
      message
      status
    }
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      createCategoryInput: // value for 'createCategoryInput'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($updateCategoryInput: UpdateCategoryInput!) {
  updateCategory(updateCategoryInput: $updateCategoryInput) {
    category {
      id
      name
      description
    }
    response {
      message
      status
    }
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      updateCategoryInput: // value for 'updateCategoryInput'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($deleteCategoryId: String!) {
  deleteCategory(id: $deleteCategoryId) {
    message
    status
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      deleteCategoryId: // value for 'deleteCategoryId'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const FetchAllFeeTypesDocument = gql`
    query FetchAllFeeTypes($fetchFeeTypes: FetchFeeTypeInput!) {
  fetchAllFeeTypes(fetchFeeTypes: $fetchFeeTypes) {
    feeTypes {
      id
      feeType
    }
    pagination {
      page
      totalCount
      totalPages
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFetchAllFeeTypesQuery__
 *
 * To run a query within a React component, call `useFetchAllFeeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllFeeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllFeeTypesQuery({
 *   variables: {
 *      fetchFeeTypes: // value for 'fetchFeeTypes'
 *   },
 * });
 */
export function useFetchAllFeeTypesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllFeeTypesQuery, FetchAllFeeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllFeeTypesQuery, FetchAllFeeTypesQueryVariables>(FetchAllFeeTypesDocument, options);
      }
export function useFetchAllFeeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllFeeTypesQuery, FetchAllFeeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllFeeTypesQuery, FetchAllFeeTypesQueryVariables>(FetchAllFeeTypesDocument, options);
        }
export type FetchAllFeeTypesQueryHookResult = ReturnType<typeof useFetchAllFeeTypesQuery>;
export type FetchAllFeeTypesLazyQueryHookResult = ReturnType<typeof useFetchAllFeeTypesLazyQuery>;
export type FetchAllFeeTypesQueryResult = Apollo.QueryResult<FetchAllFeeTypesQuery, FetchAllFeeTypesQueryVariables>;
export const FetchCaseEntriesByFeeTypesDocument = gql`
    query FetchCaseEntriesByFeeTypes($caseEntriesByFeeTypesInput: CaseEntriesByFeeTypesInput!) {
  fetchCaseEntriesByFeeTypes(
    caseEntriesByFeeTypesInput: $caseEntriesByFeeTypesInput
  ) {
    entries {
      id
      amount
      status
      billItems {
        bill {
          id
          status
        }
      }
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useFetchCaseEntriesByFeeTypesQuery__
 *
 * To run a query within a React component, call `useFetchCaseEntriesByFeeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCaseEntriesByFeeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCaseEntriesByFeeTypesQuery({
 *   variables: {
 *      caseEntriesByFeeTypesInput: // value for 'caseEntriesByFeeTypesInput'
 *   },
 * });
 */
export function useFetchCaseEntriesByFeeTypesQuery(baseOptions: Apollo.QueryHookOptions<FetchCaseEntriesByFeeTypesQuery, FetchCaseEntriesByFeeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCaseEntriesByFeeTypesQuery, FetchCaseEntriesByFeeTypesQueryVariables>(FetchCaseEntriesByFeeTypesDocument, options);
      }
export function useFetchCaseEntriesByFeeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCaseEntriesByFeeTypesQuery, FetchCaseEntriesByFeeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCaseEntriesByFeeTypesQuery, FetchCaseEntriesByFeeTypesQueryVariables>(FetchCaseEntriesByFeeTypesDocument, options);
        }
export type FetchCaseEntriesByFeeTypesQueryHookResult = ReturnType<typeof useFetchCaseEntriesByFeeTypesQuery>;
export type FetchCaseEntriesByFeeTypesLazyQueryHookResult = ReturnType<typeof useFetchCaseEntriesByFeeTypesLazyQuery>;
export type FetchCaseEntriesByFeeTypesQueryResult = Apollo.QueryResult<FetchCaseEntriesByFeeTypesQuery, FetchCaseEntriesByFeeTypesQueryVariables>;
export const GetHourlyAmountLoggedForCaseDocument = gql`
    query GetHourlyAmountLoggedForCase($caseId: String!) {
  getHourlyAmountLoggedForCase(caseId: $caseId) {
    response {
      message
      status
    }
    hourlyAmountLogged
  }
}
    `;

/**
 * __useGetHourlyAmountLoggedForCaseQuery__
 *
 * To run a query within a React component, call `useGetHourlyAmountLoggedForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHourlyAmountLoggedForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHourlyAmountLoggedForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetHourlyAmountLoggedForCaseQuery(baseOptions: Apollo.QueryHookOptions<GetHourlyAmountLoggedForCaseQuery, GetHourlyAmountLoggedForCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHourlyAmountLoggedForCaseQuery, GetHourlyAmountLoggedForCaseQueryVariables>(GetHourlyAmountLoggedForCaseDocument, options);
      }
export function useGetHourlyAmountLoggedForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHourlyAmountLoggedForCaseQuery, GetHourlyAmountLoggedForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHourlyAmountLoggedForCaseQuery, GetHourlyAmountLoggedForCaseQueryVariables>(GetHourlyAmountLoggedForCaseDocument, options);
        }
export type GetHourlyAmountLoggedForCaseQueryHookResult = ReturnType<typeof useGetHourlyAmountLoggedForCaseQuery>;
export type GetHourlyAmountLoggedForCaseLazyQueryHookResult = ReturnType<typeof useGetHourlyAmountLoggedForCaseLazyQuery>;
export type GetHourlyAmountLoggedForCaseQueryResult = Apollo.QueryResult<GetHourlyAmountLoggedForCaseQuery, GetHourlyAmountLoggedForCaseQueryVariables>;
export const CreateFeeTypeDocument = gql`
    mutation CreateFeeType($feeType: String!) {
  createFeeType(feeType: $feeType) {
    response {
      message
      status
    }
    feeType {
      feeType
      id
    }
  }
}
    `;
export type CreateFeeTypeMutationFn = Apollo.MutationFunction<CreateFeeTypeMutation, CreateFeeTypeMutationVariables>;

/**
 * __useCreateFeeTypeMutation__
 *
 * To run a mutation, you first call `useCreateFeeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeeTypeMutation, { data, loading, error }] = useCreateFeeTypeMutation({
 *   variables: {
 *      feeType: // value for 'feeType'
 *   },
 * });
 */
export function useCreateFeeTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeeTypeMutation, CreateFeeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeeTypeMutation, CreateFeeTypeMutationVariables>(CreateFeeTypeDocument, options);
      }
export type CreateFeeTypeMutationHookResult = ReturnType<typeof useCreateFeeTypeMutation>;
export type CreateFeeTypeMutationResult = Apollo.MutationResult<CreateFeeTypeMutation>;
export type CreateFeeTypeMutationOptions = Apollo.BaseMutationOptions<CreateFeeTypeMutation, CreateFeeTypeMutationVariables>;
export const DeleteFeeTypeDocument = gql`
    mutation DeleteFeeType($deleteFeeTypeId: String!) {
  deleteFeeType(id: $deleteFeeTypeId)
}
    `;
export type DeleteFeeTypeMutationFn = Apollo.MutationFunction<DeleteFeeTypeMutation, DeleteFeeTypeMutationVariables>;

/**
 * __useDeleteFeeTypeMutation__
 *
 * To run a mutation, you first call `useDeleteFeeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeeTypeMutation, { data, loading, error }] = useDeleteFeeTypeMutation({
 *   variables: {
 *      deleteFeeTypeId: // value for 'deleteFeeTypeId'
 *   },
 * });
 */
export function useDeleteFeeTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeeTypeMutation, DeleteFeeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeeTypeMutation, DeleteFeeTypeMutationVariables>(DeleteFeeTypeDocument, options);
      }
export type DeleteFeeTypeMutationHookResult = ReturnType<typeof useDeleteFeeTypeMutation>;
export type DeleteFeeTypeMutationResult = Apollo.MutationResult<DeleteFeeTypeMutation>;
export type DeleteFeeTypeMutationOptions = Apollo.BaseMutationOptions<DeleteFeeTypeMutation, DeleteFeeTypeMutationVariables>;
export const UpdateFeeTypeDocument = gql`
    mutation UpdateFeeType($updateFeeTypeId: String!, $feeType: String!) {
  updateFeeType(id: $updateFeeTypeId, feeType: $feeType) {
    response {
      status
      message
    }
    feeType {
      id
      feeType
    }
  }
}
    `;
export type UpdateFeeTypeMutationFn = Apollo.MutationFunction<UpdateFeeTypeMutation, UpdateFeeTypeMutationVariables>;

/**
 * __useUpdateFeeTypeMutation__
 *
 * To run a mutation, you first call `useUpdateFeeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeeTypeMutation, { data, loading, error }] = useUpdateFeeTypeMutation({
 *   variables: {
 *      updateFeeTypeId: // value for 'updateFeeTypeId'
 *      feeType: // value for 'feeType'
 *   },
 * });
 */
export function useUpdateFeeTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeeTypeMutation, UpdateFeeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeeTypeMutation, UpdateFeeTypeMutationVariables>(UpdateFeeTypeDocument, options);
      }
export type UpdateFeeTypeMutationHookResult = ReturnType<typeof useUpdateFeeTypeMutation>;
export type UpdateFeeTypeMutationResult = Apollo.MutationResult<UpdateFeeTypeMutation>;
export type UpdateFeeTypeMutationOptions = Apollo.BaseMutationOptions<UpdateFeeTypeMutation, UpdateFeeTypeMutationVariables>;
export const FetchFirmDashboardMattersDocument = gql`
    query FetchFirmDashboardMatters($input: FirmDashboardDateRangeInput!) {
  fetchFirmDashboardMatters(input: $input) {
    activeMatters {
      asOfToday
      inRange
    }
    workCompletedMatters {
      asOfToday
      inRange
    }
    closedMatters {
      asOfToday
      inRange
    }
    activeByBillingType {
      key
      label
      count
      active
      completed
    }
    activeByLawType {
      key
      label
      count
      active
      completed
    }
    activeByResponsibleAttorney {
      key
      label
      count
    }
    mattersCreated {
      total
      direct
      fromConsults
    }
    consultsCreated {
      total
      converted
      notConverted
    }
    newMattersByBillingType {
      key
      label
      count
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchFirmDashboardMattersQuery__
 *
 * To run a query within a React component, call `useFetchFirmDashboardMattersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFirmDashboardMattersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFirmDashboardMattersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchFirmDashboardMattersQuery(baseOptions: Apollo.QueryHookOptions<FetchFirmDashboardMattersQuery, FetchFirmDashboardMattersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFirmDashboardMattersQuery, FetchFirmDashboardMattersQueryVariables>(FetchFirmDashboardMattersDocument, options);
      }
export function useFetchFirmDashboardMattersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFirmDashboardMattersQuery, FetchFirmDashboardMattersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFirmDashboardMattersQuery, FetchFirmDashboardMattersQueryVariables>(FetchFirmDashboardMattersDocument, options);
        }
export type FetchFirmDashboardMattersQueryHookResult = ReturnType<typeof useFetchFirmDashboardMattersQuery>;
export type FetchFirmDashboardMattersLazyQueryHookResult = ReturnType<typeof useFetchFirmDashboardMattersLazyQuery>;
export type FetchFirmDashboardMattersQueryResult = Apollo.QueryResult<FetchFirmDashboardMattersQuery, FetchFirmDashboardMattersQueryVariables>;
export const FetchFirmDashboardBillingDocument = gql`
    query FetchFirmDashboardBilling($input: FirmDashboardDateRangeInput!) {
  fetchFirmDashboardBilling(input: $input) {
    totalBillsCount
    finalBillsCount
    preBillsCount
    billsByBillingType {
      key
      label
      count
    }
    billsByStatus {
      key
      label
      count
    }
    billsByLawType {
      key
      label
      count
    }
    totalBillsAmount
    amountByBillingType {
      key
      label
      amount
    }
    amountByCategory {
      key
      label
      amount
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchFirmDashboardBillingQuery__
 *
 * To run a query within a React component, call `useFetchFirmDashboardBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFirmDashboardBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFirmDashboardBillingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchFirmDashboardBillingQuery(baseOptions: Apollo.QueryHookOptions<FetchFirmDashboardBillingQuery, FetchFirmDashboardBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFirmDashboardBillingQuery, FetchFirmDashboardBillingQueryVariables>(FetchFirmDashboardBillingDocument, options);
      }
export function useFetchFirmDashboardBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFirmDashboardBillingQuery, FetchFirmDashboardBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFirmDashboardBillingQuery, FetchFirmDashboardBillingQueryVariables>(FetchFirmDashboardBillingDocument, options);
        }
export type FetchFirmDashboardBillingQueryHookResult = ReturnType<typeof useFetchFirmDashboardBillingQuery>;
export type FetchFirmDashboardBillingLazyQueryHookResult = ReturnType<typeof useFetchFirmDashboardBillingLazyQuery>;
export type FetchFirmDashboardBillingQueryResult = Apollo.QueryResult<FetchFirmDashboardBillingQuery, FetchFirmDashboardBillingQueryVariables>;
export const FetchFirmDashboardAccountingDocument = gql`
    query FetchFirmDashboardAccounting($input: FirmDashboardDateRangeInput!) {
  fetchFirmDashboardAccounting(input: $input) {
    incomingOperatingTotal
    incomingByOperatingAccount {
      key
      label
      amount
    }
    incomingTrustTotal
    incomingByBankAccount {
      key
      label
      amount
    }
    incomingMonthly {
      month
      amounts {
        key
        label
        amount
      }
    }
    outgoingTotal
    outgoingTrustTotal
    outgoingTrustByMethod {
      key
      label
      amount
    }
    outgoingOperatingTotal
    outgoingOperatingByMethod {
      key
      label
      amount
    }
    outgoingByGlAccount {
      key
      label
      amount
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchFirmDashboardAccountingQuery__
 *
 * To run a query within a React component, call `useFetchFirmDashboardAccountingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFirmDashboardAccountingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFirmDashboardAccountingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchFirmDashboardAccountingQuery(baseOptions: Apollo.QueryHookOptions<FetchFirmDashboardAccountingQuery, FetchFirmDashboardAccountingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFirmDashboardAccountingQuery, FetchFirmDashboardAccountingQueryVariables>(FetchFirmDashboardAccountingDocument, options);
      }
export function useFetchFirmDashboardAccountingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFirmDashboardAccountingQuery, FetchFirmDashboardAccountingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFirmDashboardAccountingQuery, FetchFirmDashboardAccountingQueryVariables>(FetchFirmDashboardAccountingDocument, options);
        }
export type FetchFirmDashboardAccountingQueryHookResult = ReturnType<typeof useFetchFirmDashboardAccountingQuery>;
export type FetchFirmDashboardAccountingLazyQueryHookResult = ReturnType<typeof useFetchFirmDashboardAccountingLazyQuery>;
export type FetchFirmDashboardAccountingQueryResult = Apollo.QueryResult<FetchFirmDashboardAccountingQuery, FetchFirmDashboardAccountingQueryVariables>;
export const FetchFundRequestsDocument = gql`
    query FetchFundRequests($fetchFundRequestsInput: FetchFundRequestsInput!) {
  fetchFundRequests(fetchFundRequestsInput: $fetchFundRequestsInput) {
    response {
      status
      message
    }
    fundRequests {
      id
      type
      status
      amount
      dueDate
      issueDate
      amountPaid
      description
      attorneyApprovedAt
      departmentApprovedAt
      lastSentAt
      sendToClient
      case {
        id
        caseNumber
        title
        billing {
          billingType
          billApprover {
            id
            firstName
            lastName
          }
        }
        caseToUsers {
          userType
          user {
            id
            firstName
            lastName
          }
        }
      }
      creator {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchFundRequestsQuery__
 *
 * To run a query within a React component, call `useFetchFundRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFundRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFundRequestsQuery({
 *   variables: {
 *      fetchFundRequestsInput: // value for 'fetchFundRequestsInput'
 *   },
 * });
 */
export function useFetchFundRequestsQuery(baseOptions: Apollo.QueryHookOptions<FetchFundRequestsQuery, FetchFundRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFundRequestsQuery, FetchFundRequestsQueryVariables>(FetchFundRequestsDocument, options);
      }
export function useFetchFundRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFundRequestsQuery, FetchFundRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFundRequestsQuery, FetchFundRequestsQueryVariables>(FetchFundRequestsDocument, options);
        }
export type FetchFundRequestsQueryHookResult = ReturnType<typeof useFetchFundRequestsQuery>;
export type FetchFundRequestsLazyQueryHookResult = ReturnType<typeof useFetchFundRequestsLazyQuery>;
export type FetchFundRequestsQueryResult = Apollo.QueryResult<FetchFundRequestsQuery, FetchFundRequestsQueryVariables>;
export const FetchFundRequestDocument = gql`
    query FetchFundRequest($billId: Float!) {
  fetchFundRequest(billId: $billId) {
    response {
      status
      message
    }
    fundRequest {
      id
      amount
      description
      sendToClient
      account {
        id
      }
      case {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useFetchFundRequestQuery__
 *
 * To run a query within a React component, call `useFetchFundRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFundRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFundRequestQuery({
 *   variables: {
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useFetchFundRequestQuery(baseOptions: Apollo.QueryHookOptions<FetchFundRequestQuery, FetchFundRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFundRequestQuery, FetchFundRequestQueryVariables>(FetchFundRequestDocument, options);
      }
export function useFetchFundRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFundRequestQuery, FetchFundRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFundRequestQuery, FetchFundRequestQueryVariables>(FetchFundRequestDocument, options);
        }
export type FetchFundRequestQueryHookResult = ReturnType<typeof useFetchFundRequestQuery>;
export type FetchFundRequestLazyQueryHookResult = ReturnType<typeof useFetchFundRequestLazyQuery>;
export type FetchFundRequestQueryResult = Apollo.QueryResult<FetchFundRequestQuery, FetchFundRequestQueryVariables>;
export const FetchPendingFundRequestDocument = gql`
    query FetchPendingFundRequest($caseId: String!) {
  fetchPendingFundRequest(caseId: $caseId) {
    response {
      status
      message
    }
    fundRequest {
      id
      status
      amount
      description
      createdAt
    }
  }
}
    `;

/**
 * __useFetchPendingFundRequestQuery__
 *
 * To run a query within a React component, call `useFetchPendingFundRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPendingFundRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPendingFundRequestQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useFetchPendingFundRequestQuery(baseOptions: Apollo.QueryHookOptions<FetchPendingFundRequestQuery, FetchPendingFundRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPendingFundRequestQuery, FetchPendingFundRequestQueryVariables>(FetchPendingFundRequestDocument, options);
      }
export function useFetchPendingFundRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPendingFundRequestQuery, FetchPendingFundRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPendingFundRequestQuery, FetchPendingFundRequestQueryVariables>(FetchPendingFundRequestDocument, options);
        }
export type FetchPendingFundRequestQueryHookResult = ReturnType<typeof useFetchPendingFundRequestQuery>;
export type FetchPendingFundRequestLazyQueryHookResult = ReturnType<typeof useFetchPendingFundRequestLazyQuery>;
export type FetchPendingFundRequestQueryResult = Apollo.QueryResult<FetchPendingFundRequestQuery, FetchPendingFundRequestQueryVariables>;
export const FetchRecentFundRequestDocument = gql`
    query FetchRecentFundRequest($caseId: String!) {
  fetchRecentFundRequest(caseId: $caseId) {
    response {
      status
      message
    }
    fundRequest {
      id
      status
      amount
      description
      createdAt
    }
  }
}
    `;

/**
 * __useFetchRecentFundRequestQuery__
 *
 * To run a query within a React component, call `useFetchRecentFundRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentFundRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentFundRequestQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useFetchRecentFundRequestQuery(baseOptions: Apollo.QueryHookOptions<FetchRecentFundRequestQuery, FetchRecentFundRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRecentFundRequestQuery, FetchRecentFundRequestQueryVariables>(FetchRecentFundRequestDocument, options);
      }
export function useFetchRecentFundRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRecentFundRequestQuery, FetchRecentFundRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRecentFundRequestQuery, FetchRecentFundRequestQueryVariables>(FetchRecentFundRequestDocument, options);
        }
export type FetchRecentFundRequestQueryHookResult = ReturnType<typeof useFetchRecentFundRequestQuery>;
export type FetchRecentFundRequestLazyQueryHookResult = ReturnType<typeof useFetchRecentFundRequestLazyQuery>;
export type FetchRecentFundRequestQueryResult = Apollo.QueryResult<FetchRecentFundRequestQuery, FetchRecentFundRequestQueryVariables>;
export const CreateFundRequestDocument = gql`
    mutation CreateFundRequest($createFundRequestInput: [CreateFundRequestInput!]!) {
  createFundRequest(createFundRequestInput: $createFundRequestInput) {
    response {
      status
      message
    }
    fundRequests {
      id
    }
  }
}
    `;
export type CreateFundRequestMutationFn = Apollo.MutationFunction<CreateFundRequestMutation, CreateFundRequestMutationVariables>;

/**
 * __useCreateFundRequestMutation__
 *
 * To run a mutation, you first call `useCreateFundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFundRequestMutation, { data, loading, error }] = useCreateFundRequestMutation({
 *   variables: {
 *      createFundRequestInput: // value for 'createFundRequestInput'
 *   },
 * });
 */
export function useCreateFundRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFundRequestMutation, CreateFundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFundRequestMutation, CreateFundRequestMutationVariables>(CreateFundRequestDocument, options);
      }
export type CreateFundRequestMutationHookResult = ReturnType<typeof useCreateFundRequestMutation>;
export type CreateFundRequestMutationResult = Apollo.MutationResult<CreateFundRequestMutation>;
export type CreateFundRequestMutationOptions = Apollo.BaseMutationOptions<CreateFundRequestMutation, CreateFundRequestMutationVariables>;
export const UpdateFundRequestDocument = gql`
    mutation UpdateFundRequest($updateFundRequestInput: UpdateFundRequestInput!) {
  updateFundRequest(updateFundRequestInput: $updateFundRequestInput) {
    response {
      status
      message
    }
    fundRequest {
      id
    }
  }
}
    `;
export type UpdateFundRequestMutationFn = Apollo.MutationFunction<UpdateFundRequestMutation, UpdateFundRequestMutationVariables>;

/**
 * __useUpdateFundRequestMutation__
 *
 * To run a mutation, you first call `useUpdateFundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundRequestMutation, { data, loading, error }] = useUpdateFundRequestMutation({
 *   variables: {
 *      updateFundRequestInput: // value for 'updateFundRequestInput'
 *   },
 * });
 */
export function useUpdateFundRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundRequestMutation, UpdateFundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundRequestMutation, UpdateFundRequestMutationVariables>(UpdateFundRequestDocument, options);
      }
export type UpdateFundRequestMutationHookResult = ReturnType<typeof useUpdateFundRequestMutation>;
export type UpdateFundRequestMutationResult = Apollo.MutationResult<UpdateFundRequestMutation>;
export type UpdateFundRequestMutationOptions = Apollo.BaseMutationOptions<UpdateFundRequestMutation, UpdateFundRequestMutationVariables>;
export const GenerateContingencyFundRequestDocument = gql`
    mutation GenerateContingencyFundRequest($generateContingencyFundRequestInput: ContingencyFundRequestInput!) {
  generateContingencyFundRequest(
    generateContingencyFundRequestInput: $generateContingencyFundRequestInput
  ) {
    fundRequestId
    response {
      status
      message
    }
  }
}
    `;
export type GenerateContingencyFundRequestMutationFn = Apollo.MutationFunction<GenerateContingencyFundRequestMutation, GenerateContingencyFundRequestMutationVariables>;

/**
 * __useGenerateContingencyFundRequestMutation__
 *
 * To run a mutation, you first call `useGenerateContingencyFundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateContingencyFundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateContingencyFundRequestMutation, { data, loading, error }] = useGenerateContingencyFundRequestMutation({
 *   variables: {
 *      generateContingencyFundRequestInput: // value for 'generateContingencyFundRequestInput'
 *   },
 * });
 */
export function useGenerateContingencyFundRequestMutation(baseOptions?: Apollo.MutationHookOptions<GenerateContingencyFundRequestMutation, GenerateContingencyFundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateContingencyFundRequestMutation, GenerateContingencyFundRequestMutationVariables>(GenerateContingencyFundRequestDocument, options);
      }
export type GenerateContingencyFundRequestMutationHookResult = ReturnType<typeof useGenerateContingencyFundRequestMutation>;
export type GenerateContingencyFundRequestMutationResult = Apollo.MutationResult<GenerateContingencyFundRequestMutation>;
export type GenerateContingencyFundRequestMutationOptions = Apollo.BaseMutationOptions<GenerateContingencyFundRequestMutation, GenerateContingencyFundRequestMutationVariables>;
export const DeleteInterestEntriesDocument = gql`
    mutation DeleteInterestEntries($deleteInterestEntriesInput: DeleteInterestEntriesInput!) {
  deleteInterestEntries(deleteInterestEntriesInput: $deleteInterestEntriesInput) {
    deletedCount
    response {
      status
      message
    }
  }
}
    `;
export type DeleteInterestEntriesMutationFn = Apollo.MutationFunction<DeleteInterestEntriesMutation, DeleteInterestEntriesMutationVariables>;

/**
 * __useDeleteInterestEntriesMutation__
 *
 * To run a mutation, you first call `useDeleteInterestEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInterestEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInterestEntriesMutation, { data, loading, error }] = useDeleteInterestEntriesMutation({
 *   variables: {
 *      deleteInterestEntriesInput: // value for 'deleteInterestEntriesInput'
 *   },
 * });
 */
export function useDeleteInterestEntriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInterestEntriesMutation, DeleteInterestEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInterestEntriesMutation, DeleteInterestEntriesMutationVariables>(DeleteInterestEntriesDocument, options);
      }
export type DeleteInterestEntriesMutationHookResult = ReturnType<typeof useDeleteInterestEntriesMutation>;
export type DeleteInterestEntriesMutationResult = Apollo.MutationResult<DeleteInterestEntriesMutation>;
export type DeleteInterestEntriesMutationOptions = Apollo.BaseMutationOptions<DeleteInterestEntriesMutation, DeleteInterestEntriesMutationVariables>;
export const FetchCarriableVoidedBillsDocument = gql`
    query FetchCarriableVoidedBills($fetchCarriableVoidedBillsInput: FetchCarriableVoidedBillsInput!) {
  fetchCarriableVoidedBills(
    fetchCarriableVoidedBillsInput: $fetchCarriableVoidedBillsInput
  ) {
    bills {
      billId
      voidedAt
      fromDate
      toDate
      accruedInterest
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchCarriableVoidedBillsQuery__
 *
 * To run a query within a React component, call `useFetchCarriableVoidedBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCarriableVoidedBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCarriableVoidedBillsQuery({
 *   variables: {
 *      fetchCarriableVoidedBillsInput: // value for 'fetchCarriableVoidedBillsInput'
 *   },
 * });
 */
export function useFetchCarriableVoidedBillsQuery(baseOptions: Apollo.QueryHookOptions<FetchCarriableVoidedBillsQuery, FetchCarriableVoidedBillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCarriableVoidedBillsQuery, FetchCarriableVoidedBillsQueryVariables>(FetchCarriableVoidedBillsDocument, options);
      }
export function useFetchCarriableVoidedBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCarriableVoidedBillsQuery, FetchCarriableVoidedBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCarriableVoidedBillsQuery, FetchCarriableVoidedBillsQueryVariables>(FetchCarriableVoidedBillsDocument, options);
        }
export type FetchCarriableVoidedBillsQueryHookResult = ReturnType<typeof useFetchCarriableVoidedBillsQuery>;
export type FetchCarriableVoidedBillsLazyQueryHookResult = ReturnType<typeof useFetchCarriableVoidedBillsLazyQuery>;
export type FetchCarriableVoidedBillsQueryResult = Apollo.QueryResult<FetchCarriableVoidedBillsQuery, FetchCarriableVoidedBillsQueryVariables>;
export const CreateCarriedForwardInterestDocument = gql`
    mutation CreateCarriedForwardInterest($createCarriedForwardInterestInput: CreateCarriedForwardInterestInput!) {
  createCarriedForwardInterest(
    createCarriedForwardInterestInput: $createCarriedForwardInterestInput
  ) {
    createdCount
    totalCarried
    response {
      status
      message
    }
  }
}
    `;
export type CreateCarriedForwardInterestMutationFn = Apollo.MutationFunction<CreateCarriedForwardInterestMutation, CreateCarriedForwardInterestMutationVariables>;

/**
 * __useCreateCarriedForwardInterestMutation__
 *
 * To run a mutation, you first call `useCreateCarriedForwardInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarriedForwardInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarriedForwardInterestMutation, { data, loading, error }] = useCreateCarriedForwardInterestMutation({
 *   variables: {
 *      createCarriedForwardInterestInput: // value for 'createCarriedForwardInterestInput'
 *   },
 * });
 */
export function useCreateCarriedForwardInterestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarriedForwardInterestMutation, CreateCarriedForwardInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarriedForwardInterestMutation, CreateCarriedForwardInterestMutationVariables>(CreateCarriedForwardInterestDocument, options);
      }
export type CreateCarriedForwardInterestMutationHookResult = ReturnType<typeof useCreateCarriedForwardInterestMutation>;
export type CreateCarriedForwardInterestMutationResult = Apollo.MutationResult<CreateCarriedForwardInterestMutation>;
export type CreateCarriedForwardInterestMutationOptions = Apollo.BaseMutationOptions<CreateCarriedForwardInterestMutation, CreateCarriedForwardInterestMutationVariables>;
export const GetBillInterestDocument = gql`
    query getBillInterest($billInterestInput: BillInterestInput!) {
  getBillInterest(billInterestInput: $billInterestInput) {
    interestDue
    interestAccrued
    rate
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetBillInterestQuery__
 *
 * To run a query within a React component, call `useGetBillInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillInterestQuery({
 *   variables: {
 *      billInterestInput: // value for 'billInterestInput'
 *   },
 * });
 */
export function useGetBillInterestQuery(baseOptions: Apollo.QueryHookOptions<GetBillInterestQuery, GetBillInterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillInterestQuery, GetBillInterestQueryVariables>(GetBillInterestDocument, options);
      }
export function useGetBillInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillInterestQuery, GetBillInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillInterestQuery, GetBillInterestQueryVariables>(GetBillInterestDocument, options);
        }
export type GetBillInterestQueryHookResult = ReturnType<typeof useGetBillInterestQuery>;
export type GetBillInterestLazyQueryHookResult = ReturnType<typeof useGetBillInterestLazyQuery>;
export type GetBillInterestQueryResult = Apollo.QueryResult<GetBillInterestQuery, GetBillInterestQueryVariables>;
export const FetchInterestEntriesDocument = gql`
    query FetchInterestEntries($fetchInterestEntriesInput: FetchInterestEntriesInput!) {
  fetchInterestEntries(fetchInterestEntriesInput: $fetchInterestEntriesInput) {
    response {
      status
      message
    }
    interestEntries {
      id
      date
      accruedInterest
      cumulativeInterest
      principal
      days
      rate
      advRefno
      fromAdv
      bill {
        id
        status
        case {
          id
          caseNumber
          title
          billing {
            writeOffInterest
          }
        }
      }
      client {
        id
        firstName
        lastName
        businessName
        clientNumber
      }
      createdAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
  }
}
    `;

/**
 * __useFetchInterestEntriesQuery__
 *
 * To run a query within a React component, call `useFetchInterestEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInterestEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInterestEntriesQuery({
 *   variables: {
 *      fetchInterestEntriesInput: // value for 'fetchInterestEntriesInput'
 *   },
 * });
 */
export function useFetchInterestEntriesQuery(baseOptions: Apollo.QueryHookOptions<FetchInterestEntriesQuery, FetchInterestEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInterestEntriesQuery, FetchInterestEntriesQueryVariables>(FetchInterestEntriesDocument, options);
      }
export function useFetchInterestEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInterestEntriesQuery, FetchInterestEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInterestEntriesQuery, FetchInterestEntriesQueryVariables>(FetchInterestEntriesDocument, options);
        }
export type FetchInterestEntriesQueryHookResult = ReturnType<typeof useFetchInterestEntriesQuery>;
export type FetchInterestEntriesLazyQueryHookResult = ReturnType<typeof useFetchInterestEntriesLazyQuery>;
export type FetchInterestEntriesQueryResult = Apollo.QueryResult<FetchInterestEntriesQuery, FetchInterestEntriesQueryVariables>;
export const FetchJournalEntriesDocument = gql`
    query FetchJournalEntries($input: FetchJournalEntriesInput!) {
  fetchJournalEntries(input: $input) {
    journalEntries {
      id
      date
      notes
      journalEntryNumber
      advJournalRef
      isSystemGenerated
      closedAt
      bill {
        id
      }
      case {
        id
        caseNumber
      }
      vendor {
        id
        vendorId
      }
      creator {
        id
      }
      lineItems {
        id
        amount
        type
        account {
          id
          name
          category
          sortCode
        }
        office {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
    pagination {
      totalCount
      page
      totalPages
      limit
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchJournalEntriesQuery__
 *
 * To run a query within a React component, call `useFetchJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJournalEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchJournalEntriesQuery(baseOptions: Apollo.QueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>(FetchJournalEntriesDocument, options);
      }
export function useFetchJournalEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>(FetchJournalEntriesDocument, options);
        }
export type FetchJournalEntriesQueryHookResult = ReturnType<typeof useFetchJournalEntriesQuery>;
export type FetchJournalEntriesLazyQueryHookResult = ReturnType<typeof useFetchJournalEntriesLazyQuery>;
export type FetchJournalEntriesQueryResult = Apollo.QueryResult<FetchJournalEntriesQuery, FetchJournalEntriesQueryVariables>;
export const FetchJournalEntryDocument = gql`
    query fetchJournalEntry($id: String!) {
  fetchJournalEntry(id: $id) {
    id
    date
    notes
    journalEntryNumber
    closedAt
    isSystemGenerated
    creator {
      id
      firstName
      lastName
    }
    lineItems {
      id
      amount
      type
      office {
        id
        name
      }
      account {
        id
        name
        sortCode
      }
    }
  }
}
    `;

/**
 * __useFetchJournalEntryQuery__
 *
 * To run a query within a React component, call `useFetchJournalEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJournalEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJournalEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchJournalEntryQuery(baseOptions: Apollo.QueryHookOptions<FetchJournalEntryQuery, FetchJournalEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchJournalEntryQuery, FetchJournalEntryQueryVariables>(FetchJournalEntryDocument, options);
      }
export function useFetchJournalEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchJournalEntryQuery, FetchJournalEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchJournalEntryQuery, FetchJournalEntryQueryVariables>(FetchJournalEntryDocument, options);
        }
export type FetchJournalEntryQueryHookResult = ReturnType<typeof useFetchJournalEntryQuery>;
export type FetchJournalEntryLazyQueryHookResult = ReturnType<typeof useFetchJournalEntryLazyQuery>;
export type FetchJournalEntryQueryResult = Apollo.QueryResult<FetchJournalEntryQuery, FetchJournalEntryQueryVariables>;
export const CreateManualJournalEntriesDocument = gql`
    mutation CreateManualJournalEntries($input: CreateManualJournalEntriesInput!) {
  createManualJournalEntries(input: $input) {
    response {
      status
      message
    }
    journalEntry {
      id
    }
  }
}
    `;
export type CreateManualJournalEntriesMutationFn = Apollo.MutationFunction<CreateManualJournalEntriesMutation, CreateManualJournalEntriesMutationVariables>;

/**
 * __useCreateManualJournalEntriesMutation__
 *
 * To run a mutation, you first call `useCreateManualJournalEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualJournalEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualJournalEntriesMutation, { data, loading, error }] = useCreateManualJournalEntriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualJournalEntriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualJournalEntriesMutation, CreateManualJournalEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualJournalEntriesMutation, CreateManualJournalEntriesMutationVariables>(CreateManualJournalEntriesDocument, options);
      }
export type CreateManualJournalEntriesMutationHookResult = ReturnType<typeof useCreateManualJournalEntriesMutation>;
export type CreateManualJournalEntriesMutationResult = Apollo.MutationResult<CreateManualJournalEntriesMutation>;
export type CreateManualJournalEntriesMutationOptions = Apollo.BaseMutationOptions<CreateManualJournalEntriesMutation, CreateManualJournalEntriesMutationVariables>;
export const DeleteManualJournalEntryDocument = gql`
    mutation DeleteManualJournalEntry($id: String!) {
  deleteManualJournalEntry(id: $id) {
    response {
      status
      message
    }
  }
}
    `;
export type DeleteManualJournalEntryMutationFn = Apollo.MutationFunction<DeleteManualJournalEntryMutation, DeleteManualJournalEntryMutationVariables>;

/**
 * __useDeleteManualJournalEntryMutation__
 *
 * To run a mutation, you first call `useDeleteManualJournalEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManualJournalEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManualJournalEntryMutation, { data, loading, error }] = useDeleteManualJournalEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteManualJournalEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManualJournalEntryMutation, DeleteManualJournalEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManualJournalEntryMutation, DeleteManualJournalEntryMutationVariables>(DeleteManualJournalEntryDocument, options);
      }
export type DeleteManualJournalEntryMutationHookResult = ReturnType<typeof useDeleteManualJournalEntryMutation>;
export type DeleteManualJournalEntryMutationResult = Apollo.MutationResult<DeleteManualJournalEntryMutation>;
export type DeleteManualJournalEntryMutationOptions = Apollo.BaseMutationOptions<DeleteManualJournalEntryMutation, DeleteManualJournalEntryMutationVariables>;
export const FetchAllLawTypesDocument = gql`
    query FetchAllLawTypes {
  fetchAllLawTypes {
    response {
      status
      message
    }
    lawTypes {
      id
      name
      syncWithOutlook
      createdAt
      updatedAt
      caseTypes {
        id
        name
        lawTypeId
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFetchAllLawTypesQuery__
 *
 * To run a query within a React component, call `useFetchAllLawTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllLawTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllLawTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllLawTypesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllLawTypesQuery, FetchAllLawTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllLawTypesQuery, FetchAllLawTypesQueryVariables>(FetchAllLawTypesDocument, options);
      }
export function useFetchAllLawTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllLawTypesQuery, FetchAllLawTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllLawTypesQuery, FetchAllLawTypesQueryVariables>(FetchAllLawTypesDocument, options);
        }
export type FetchAllLawTypesQueryHookResult = ReturnType<typeof useFetchAllLawTypesQuery>;
export type FetchAllLawTypesLazyQueryHookResult = ReturnType<typeof useFetchAllLawTypesLazyQuery>;
export type FetchAllLawTypesQueryResult = Apollo.QueryResult<FetchAllLawTypesQuery, FetchAllLawTypesQueryVariables>;
export const FetchLawTypeDocument = gql`
    query FetchLawType($lawTypeInput: LawTypeInput!) {
  fetchLawType(lawTypeInput: $lawTypeInput) {
    response {
      status
      error
      message
      name
    }
    lawType {
      id
      name
      syncWithOutlook
      createdAt
      updatedAt
      caseTypes {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        totalCaseCount
        lawType {
          id
          name
          syncWithOutlook
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLawTypeQuery__
 *
 * To run a query within a React component, call `useFetchLawTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLawTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLawTypeQuery({
 *   variables: {
 *      lawTypeInput: // value for 'lawTypeInput'
 *   },
 * });
 */
export function useFetchLawTypeQuery(baseOptions: Apollo.QueryHookOptions<FetchLawTypeQuery, FetchLawTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLawTypeQuery, FetchLawTypeQueryVariables>(FetchLawTypeDocument, options);
      }
export function useFetchLawTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLawTypeQuery, FetchLawTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLawTypeQuery, FetchLawTypeQueryVariables>(FetchLawTypeDocument, options);
        }
export type FetchLawTypeQueryHookResult = ReturnType<typeof useFetchLawTypeQuery>;
export type FetchLawTypeLazyQueryHookResult = ReturnType<typeof useFetchLawTypeLazyQuery>;
export type FetchLawTypeQueryResult = Apollo.QueryResult<FetchLawTypeQuery, FetchLawTypeQueryVariables>;
export const CreateLawTypeDocument = gql`
    mutation CreateLawType($createLawTypeInput: CreateLawTypeInput!) {
  createLawType(createLawTypeInput: $createLawTypeInput) {
    response {
      status
      error
      message
      name
    }
    lawType {
      id
      name
      syncWithOutlook
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateLawTypeMutationFn = Apollo.MutationFunction<CreateLawTypeMutation, CreateLawTypeMutationVariables>;

/**
 * __useCreateLawTypeMutation__
 *
 * To run a mutation, you first call `useCreateLawTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLawTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLawTypeMutation, { data, loading, error }] = useCreateLawTypeMutation({
 *   variables: {
 *      createLawTypeInput: // value for 'createLawTypeInput'
 *   },
 * });
 */
export function useCreateLawTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLawTypeMutation, CreateLawTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLawTypeMutation, CreateLawTypeMutationVariables>(CreateLawTypeDocument, options);
      }
export type CreateLawTypeMutationHookResult = ReturnType<typeof useCreateLawTypeMutation>;
export type CreateLawTypeMutationResult = Apollo.MutationResult<CreateLawTypeMutation>;
export type CreateLawTypeMutationOptions = Apollo.BaseMutationOptions<CreateLawTypeMutation, CreateLawTypeMutationVariables>;
export const DeleteLawTypeDocument = gql`
    mutation DeleteLawType($deleteLawTypeInput: DeleteLawType!) {
  deleteLawType(deleteLawTypeInput: $deleteLawTypeInput) {
    response {
      status
      error
      message
      name
    }
  }
}
    `;
export type DeleteLawTypeMutationFn = Apollo.MutationFunction<DeleteLawTypeMutation, DeleteLawTypeMutationVariables>;

/**
 * __useDeleteLawTypeMutation__
 *
 * To run a mutation, you first call `useDeleteLawTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLawTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLawTypeMutation, { data, loading, error }] = useDeleteLawTypeMutation({
 *   variables: {
 *      deleteLawTypeInput: // value for 'deleteLawTypeInput'
 *   },
 * });
 */
export function useDeleteLawTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLawTypeMutation, DeleteLawTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLawTypeMutation, DeleteLawTypeMutationVariables>(DeleteLawTypeDocument, options);
      }
export type DeleteLawTypeMutationHookResult = ReturnType<typeof useDeleteLawTypeMutation>;
export type DeleteLawTypeMutationResult = Apollo.MutationResult<DeleteLawTypeMutation>;
export type DeleteLawTypeMutationOptions = Apollo.BaseMutationOptions<DeleteLawTypeMutation, DeleteLawTypeMutationVariables>;
export const UpdateLawTypeDocument = gql`
    mutation UpdateLawType($updateLawTypeInput: UpdateLawTypeInput!) {
  updateLawType(updateLawTypeInput: $updateLawTypeInput) {
    response {
      status
      error
      message
      name
    }
    lawType {
      id
      name
      syncWithOutlook
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateLawTypeMutationFn = Apollo.MutationFunction<UpdateLawTypeMutation, UpdateLawTypeMutationVariables>;

/**
 * __useUpdateLawTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLawTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLawTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLawTypeMutation, { data, loading, error }] = useUpdateLawTypeMutation({
 *   variables: {
 *      updateLawTypeInput: // value for 'updateLawTypeInput'
 *   },
 * });
 */
export function useUpdateLawTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLawTypeMutation, UpdateLawTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLawTypeMutation, UpdateLawTypeMutationVariables>(UpdateLawTypeDocument, options);
      }
export type UpdateLawTypeMutationHookResult = ReturnType<typeof useUpdateLawTypeMutation>;
export type UpdateLawTypeMutationResult = Apollo.MutationResult<UpdateLawTypeMutation>;
export type UpdateLawTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLawTypeMutation, UpdateLawTypeMutationVariables>;
export const CreateCaseTypeDocument = gql`
    mutation CreateCaseType($createCaseTypeInput: CreateCaseTypeInput!) {
  createCaseType(createCaseTypeInput: $createCaseTypeInput) {
    response {
      status
      error
      message
      name
    }
    caseType {
      id
      name
    }
  }
}
    `;
export type CreateCaseTypeMutationFn = Apollo.MutationFunction<CreateCaseTypeMutation, CreateCaseTypeMutationVariables>;

/**
 * __useCreateCaseTypeMutation__
 *
 * To run a mutation, you first call `useCreateCaseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseTypeMutation, { data, loading, error }] = useCreateCaseTypeMutation({
 *   variables: {
 *      createCaseTypeInput: // value for 'createCaseTypeInput'
 *   },
 * });
 */
export function useCreateCaseTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseTypeMutation, CreateCaseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseTypeMutation, CreateCaseTypeMutationVariables>(CreateCaseTypeDocument, options);
      }
export type CreateCaseTypeMutationHookResult = ReturnType<typeof useCreateCaseTypeMutation>;
export type CreateCaseTypeMutationResult = Apollo.MutationResult<CreateCaseTypeMutation>;
export type CreateCaseTypeMutationOptions = Apollo.BaseMutationOptions<CreateCaseTypeMutation, CreateCaseTypeMutationVariables>;
export const DeleteCaseTypeDocument = gql`
    mutation deleteCaseType($deleteCaseTypeInput: DeleteCaseType!) {
  deleteCaseType(deleteCaseTypeInput: $deleteCaseTypeInput) {
    response {
      status
      error
      message
      name
    }
  }
}
    `;
export type DeleteCaseTypeMutationFn = Apollo.MutationFunction<DeleteCaseTypeMutation, DeleteCaseTypeMutationVariables>;

/**
 * __useDeleteCaseTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCaseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseTypeMutation, { data, loading, error }] = useDeleteCaseTypeMutation({
 *   variables: {
 *      deleteCaseTypeInput: // value for 'deleteCaseTypeInput'
 *   },
 * });
 */
export function useDeleteCaseTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseTypeMutation, DeleteCaseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseTypeMutation, DeleteCaseTypeMutationVariables>(DeleteCaseTypeDocument, options);
      }
export type DeleteCaseTypeMutationHookResult = ReturnType<typeof useDeleteCaseTypeMutation>;
export type DeleteCaseTypeMutationResult = Apollo.MutationResult<DeleteCaseTypeMutation>;
export type DeleteCaseTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCaseTypeMutation, DeleteCaseTypeMutationVariables>;
export const UpdateCaseTypeDocument = gql`
    mutation UpdateCaseType($updateCaseTypeInput: UpdateCaseTypeInput!) {
  updateCaseType(updateCaseTypeInput: $updateCaseTypeInput) {
    response {
      status
      error
      message
      name
    }
    caseType {
      id
      name
      createdAt
      updatedAt
      lawTypeId
    }
  }
}
    `;
export type UpdateCaseTypeMutationFn = Apollo.MutationFunction<UpdateCaseTypeMutation, UpdateCaseTypeMutationVariables>;

/**
 * __useUpdateCaseTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCaseTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseTypeMutation, { data, loading, error }] = useUpdateCaseTypeMutation({
 *   variables: {
 *      updateCaseTypeInput: // value for 'updateCaseTypeInput'
 *   },
 * });
 */
export function useUpdateCaseTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseTypeMutation, UpdateCaseTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseTypeMutation, UpdateCaseTypeMutationVariables>(UpdateCaseTypeDocument, options);
      }
export type UpdateCaseTypeMutationHookResult = ReturnType<typeof useUpdateCaseTypeMutation>;
export type UpdateCaseTypeMutationResult = Apollo.MutationResult<UpdateCaseTypeMutation>;
export type UpdateCaseTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCaseTypeMutation, UpdateCaseTypeMutationVariables>;
export const FetchAllCaseNotesDocument = gql`
    query FetchAllCaseNotes($notesInput: NotesByCaseInput!) {
  fetchAllCaseNotes(notesInput: $notesInput) {
    notes {
      id
      description
      userId
      caseId
      createdAt
      updatedAt
      noteTypeId
      noteType {
        id
        noteType
        createdAt
        updatedAt
      }
      user {
        id
        firstName
        lastName
        status
        emailVerified
        email
        phoneNumber
        createdAt
        updatedAt
        initials
        hourlyRate
        roles {
          id
          role
          createdAt
          updatedAt
        }
      }
      externalUser {
        id
        firstName
        lastName
        displayName
        phoneNumber
        ssn
        clientNumber
        addresses {
          address1
          address2
          city
          state
          country
          county
          zipCode
          id
          createdAt
          updatedAt
        }
        externalUserRoles {
          id
          externalUserId
          externalUserRoleId
          externalUserRole {
            id
            role
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllCaseNotesQuery__
 *
 * To run a query within a React component, call `useFetchAllCaseNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCaseNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCaseNotesQuery({
 *   variables: {
 *      notesInput: // value for 'notesInput'
 *   },
 * });
 */
export function useFetchAllCaseNotesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCaseNotesQuery, FetchAllCaseNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCaseNotesQuery, FetchAllCaseNotesQueryVariables>(FetchAllCaseNotesDocument, options);
      }
export function useFetchAllCaseNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCaseNotesQuery, FetchAllCaseNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCaseNotesQuery, FetchAllCaseNotesQueryVariables>(FetchAllCaseNotesDocument, options);
        }
export type FetchAllCaseNotesQueryHookResult = ReturnType<typeof useFetchAllCaseNotesQuery>;
export type FetchAllCaseNotesLazyQueryHookResult = ReturnType<typeof useFetchAllCaseNotesLazyQuery>;
export type FetchAllCaseNotesQueryResult = Apollo.QueryResult<FetchAllCaseNotesQuery, FetchAllCaseNotesQueryVariables>;
export const FetchAllUserNotesDocument = gql`
    query FetchAllUserNotes($notesInput: NotesByUserInput!) {
  fetchAllUserNotes(notesInput: $notesInput) {
    notes {
      id
      description
      noteTypeId
      user {
        id
        firstName
        lastName
        status
        emailVerified
        email
        phoneNumber
        createdAt
        updatedAt
        initials
        roles {
          id
          role
          createdAt
          updatedAt
        }
      }
      userId
      caseId
      createdAt
      updatedAt
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllUserNotesQuery__
 *
 * To run a query within a React component, call `useFetchAllUserNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllUserNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllUserNotesQuery({
 *   variables: {
 *      notesInput: // value for 'notesInput'
 *   },
 * });
 */
export function useFetchAllUserNotesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllUserNotesQuery, FetchAllUserNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllUserNotesQuery, FetchAllUserNotesQueryVariables>(FetchAllUserNotesDocument, options);
      }
export function useFetchAllUserNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllUserNotesQuery, FetchAllUserNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllUserNotesQuery, FetchAllUserNotesQueryVariables>(FetchAllUserNotesDocument, options);
        }
export type FetchAllUserNotesQueryHookResult = ReturnType<typeof useFetchAllUserNotesQuery>;
export type FetchAllUserNotesLazyQueryHookResult = ReturnType<typeof useFetchAllUserNotesLazyQuery>;
export type FetchAllUserNotesQueryResult = Apollo.QueryResult<FetchAllUserNotesQuery, FetchAllUserNotesQueryVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($createNoteInput: CreateNoteInput!) {
  createNote(createNoteInput: $createNoteInput) {
    note {
      description
      id
      user {
        firstName
        lastName
        initials
        roles {
          role
        }
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      createNoteInput: // value for 'createNoteInput'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($deleteNoteInput: DeleteNote!) {
  deleteNote(deleteNoteInput: $deleteNoteInput) {
    response {
      status
      message
    }
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      deleteNoteInput: // value for 'deleteNoteInput'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($updateNoteInput: UpdateNoteInput!) {
  updateNote(updateNoteInput: $updateNoteInput) {
    response {
      status
      message
    }
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      updateNoteInput: // value for 'updateNoteInput'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const NoteTypesDocument = gql`
    query NoteTypes {
  fetchAllNoteTypes {
    noteTypes {
      id
      noteType
      createdAt
      updatedAt
    }
    response {
      status
    }
  }
}
    `;

/**
 * __useNoteTypesQuery__
 *
 * To run a query within a React component, call `useNoteTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoteTypesQuery(baseOptions?: Apollo.QueryHookOptions<NoteTypesQuery, NoteTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTypesQuery, NoteTypesQueryVariables>(NoteTypesDocument, options);
      }
export function useNoteTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTypesQuery, NoteTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTypesQuery, NoteTypesQueryVariables>(NoteTypesDocument, options);
        }
export type NoteTypesQueryHookResult = ReturnType<typeof useNoteTypesQuery>;
export type NoteTypesLazyQueryHookResult = ReturnType<typeof useNoteTypesLazyQuery>;
export type NoteTypesQueryResult = Apollo.QueryResult<NoteTypesQuery, NoteTypesQueryVariables>;
export const FetchAllOfficesDocument = gql`
    query FetchAllOffices($fetchOfficesInput: FetchAllOfficesInput!) {
  fetchAllOffices(fetchOfficesInput: $fetchOfficesInput) {
    response {
      message
      status
    }
    offices {
      id
      name
      phone
      email
      description
      isLocationOpen
      type
      officeNumber
      addresses {
        id
        address1
        address2
        city
        state
        country
        zipCode
      }
    }
  }
}
    `;

/**
 * __useFetchAllOfficesQuery__
 *
 * To run a query within a React component, call `useFetchAllOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllOfficesQuery({
 *   variables: {
 *      fetchOfficesInput: // value for 'fetchOfficesInput'
 *   },
 * });
 */
export function useFetchAllOfficesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllOfficesQuery, FetchAllOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllOfficesQuery, FetchAllOfficesQueryVariables>(FetchAllOfficesDocument, options);
      }
export function useFetchAllOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllOfficesQuery, FetchAllOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllOfficesQuery, FetchAllOfficesQueryVariables>(FetchAllOfficesDocument, options);
        }
export type FetchAllOfficesQueryHookResult = ReturnType<typeof useFetchAllOfficesQuery>;
export type FetchAllOfficesLazyQueryHookResult = ReturnType<typeof useFetchAllOfficesLazyQuery>;
export type FetchAllOfficesQueryResult = Apollo.QueryResult<FetchAllOfficesQuery, FetchAllOfficesQueryVariables>;
export const CreateOfficeDocument = gql`
    mutation CreateOffice($createOfficeInput: CreateOfficeInput!) {
  createOffice(createOfficeInput: $createOfficeInput) {
    office {
      id
      name
      phone
      description
    }
  }
}
    `;
export type CreateOfficeMutationFn = Apollo.MutationFunction<CreateOfficeMutation, CreateOfficeMutationVariables>;

/**
 * __useCreateOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeMutation, { data, loading, error }] = useCreateOfficeMutation({
 *   variables: {
 *      createOfficeInput: // value for 'createOfficeInput'
 *   },
 * });
 */
export function useCreateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeMutation, CreateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeMutation, CreateOfficeMutationVariables>(CreateOfficeDocument, options);
      }
export type CreateOfficeMutationHookResult = ReturnType<typeof useCreateOfficeMutation>;
export type CreateOfficeMutationResult = Apollo.MutationResult<CreateOfficeMutation>;
export type CreateOfficeMutationOptions = Apollo.BaseMutationOptions<CreateOfficeMutation, CreateOfficeMutationVariables>;
export const UpdateOfficeDocument = gql`
    mutation UpdateOffice($updateOfficeInput: UpdateOfficeInput!) {
  updateOffice(updateOfficeInput: $updateOfficeInput) {
    office {
      id
      name
      phone
      description
    }
  }
}
    `;
export type UpdateOfficeMutationFn = Apollo.MutationFunction<UpdateOfficeMutation, UpdateOfficeMutationVariables>;

/**
 * __useUpdateOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeMutation, { data, loading, error }] = useUpdateOfficeMutation({
 *   variables: {
 *      updateOfficeInput: // value for 'updateOfficeInput'
 *   },
 * });
 */
export function useUpdateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeMutation, UpdateOfficeMutationVariables>(UpdateOfficeDocument, options);
      }
export type UpdateOfficeMutationHookResult = ReturnType<typeof useUpdateOfficeMutation>;
export type UpdateOfficeMutationResult = Apollo.MutationResult<UpdateOfficeMutation>;
export type UpdateOfficeMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>;
export const DeleteOfficeDocument = gql`
    mutation DeleteOffice($deleteOfficeId: Float!, $addressId: String!) {
  deleteOffice(id: $deleteOfficeId, addressId: $addressId) {
    status
    message
  }
}
    `;
export type DeleteOfficeMutationFn = Apollo.MutationFunction<DeleteOfficeMutation, DeleteOfficeMutationVariables>;

/**
 * __useDeleteOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeMutation, { data, loading, error }] = useDeleteOfficeMutation({
 *   variables: {
 *      deleteOfficeId: // value for 'deleteOfficeId'
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useDeleteOfficeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfficeMutation, DeleteOfficeMutationVariables>(DeleteOfficeDocument, options);
      }
export type DeleteOfficeMutationHookResult = ReturnType<typeof useDeleteOfficeMutation>;
export type DeleteOfficeMutationResult = Apollo.MutationResult<DeleteOfficeMutation>;
export type DeleteOfficeMutationOptions = Apollo.BaseMutationOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>;
export const CreatePayableRefundDocument = gql`
    mutation CreatePayableRefund($input: CreatePayableRefundInput!) {
  createPayableRefund(input: $input) {
    payableRefund {
      id
    }
    response {
      message
      status
    }
  }
}
    `;
export type CreatePayableRefundMutationFn = Apollo.MutationFunction<CreatePayableRefundMutation, CreatePayableRefundMutationVariables>;

/**
 * __useCreatePayableRefundMutation__
 *
 * To run a mutation, you first call `useCreatePayableRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayableRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayableRefundMutation, { data, loading, error }] = useCreatePayableRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayableRefundMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayableRefundMutation, CreatePayableRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayableRefundMutation, CreatePayableRefundMutationVariables>(CreatePayableRefundDocument, options);
      }
export type CreatePayableRefundMutationHookResult = ReturnType<typeof useCreatePayableRefundMutation>;
export type CreatePayableRefundMutationResult = Apollo.MutationResult<CreatePayableRefundMutation>;
export type CreatePayableRefundMutationOptions = Apollo.BaseMutationOptions<CreatePayableRefundMutation, CreatePayableRefundMutationVariables>;
export const FetchPayableRefundsDocument = gql`
    query FetchPayableRefunds($input: FetchPayableRefundsInput!) {
  fetchPayableRefunds(input: $input) {
    payableRefunds {
      id
      amount
      date
      paymentMethod
      description
      createdAt
      payable {
        id
        voucherNo
        amount
        vendor {
          id
          name
          vendorId
        }
      }
      office {
        id
        name
      }
      account {
        id
        name
        sortCode
      }
      glAccount {
        id
        name
        sortCode
      }
    }
    pagination {
      totalCount
      page
      limit
      totalPages
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPayableRefundsQuery__
 *
 * To run a query within a React component, call `useFetchPayableRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPayableRefundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPayableRefundsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchPayableRefundsQuery(baseOptions: Apollo.QueryHookOptions<FetchPayableRefundsQuery, FetchPayableRefundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPayableRefundsQuery, FetchPayableRefundsQueryVariables>(FetchPayableRefundsDocument, options);
      }
export function useFetchPayableRefundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPayableRefundsQuery, FetchPayableRefundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPayableRefundsQuery, FetchPayableRefundsQueryVariables>(FetchPayableRefundsDocument, options);
        }
export type FetchPayableRefundsQueryHookResult = ReturnType<typeof useFetchPayableRefundsQuery>;
export type FetchPayableRefundsLazyQueryHookResult = ReturnType<typeof useFetchPayableRefundsLazyQuery>;
export type FetchPayableRefundsQueryResult = Apollo.QueryResult<FetchPayableRefundsQuery, FetchPayableRefundsQueryVariables>;
export const FetchAllPaymentsForReconciliationDocument = gql`
    query FetchAllPaymentsForReconciliation($fetchAllPaymentsInput: FetchPaymentsInput!) {
  fetchAllPaymentsForReconciliation(fetchAllPaymentsInput: $fetchAllPaymentsInput) {
    payments {
      id
      paymentMethod
      referenceNumber
      slipNumber
      reconciliation {
        id
      }
      reconciledAt
      reconciledBy {
        id
        firstName
        lastName
      }
      client {
        id
        lastName
        email
        firstName
        displayName
        initials
        clientNumber
        middleName
        suffix
      }
      vendor {
        id
        name
        sortCode
      }
      payable {
        id
        voucherNo
        checkOrAchNumber
      }
      date
      amount
      office {
        id
        name
      }
      createdAt
      paymentType
    }
    pagination {
      totalPages
      totalCount
      page
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAllPaymentsForReconciliationQuery__
 *
 * To run a query within a React component, call `useFetchAllPaymentsForReconciliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllPaymentsForReconciliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllPaymentsForReconciliationQuery({
 *   variables: {
 *      fetchAllPaymentsInput: // value for 'fetchAllPaymentsInput'
 *   },
 * });
 */
export function useFetchAllPaymentsForReconciliationQuery(baseOptions: Apollo.QueryHookOptions<FetchAllPaymentsForReconciliationQuery, FetchAllPaymentsForReconciliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllPaymentsForReconciliationQuery, FetchAllPaymentsForReconciliationQueryVariables>(FetchAllPaymentsForReconciliationDocument, options);
      }
export function useFetchAllPaymentsForReconciliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllPaymentsForReconciliationQuery, FetchAllPaymentsForReconciliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllPaymentsForReconciliationQuery, FetchAllPaymentsForReconciliationQueryVariables>(FetchAllPaymentsForReconciliationDocument, options);
        }
export type FetchAllPaymentsForReconciliationQueryHookResult = ReturnType<typeof useFetchAllPaymentsForReconciliationQuery>;
export type FetchAllPaymentsForReconciliationLazyQueryHookResult = ReturnType<typeof useFetchAllPaymentsForReconciliationLazyQuery>;
export type FetchAllPaymentsForReconciliationQueryResult = Apollo.QueryResult<FetchAllPaymentsForReconciliationQuery, FetchAllPaymentsForReconciliationQueryVariables>;
export const FetchPaginatedAccountPaymentsDocument = gql`
    query FetchPaginatedAccountPayments($PaginatedAccountPaymentsInput: PaginatedAccountPaymentsInput!) {
  fetchPaginatedAccountPayments(
    fetchPaginatedAccountPaymentsInput: $PaginatedAccountPaymentsInput
  ) {
    response {
      status
      error
      message
    }
    pagination {
      totalPages
      totalCount
      page
    }
    payments {
      id
      amount
      date
      paymentType
      runningBalance
      paymentMethod
      createdAt
      updatedAt
      client {
        id
        firstName
        lastName
        displayName
      }
      vendor {
        id
        name
      }
      case {
        id
        caseNumber
        title
      }
      bill {
        id
      }
      linkedPayment {
        account {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchPaginatedAccountPaymentsQuery__
 *
 * To run a query within a React component, call `useFetchPaginatedAccountPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaginatedAccountPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaginatedAccountPaymentsQuery({
 *   variables: {
 *      PaginatedAccountPaymentsInput: // value for 'PaginatedAccountPaymentsInput'
 *   },
 * });
 */
export function useFetchPaginatedAccountPaymentsQuery(baseOptions: Apollo.QueryHookOptions<FetchPaginatedAccountPaymentsQuery, FetchPaginatedAccountPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaginatedAccountPaymentsQuery, FetchPaginatedAccountPaymentsQueryVariables>(FetchPaginatedAccountPaymentsDocument, options);
      }
export function useFetchPaginatedAccountPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaginatedAccountPaymentsQuery, FetchPaginatedAccountPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaginatedAccountPaymentsQuery, FetchPaginatedAccountPaymentsQueryVariables>(FetchPaginatedAccountPaymentsDocument, options);
        }
export type FetchPaginatedAccountPaymentsQueryHookResult = ReturnType<typeof useFetchPaginatedAccountPaymentsQuery>;
export type FetchPaginatedAccountPaymentsLazyQueryHookResult = ReturnType<typeof useFetchPaginatedAccountPaymentsLazyQuery>;
export type FetchPaginatedAccountPaymentsQueryResult = Apollo.QueryResult<FetchPaginatedAccountPaymentsQuery, FetchPaginatedAccountPaymentsQueryVariables>;
export const FetchBillPaymentsDocument = gql`
    query FetchBillPayments($BillPaymentsInput: BillPaymentsInput!) {
  fetchBillPayments(billPaymentsInput: $BillPaymentsInput) {
    payments {
      id
      amount
      returnAmount
      returnNotes
      returnedAt
      returnedPaymentId
      date
      paymentType
      paymentMethod
      referenceNumber
      slipNumber
      createdAt
      paymentSource
      reconciledAt
      office {
        id
        name
      }
      account {
        id
        type
        name
        sortCode
      }
      linkedPayment {
        id
        account {
          id
          name
          sortCode
          type
        }
      }
      client {
        id
        firstName
        lastName
        displayName
      }
      vendor {
        id
        name
      }
      creator {
        id
        firstName
        lastName
      }
      transaction {
        id
        amount
        status
        transactionId
        settledAt
        createdAt
        cardData {
          cardNumber
          customerFirstName
          customerLastName
        }
        bankData {
          nameOnAccount
          accountNumber
          routingNumber
          accountType
        }
      }
      paymentAllocations {
        id
        amount
        type
        fee
        cost
        expense
        paymentDate
        bill {
          id
        }
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchBillPaymentsQuery__
 *
 * To run a query within a React component, call `useFetchBillPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillPaymentsQuery({
 *   variables: {
 *      BillPaymentsInput: // value for 'BillPaymentsInput'
 *   },
 * });
 */
export function useFetchBillPaymentsQuery(baseOptions: Apollo.QueryHookOptions<FetchBillPaymentsQuery, FetchBillPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillPaymentsQuery, FetchBillPaymentsQueryVariables>(FetchBillPaymentsDocument, options);
      }
export function useFetchBillPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillPaymentsQuery, FetchBillPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillPaymentsQuery, FetchBillPaymentsQueryVariables>(FetchBillPaymentsDocument, options);
        }
export type FetchBillPaymentsQueryHookResult = ReturnType<typeof useFetchBillPaymentsQuery>;
export type FetchBillPaymentsLazyQueryHookResult = ReturnType<typeof useFetchBillPaymentsLazyQuery>;
export type FetchBillPaymentsQueryResult = Apollo.QueryResult<FetchBillPaymentsQuery, FetchBillPaymentsQueryVariables>;
export const TransferFundsBetweenAccountsDocument = gql`
    mutation TransferFundsBetweenAccounts($TransferFundsBetweenAccountsInput: TransferFundsBetweenAccountsInput!) {
  transferFundsBetweenAccounts(
    transferFundsBetweenAccountsInput: $TransferFundsBetweenAccountsInput
  ) {
    response {
      status
      message
    }
    payment {
      id
    }
  }
}
    `;
export type TransferFundsBetweenAccountsMutationFn = Apollo.MutationFunction<TransferFundsBetweenAccountsMutation, TransferFundsBetweenAccountsMutationVariables>;

/**
 * __useTransferFundsBetweenAccountsMutation__
 *
 * To run a mutation, you first call `useTransferFundsBetweenAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferFundsBetweenAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferFundsBetweenAccountsMutation, { data, loading, error }] = useTransferFundsBetweenAccountsMutation({
 *   variables: {
 *      TransferFundsBetweenAccountsInput: // value for 'TransferFundsBetweenAccountsInput'
 *   },
 * });
 */
export function useTransferFundsBetweenAccountsMutation(baseOptions?: Apollo.MutationHookOptions<TransferFundsBetweenAccountsMutation, TransferFundsBetweenAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferFundsBetweenAccountsMutation, TransferFundsBetweenAccountsMutationVariables>(TransferFundsBetweenAccountsDocument, options);
      }
export type TransferFundsBetweenAccountsMutationHookResult = ReturnType<typeof useTransferFundsBetweenAccountsMutation>;
export type TransferFundsBetweenAccountsMutationResult = Apollo.MutationResult<TransferFundsBetweenAccountsMutation>;
export type TransferFundsBetweenAccountsMutationOptions = Apollo.BaseMutationOptions<TransferFundsBetweenAccountsMutation, TransferFundsBetweenAccountsMutationVariables>;
export const FetchPaymentByIdDocument = gql`
    query FetchPaymentById($paymentId: String!) {
  fetchPaymentById(paymentId: $paymentId) {
    payment {
      id
      amount
      returnAmount
      returnNotes
      returnedAt
      date
      paymentMethod
      paymentType
      paymentSource
      referenceNumber
      slipNumber
      notes
      reconciledAt
      createdAt
      updatedAt
      account {
        id
        name
        currentBalance
        isBankAccount
        sortCode
        type
      }
      office {
        id
        name
      }
      bill {
        id
        status
        type
        amount
      }
      case {
        id
        title
        caseNumber
        consultMatterNumber
      }
      client {
        id
        firstName
        lastName
        displayName
        middleName
        email
        clientNumber
      }
      vendor {
        id
        name
        vendorId
      }
      creator {
        id
        firstName
        lastName
        email
      }
      reconciledBy {
        id
        firstName
        lastName
        email
      }
      linkedPayment {
        id
        account {
          id
          name
        }
      }
      transaction {
        id
        status
        transactionId
        amount
        settledAt
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPaymentByIdQuery__
 *
 * To run a query within a React component, call `useFetchPaymentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentByIdQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useFetchPaymentByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchPaymentByIdQuery, FetchPaymentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentByIdQuery, FetchPaymentByIdQueryVariables>(FetchPaymentByIdDocument, options);
      }
export function useFetchPaymentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentByIdQuery, FetchPaymentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentByIdQuery, FetchPaymentByIdQueryVariables>(FetchPaymentByIdDocument, options);
        }
export type FetchPaymentByIdQueryHookResult = ReturnType<typeof useFetchPaymentByIdQuery>;
export type FetchPaymentByIdLazyQueryHookResult = ReturnType<typeof useFetchPaymentByIdLazyQuery>;
export type FetchPaymentByIdQueryResult = Apollo.QueryResult<FetchPaymentByIdQuery, FetchPaymentByIdQueryVariables>;
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($updatePaymentInput: UpdatePaymentInput!) {
  updatePayment(updatePaymentInput: $updatePaymentInput) {
    payment {
      id
      amount
      date
      paymentMethod
      referenceNumber
      slipNumber
      notes
      account {
        id
        name
      }
      office {
        id
        name
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      updatePaymentInput: // value for 'updatePaymentInput'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const CreateFirmPaymentDocument = gql`
    mutation CreateFirmPayment($input: CreateFirmPaymentInput!) {
  createFirmPayment(input: $input) {
    response {
      status
      message
    }
  }
}
    `;
export type CreateFirmPaymentMutationFn = Apollo.MutationFunction<CreateFirmPaymentMutation, CreateFirmPaymentMutationVariables>;

/**
 * __useCreateFirmPaymentMutation__
 *
 * To run a mutation, you first call `useCreateFirmPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirmPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirmPaymentMutation, { data, loading, error }] = useCreateFirmPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFirmPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirmPaymentMutation, CreateFirmPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirmPaymentMutation, CreateFirmPaymentMutationVariables>(CreateFirmPaymentDocument, options);
      }
export type CreateFirmPaymentMutationHookResult = ReturnType<typeof useCreateFirmPaymentMutation>;
export type CreateFirmPaymentMutationResult = Apollo.MutationResult<CreateFirmPaymentMutation>;
export type CreateFirmPaymentMutationOptions = Apollo.BaseMutationOptions<CreateFirmPaymentMutation, CreateFirmPaymentMutationVariables>;
export const CancelPrintJobDocument = gql`
    mutation CancelPrintJob($id: String!) {
  cancelPrintJob(id: $id) {
    printJob {
      id
      status
    }
    response {
      status
      message
    }
  }
}
    `;
export type CancelPrintJobMutationFn = Apollo.MutationFunction<CancelPrintJobMutation, CancelPrintJobMutationVariables>;

/**
 * __useCancelPrintJobMutation__
 *
 * To run a mutation, you first call `useCancelPrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPrintJobMutation, { data, loading, error }] = useCancelPrintJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPrintJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelPrintJobMutation, CancelPrintJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPrintJobMutation, CancelPrintJobMutationVariables>(CancelPrintJobDocument, options);
      }
export type CancelPrintJobMutationHookResult = ReturnType<typeof useCancelPrintJobMutation>;
export type CancelPrintJobMutationResult = Apollo.MutationResult<CancelPrintJobMutation>;
export type CancelPrintJobMutationOptions = Apollo.BaseMutationOptions<CancelPrintJobMutation, CancelPrintJobMutationVariables>;
export const RetryPrintJobDocument = gql`
    mutation RetryPrintJob($id: String!) {
  retryPrintJob(id: $id) {
    printJob {
      id
      status
    }
    response {
      status
      message
    }
  }
}
    `;
export type RetryPrintJobMutationFn = Apollo.MutationFunction<RetryPrintJobMutation, RetryPrintJobMutationVariables>;

/**
 * __useRetryPrintJobMutation__
 *
 * To run a mutation, you first call `useRetryPrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPrintJobMutation, { data, loading, error }] = useRetryPrintJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryPrintJobMutation(baseOptions?: Apollo.MutationHookOptions<RetryPrintJobMutation, RetryPrintJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryPrintJobMutation, RetryPrintJobMutationVariables>(RetryPrintJobDocument, options);
      }
export type RetryPrintJobMutationHookResult = ReturnType<typeof useRetryPrintJobMutation>;
export type RetryPrintJobMutationResult = Apollo.MutationResult<RetryPrintJobMutation>;
export type RetryPrintJobMutationOptions = Apollo.BaseMutationOptions<RetryPrintJobMutation, RetryPrintJobMutationVariables>;
export const CreatePrintJobDocument = gql`
    mutation CreatePrintJob($input: CreatePrintJobInput!) {
  createPrintJob(input: $input) {
    printJob {
      id
      printJobType
      status
      totalBills
      processedBills
      errorMessage
      batchId
      createdAt
      creator {
        id
        firstName
        lastName
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type CreatePrintJobMutationFn = Apollo.MutationFunction<CreatePrintJobMutation, CreatePrintJobMutationVariables>;

/**
 * __useCreatePrintJobMutation__
 *
 * To run a mutation, you first call `useCreatePrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintJobMutation, { data, loading, error }] = useCreatePrintJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrintJobMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintJobMutation, CreatePrintJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintJobMutation, CreatePrintJobMutationVariables>(CreatePrintJobDocument, options);
      }
export type CreatePrintJobMutationHookResult = ReturnType<typeof useCreatePrintJobMutation>;
export type CreatePrintJobMutationResult = Apollo.MutationResult<CreatePrintJobMutation>;
export type CreatePrintJobMutationOptions = Apollo.BaseMutationOptions<CreatePrintJobMutation, CreatePrintJobMutationVariables>;
export const FetchPrintJobsDocument = gql`
    query FetchPrintJobs($input: FetchPrintJobsInput!) {
  fetchPrintJobs(input: $input) {
    printJobs {
      id
      printJobType
      status
      billIds
      attorneyIds
      attorneyRole
      totalBills
      processedBills
      errorMessage
      skippedBills
      sortBy
      sortDir
      caseId
      batchId
      trustScope
      deliveryMethods
      billingTypes
      paymentStatuses
      includeProformaNotes
      sentToClientAt
      createdAt
      updatedAt
      creator {
        id
        firstName
        lastName
        email
      }
      attorneys {
        id
        firstName
        lastName
      }
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPrintJobsQuery__
 *
 * To run a query within a React component, call `useFetchPrintJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPrintJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPrintJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchPrintJobsQuery(baseOptions: Apollo.QueryHookOptions<FetchPrintJobsQuery, FetchPrintJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPrintJobsQuery, FetchPrintJobsQueryVariables>(FetchPrintJobsDocument, options);
      }
export function useFetchPrintJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPrintJobsQuery, FetchPrintJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPrintJobsQuery, FetchPrintJobsQueryVariables>(FetchPrintJobsDocument, options);
        }
export type FetchPrintJobsQueryHookResult = ReturnType<typeof useFetchPrintJobsQuery>;
export type FetchPrintJobsLazyQueryHookResult = ReturnType<typeof useFetchPrintJobsLazyQuery>;
export type FetchPrintJobsQueryResult = Apollo.QueryResult<FetchPrintJobsQuery, FetchPrintJobsQueryVariables>;
export const FetchPrintJobDocument = gql`
    query FetchPrintJob($id: String!) {
  fetchPrintJob(id: $id) {
    printJob {
      id
      printJobType
      status
      totalBills
      processedBills
      errorMessage
      skippedBills
      sortBy
      sortDir
      createdAt
      creator {
        id
        firstName
        lastName
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchPrintJobQuery__
 *
 * To run a query within a React component, call `useFetchPrintJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPrintJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPrintJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchPrintJobQuery(baseOptions: Apollo.QueryHookOptions<FetchPrintJobQuery, FetchPrintJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPrintJobQuery, FetchPrintJobQueryVariables>(FetchPrintJobDocument, options);
      }
export function useFetchPrintJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPrintJobQuery, FetchPrintJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPrintJobQuery, FetchPrintJobQueryVariables>(FetchPrintJobDocument, options);
        }
export type FetchPrintJobQueryHookResult = ReturnType<typeof useFetchPrintJobQuery>;
export type FetchPrintJobLazyQueryHookResult = ReturnType<typeof useFetchPrintJobLazyQuery>;
export type FetchPrintJobQueryResult = Apollo.QueryResult<FetchPrintJobQuery, FetchPrintJobQueryVariables>;
export const DownloadPrintJobDocument = gql`
    query DownloadPrintJob($id: String!) {
  downloadPrintJob(id: $id) {
    preSignedUrl
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useDownloadPrintJobQuery__
 *
 * To run a query within a React component, call `useDownloadPrintJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPrintJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPrintJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadPrintJobQuery(baseOptions: Apollo.QueryHookOptions<DownloadPrintJobQuery, DownloadPrintJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadPrintJobQuery, DownloadPrintJobQueryVariables>(DownloadPrintJobDocument, options);
      }
export function useDownloadPrintJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadPrintJobQuery, DownloadPrintJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadPrintJobQuery, DownloadPrintJobQueryVariables>(DownloadPrintJobDocument, options);
        }
export type DownloadPrintJobQueryHookResult = ReturnType<typeof useDownloadPrintJobQuery>;
export type DownloadPrintJobLazyQueryHookResult = ReturnType<typeof useDownloadPrintJobLazyQuery>;
export type DownloadPrintJobQueryResult = Apollo.QueryResult<DownloadPrintJobQuery, DownloadPrintJobQueryVariables>;
export const QueuesOverviewDocument = gql`
    query QueuesOverview {
  queuesOverview {
    queues {
      name
      isPaused
      counts {
        waiting
        active
        completed
        failed
        delayed
        paused
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useQueuesOverviewQuery__
 *
 * To run a query within a React component, call `useQueuesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueuesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueuesOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueuesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<QueuesOverviewQuery, QueuesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueuesOverviewQuery, QueuesOverviewQueryVariables>(QueuesOverviewDocument, options);
      }
export function useQueuesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueuesOverviewQuery, QueuesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueuesOverviewQuery, QueuesOverviewQueryVariables>(QueuesOverviewDocument, options);
        }
export type QueuesOverviewQueryHookResult = ReturnType<typeof useQueuesOverviewQuery>;
export type QueuesOverviewLazyQueryHookResult = ReturnType<typeof useQueuesOverviewLazyQuery>;
export type QueuesOverviewQueryResult = Apollo.QueryResult<QueuesOverviewQuery, QueuesOverviewQueryVariables>;
export const QueueJobsDocument = gql`
    query QueueJobs($fetchQueueJobsInput: FetchQueueJobsInput!) {
  queueJobs(fetchQueueJobsInput: $fetchQueueJobsInput) {
    jobs {
      id
      name
      attemptsMade
      createdAt
      processedAt
      finishedAt
      progress
      failedReason
      stacktrace
      data
    }
    total
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useQueueJobsQuery__
 *
 * To run a query within a React component, call `useQueueJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueJobsQuery({
 *   variables: {
 *      fetchQueueJobsInput: // value for 'fetchQueueJobsInput'
 *   },
 * });
 */
export function useQueueJobsQuery(baseOptions: Apollo.QueryHookOptions<QueueJobsQuery, QueueJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueueJobsQuery, QueueJobsQueryVariables>(QueueJobsDocument, options);
      }
export function useQueueJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueueJobsQuery, QueueJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueueJobsQuery, QueueJobsQueryVariables>(QueueJobsDocument, options);
        }
export type QueueJobsQueryHookResult = ReturnType<typeof useQueueJobsQuery>;
export type QueueJobsLazyQueryHookResult = ReturnType<typeof useQueueJobsLazyQuery>;
export type QueueJobsQueryResult = Apollo.QueryResult<QueueJobsQuery, QueueJobsQueryVariables>;
export const PauseQueueDocument = gql`
    mutation PauseQueue($queueNameInput: QueueNameInput!) {
  pauseQueue(queueNameInput: $queueNameInput) {
    name
    isPaused
    response {
      status
      message
    }
  }
}
    `;
export type PauseQueueMutationFn = Apollo.MutationFunction<PauseQueueMutation, PauseQueueMutationVariables>;

/**
 * __usePauseQueueMutation__
 *
 * To run a mutation, you first call `usePauseQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseQueueMutation, { data, loading, error }] = usePauseQueueMutation({
 *   variables: {
 *      queueNameInput: // value for 'queueNameInput'
 *   },
 * });
 */
export function usePauseQueueMutation(baseOptions?: Apollo.MutationHookOptions<PauseQueueMutation, PauseQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseQueueMutation, PauseQueueMutationVariables>(PauseQueueDocument, options);
      }
export type PauseQueueMutationHookResult = ReturnType<typeof usePauseQueueMutation>;
export type PauseQueueMutationResult = Apollo.MutationResult<PauseQueueMutation>;
export type PauseQueueMutationOptions = Apollo.BaseMutationOptions<PauseQueueMutation, PauseQueueMutationVariables>;
export const ResumeQueueDocument = gql`
    mutation ResumeQueue($queueNameInput: QueueNameInput!) {
  resumeQueue(queueNameInput: $queueNameInput) {
    name
    isPaused
    response {
      status
      message
    }
  }
}
    `;
export type ResumeQueueMutationFn = Apollo.MutationFunction<ResumeQueueMutation, ResumeQueueMutationVariables>;

/**
 * __useResumeQueueMutation__
 *
 * To run a mutation, you first call `useResumeQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeQueueMutation, { data, loading, error }] = useResumeQueueMutation({
 *   variables: {
 *      queueNameInput: // value for 'queueNameInput'
 *   },
 * });
 */
export function useResumeQueueMutation(baseOptions?: Apollo.MutationHookOptions<ResumeQueueMutation, ResumeQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeQueueMutation, ResumeQueueMutationVariables>(ResumeQueueDocument, options);
      }
export type ResumeQueueMutationHookResult = ReturnType<typeof useResumeQueueMutation>;
export type ResumeQueueMutationResult = Apollo.MutationResult<ResumeQueueMutation>;
export type ResumeQueueMutationOptions = Apollo.BaseMutationOptions<ResumeQueueMutation, ResumeQueueMutationVariables>;
export const RetryQueueJobDocument = gql`
    mutation RetryQueueJob($queueJobActionInput: QueueJobActionInput!) {
  retryQueueJob(queueJobActionInput: $queueJobActionInput) {
    name
    response {
      status
      message
    }
  }
}
    `;
export type RetryQueueJobMutationFn = Apollo.MutationFunction<RetryQueueJobMutation, RetryQueueJobMutationVariables>;

/**
 * __useRetryQueueJobMutation__
 *
 * To run a mutation, you first call `useRetryQueueJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryQueueJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryQueueJobMutation, { data, loading, error }] = useRetryQueueJobMutation({
 *   variables: {
 *      queueJobActionInput: // value for 'queueJobActionInput'
 *   },
 * });
 */
export function useRetryQueueJobMutation(baseOptions?: Apollo.MutationHookOptions<RetryQueueJobMutation, RetryQueueJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryQueueJobMutation, RetryQueueJobMutationVariables>(RetryQueueJobDocument, options);
      }
export type RetryQueueJobMutationHookResult = ReturnType<typeof useRetryQueueJobMutation>;
export type RetryQueueJobMutationResult = Apollo.MutationResult<RetryQueueJobMutation>;
export type RetryQueueJobMutationOptions = Apollo.BaseMutationOptions<RetryQueueJobMutation, RetryQueueJobMutationVariables>;
export const RemoveQueueJobDocument = gql`
    mutation RemoveQueueJob($queueJobActionInput: QueueJobActionInput!) {
  removeQueueJob(queueJobActionInput: $queueJobActionInput) {
    name
    response {
      status
      message
    }
  }
}
    `;
export type RemoveQueueJobMutationFn = Apollo.MutationFunction<RemoveQueueJobMutation, RemoveQueueJobMutationVariables>;

/**
 * __useRemoveQueueJobMutation__
 *
 * To run a mutation, you first call `useRemoveQueueJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQueueJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQueueJobMutation, { data, loading, error }] = useRemoveQueueJobMutation({
 *   variables: {
 *      queueJobActionInput: // value for 'queueJobActionInput'
 *   },
 * });
 */
export function useRemoveQueueJobMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQueueJobMutation, RemoveQueueJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQueueJobMutation, RemoveQueueJobMutationVariables>(RemoveQueueJobDocument, options);
      }
export type RemoveQueueJobMutationHookResult = ReturnType<typeof useRemoveQueueJobMutation>;
export type RemoveQueueJobMutationResult = Apollo.MutationResult<RemoveQueueJobMutation>;
export type RemoveQueueJobMutationOptions = Apollo.BaseMutationOptions<RemoveQueueJobMutation, RemoveQueueJobMutationVariables>;
export const FetchAccountReconciliationDocument = gql`
    query FetchAccountReconciliation($fetchAccountReconciliationInput: AccountReconciliationInput!) {
  fetchAccountReconciliation(
    fetchAccountReconciliationInput: $fetchAccountReconciliationInput
  ) {
    openingBalance
    reconciliation {
      beginningBalance
      statementBalance
      clearedBalance
      finished
    }
    lastReconciliation {
      beginningBalance
      statementBalance
      clearedBalance
      finished
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useFetchAccountReconciliationQuery__
 *
 * To run a query within a React component, call `useFetchAccountReconciliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountReconciliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountReconciliationQuery({
 *   variables: {
 *      fetchAccountReconciliationInput: // value for 'fetchAccountReconciliationInput'
 *   },
 * });
 */
export function useFetchAccountReconciliationQuery(baseOptions: Apollo.QueryHookOptions<FetchAccountReconciliationQuery, FetchAccountReconciliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountReconciliationQuery, FetchAccountReconciliationQueryVariables>(FetchAccountReconciliationDocument, options);
      }
export function useFetchAccountReconciliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountReconciliationQuery, FetchAccountReconciliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountReconciliationQuery, FetchAccountReconciliationQueryVariables>(FetchAccountReconciliationDocument, options);
        }
export type FetchAccountReconciliationQueryHookResult = ReturnType<typeof useFetchAccountReconciliationQuery>;
export type FetchAccountReconciliationLazyQueryHookResult = ReturnType<typeof useFetchAccountReconciliationLazyQuery>;
export type FetchAccountReconciliationQueryResult = Apollo.QueryResult<FetchAccountReconciliationQuery, FetchAccountReconciliationQueryVariables>;
export const FetchReconciliationsDocument = gql`
    query FetchReconciliations($fetchAllReconciliationInput: FetchReconciliationsInput!) {
  fetchReconciliations(fetchAllReconciliationInput: $fetchAllReconciliationInput) {
    response {
      status
      message
    }
    reconciliations {
      id
      account {
        id
        name
        sortCode
      }
      startDate
      endDate
      beginningBalance
      statementBalance
      clearedBalance
      difference
      finished
      unreconciledAt
      reconciledBy {
        id
        firstName
        lastName
      }
      unreconciledBy {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFetchReconciliationsQuery__
 *
 * To run a query within a React component, call `useFetchReconciliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReconciliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReconciliationsQuery({
 *   variables: {
 *      fetchAllReconciliationInput: // value for 'fetchAllReconciliationInput'
 *   },
 * });
 */
export function useFetchReconciliationsQuery(baseOptions: Apollo.QueryHookOptions<FetchReconciliationsQuery, FetchReconciliationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReconciliationsQuery, FetchReconciliationsQueryVariables>(FetchReconciliationsDocument, options);
      }
export function useFetchReconciliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReconciliationsQuery, FetchReconciliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReconciliationsQuery, FetchReconciliationsQueryVariables>(FetchReconciliationsDocument, options);
        }
export type FetchReconciliationsQueryHookResult = ReturnType<typeof useFetchReconciliationsQuery>;
export type FetchReconciliationsLazyQueryHookResult = ReturnType<typeof useFetchReconciliationsLazyQuery>;
export type FetchReconciliationsQueryResult = Apollo.QueryResult<FetchReconciliationsQuery, FetchReconciliationsQueryVariables>;
export const FetchReconciliationDocument = gql`
    query FetchReconciliation($id: Float!) {
  fetchReconciliation(id: $id) {
    id
    account {
      id
      name
      sortCode
    }
    startDate
    endDate
    beginningBalance
    statementBalance
    clearedBalance
    difference
    finished
    unreconciledAt
    reconciledBy {
      id
      firstName
      lastName
    }
    unreconciledBy {
      id
      firstName
      lastName
    }
    payments {
      id
      paymentMethod
      referenceNumber
      slipNumber
      reconciledAt
      client {
        id
        firstName
        lastName
        displayName
        clientNumber
      }
      vendor {
        id
        name
        sortCode
      }
      date
      amount
      office {
        id
        name
      }
      createdAt
      paymentType
      account {
        id
        name
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFetchReconciliationQuery__
 *
 * To run a query within a React component, call `useFetchReconciliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReconciliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReconciliationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchReconciliationQuery(baseOptions: Apollo.QueryHookOptions<FetchReconciliationQuery, FetchReconciliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReconciliationQuery, FetchReconciliationQueryVariables>(FetchReconciliationDocument, options);
      }
export function useFetchReconciliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReconciliationQuery, FetchReconciliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReconciliationQuery, FetchReconciliationQueryVariables>(FetchReconciliationDocument, options);
        }
export type FetchReconciliationQueryHookResult = ReturnType<typeof useFetchReconciliationQuery>;
export type FetchReconciliationLazyQueryHookResult = ReturnType<typeof useFetchReconciliationLazyQuery>;
export type FetchReconciliationQueryResult = Apollo.QueryResult<FetchReconciliationQuery, FetchReconciliationQueryVariables>;
export const DownloadReconciliationDocumentDocument = gql`
    mutation DownloadReconciliationDocument($reconciliationDocumentInput: ReconciliationDocumentInput!) {
  downloadReconciliationDocument(
    reconciliationDocumentInput: $reconciliationDocumentInput
  ) {
    preSignedUrl
    status
    response {
      status
      error
      message
    }
  }
}
    `;
export type DownloadReconciliationDocumentMutationFn = Apollo.MutationFunction<DownloadReconciliationDocumentMutation, DownloadReconciliationDocumentMutationVariables>;

/**
 * __useDownloadReconciliationDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadReconciliationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadReconciliationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadReconciliationDocumentMutation, { data, loading, error }] = useDownloadReconciliationDocumentMutation({
 *   variables: {
 *      reconciliationDocumentInput: // value for 'reconciliationDocumentInput'
 *   },
 * });
 */
export function useDownloadReconciliationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DownloadReconciliationDocumentMutation, DownloadReconciliationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadReconciliationDocumentMutation, DownloadReconciliationDocumentMutationVariables>(DownloadReconciliationDocumentDocument, options);
      }
export type DownloadReconciliationDocumentMutationHookResult = ReturnType<typeof useDownloadReconciliationDocumentMutation>;
export type DownloadReconciliationDocumentMutationResult = Apollo.MutationResult<DownloadReconciliationDocumentMutation>;
export type DownloadReconciliationDocumentMutationOptions = Apollo.BaseMutationOptions<DownloadReconciliationDocumentMutation, DownloadReconciliationDocumentMutationVariables>;
export const FetchReconciliationDocumentStatusDocument = gql`
    query FetchReconciliationDocumentStatus($id: Int!) {
  fetchReconciliationDocumentStatus(id: $id) {
    id
    pdfStatus
    csvStatus
    documentErrorMessage
  }
}
    `;

/**
 * __useFetchReconciliationDocumentStatusQuery__
 *
 * To run a query within a React component, call `useFetchReconciliationDocumentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReconciliationDocumentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReconciliationDocumentStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchReconciliationDocumentStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchReconciliationDocumentStatusQuery, FetchReconciliationDocumentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReconciliationDocumentStatusQuery, FetchReconciliationDocumentStatusQueryVariables>(FetchReconciliationDocumentStatusDocument, options);
      }
export function useFetchReconciliationDocumentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReconciliationDocumentStatusQuery, FetchReconciliationDocumentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReconciliationDocumentStatusQuery, FetchReconciliationDocumentStatusQueryVariables>(FetchReconciliationDocumentStatusDocument, options);
        }
export type FetchReconciliationDocumentStatusQueryHookResult = ReturnType<typeof useFetchReconciliationDocumentStatusQuery>;
export type FetchReconciliationDocumentStatusLazyQueryHookResult = ReturnType<typeof useFetchReconciliationDocumentStatusLazyQuery>;
export type FetchReconciliationDocumentStatusQueryResult = Apollo.QueryResult<FetchReconciliationDocumentStatusQuery, FetchReconciliationDocumentStatusQueryVariables>;
export const UndoReconciliationDocument = gql`
    mutation UndoReconciliation($id: Float!) {
  undoReconciliation(id: $id) {
    response {
      status
      error
      message
    }
  }
}
    `;
export type UndoReconciliationMutationFn = Apollo.MutationFunction<UndoReconciliationMutation, UndoReconciliationMutationVariables>;

/**
 * __useUndoReconciliationMutation__
 *
 * To run a mutation, you first call `useUndoReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoReconciliationMutation, { data, loading, error }] = useUndoReconciliationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<UndoReconciliationMutation, UndoReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoReconciliationMutation, UndoReconciliationMutationVariables>(UndoReconciliationDocument, options);
      }
export type UndoReconciliationMutationHookResult = ReturnType<typeof useUndoReconciliationMutation>;
export type UndoReconciliationMutationResult = Apollo.MutationResult<UndoReconciliationMutation>;
export type UndoReconciliationMutationOptions = Apollo.BaseMutationOptions<UndoReconciliationMutation, UndoReconciliationMutationVariables>;
export const FetchMyReconciliationSessionsDocument = gql`
    query FetchMyReconciliationSessions {
  fetchMyReconciliationSessions {
    ...ReconciliationSessionSummary
  }
}
    ${ReconciliationSessionSummaryFragmentDoc}`;

/**
 * __useFetchMyReconciliationSessionsQuery__
 *
 * To run a query within a React component, call `useFetchMyReconciliationSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMyReconciliationSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMyReconciliationSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMyReconciliationSessionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchMyReconciliationSessionsQuery, FetchMyReconciliationSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMyReconciliationSessionsQuery, FetchMyReconciliationSessionsQueryVariables>(FetchMyReconciliationSessionsDocument, options);
      }
export function useFetchMyReconciliationSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMyReconciliationSessionsQuery, FetchMyReconciliationSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMyReconciliationSessionsQuery, FetchMyReconciliationSessionsQueryVariables>(FetchMyReconciliationSessionsDocument, options);
        }
export type FetchMyReconciliationSessionsQueryHookResult = ReturnType<typeof useFetchMyReconciliationSessionsQuery>;
export type FetchMyReconciliationSessionsLazyQueryHookResult = ReturnType<typeof useFetchMyReconciliationSessionsLazyQuery>;
export type FetchMyReconciliationSessionsQueryResult = Apollo.QueryResult<FetchMyReconciliationSessionsQuery, FetchMyReconciliationSessionsQueryVariables>;
export const FetchReconciliationSessionDocument = gql`
    query FetchReconciliationSession($sessionId: Int!) {
  fetchReconciliationSession(sessionId: $sessionId) {
    ...ReconciliationSessionFull
  }
}
    ${ReconciliationSessionFullFragmentDoc}`;

/**
 * __useFetchReconciliationSessionQuery__
 *
 * To run a query within a React component, call `useFetchReconciliationSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReconciliationSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReconciliationSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useFetchReconciliationSessionQuery(baseOptions: Apollo.QueryHookOptions<FetchReconciliationSessionQuery, FetchReconciliationSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReconciliationSessionQuery, FetchReconciliationSessionQueryVariables>(FetchReconciliationSessionDocument, options);
      }
export function useFetchReconciliationSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReconciliationSessionQuery, FetchReconciliationSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReconciliationSessionQuery, FetchReconciliationSessionQueryVariables>(FetchReconciliationSessionDocument, options);
        }
export type FetchReconciliationSessionQueryHookResult = ReturnType<typeof useFetchReconciliationSessionQuery>;
export type FetchReconciliationSessionLazyQueryHookResult = ReturnType<typeof useFetchReconciliationSessionLazyQuery>;
export type FetchReconciliationSessionQueryResult = Apollo.QueryResult<FetchReconciliationSessionQuery, FetchReconciliationSessionQueryVariables>;
export const StartOrResumeReconciliationSessionDocument = gql`
    mutation StartOrResumeReconciliationSession($input: StartReconciliationSessionInput!) {
  startOrResumeReconciliationSession(input: $input) {
    ...ReconciliationSessionFull
  }
}
    ${ReconciliationSessionFullFragmentDoc}`;
export type StartOrResumeReconciliationSessionMutationFn = Apollo.MutationFunction<StartOrResumeReconciliationSessionMutation, StartOrResumeReconciliationSessionMutationVariables>;

/**
 * __useStartOrResumeReconciliationSessionMutation__
 *
 * To run a mutation, you first call `useStartOrResumeReconciliationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOrResumeReconciliationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOrResumeReconciliationSessionMutation, { data, loading, error }] = useStartOrResumeReconciliationSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartOrResumeReconciliationSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartOrResumeReconciliationSessionMutation, StartOrResumeReconciliationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartOrResumeReconciliationSessionMutation, StartOrResumeReconciliationSessionMutationVariables>(StartOrResumeReconciliationSessionDocument, options);
      }
export type StartOrResumeReconciliationSessionMutationHookResult = ReturnType<typeof useStartOrResumeReconciliationSessionMutation>;
export type StartOrResumeReconciliationSessionMutationResult = Apollo.MutationResult<StartOrResumeReconciliationSessionMutation>;
export type StartOrResumeReconciliationSessionMutationOptions = Apollo.BaseMutationOptions<StartOrResumeReconciliationSessionMutation, StartOrResumeReconciliationSessionMutationVariables>;
export const UpdateReconciliationSessionDocument = gql`
    mutation UpdateReconciliationSession($input: UpdateReconciliationSessionInput!) {
  updateReconciliationSession(input: $input) {
    ...ReconciliationSessionSummary
  }
}
    ${ReconciliationSessionSummaryFragmentDoc}`;
export type UpdateReconciliationSessionMutationFn = Apollo.MutationFunction<UpdateReconciliationSessionMutation, UpdateReconciliationSessionMutationVariables>;

/**
 * __useUpdateReconciliationSessionMutation__
 *
 * To run a mutation, you first call `useUpdateReconciliationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReconciliationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReconciliationSessionMutation, { data, loading, error }] = useUpdateReconciliationSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReconciliationSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReconciliationSessionMutation, UpdateReconciliationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReconciliationSessionMutation, UpdateReconciliationSessionMutationVariables>(UpdateReconciliationSessionDocument, options);
      }
export type UpdateReconciliationSessionMutationHookResult = ReturnType<typeof useUpdateReconciliationSessionMutation>;
export type UpdateReconciliationSessionMutationResult = Apollo.MutationResult<UpdateReconciliationSessionMutation>;
export type UpdateReconciliationSessionMutationOptions = Apollo.BaseMutationOptions<UpdateReconciliationSessionMutation, UpdateReconciliationSessionMutationVariables>;
export const UpdateReconciliationSessionViewPreferencesDocument = gql`
    mutation UpdateReconciliationSessionViewPreferences($input: UpdateReconciliationSessionViewPreferencesInput!) {
  updateReconciliationSessionViewPreferences(input: $input) {
    ...ReconciliationSessionViewPrefs
  }
}
    ${ReconciliationSessionViewPrefsFragmentDoc}`;
export type UpdateReconciliationSessionViewPreferencesMutationFn = Apollo.MutationFunction<UpdateReconciliationSessionViewPreferencesMutation, UpdateReconciliationSessionViewPreferencesMutationVariables>;

/**
 * __useUpdateReconciliationSessionViewPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateReconciliationSessionViewPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReconciliationSessionViewPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReconciliationSessionViewPreferencesMutation, { data, loading, error }] = useUpdateReconciliationSessionViewPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReconciliationSessionViewPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReconciliationSessionViewPreferencesMutation, UpdateReconciliationSessionViewPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReconciliationSessionViewPreferencesMutation, UpdateReconciliationSessionViewPreferencesMutationVariables>(UpdateReconciliationSessionViewPreferencesDocument, options);
      }
export type UpdateReconciliationSessionViewPreferencesMutationHookResult = ReturnType<typeof useUpdateReconciliationSessionViewPreferencesMutation>;
export type UpdateReconciliationSessionViewPreferencesMutationResult = Apollo.MutationResult<UpdateReconciliationSessionViewPreferencesMutation>;
export type UpdateReconciliationSessionViewPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateReconciliationSessionViewPreferencesMutation, UpdateReconciliationSessionViewPreferencesMutationVariables>;
export const ClearReconciliationSessionItemsDocument = gql`
    mutation ClearReconciliationSessionItems($input: ClearReconciliationSessionInput!) {
  clearReconciliationSessionItems(input: $input) {
    ...ReconciliationSessionFull
  }
}
    ${ReconciliationSessionFullFragmentDoc}`;
export type ClearReconciliationSessionItemsMutationFn = Apollo.MutationFunction<ClearReconciliationSessionItemsMutation, ClearReconciliationSessionItemsMutationVariables>;

/**
 * __useClearReconciliationSessionItemsMutation__
 *
 * To run a mutation, you first call `useClearReconciliationSessionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearReconciliationSessionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearReconciliationSessionItemsMutation, { data, loading, error }] = useClearReconciliationSessionItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearReconciliationSessionItemsMutation(baseOptions?: Apollo.MutationHookOptions<ClearReconciliationSessionItemsMutation, ClearReconciliationSessionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearReconciliationSessionItemsMutation, ClearReconciliationSessionItemsMutationVariables>(ClearReconciliationSessionItemsDocument, options);
      }
export type ClearReconciliationSessionItemsMutationHookResult = ReturnType<typeof useClearReconciliationSessionItemsMutation>;
export type ClearReconciliationSessionItemsMutationResult = Apollo.MutationResult<ClearReconciliationSessionItemsMutation>;
export type ClearReconciliationSessionItemsMutationOptions = Apollo.BaseMutationOptions<ClearReconciliationSessionItemsMutation, ClearReconciliationSessionItemsMutationVariables>;
export const DiscardReconciliationSessionDocument = gql`
    mutation DiscardReconciliationSession($sessionId: Int!) {
  discardReconciliationSession(sessionId: $sessionId) {
    id
    status
    version
  }
}
    `;
export type DiscardReconciliationSessionMutationFn = Apollo.MutationFunction<DiscardReconciliationSessionMutation, DiscardReconciliationSessionMutationVariables>;

/**
 * __useDiscardReconciliationSessionMutation__
 *
 * To run a mutation, you first call `useDiscardReconciliationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardReconciliationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardReconciliationSessionMutation, { data, loading, error }] = useDiscardReconciliationSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useDiscardReconciliationSessionMutation(baseOptions?: Apollo.MutationHookOptions<DiscardReconciliationSessionMutation, DiscardReconciliationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardReconciliationSessionMutation, DiscardReconciliationSessionMutationVariables>(DiscardReconciliationSessionDocument, options);
      }
export type DiscardReconciliationSessionMutationHookResult = ReturnType<typeof useDiscardReconciliationSessionMutation>;
export type DiscardReconciliationSessionMutationResult = Apollo.MutationResult<DiscardReconciliationSessionMutation>;
export type DiscardReconciliationSessionMutationOptions = Apollo.BaseMutationOptions<DiscardReconciliationSessionMutation, DiscardReconciliationSessionMutationVariables>;
export const CommitReconciliationSessionDocument = gql`
    mutation CommitReconciliationSession($sessionId: Int!) {
  commitReconciliationSession(sessionId: $sessionId) {
    id
    status
    version
    committedReconciliation {
      id
    }
  }
}
    `;
export type CommitReconciliationSessionMutationFn = Apollo.MutationFunction<CommitReconciliationSessionMutation, CommitReconciliationSessionMutationVariables>;

/**
 * __useCommitReconciliationSessionMutation__
 *
 * To run a mutation, you first call `useCommitReconciliationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitReconciliationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitReconciliationSessionMutation, { data, loading, error }] = useCommitReconciliationSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCommitReconciliationSessionMutation(baseOptions?: Apollo.MutationHookOptions<CommitReconciliationSessionMutation, CommitReconciliationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitReconciliationSessionMutation, CommitReconciliationSessionMutationVariables>(CommitReconciliationSessionDocument, options);
      }
export type CommitReconciliationSessionMutationHookResult = ReturnType<typeof useCommitReconciliationSessionMutation>;
export type CommitReconciliationSessionMutationResult = Apollo.MutationResult<CommitReconciliationSessionMutation>;
export type CommitReconciliationSessionMutationOptions = Apollo.BaseMutationOptions<CommitReconciliationSessionMutation, CommitReconciliationSessionMutationVariables>;
export const FetchAllReferencesDocument = gql`
    query FetchAllReferences($fetchAllReferences: FetchAllReferencesInput!) {
  fetchAllReferences(fetchAllReferences: $fetchAllReferences) {
    response {
      status
      message
    }
    pagination {
      totalCount
      totalPages
      page
    }
    references {
      updatedAt
      id
      createdAt
      referral
      active
      referralSource {
        id
        sourceType
        createdAt
        updatedAt
      }
      eligibleFor1099Report
    }
  }
}
    `;

/**
 * __useFetchAllReferencesQuery__
 *
 * To run a query within a React component, call `useFetchAllReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllReferencesQuery({
 *   variables: {
 *      fetchAllReferences: // value for 'fetchAllReferences'
 *   },
 * });
 */
export function useFetchAllReferencesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllReferencesQuery, FetchAllReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllReferencesQuery, FetchAllReferencesQueryVariables>(FetchAllReferencesDocument, options);
      }
export function useFetchAllReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllReferencesQuery, FetchAllReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllReferencesQuery, FetchAllReferencesQueryVariables>(FetchAllReferencesDocument, options);
        }
export type FetchAllReferencesQueryHookResult = ReturnType<typeof useFetchAllReferencesQuery>;
export type FetchAllReferencesLazyQueryHookResult = ReturnType<typeof useFetchAllReferencesLazyQuery>;
export type FetchAllReferencesQueryResult = Apollo.QueryResult<FetchAllReferencesQuery, FetchAllReferencesQueryVariables>;
export const DeleteReferenceDocument = gql`
    mutation DeleteReference($deleteReferenceId: String!) {
  deleteReference(id: $deleteReferenceId)
}
    `;
export type DeleteReferenceMutationFn = Apollo.MutationFunction<DeleteReferenceMutation, DeleteReferenceMutationVariables>;

/**
 * __useDeleteReferenceMutation__
 *
 * To run a mutation, you first call `useDeleteReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReferenceMutation, { data, loading, error }] = useDeleteReferenceMutation({
 *   variables: {
 *      deleteReferenceId: // value for 'deleteReferenceId'
 *   },
 * });
 */
export function useDeleteReferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReferenceMutation, DeleteReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReferenceMutation, DeleteReferenceMutationVariables>(DeleteReferenceDocument, options);
      }
export type DeleteReferenceMutationHookResult = ReturnType<typeof useDeleteReferenceMutation>;
export type DeleteReferenceMutationResult = Apollo.MutationResult<DeleteReferenceMutation>;
export type DeleteReferenceMutationOptions = Apollo.BaseMutationOptions<DeleteReferenceMutation, DeleteReferenceMutationVariables>;
export const CreateReferenceDocument = gql`
    mutation CreateReference($createReferenceInput: CreateReferenceInput!) {
  createReference(createReferenceInput: $createReferenceInput) {
    response {
      status
      message
    }
    reference {
      id
      referral
      active
      referralSourceId
    }
  }
}
    `;
export type CreateReferenceMutationFn = Apollo.MutationFunction<CreateReferenceMutation, CreateReferenceMutationVariables>;

/**
 * __useCreateReferenceMutation__
 *
 * To run a mutation, you first call `useCreateReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferenceMutation, { data, loading, error }] = useCreateReferenceMutation({
 *   variables: {
 *      createReferenceInput: // value for 'createReferenceInput'
 *   },
 * });
 */
export function useCreateReferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferenceMutation, CreateReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferenceMutation, CreateReferenceMutationVariables>(CreateReferenceDocument, options);
      }
export type CreateReferenceMutationHookResult = ReturnType<typeof useCreateReferenceMutation>;
export type CreateReferenceMutationResult = Apollo.MutationResult<CreateReferenceMutation>;
export type CreateReferenceMutationOptions = Apollo.BaseMutationOptions<CreateReferenceMutation, CreateReferenceMutationVariables>;
export const UpdateReferenceDocument = gql`
    mutation UpdateReference($updateReferenceInput: UpdateReferenceInput!) {
  updateReference(updateReferenceInput: $updateReferenceInput) {
    response {
      message
      status
    }
    reference {
      id
      referral
      active
      referralSourceId
    }
  }
}
    `;
export type UpdateReferenceMutationFn = Apollo.MutationFunction<UpdateReferenceMutation, UpdateReferenceMutationVariables>;

/**
 * __useUpdateReferenceMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceMutation, { data, loading, error }] = useUpdateReferenceMutation({
 *   variables: {
 *      updateReferenceInput: // value for 'updateReferenceInput'
 *   },
 * });
 */
export function useUpdateReferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceMutation, UpdateReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceMutation, UpdateReferenceMutationVariables>(UpdateReferenceDocument, options);
      }
export type UpdateReferenceMutationHookResult = ReturnType<typeof useUpdateReferenceMutation>;
export type UpdateReferenceMutationResult = Apollo.MutationResult<UpdateReferenceMutation>;
export type UpdateReferenceMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceMutation, UpdateReferenceMutationVariables>;
export const GetReportTemplatesDocument = gql`
    query getReportTemplates {
  getReportTemplates {
    group
    selections {
      selection
      sortFields
      selectionFields {
        field
        type
        options
        operator
        label
        required
        defaultValue
        minDate
        maxDate
        visibilityRules {
          dependsOn
          value
          operator
        }
      }
      label
      description
    }
    label
    description
  }
}
    `;

/**
 * __useGetReportTemplatesQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
      }
export function useGetReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>(GetReportTemplatesDocument, options);
        }
export type GetReportTemplatesQueryHookResult = ReturnType<typeof useGetReportTemplatesQuery>;
export type GetReportTemplatesLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesLazyQuery>;
export type GetReportTemplatesQueryResult = Apollo.QueryResult<GetReportTemplatesQuery, GetReportTemplatesQueryVariables>;
export const GenerateReportDocument = gql`
    mutation generateReport($createReportInput: CreateReportInput!) {
  generateReport(createReportInput: $createReportInput) {
    response {
      status
      error
      message
    }
  }
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      createReportInput: // value for 'createReportInput'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const RetryReportDocument = gql`
    mutation RetryReport($reportId: String!) {
  retryReport(reportId: $reportId) {
    response {
      status
      error
      message
    }
  }
}
    `;
export type RetryReportMutationFn = Apollo.MutationFunction<RetryReportMutation, RetryReportMutationVariables>;

/**
 * __useRetryReportMutation__
 *
 * To run a mutation, you first call `useRetryReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryReportMutation, { data, loading, error }] = useRetryReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useRetryReportMutation(baseOptions?: Apollo.MutationHookOptions<RetryReportMutation, RetryReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryReportMutation, RetryReportMutationVariables>(RetryReportDocument, options);
      }
export type RetryReportMutationHookResult = ReturnType<typeof useRetryReportMutation>;
export type RetryReportMutationResult = Apollo.MutationResult<RetryReportMutation>;
export type RetryReportMutationOptions = Apollo.BaseMutationOptions<RetryReportMutation, RetryReportMutationVariables>;
export const CancelReportDocument = gql`
    mutation CancelReport($reportId: String!) {
  cancelReport(reportId: $reportId) {
    response {
      status
      error
      message
    }
  }
}
    `;
export type CancelReportMutationFn = Apollo.MutationFunction<CancelReportMutation, CancelReportMutationVariables>;

/**
 * __useCancelReportMutation__
 *
 * To run a mutation, you first call `useCancelReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReportMutation, { data, loading, error }] = useCancelReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useCancelReportMutation(baseOptions?: Apollo.MutationHookOptions<CancelReportMutation, CancelReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReportMutation, CancelReportMutationVariables>(CancelReportDocument, options);
      }
export type CancelReportMutationHookResult = ReturnType<typeof useCancelReportMutation>;
export type CancelReportMutationResult = Apollo.MutationResult<CancelReportMutation>;
export type CancelReportMutationOptions = Apollo.BaseMutationOptions<CancelReportMutation, CancelReportMutationVariables>;
export const FetchReportsDocument = gql`
    query FetchReports($input: ReportsInput!) {
  fetchReports(reportsInput: $input) {
    reports {
      id
      creator {
        id
        firstName
        lastName
        email
      }
      reportGroup
      reportSelection
      status
      selectionFields
      displaySelectionFields
      fileName
      errorMessage
      createdAt
      updatedAt
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
    response {
      status
      error
      message
    }
  }
}
    `;

/**
 * __useFetchReportsQuery__
 *
 * To run a query within a React component, call `useFetchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchReportsQuery(baseOptions: Apollo.QueryHookOptions<FetchReportsQuery, FetchReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReportsQuery, FetchReportsQueryVariables>(FetchReportsDocument, options);
      }
export function useFetchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReportsQuery, FetchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReportsQuery, FetchReportsQueryVariables>(FetchReportsDocument, options);
        }
export type FetchReportsQueryHookResult = ReturnType<typeof useFetchReportsQuery>;
export type FetchReportsLazyQueryHookResult = ReturnType<typeof useFetchReportsLazyQuery>;
export type FetchReportsQueryResult = Apollo.QueryResult<FetchReportsQuery, FetchReportsQueryVariables>;
export const DownloadReportDocument = gql`
    query downloadReport($reportDownloadInput: ReportDownloadInput!) {
  downloadReport(reportDownloadInput: $reportDownloadInput) {
    response {
      status
      message
    }
    preSignedUrl
  }
}
    `;

/**
 * __useDownloadReportQuery__
 *
 * To run a query within a React component, call `useDownloadReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReportQuery({
 *   variables: {
 *      reportDownloadInput: // value for 'reportDownloadInput'
 *   },
 * });
 */
export function useDownloadReportQuery(baseOptions: Apollo.QueryHookOptions<DownloadReportQuery, DownloadReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadReportQuery, DownloadReportQueryVariables>(DownloadReportDocument, options);
      }
export function useDownloadReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadReportQuery, DownloadReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadReportQuery, DownloadReportQueryVariables>(DownloadReportDocument, options);
        }
export type DownloadReportQueryHookResult = ReturnType<typeof useDownloadReportQuery>;
export type DownloadReportLazyQueryHookResult = ReturnType<typeof useDownloadReportLazyQuery>;
export type DownloadReportQueryResult = Apollo.QueryResult<DownloadReportQuery, DownloadReportQueryVariables>;
export const FetchActivitiesDocument = gql`
    query FetchActivities($fetchActivityInput: FetchLogsInput!) {
  fetchActivities(fetchActivityInput: $fetchActivityInput) {
    activities {
      id
      action
      creator {
        id
        firstName
        lastName
        status
        roles {
          id
          role
        }
      }
      entityType
      entityId
      billId
      description
      actorName
      createdAt
    }
    response {
      message
      status
    }
    pagination {
      page
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFetchActivitiesQuery__
 *
 * To run a query within a React component, call `useFetchActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActivitiesQuery({
 *   variables: {
 *      fetchActivityInput: // value for 'fetchActivityInput'
 *   },
 * });
 */
export function useFetchActivitiesQuery(baseOptions: Apollo.QueryHookOptions<FetchActivitiesQuery, FetchActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActivitiesQuery, FetchActivitiesQueryVariables>(FetchActivitiesDocument, options);
      }
export function useFetchActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActivitiesQuery, FetchActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActivitiesQuery, FetchActivitiesQueryVariables>(FetchActivitiesDocument, options);
        }
export type FetchActivitiesQueryHookResult = ReturnType<typeof useFetchActivitiesQuery>;
export type FetchActivitiesLazyQueryHookResult = ReturnType<typeof useFetchActivitiesLazyQuery>;
export type FetchActivitiesQueryResult = Apollo.QueryResult<FetchActivitiesQuery, FetchActivitiesQueryVariables>;
export const FetchReportCreatorsDocument = gql`
    query FetchReportCreators {
  fetchReportCreators {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useFetchReportCreatorsQuery__
 *
 * To run a query within a React component, call `useFetchReportCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReportCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReportCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchReportCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<FetchReportCreatorsQuery, FetchReportCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchReportCreatorsQuery, FetchReportCreatorsQueryVariables>(FetchReportCreatorsDocument, options);
      }
export function useFetchReportCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchReportCreatorsQuery, FetchReportCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchReportCreatorsQuery, FetchReportCreatorsQueryVariables>(FetchReportCreatorsDocument, options);
        }
export type FetchReportCreatorsQueryHookResult = ReturnType<typeof useFetchReportCreatorsQuery>;
export type FetchReportCreatorsLazyQueryHookResult = ReturnType<typeof useFetchReportCreatorsLazyQuery>;
export type FetchReportCreatorsQueryResult = Apollo.QueryResult<FetchReportCreatorsQuery, FetchReportCreatorsQueryVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($registerUserInput: RegisterUserInput!) {
  registerUser(user: $registerUserInput) {
    response {
      status
      message
      error
    }
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
    }
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      registerUserInput: // value for 'registerUserInput'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const FetchAllRolesDocument = gql`
    query FetchAllRoles {
  fetchAllRoles {
    response {
      status
      message
      error
    }
    roles {
      id
      role
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useFetchAllRolesQuery__
 *
 * To run a query within a React component, call `useFetchAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllRolesQuery, FetchAllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllRolesQuery, FetchAllRolesQueryVariables>(FetchAllRolesDocument, options);
      }
export function useFetchAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllRolesQuery, FetchAllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllRolesQuery, FetchAllRolesQueryVariables>(FetchAllRolesDocument, options);
        }
export type FetchAllRolesQueryHookResult = ReturnType<typeof useFetchAllRolesQuery>;
export type FetchAllRolesLazyQueryHookResult = ReturnType<typeof useFetchAllRolesLazyQuery>;
export type FetchAllRolesQueryResult = Apollo.QueryResult<FetchAllRolesQuery, FetchAllRolesQueryVariables>;
export const FetchAllUsersDocument = gql`
    query FetchAllUsers($userInput: UsersInput!) {
  fetchAllUsers(userInput: $userInput) {
    response {
      name
      error
      status
      message
    }
    pagination {
      page
      totalCount
      totalPages
      limit
    }
    users {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
      hourlyRate
      mfaEmailEnabled
      mfaAuthEnabled
      lockedAt
      office {
        id
        name
        isLocationOpen
        createdAt
        updatedAt
      }
      roles {
        id
        role
        createdAt
        updatedAt
      }
      hourlyRate
      paralegals {
        id
        firstName
        lastName
        status
        emailVerified
        email
        phoneNumber
        createdAt
        updatedAt
        initials
        hourlyRate
      }
      deptToUsers {
        department {
          id
          name
          description
        }
        departmentId
        updatedAt
        userId
        createdAt
        user {
          id
          status
          emailVerified
          email
          hourlyRate
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAllUsersQuery__
 *
 * To run a query within a React component, call `useFetchAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllUsersQuery({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useFetchAllUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchAllUsersQuery, FetchAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllUsersQuery, FetchAllUsersQueryVariables>(FetchAllUsersDocument, options);
      }
export function useFetchAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllUsersQuery, FetchAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllUsersQuery, FetchAllUsersQueryVariables>(FetchAllUsersDocument, options);
        }
export type FetchAllUsersQueryHookResult = ReturnType<typeof useFetchAllUsersQuery>;
export type FetchAllUsersLazyQueryHookResult = ReturnType<typeof useFetchAllUsersLazyQuery>;
export type FetchAllUsersQueryResult = Apollo.QueryResult<FetchAllUsersQuery, FetchAllUsersQueryVariables>;
export const FetchUsersByIdsDocument = gql`
    query FetchUsersByIds($userIdsInput: UserIdsInput!) {
  fetchUsersByIds(userIdsInput: $userIdsInput) {
    users {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
    }
  }
}
    `;

/**
 * __useFetchUsersByIdsQuery__
 *
 * To run a query within a React component, call `useFetchUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersByIdsQuery({
 *   variables: {
 *      userIdsInput: // value for 'userIdsInput'
 *   },
 * });
 */
export function useFetchUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchUsersByIdsQuery, FetchUsersByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersByIdsQuery, FetchUsersByIdsQueryVariables>(FetchUsersByIdsDocument, options);
      }
export function useFetchUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersByIdsQuery, FetchUsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersByIdsQuery, FetchUsersByIdsQueryVariables>(FetchUsersByIdsDocument, options);
        }
export type FetchUsersByIdsQueryHookResult = ReturnType<typeof useFetchUsersByIdsQuery>;
export type FetchUsersByIdsLazyQueryHookResult = ReturnType<typeof useFetchUsersByIdsLazyQuery>;
export type FetchUsersByIdsQueryResult = Apollo.QueryResult<FetchUsersByIdsQuery, FetchUsersByIdsQueryVariables>;
export const ActivateUserDocument = gql`
    mutation ActivateUser($user: UserIdInput!) {
  activateUser(user: $user) {
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
      roles {
        id
        role
        createdAt
        updatedAt
      }
    }
    response {
      message
      status
    }
  }
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const UnlockUserDocument = gql`
    mutation UnlockUser($user: UserIdInput!) {
  unlockUser(user: $user) {
    user {
      id
      lockedAt
    }
    response {
      message
      status
    }
  }
}
    `;
export type UnlockUserMutationFn = Apollo.MutationFunction<UnlockUserMutation, UnlockUserMutationVariables>;

/**
 * __useUnlockUserMutation__
 *
 * To run a mutation, you first call `useUnlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockUserMutation, { data, loading, error }] = useUnlockUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUnlockUserMutation(baseOptions?: Apollo.MutationHookOptions<UnlockUserMutation, UnlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockUserMutation, UnlockUserMutationVariables>(UnlockUserDocument, options);
      }
export type UnlockUserMutationHookResult = ReturnType<typeof useUnlockUserMutation>;
export type UnlockUserMutationResult = Apollo.MutationResult<UnlockUserMutation>;
export type UnlockUserMutationOptions = Apollo.BaseMutationOptions<UnlockUserMutation, UnlockUserMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($user: UserIdInput!) {
  deactivateUser(user: $user) {
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
      roles {
        id
        role
        createdAt
        updatedAt
      }
    }
    response {
      message
      status
    }
  }
}
    `;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($updateRoleInput: UpdateRoleInput!) {
  updateRole(user: $updateRoleInput) {
    user {
      id
      status
      firstName
      lastName
      emailVerified
      email
      createdAt
      updatedAt
      initials
      hourlyRate
      roles {
        id
        role
        createdAt
        updatedAt
      }
      paralegals {
        id
        firstName
        lastName
        status
        emailVerified
        email
        phoneNumber
        createdAt
        updatedAt
        initials
      }
      notes {
        id
        description
        userId
        caseId
        createdAt
        updatedAt
      }
      deptToUsers {
        departmentId
        department {
          id
          name
        }
        createdAt
        updatedAt
        userId
        user {
          id
          lastName
        }
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      updateRoleInput: // value for 'updateRoleInput'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($updatePasswordInput: UpdatePasswordInput!) {
  updatePassword(updatePasswordInput: $updatePasswordInput) {
    user {
      id
      status
      emailVerified
      email
      createdAt
      updatedAt
      initials
      roles {
        id
        role
        createdAt
        updatedAt
      }
      notes {
        id
        description
        userId
        caseId
        createdAt
        updatedAt
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($removeUserInput: UserIdInput!) {
  removeUser(user: $removeUserInput) {
    user {
      id
      status
      emailVerified
      email
      createdAt
      updatedAt
      initials
      roles {
        id
        role
        createdAt
        updatedAt
      }
      notes {
        id
        description
        userId
        caseId
        createdAt
        updatedAt
      }
    }
    response {
      status
      message
    }
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      removeUserInput: // value for 'removeUserInput'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const SearchUserDocument = gql`
    query SearchUser($searchUserInput: SearchUserInput!) {
  searchUser(searchUserInput: $searchUserInput) {
    users {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
      hourlyRate
      mfaEmailEnabled
      mfaAuthEnabled
      lockedAt
      roles {
        id
        role
        createdAt
        updatedAt
      }
      hourlyRate
      paralegals {
        id
        firstName
        lastName
        status
        emailVerified
        email
        phoneNumber
        createdAt
        updatedAt
        initials
        hourlyRate
      }
      deptToUsers {
        department {
          id
          name
          description
        }
        departmentId
        updatedAt
        userId
        createdAt
        user {
          id
          status
          emailVerified
          email
          hourlyRate
          createdAt
          updatedAt
        }
      }
    }
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      searchUserInput: // value for 'searchUserInput'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const FetchAllCasesDocument = gql`
    query FetchAllCases($casesInput: CasesInput!) {
  fetchAllCases(casesInput: $casesInput) {
    cases {
      id
      advantageCode
      title
      description
      caseNumber
      consultMatterNumber
      status
      dueDate
      accidentDate
      caseTypeId
      courtId
      deletedAt
      createdAt
      updatedAt
      caseTypeId
      courtId
      isConsultMatter
      advCaseNumber
      caseEvents {
        id
        eventType
        hearingAt
        nextHearingAt
        createdAt
        updatedAt
      }
      caseToExternalUserToExternalUserRole {
        id
        litigationId
        externalUserToExternalUserRoleId
        isArchived
        createdAt
        updatedAt
        caseRole
        externalUserToExternalUserRole {
          id
          externalUserId
          externalUserRoleId
          createdAt
          updatedAt
          externalUser {
            id
            initials
            lastName
            firstName
            displayName
            suffix
            middleName
            clientNumber
            dateOfBirth
            homePhone
            phoneNumber
            personalPhone
            email
            lastPayDate
            contractBalance
            lastPayAmount
            trustBalance
            arrearsBalance
            createdAt
            updatedAt
            externalUserRoles {
              id
              externalUserId
              externalUserRoleId
              createdAt
              updatedAt
              externalUserRole {
                id
                role
                createdAt
                updatedAt
              }
            }
          }
        }
      }
      caseToUsers {
        id
        userId
        caseId
        userType
        createdAt
        updatedAt
        user {
          id
          firstName
          lastName
          status
          emailVerified
          email
          createdAt
          updatedAt
          initials
          hourlyRate
          roles {
            id
            role
            createdAt
            updatedAt
          }
        }
        hourlyRate
      }
      court {
        id
        county
        name
        createdAt
        updatedAt
      }
      caseType {
        id
        name
        lawTypeId
        createdAt
        updatedAt
        lawType {
          id
          name
          createdAt
          syncWithOutlook
          updatedAt
        }
      }
      billing {
        id
        billingType
        createdAt
        updatedAt
      }
      bills {
        id
        type
        status
        amount
        sendToClient
        case {
          id
          caseTypeId
          createdAt
          updatedAt
          status
        }
        createdAt
        updatedAt
      }
    }
    response {
      status
      message
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFetchAllCasesQuery__
 *
 * To run a query within a React component, call `useFetchAllCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCasesQuery({
 *   variables: {
 *      casesInput: // value for 'casesInput'
 *   },
 * });
 */
export function useFetchAllCasesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCasesQuery, FetchAllCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCasesQuery, FetchAllCasesQueryVariables>(FetchAllCasesDocument, options);
      }
export function useFetchAllCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCasesQuery, FetchAllCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCasesQuery, FetchAllCasesQueryVariables>(FetchAllCasesDocument, options);
        }
export type FetchAllCasesQueryHookResult = ReturnType<typeof useFetchAllCasesQuery>;
export type FetchAllCasesLazyQueryHookResult = ReturnType<typeof useFetchAllCasesLazyQuery>;
export type FetchAllCasesQueryResult = Apollo.QueryResult<FetchAllCasesQuery, FetchAllCasesQueryVariables>;
export const FetchAllCasesLightDocument = gql`
    query FetchAllCasesLight($casesLightInput: CasesLightInput!) {
  fetchAllCasesLight(casesLightInput: $casesLightInput) {
    cases {
      id
      caseNumber
      consultMatterNumber
      title
      isConsultMatter
      caseToUsers {
        id
        userId
        caseId
        userType
        user {
          id
        }
      }
      caseToExternalUserToExternalUserRole {
        id
        externalUserToExternalUserRole {
          externalUser {
            id
            firstName
            lastName
            displayName
            clientNumber
            externalUserRoles {
              externalUserRole {
                role
              }
            }
          }
        }
      }
    }
    response {
      status
      message
    }
    pagination {
      page
      limit
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFetchAllCasesLightQuery__
 *
 * To run a query within a React component, call `useFetchAllCasesLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllCasesLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllCasesLightQuery({
 *   variables: {
 *      casesLightInput: // value for 'casesLightInput'
 *   },
 * });
 */
export function useFetchAllCasesLightQuery(baseOptions: Apollo.QueryHookOptions<FetchAllCasesLightQuery, FetchAllCasesLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllCasesLightQuery, FetchAllCasesLightQueryVariables>(FetchAllCasesLightDocument, options);
      }
export function useFetchAllCasesLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllCasesLightQuery, FetchAllCasesLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllCasesLightQuery, FetchAllCasesLightQueryVariables>(FetchAllCasesLightDocument, options);
        }
export type FetchAllCasesLightQueryHookResult = ReturnType<typeof useFetchAllCasesLightQuery>;
export type FetchAllCasesLightLazyQueryHookResult = ReturnType<typeof useFetchAllCasesLightLazyQuery>;
export type FetchAllCasesLightQueryResult = Apollo.QueryResult<FetchAllCasesLightQuery, FetchAllCasesLightQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($updateUserInput: UpdateUserInput!) {
  updateUser(user: $updateUserInput) {
    response {
      status
      message
    }
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      createdAt
      updatedAt
      phoneNumber
      initials
      hourlyRate
      roles {
        id
        role
        createdAt
        updatedAt
      }
      caseToUsers {
        id
        userId
        caseId
        userType
        createdAt
        updatedAt
        litigation {
          id
          advantageCode
          title
          description
          caseNumber
          status
          caseTypeId
          courtId
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserGeneralInfoDocument = gql`
    mutation UpdateUserGeneralInfo($user: UpdateGeneralInput!) {
  updateUserGeneralInfo(user: $user) {
    response {
      message
      status
    }
    user {
      email
      id
      lastName
      firstName
      initials
      office {
        id
        name
      }
    }
  }
}
    `;
export type UpdateUserGeneralInfoMutationFn = Apollo.MutationFunction<UpdateUserGeneralInfoMutation, UpdateUserGeneralInfoMutationVariables>;

/**
 * __useUpdateUserGeneralInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserGeneralInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGeneralInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGeneralInfoMutation, { data, loading, error }] = useUpdateUserGeneralInfoMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserGeneralInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGeneralInfoMutation, UpdateUserGeneralInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGeneralInfoMutation, UpdateUserGeneralInfoMutationVariables>(UpdateUserGeneralInfoDocument, options);
      }
export type UpdateUserGeneralInfoMutationHookResult = ReturnType<typeof useUpdateUserGeneralInfoMutation>;
export type UpdateUserGeneralInfoMutationResult = Apollo.MutationResult<UpdateUserGeneralInfoMutation>;
export type UpdateUserGeneralInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserGeneralInfoMutation, UpdateUserGeneralInfoMutationVariables>;
export const FindOneUserDocument = gql`
    query FindOneUser($findOneUserId: String!) {
  findOneUser(id: $findOneUserId) {
    user {
      id
      firstName
      lastName
      status
      emailVerified
      email
      phoneNumber
      createdAt
      updatedAt
      initials
      hourlyRate
      roles {
        id
        role
      }
    }
  }
}
    `;

/**
 * __useFindOneUserQuery__
 *
 * To run a query within a React component, call `useFindOneUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneUserQuery({
 *   variables: {
 *      findOneUserId: // value for 'findOneUserId'
 *   },
 * });
 */
export function useFindOneUserQuery(baseOptions: Apollo.QueryHookOptions<FindOneUserQuery, FindOneUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneUserQuery, FindOneUserQueryVariables>(FindOneUserDocument, options);
      }
export function useFindOneUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneUserQuery, FindOneUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneUserQuery, FindOneUserQueryVariables>(FindOneUserDocument, options);
        }
export type FindOneUserQueryHookResult = ReturnType<typeof useFindOneUserQuery>;
export type FindOneUserLazyQueryHookResult = ReturnType<typeof useFindOneUserLazyQuery>;
export type FindOneUserQueryResult = Apollo.QueryResult<FindOneUserQuery, FindOneUserQueryVariables>;
export const GetClientByClientNumberDocument = gql`
    query GetClientByClientNumber($clientNumber: String!) {
  getClientByClientNumber(clientNumber: $clientNumber) {
    externalUser {
      id
      initials
      lastName
      firstName
      displayName
      suffix
      middleName
      clientNumber
      dateOfBirth
      homePhone
      phoneNumber
      personalPhone
      email
      lastPayDate
      contractBalance
      lastPayAmount
      trustBalance
      arrearsBalance
      residualBalance
      businessName
      isInternational
      language
      socialSecurityNumber
      driverLicenseNumber
      createdAt
      updatedAt
      addresses {
        id
        address1
        address2
        city
        state
        country
        county
        zipCode
        createdAt
        updatedAt
      }
      externalUserRoles {
        id
        externalUserId
        externalUserRoleId
        createdAt
        updatedAt
        externalUserRole {
          id
          role
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientByClientNumberQuery__
 *
 * To run a query within a React component, call `useGetClientByClientNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientByClientNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientByClientNumberQuery({
 *   variables: {
 *      clientNumber: // value for 'clientNumber'
 *   },
 * });
 */
export function useGetClientByClientNumberQuery(baseOptions: Apollo.QueryHookOptions<GetClientByClientNumberQuery, GetClientByClientNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientByClientNumberQuery, GetClientByClientNumberQueryVariables>(GetClientByClientNumberDocument, options);
      }
export function useGetClientByClientNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientByClientNumberQuery, GetClientByClientNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientByClientNumberQuery, GetClientByClientNumberQueryVariables>(GetClientByClientNumberDocument, options);
        }
export type GetClientByClientNumberQueryHookResult = ReturnType<typeof useGetClientByClientNumberQuery>;
export type GetClientByClientNumberLazyQueryHookResult = ReturnType<typeof useGetClientByClientNumberLazyQuery>;
export type GetClientByClientNumberQueryResult = Apollo.QueryResult<GetClientByClientNumberQuery, GetClientByClientNumberQueryVariables>;
export const GetNextClientNumberDocument = gql`
    query GetNextClientNumber($isConsultClient: Boolean!) {
  getNextClientNumber(isConsultClient: $isConsultClient) {
    clientNo
    response {
      status
    }
  }
}
    `;

/**
 * __useGetNextClientNumberQuery__
 *
 * To run a query within a React component, call `useGetNextClientNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextClientNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextClientNumberQuery({
 *   variables: {
 *      isConsultClient: // value for 'isConsultClient'
 *   },
 * });
 */
export function useGetNextClientNumberQuery(baseOptions: Apollo.QueryHookOptions<GetNextClientNumberQuery, GetNextClientNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextClientNumberQuery, GetNextClientNumberQueryVariables>(GetNextClientNumberDocument, options);
      }
export function useGetNextClientNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextClientNumberQuery, GetNextClientNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextClientNumberQuery, GetNextClientNumberQueryVariables>(GetNextClientNumberDocument, options);
        }
export type GetNextClientNumberQueryHookResult = ReturnType<typeof useGetNextClientNumberQuery>;
export type GetNextClientNumberLazyQueryHookResult = ReturnType<typeof useGetNextClientNumberLazyQuery>;
export type GetNextClientNumberQueryResult = Apollo.QueryResult<GetNextClientNumberQuery, GetNextClientNumberQueryVariables>;
export const UpdateUserMfaSettingsDocument = gql`
    mutation updateUserMfaSettings($mfaSettingsInput: UpdateUserMfaSettingsInput!) {
  updateUserMfaSettings(mfaSettings: $mfaSettingsInput) {
    response {
      status
      message
    }
    user {
      id
      mfaEmailEnabled
      mfaAuthEnabled
    }
  }
}
    `;
export type UpdateUserMfaSettingsMutationFn = Apollo.MutationFunction<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>;

/**
 * __useUpdateUserMfaSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserMfaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMfaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMfaSettingsMutation, { data, loading, error }] = useUpdateUserMfaSettingsMutation({
 *   variables: {
 *      mfaSettingsInput: // value for 'mfaSettingsInput'
 *   },
 * });
 */
export function useUpdateUserMfaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>(UpdateUserMfaSettingsDocument, options);
      }
export type UpdateUserMfaSettingsMutationHookResult = ReturnType<typeof useUpdateUserMfaSettingsMutation>;
export type UpdateUserMfaSettingsMutationResult = Apollo.MutationResult<UpdateUserMfaSettingsMutation>;
export type UpdateUserMfaSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>;
export const CreateVendorDocument = gql`
    mutation CreateVendor($createVendorInput: CreateVendorInput!) {
  createVendor(createVendorInput: $createVendorInput) {
    vendor {
      id
      name
    }
    response {
      status
      message
    }
  }
}
    `;
export type CreateVendorMutationFn = Apollo.MutationFunction<CreateVendorMutation, CreateVendorMutationVariables>;

/**
 * __useCreateVendorMutation__
 *
 * To run a mutation, you first call `useCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorMutation, { data, loading, error }] = useCreateVendorMutation({
 *   variables: {
 *      createVendorInput: // value for 'createVendorInput'
 *   },
 * });
 */
export function useCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorMutation, CreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument, options);
      }
export type CreateVendorMutationHookResult = ReturnType<typeof useCreateVendorMutation>;
export type CreateVendorMutationResult = Apollo.MutationResult<CreateVendorMutation>;
export type CreateVendorMutationOptions = Apollo.BaseMutationOptions<CreateVendorMutation, CreateVendorMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($updateVendorInput: UpdateVendorInput!) {
  updateVendor(updateVendorInput: $updateVendorInput) {
    vendor {
      id
      name
    }
    response {
      status
      message
    }
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      updateVendorInput: // value for 'updateVendorInput'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const DeactivateVendorDocument = gql`
    mutation DeactivateVendor($id: Int!) {
  deactivateVendor(id: $id) {
    vendor {
      id
      deletedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type DeactivateVendorMutationFn = Apollo.MutationFunction<DeactivateVendorMutation, DeactivateVendorMutationVariables>;

/**
 * __useDeactivateVendorMutation__
 *
 * To run a mutation, you first call `useDeactivateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateVendorMutation, { data, loading, error }] = useDeactivateVendorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateVendorMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateVendorMutation, DeactivateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateVendorMutation, DeactivateVendorMutationVariables>(DeactivateVendorDocument, options);
      }
export type DeactivateVendorMutationHookResult = ReturnType<typeof useDeactivateVendorMutation>;
export type DeactivateVendorMutationResult = Apollo.MutationResult<DeactivateVendorMutation>;
export type DeactivateVendorMutationOptions = Apollo.BaseMutationOptions<DeactivateVendorMutation, DeactivateVendorMutationVariables>;
export const ReactivateVendorDocument = gql`
    mutation ReactivateVendor($id: Int!) {
  reactivateVendor(id: $id) {
    vendor {
      id
      deletedAt
    }
    response {
      status
      message
    }
  }
}
    `;
export type ReactivateVendorMutationFn = Apollo.MutationFunction<ReactivateVendorMutation, ReactivateVendorMutationVariables>;

/**
 * __useReactivateVendorMutation__
 *
 * To run a mutation, you first call `useReactivateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateVendorMutation, { data, loading, error }] = useReactivateVendorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateVendorMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateVendorMutation, ReactivateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateVendorMutation, ReactivateVendorMutationVariables>(ReactivateVendorDocument, options);
      }
export type ReactivateVendorMutationHookResult = ReturnType<typeof useReactivateVendorMutation>;
export type ReactivateVendorMutationResult = Apollo.MutationResult<ReactivateVendorMutation>;
export type ReactivateVendorMutationOptions = Apollo.BaseMutationOptions<ReactivateVendorMutation, ReactivateVendorMutationVariables>;
export const FetchAllVendorsDocument = gql`
    query FetchAllVendors($fetchVendorsInput: FetchAllVendorsInput!) {
  fetchAllVendors(fetchVendorsInput: $fetchVendorsInput) {
    pagination {
      totalCount
      totalPages
      page
    }
    response {
      status
      message
    }
    vendors {
      required1099
      id
      name
      phone
      addresses {
        id
        address1
        address2
        city
        state
        country
        county
        zipCode
      }
      separateCheckPerInvoice
      email
      socialSecurityNumber
      taxId
      sortCode
      description
      parentVendor {
        id
        name
      }
      glAccount {
        id
        name
        sortCode
      }
      vendorId
      deletedAt
      office {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchAllVendorsQuery__
 *
 * To run a query within a React component, call `useFetchAllVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllVendorsQuery({
 *   variables: {
 *      fetchVendorsInput: // value for 'fetchVendorsInput'
 *   },
 * });
 */
export function useFetchAllVendorsQuery(baseOptions: Apollo.QueryHookOptions<FetchAllVendorsQuery, FetchAllVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllVendorsQuery, FetchAllVendorsQueryVariables>(FetchAllVendorsDocument, options);
      }
export function useFetchAllVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllVendorsQuery, FetchAllVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllVendorsQuery, FetchAllVendorsQueryVariables>(FetchAllVendorsDocument, options);
        }
export type FetchAllVendorsQueryHookResult = ReturnType<typeof useFetchAllVendorsQuery>;
export type FetchAllVendorsLazyQueryHookResult = ReturnType<typeof useFetchAllVendorsLazyQuery>;
export type FetchAllVendorsQueryResult = Apollo.QueryResult<FetchAllVendorsQuery, FetchAllVendorsQueryVariables>;
export const GetNextVendorIdDocument = gql`
    query GetNextVendorId {
  getNextVendorId {
    nextVendorId
    response {
      status
      message
    }
  }
}
    `;

/**
 * __useGetNextVendorIdQuery__
 *
 * To run a query within a React component, call `useGetNextVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextVendorIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextVendorIdQuery(baseOptions?: Apollo.QueryHookOptions<GetNextVendorIdQuery, GetNextVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextVendorIdQuery, GetNextVendorIdQueryVariables>(GetNextVendorIdDocument, options);
      }
export function useGetNextVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextVendorIdQuery, GetNextVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextVendorIdQuery, GetNextVendorIdQueryVariables>(GetNextVendorIdDocument, options);
        }
export type GetNextVendorIdQueryHookResult = ReturnType<typeof useGetNextVendorIdQuery>;
export type GetNextVendorIdLazyQueryHookResult = ReturnType<typeof useGetNextVendorIdLazyQuery>;
export type GetNextVendorIdQueryResult = Apollo.QueryResult<GetNextVendorIdQuery, GetNextVendorIdQueryVariables>;